/* *********** */
/* + main.js + */
/* *********** */
"use strict";

// CSS
// require('../lib/Bootstrap/css/bootstrap.min.css');
require("../css/main.css");

// Vendor libraries (jQuery, Bootstrap, jsTree, DataTables, Split, moment,
// lodash, d3, ...) are loaded as plain <script> tags in index.php, BEFORE this
// bundle. They register browser globals ($, jQuery, moment, _, d3, ...) that the
// code below relies on. They are intentionally NOT bundled: the old webpack-1
// `script-loader` approach breaks under webpack 5 (the UMD wrappers hit an
// undefined `require`, so jQuery never registered and the whole app failed).

// Modules
var Utils = require("./utils.js");
var initUserManagement = require("./userManagement.js");
var DOMPurify = require("dompurify");

// Main
$(document).ready(function () {
  // ++ Consts
  var IS_ON_PREMISE = false;

  var IS_DEBUG = false;

  var IS_JET_COLORS = false;

  var DATE_TIME_UPODATE_INTERVAL = 1 * 60 * 1000;

  var TREE_UPODATE_INTERVAL = 5 * 60 * 1000;

  var SPECTROGRAMS_UPODATE_INTERVAL = 5 * 60 * 1000;
  // var SPECTROGRAMS_UPODATE_INTERVAL = 0.5 * 60 * 1000;

  var INTERNALS_SAMPLES_UPODATE_INTERVAL = 0.5 * 60 * 1000;

  var NODE_SEARCH_DELAY = 350;
  var TD_GRAPHS_SEARCH_DELAY = 350;

  var ICON_V_NODE = "images/Lcircle";
  var ICON_V_NODE_IGNORED = "images/ignoredinherit";
  var ICON_V_NODE_DELETED = "images/Lcircleblack";

  var ICON_D_NODE = "images/Dcircle";
  var ICON_D_NODE_IGNORED = "images/ignoredinherit";
  var ICON_D_NODE_DELETED = "images/Dcircleblack";

  var ICON_N_NODE = "images/circle";
  var ICON_N_NODE_IGNORED = "images/ignoredinherit";
  var ICON_N_NODE_DELETED = "images/circleblack";

  var ICON_ALL_NODE_IGNORED_INHERIT = "images/ignored";

  var MARKER_ICON_BASE = "https://maps.google.com/mapfiles/kml/paddle/";
  var MARKER_ICON_OK = MARKER_ICON_BASE + "grn-blank_maps.png";
  var MARKER_ICON_OK_COMMERR = MARKER_ICON_BASE + "grn-stars_maps.png";
  var MARKER_ICON_WARNING = MARKER_ICON_BASE + "orange-blank_maps.png";
  var MARKER_ICON_WARNING_COMMERR = MARKER_ICON_BASE + "orange-stars_maps.png";
  var MARKER_ICON_ERROR = MARKER_ICON_BASE + "red-blank_maps.png";
  var MARKER_ICON_ERROR_COMMERR = MARKER_ICON_BASE + "red-stars_maps.png";
  var MARKER_ICON_HISTORY_CURRENT = MARKER_ICON_BASE + "grn-blank.png";
  var MARKER_ICON_HISTORY = MARKER_ICON_BASE + "blu-blank_maps.png";
  var MARKER_ICON_HISTORY_OLDEST = MARKER_ICON_BASE + "ltblu-blank_maps.png";

  var colors = [
    d3.rgb(255, 84, 255),
    d3.rgb(253, 64, 251),
    d3.rgb(254, 39, 254),
    d3.rgb(254, 22, 255),
    d3.rgb(254, 0, 254),
    d3.rgb(247, 0, 205),
    d3.rgb(254, 0, 156),
    d3.rgb(244, 4, 99),
    d3.rgb(246, 3, 46),
    d3.rgb(244, 3, 8),
    d3.rgb(254, 37, 1),
    d3.rgb(255, 71, 2),
    d3.rgb(254, 100, 0),
    d3.rgb(254, 132, 3),
    d3.rgb(255, 149, 0),
    d3.rgb(255, 163, 2),
    d3.rgb(252, 180, 3),
    d3.rgb(251, 191, 0),
    d3.rgb(253, 205, 7),
    d3.rgb(251, 209, 4),
    d3.rgb(249, 226, 7),
    d3.rgb(252, 235, 12),
    d3.rgb(251, 240, 7),
    d3.rgb(242, 246, 7),
    d3.rgb(179, 219, 3),
    d3.rgb(139, 211, 14),
    d3.rgb(79, 183, 31),
    d3.rgb(18, 159, 36),
    d3.rgb(0, 166, 69),
    d3.rgb(0, 187, 116),
    d3.rgb(5, 210, 160),
    d3.rgb(10, 225, 199),
    d3.rgb(17, 249, 253),
    d3.rgb(8, 206, 241),
    d3.rgb(31, 158, 236),
    d3.rgb(61, 97, 228),
    d3.rgb(80, 39, 221),
    d3.rgb(97, 0, 201),
    d3.rgb(90, 13, 173),
    d3.rgb(81, 24, 134),
    d3.rgb(65, 34, 94),
    d3.rgb(63, 52, 73),
    d3.rgb(255, 255, 255),
  ];

  var powerToColorScale = d3
    .scaleLinear()
    .domain([
      -83, -84, -85, -86, -87, -88, -89, -90, -91, -92, -93, -94, -95, -96, -97,
      -98, -99, -100, -101, -102, -103, -104, -105, -106, -107, -108, -109,
      -110, -111, -112, -113, -114, -115, -116, -117, -118, -119, -120, -121,
      -122, -123, -124, -139,
    ])
    .range(colors);

  var colorsJet = [
    d3.rgb(255, 84, 255),
    d3.rgb(255, 84, 255),
    d3.rgb(253, 64, 251),
    d3.rgb(253, 64, 251),
    d3.rgb(254, 39, 254),
    d3.rgb(254, 39, 254),
    d3.rgb(254, 22, 255),
    d3.rgb(254, 22, 255),
    d3.rgb(254, 0, 254),
    d3.rgb(254, 0, 254),
    d3.rgb(247, 0, 205),
    d3.rgb(247, 0, 205),
    d3.rgb(254, 0, 156),
    d3.rgb(254, 0, 156),
    d3.rgb(244, 4, 99),
    d3.rgb(244, 4, 99),
    d3.rgb(246, 3, 46),
    d3.rgb(246, 3, 46),
    d3.rgb(244, 3, 8),
    d3.rgb(244, 3, 8),
    d3.rgb(254, 37, 1),
    d3.rgb(254, 37, 1),
    d3.rgb(255, 71, 2),
    d3.rgb(255, 71, 2),
    d3.rgb(254, 100, 0),
    d3.rgb(254, 100, 0),
    d3.rgb(254, 132, 3),
    d3.rgb(254, 132, 3),
    d3.rgb(255, 149, 0),
    d3.rgb(255, 149, 0),
    d3.rgb(255, 163, 2),
    d3.rgb(255, 163, 2),
    d3.rgb(252, 180, 3),
    d3.rgb(252, 180, 3),
    d3.rgb(251, 191, 0),
    d3.rgb(251, 191, 0),
    d3.rgb(253, 205, 7),
    d3.rgb(253, 205, 7),
    d3.rgb(251, 209, 4),
    d3.rgb(251, 209, 4),
    d3.rgb(249, 226, 7),
    d3.rgb(249, 226, 7),
    d3.rgb(252, 235, 12),
    d3.rgb(252, 235, 12),
    d3.rgb(251, 240, 7),
    d3.rgb(251, 240, 7),
    d3.rgb(242, 246, 7),
    d3.rgb(242, 246, 7),
    d3.rgb(179, 219, 3),
    d3.rgb(179, 219, 3),
    d3.rgb(139, 211, 14),
    d3.rgb(139, 211, 14),
    d3.rgb(79, 183, 31),
    d3.rgb(79, 183, 31),
    d3.rgb(18, 159, 36),
    d3.rgb(18, 159, 36),
    d3.rgb(0, 166, 69),
    d3.rgb(0, 166, 69),
    d3.rgb(0, 187, 116),
    d3.rgb(0, 187, 116),
    d3.rgb(5, 210, 160),
    d3.rgb(5, 210, 160),
    d3.rgb(10, 225, 199),
    d3.rgb(10, 225, 199),
    d3.rgb(17, 249, 253),
    d3.rgb(17, 249, 253),
    d3.rgb(8, 206, 241),
    d3.rgb(8, 206, 241),
    d3.rgb(31, 158, 236),
    d3.rgb(31, 158, 236),
    d3.rgb(61, 97, 228),
    d3.rgb(61, 97, 228),
    d3.rgb(80, 39, 221),
    d3.rgb(80, 39, 221),
    d3.rgb(97, 0, 201),
    d3.rgb(97, 0, 201),
    d3.rgb(90, 13, 173),
    d3.rgb(90, 13, 173),
    d3.rgb(81, 24, 134),
    d3.rgb(81, 24, 134),
    d3.rgb(65, 34, 94),
    d3.rgb(65, 34, 94),
    d3.rgb(63, 52, 73),
    d3.rgb(63, 52, 73),
    d3.rgb(255, 255, 255),
  ];

  var powerToJetColorScale = d3
    .scaleLinear()
    .domain([
      -40, -41, -42, -43, -44, -45, -46, -47, -48, -49, -50, -51, -52, -53, -54,
      -55, -56, -57, -58, -59, -60, -61, -62, -63, -64, -65, -66, -67, -68, -69,
      -70, -71, -72, -73, -74, -75, -76, -77, -78, -79, -80, -81, -82, -83, -84,
      -85, -86, -87, -88, -89, -90, -91, -92, -93, -94, -95, -96, -97, -98, -99,
      -100, -101, -102, -103, -104, -105, -106, -107, -108, -109, -110, -111,
      -112, -113, -114, -115, -116, -117, -118, -119, -120, -121, -122, -123,
      -124, -139,
    ])
    .range(colorsJet);

  // ATT colormap: linear blend from -125 dBm (lowest noise) to -85 dBm
  // (highest noise). Stops are evenly spaced (i/9 of the 40 dB span). RGB
  // interpolates between neighboring stops; values outside the span clamp.
  var attColorStops = [
    d3.rgb(64, 64, 64),
    d3.rgb(102, 0, 204),
    d3.rgb(0, 255, 255),
    d3.rgb(0, 153, 51),
    d3.rgb(255, 255, 0),
    d3.rgb(255, 204, 0),
    d3.rgb(255, 153, 0),
    d3.rgb(255, 0, 0),
    d3.rgb(255, 0, 255),
    d3.rgb(255, 102, 255),
  ];
  var ATT_DBM_MIN = -125;
  var ATT_DBM_MAX = -85;
  var attColorDomain = [];
  for (var attStopIndex = 0; attStopIndex < attColorStops.length; attStopIndex++) {
    attColorDomain.push(
      ATT_DBM_MIN +
        ((ATT_DBM_MAX - ATT_DBM_MIN) * attStopIndex) /
          (attColorStops.length - 1)
    );
  }
  var powerToAttColorScale = d3
    .scaleLinear()
    .domain(attColorDomain)
    .range(attColorStops)
    .clamp(true);

  function spectrogramPowerColor(dbm) {
    if (globColormap === "att") {
      return powerToAttColorScale(dbm);
    }
    return IS_JET_COLORS ? powerToJetColorScale(dbm) : powerToColorScale(dbm);
  }

  // var colorsJet = [d3.rgb(0, 0, 144), d3.rgb(0, 0, 160), d3.rgb(0, 0, 176), d3.rgb(0, 0, 192), d3.rgb(0, 0, 208),
  // d3.rgb(0, 0, 224), d3.rgb(0, 0, 240), d3.rgb(0, 0, 255), d3.rgb(0, 16, 255), d3.rgb(0, 32, 255), d3.rgb(0, 48, 255),
  // d3.rgb(0, 64, 255), d3.rgb(0, 80, 255), d3.rgb(0, 96, 255), d3.rgb(0, 112, 255), d3.rgb(0, 128, 255), d3.rgb(0, 144, 255),
  // d3.rgb(0, 160, 255), d3.rgb(0, 176, 255), d3.rgb(0, 192, 255), d3.rgb(0, 208, 255), d3.rgb(0, 224, 255), d3.rgb(0, 240, 255),
  // d3.rgb(0, 255, 255), d3.rgb(16, 255, 240), d3.rgb(32, 255, 224), d3.rgb(48, 255, 208), d3.rgb(64, 255, 192), d3.rgb(80, 255, 176),
  // d3.rgb(96, 255, 160), d3.rgb(112, 255, 144), d3.rgb(128, 255, 128), d3.rgb(144, 255, 112), d3.rgb(160, 255, 96), d3.rgb(176, 255, 80),
  // d3.rgb(192, 255, 64), d3.rgb(208, 255, 48), d3.rgb(224, 255, 32), d3.rgb(240, 255, 16), d3.rgb(255, 255, 0), d3.rgb(255, 240, 0),
  // d3.rgb(255, 224, 0), d3.rgb(255, 208, 0), d3.rgb(255, 192, 0), d3.rgb(255, 176, 0), d3.rgb(255, 160, 0), d3.rgb(255, 144, 0),
  // d3.rgb(255, 128, 0), d3.rgb(255, 112, 0), d3.rgb(255, 96, 0), d3.rgb(255, 80, 0), d3.rgb(255, 64, 0), d3.rgb(255, 48, 0),
  // d3.rgb(255, 32, 0), d3.rgb(255, 16, 0), d3.rgb(255, 0, 0), d3.rgb(240, 0, 0), d3.rgb(224, 0, 0), d3.rgb(208, 0, 0), d3.rgb(192, 0, 0),
  // d3.rgb(176, 0, 0), d3.rgb(160, 0, 0), d3.rgb(144, 0, 0), d3.rgb(128, 0, 0)]; // ,
  // // d3.rgb(255,
  // // 255,
  // // 255)];

  // var powerToJetColorScale = d3.scaleLinear()
  // 	.domain([-140, -139, -138, -137, -136, -135, -134, -133, -132, -131, -130, -129, -128, -127, -126, -125, -124, -123,
  // 	-122, -121, -120, -119, -118, -117, -116, -115, -114, -113, -112, -111, -110, -109, -108, -107, -106, -105, -104,
  // 	-103, -102, -101, -100, -99, -98, -97, -96, -95, -94, -93, -92, -91, -90, -89, -88, -87, -86, -85, -84, -83, -82,
  // 	-81, -80, -79, -78, -77, -76, -75, -74, -73, -72, -71, -70]
  // 	)
  // 	.range(colorsJet);

  // var powerToJetColorScale = d3.scaleLinear()
  // .domain([-70, -71, -72, -73, -74, -75, -76, -77, -78, -79, -80, -81,
  // -82, -83, -84, -85, -86, -87, -88, -89, -90, -91, -92, -93, -94,
  // -95, -96, -97, -98, -99, -100, -101, -102, -103, -104, -105, -106,
  // -107, -108, -109, -110, -111, -112, -113, -114, -115,
  // -116, -117, -118, -119, -120, -121, -122, -123, -124, -125, -126,
  // -127, -128, -129, -130, -131, -132, -133, -134, -135,
  // -136, -137, -138, -139, -140]
  // )
  // .range(colorsJet);

  var noTooltipDbmThreshold = -139;

  var graphMargin = {
    top: 11,
    spectrogramsTop: 5,
    topWide: 45,
    left: 75,
    leftRColumn: 10,
    bottom: 20, // with MHz label at the bottom 45
    bottomWide: 25, // with MHz label at the bottom 50
  };

  var graphMarginRRD = {
    top: 11,
    topWide: 45,
    left: 75,
    bottom: 45,
    bottomWide: 50,
  };

  var tdGraphColor = -1;

  var tdGraphColor2Col = {
    a_in: {
      color: "rgb(73, 187, 123)",
      text: "A In",
    },
    a_out: {
      color: "rgb(126, 230, 0)",
      text: "A Out",
    },
    b_in: {
      color: "rgb(177, 68, 30)",
      text: "B In",
    },
    b_out: {
      color: "rgb(234, 143, 0)",
      text: "B Out",
    },
    // c_in: {
    // 	color: 'rgb(255, 85, 118)',
    // 	text: 'C In'
    // },
    // c_out: {
    // 	color: 'rgb(255, 0, 255)',
    // 	text: 'C Out'
    // },
    // d_in: {
    // 	color: 'rgb(161, 80, 170)',
    // 	text: 'D In'
    // },
    // d_out: {
    // 	color: 'rgb(216, 172, 224)',
    // 	text: 'D Out'
    // },
    c_in: {
      color: "rgb(73, 187, 123)",
      text: "C In",
    },
    c_out: {
      color: "rgb(126, 230, 0)",
      text: "C Out",
    },
    d_in: {
      color: "rgb(177, 68, 30)",
      text: "D In",
    },
    d_out: {
      color: "rgb(234, 143, 0)",
      text: "D Out",
    },
    avg_in: {
      color: "rgb(0, 81, 153)",
      text: "Avg In",
    },
    avg_out: {
      color: "rgb(124, 179, 241)",
      text: "Avg Out",
    },
    fdeq_a: {
      color: "rgb(100, 209, 62)",
      text: "Canc. A",
    },
    fdeq_b: {
      color: "rgb(206, 106, 15",
      text: "Canc. B",
    },
    // fdeq_c: {
    // 	color: 'rgb(255, 43, 187)',
    // 	text: 'Canc. C'
    // },
    // fdeq_d: {
    // 	color: 'rgb(189, 126, 197)',
    // 	text: 'Canc. D'
    // },
    fdeq_c: {
      color: "rgb(100, 209, 62)",
      text: "Canc. C",
    },
    fdeq_d: {
      color: "rgb(206, 106, 15",
      text: "Canc. D",
    },
    fdeq_avg: {
      color: "rgb(62,130,197)",
      text: "Canc. AVG",
    },
  };

  var tdGraphColor4Col = {
    a_in: {
      color: "rgb(73, 187, 123)",
      text: "A In",
    },
    a_out: {
      color: "rgb(126, 230, 0)",
      text: "A Out",
    },
    c_in: {
      color: "rgb(177, 68, 30)",
      text: "C In",
    },
    c_out: {
      color: "rgb(234, 143, 0)",
      text: "C Out",
    },
    // c_in: {
    // 	color: 'rgb(255, 85, 118)',
    // 	text: 'C In'
    // },
    // c_out: {
    // 	color: 'rgb(255, 0, 255)',
    // 	text: 'C Out'
    // },
    // d_in: {
    // 	color: 'rgb(161, 80, 170)',
    // 	text: 'D In'
    // },
    // d_out: {
    // 	color: 'rgb(216, 172, 224)',
    // 	text: 'D Out'
    // },
    b_in: {
      color: "rgb(73, 187, 123)",
      text: "B In",
    },
    b_out: {
      color: "rgb(126, 230, 0)",
      text: "B Out",
    },
    d_in: {
      color: "rgb(177, 68, 30)",
      text: "D In",
    },
    d_out: {
      color: "rgb(234, 143, 0)",
      text: "D Out",
    },
    avg_in: {
      color: "rgb(0, 81, 153)",
      text: "Avg In",
    },
    avg_out: {
      color: "rgb(124, 179, 241)",
      text: "Avg Out",
    },
    fdeq_a: {
      color: "rgb(100, 209, 62)",
      text: "Canc. A",
    },
    fdeq_c: {
      color: "rgb(206, 106, 15",
      text: "Canc. C",
    },
    // fdeq_c: {
    // 	color: 'rgb(255, 43, 187)',
    // 	text: 'Canc. C'
    // },
    // fdeq_d: {
    // 	color: 'rgb(189, 126, 197)',
    // 	text: 'Canc. D'
    // },
    fdeq_b: {
      color: "rgb(100, 209, 62)",
      text: "Canc. B",
    },
    fdeq_d: {
      color: "rgb(206, 106, 15",
      text: "Canc. D",
    },
    fdeq_avg: {
      color: "rgb(62,130,197)",
      text: "Canc. AVG",
    },
  };

  var tdGraphLegend = [
    "a_in",
    "fdeq_a",
    "a_out",
    "b_in",
    "fdeq_b",
    "b_out",
    "c_in",
    "fdeq_c",
    "c_out",
    "d_in",
    "fdeq_d",
    "d_out",
    "avg_in",
    "fdeq_avg",
    "avg_out",
  ];

  var SPECTROGRAM_GAP_FILL_THRESHOLD_MSEC = 5 * 60 * 1000;

  var RRD_GRAPH_LABELS_AREA_HEIGHT = 50;
  var RRD_GRAPH_LABELS_Y_OFFSET_BEGIN = 26;
  var RRD_GRAPH_LABELS_Y_OFFSET_NEXT = 20;
  var RRD_GRAPH_LABELS_ICON_SIZE = 12;
  var RRD_GRAPH_LABELS_X_OFFSET_MULTIPLIER = 8;
  var RRD_GRAPH_LABELS_X_OFFSET_MULTIPLIER_BIG = 8;
  var RRD_GRAPH_LABELS_X_VAL_OFFSET = 100;
  var RRD_GRAPH_MIN_MINUTES_FOR_ZOOM = 15;
  var SPECTROGRAMS_GRAPH_MIN_MINUTES_FOR_ZOOM = 15;
  // == Consts

  // ++ Globals
  var globUserData = null;
  var globTreeData = null;

  var globCurrentTab = "";
  var globPrevDateRangeContainingTab = "";
  var globLastTabChangeRequest = "";

  var globCurrentNode = "";
  var globIsSameNodeSelected = false;
  var globIsHighLevelParent = false;

  var globLastNodeChangeRequest = "";
  var globMap = null;
  var globMapMarkers = null;
  var globMapMarkersCurrentMarker = 0;

  var globIgnoredPropegated = [];

  var globIsCreateTree = false;
  var globCheckOpen = false;
  var globIsRenaming = false;
  var globIsManualTreeRefresh = false;

  var globNumCommStatusErrors = 0;

  var globSaveTreeScrollTop = 0;

  // var globServerTime = null;
  var globServerTimezone = null;
  var globCsrfToken = "";

  $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    if (!options.crossDomain && globCsrfToken) {
      jqXHR.setRequestHeader("X-CSRF-Token", globCsrfToken);
    }
  });

  // d3.request calls don't go through jQuery's prefilter.
  var d3Request = d3.request;
  d3.request = function () {
    return d3Request.apply(this, arguments).header("X-CSRF-Token", globCsrfToken);
  };

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  var globLastTimeCheck = null;
  var globLastTreeUpdateTime = null;

  var globTreeUpdateTimer = null;
  var globSpectrogramsUpdateTimer = null;
  var globNodeSearchTimer = null;
  var globResizeTimer = null;

  var dtGraphsSearchTimer = null;

  var globIsNodePadDataChanged = false;
  var globIsAllowNodePadDataDiscard = false;
  var globIsNodePadEntryEdit = false;
  var globNodePadCurrentEntryEdit = "";
  var globNodePadFetchSeq = 0;
  var globNodePadFetchXhr = null;

  var globTreeStatusOverlays = [];
  var globTreeStatusOverlaysReady = false;
  var globTreeStatusOverlaysReadyTimer = null;

  var globGraphRectInlineSpace = 25; // 25
  var globGraphBetweenSpace = 15; // 25

  var globGraphRectInlineSpaceRRD = 25;
  var globGraphBetweenSpaceRRD = 25;

  var globGraphTypeTitle = {
    a_in: "A In",
    a_out: "A Out",
    b_in: "B In",
    b_out: "B Out",
    c_in: "C In",
    c_out: "C Out",
    d_in: "D In",
    d_out: "D Out",
    avg_in: "Avg In",
    avg_out: "Avg Out",
  };

  var globGraph2DTitle = "2D";

  var globIs2DFrozen = false;

  var globIsSpectrogramTimeavgRect = false;
  var globSpectrogramsGraphsZoomDates = [];

  var globIsSpectrogramGotRColumn = false;
  var globIs4AntDevice = false;

  var globSpectrogramGraphTypesArrL = [];
  var globSpectrogramGraphTypesArrR = [];

  var glob2DRectL, glob2DRectR;

  var globRectWidth = 1,
    globRectHeight = 1;

  var globOptixModeGraphs = {
    mode0: {
      color: "green",
      title: "Active (0)",
    },
    mode1: {
      color: "blue",
      title: "Transparent (1)",
    },
    mode2: {
      color: "cyan",
      title: "Transparent (2)",
    },
    mode3: {
      color: "cyan",
      title: "Transparent (3)",
    },
    mode4: {
      color: "purple",
      title: "Bypass (4)",
    },
    mode5: {
      color: "fuchsia",
      title: "Bypass (5)",
    },
    mode6: {
      color: "fuchsia",
      title: "Bypass (6)",
    },
    mode7: {
      color: "fuchsia",
      title: "Bypass (7)",
    },
  };

  /*
   * Class name for an OPTiX link mode, used instead of an inline fill so the
   * colour comes from a CSS token and follows the theme without a redraw.
   * An unknown or missing mode maps to the explicit "na" class rather than
   * falling through to the SVG default of black, which used to read as a real
   * state in light mode and vanish entirely in dark.
   */
  function optixModeClass(modeNumber) {
    return globOptixModeGraphs["mode" + modeNumber]
      ? "optix-mode-" + modeNumber
      : "optix-mode-na";
  }

  var globLinkStatusModeGraphs = {
    status0: {
      color: "yellow",
      title: "Used for common parents only",
    },
    status1: {
      color: "turquoise",
      title: "Status 1",
    },
    status2: {
      color: "slateblue",
      title: "Status 2",
    },
  };

  var globUCUGraphs = [
    {
      name: "UCUTemperature",
      title:
        "Temperature\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0",
      yAxisLabel: "&deg;C",
      temperature: {
        color: "rgb(13, 0, 106)",
        label: "UCU\u00A0\u00A0\u00A0",
        adjustXPos: -28,
        isNewLine: false,
      },
      sfp_temperature: {
        color: "rgb(13, 70, 244)",
        label: "MZN\u00A0\u00A0\u00A0",
        adjustXPos: -28,
        isNewLine: true,
      },
      fa_temperature: {
        color: "rgb(0, 150, 255)",
        label: "FA\u00A0\u00A0\u00A0\u00A0",
        adjustXPos: -28,
        isNewLine: false,
      },
    },
    {
      name: "UCURSSI",
      title:
        "UCU RSSI, RSRP\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0",
      yAxisLabel: "[dBm]",
      modem_rssi: {
        color: "rgb(13, 0, 106)",
        label: "RSSI\u00A0\u00A0\u00A0",
        adjustXPos: -28,
        isNewLine: true,
      },
      modem_rsrp: {
        color: "rgb(13, 70, 244)",
        label: "RSRP\u00A0\u00A0\u00A0",
        adjustXPos: -28,
        isNewLine: true,
      },
    },
    {
      name: "UCURSRQ",
      title:
        "UCU RSRQ\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0",
      yAxisLabel: "[dBm]",
      modem_rsrq: {
        color: "rgb(13, 0, 106)",
        label: "RSRQ\u00A0\u00A0\u00A0",
        adjustXPos: -28,
        isNewLine: true,
      },
    },
  ];

  var globRRDOptixGraphs = [];
  globRRDOptixGraphs["monitoring_a"] = {
    name: "MonitoringA",
    title:
      "Sector Overview: Monitoring\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0",
    yAxisLabel: "",
    line1: {
      color: "rgb(73, 187, 123)",
    },
    line2: {
      color: "rgb(177, 68, 30)",
    },
    line3: {
      color: "rgb(0, 81, 153)",
    },
    line4: {
      color: "rgb(161, 80, 170)",
    },
    line5: {
      color: "rgb(126, 230, 0)",
    },
    line6: {
      color: "rgb(234, 143, 0)",
    },
  };

  var globRRDGraphs = [
    {
      name: "InOutRSSI",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: false,
      titlePrefix: "Sector Overview: ",
      titleSuffix: " Input & Output RSSI",
      yAxisLabel: "[dBm]",
      input_power_channel1: {
        color: "rgb(73, 187, 123)",
        label: "Input Ch 1",
        isNewLine: true,
      },
      input_power_channel2: {
        color: "rgb(177, 68, 30)",
        label: "Input Ch 2",
        isNewLine: true,
      },
      input_power_channel3: {
        color: "rgb(0, 81, 153)",
        label: "Input Ch 3",
        isNewLine: true,
      },
      input_power_channel4: {
        color: "rgb(161, 80, 170)",
        label: "Input Ch 4",
        isNewLine: true,
      },
      output_power_channel1: {
        color: "rgb(126, 230, 0)",
        label: "Output Ch 1",
        isNewLine: false, // true
      },
      output_power_channel2: {
        color: "rgb(234, 143, 0)",
        label: "Output Ch 2",
        isNewLine: false,
      },
      output_power_channel3: {
        color: "rgb(124, 179, 241)",
        label: "Output Ch 3",
        adjustXPos: -8,
        isNewLine: false,
      },
      output_power_channel4: {
        color: "rgb(216, 172, 224)",
        label: "Output Ch 4",
        adjustXPos: -16,
        isNewLine: false,
      },
    },
    {
      name: "Cancellation",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: false,
      titlePrefix: "Sector Overview: ",
      titleSuffix: " Cancellation\u00A0\u00A0\u00A0",
      yAxisLabel: "[db]",
      adjustLegend: 5,
      cancellation_channel1: {
        color: "rgb(126, 230, 0)",
        label: "Cancellation Ch 1",
        isNewLine: false,
      },
      cancellation_channel2: {
        color: "rgb(234, 143, 0)",
        label: "Cancellation Ch 2",
        isNewLine: false,
      },
      cancellation_channel3: {
        color: "rgb(124, 179, 241)",
        label: "Cancellation Ch 3",
        isNewLine: false,
      },
      cancellation_channel4: {
        color: "rgb(216, 172, 224)",
        label: "Cancellation Ch 4",
        isNewLine: false,
      },
    },
    /*		{
          'name' : 'Alarms',
          'title' : 'Sector Overview: Alarms\u00A0\u00A0\u00A0',
          'isGraphPerAnt': false,
          'isGraphForEachAntPair': false,
          'yAxisLabel' : '',
          'isNoValInLegend' : true,
          'alarmNames' : [
            'SERDES_FIFO',
            'FPGA',
            'InPower',
            'DLPLL',
            'ULPLL',
            'Temperature',
            'EXTMEM',
            'LNA',
            'LowInputPower',
            'StrongOOBInterferer',
            'StrongBranchMismatch'
          ],
          'SERDES_FIFO' : {
            'color' : 'rgb(255, 242, 0)',
            'label' : 'SERDES_FIFO',
            'isNewLine' : false,
            'bit' : 9
          },
          'FPGA' : {
            'color' : 'rgb(222, 0, 86)',
            'label' : 'FPGA',
            'isNewLine' : false,
            'bit' : 5
          },
          'InPower' : {
            'color' : 'rgb(175, 236, 237)',
            'label' : 'In Power',
            'isNewLine' : false,
            'bit' : 3
          },
          'DLPLL' : {
            'color' : 'rgb(150, 231, 138)',
            'label' : 'DL PLL',
            'isNewLine' : false,
            'bit' : 2
          },
          'ULPLL' : {
            'color' : 'rgb(68, 68, 255)',
            'label' : 'UL PLL',
            'isNewLine' : false,
            'bit' : 1
          },
          'Temperature' : {
            'color' : 'rgb(21, 116, 25)',
            'label' : 'Temperature',
            'isNewLine' : true,
            'bit' : 0
          },
          'EXTMEM' : {
            'color' : 'rgb(255, 0, 255)',
            'label' : 'EXT_MEM    ',
            'isNewLine' : false,
            'bit' : 8
          },
          'LNA' : {
            'color' : 'rgb(196, 253, 61)',
            'label' : 'LNA ',
            'isNewLine' : false,
            'bit' : 10
          },
          'LowInputPower' : {
            'color' : 'rgb(255, 125, 0)',
            'label' : 'Low Input Power',
            'isNewLine' : false,
            'bit' : 13
          },
          'StrongOOBInterferer' : {
            'color' : 'rgb(255, 85, 118)',
            'label' : 'Strong OOB Interferer',
            'adjustXPos' : -56,
            'isNewLine' : false,
            'bit' : 14
          },
          'StrongBranchMismatch' : {
            'color' : 'rgb(255, 160, 158)',
            'label' : 'Strong Branch Mismatch',
            'adjustXPos' : -16,
            'isNewLine' : false,
            'bit' : 15
          }
        },
    */
    {
      name: "ABInputsRSSI",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: false,
      titlePrefix: "Sector Overview: ",
      titleSuffix: " Inputs RSSI",
      yAxisLabel: "[dBm]",
      input_power_a_channel1: {
        color: "rgb(73, 187, 123)",
        label: "Input A Ch 1",
        isNewLine: false,
      },
      input_power_b_channel1: {
        color: "rgb(177, 68, 30)",
        label: "Input B Ch 1",
        isNewLine: false,
      },
      input_power_c_channel1: {
        color: "rgb(255, 85, 118)",
        label: "Input C Ch 1",
        isNewLine: true,
      },
      input_power_d_channel1: {
        color: "rgb(161, 80, 170)",
        label: "Input D Ch 1",
        isNewLine: false,
      },
      input_power_a_channel2: {
        color: "rgb(177, 68, 30",
        label: "Input A Ch 2",
        isNewLine: false,
      },
      input_power_b_channel2: {
        color: "rgb(234, 143, 0)",
        label: "Input B Ch 2",
        isNewLine: false,
      },
      input_power_c_channel2: {
        color: "rgb(177, 68, 30",
        label: "Input C Ch 2",
        isNewLine: true,
      },
      input_power_d_channel2: {
        color: "rgb(234, 143, 0)",
        label: "Input D Ch 2",
        isNewLine: false,
      },
      input_power_a_channel3: {
        color: "rgb(0, 81, 153)",
        label: "Input A Ch 3",
        isNewLine: false,
      },
      input_power_b_channel3: {
        color: "rgb(124, 179, 241)",
        label: "Input B Ch 3",
        isNewLine: false,
      },
      input_power_c_channel3: {
        color: "rgb(0, 81, 153)",
        label: "Input C Ch 3",
        isNewLine: true,
      },
      input_power_d_channel3: {
        color: "rgb(124, 179, 241)",
        label: "Input D Ch 3",
        isNewLine: false,
      },
      input_power_a_channel4: {
        color: "rgb(161, 80, 170)",
        label: "Input A Ch 4",
        isNewLine: false,
      },
      input_power_b_channel4: {
        color: "rgb(216, 172, 224)",
        label: "Input B Ch 4",
        isNewLine: false,
      },
      input_power_c_channel4: {
        color: "rgb(161, 80, 170)",
        label: "Input C Ch 4",
        isNewLine: true,
      },
      input_power_d_channel4: {
        color: "rgb(216, 172, 224)",
        label: "Input D Ch 4",
        isNewLine: false,
      },
    },
    {
      name: "ABInputsOffset",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: false,
      titlePrefix: "Sector Overview: ",
      titleSuffix: " Inputs Offset",
      yAxisLabel: "[db]",
      adjustLegend: 0,
      input_offset_channel1: {
        color: "rgb(73, 187, 123)",
        label: "Input Offset Level Ch 1",
        isNewLine: false,
      },
      input_offset_channel2: {
        color: "rgb(177, 68, 30",
        label: "Input Offset Level Ch 2",
        isNewLine: false,
      },
      input_offset_channel3: {
        color: "rgb(0, 81, 153)",
        label: "Input Offset Level Ch 3",
        isNewLine: false,
      },
      input_offset_channel4: {
        color: "rgb(161, 80, 170)",
        label: "Input Offset Level Ch 4",
        isNewLine: false,
      },
    },
    {
      name: "ABOutputRSSI",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: false,
      titlePrefix: "Sector Overview: ",
      titleSuffix: " Outputs RSSI",
      yAxisLabel: "[dBm]",
      output_power_a_channel1: {
        color: "rgb(126, 230, 0)",
        label: "Output A Ch 1",
        isNewLine: false,
      },
      output_power_b_channel1: {
        color: "rgb(234, 143, 0)",
        label: "Output B Ch 1",
        isNewLine: false,
      },
      output_power_c_channel1: {
        color: "rgb(255, 0, 255)",
        label: "Output C Ch 1",
        isNewLine: true,
      },
      output_power_d_channel1: {
        color: "rgb(216, 172, 224)",
        label: "Output D Ch 1",
        isNewLine: false,
      },
      output_power_a_channel2: {
        color: "rgb(177, 68, 30",
        label: "Output A Ch 2",
        isNewLine: false,
      },
      output_power_b_channel2: {
        color: "rgb(234, 143, 0)",
        label: "Output B Ch 2",
        isNewLine: false,
      },
      output_power_c_channel2: {
        color: "rgb(177, 68, 30",
        label: "Output C Ch 2",
        isNewLine: true,
      },
      output_power_d_channel2: {
        color: "rgb(234, 143, 0)",
        label: "Output d Ch 2",
        isNewLine: false,
      },
      output_power_a_channel3: {
        color: "rgb(0, 81, 153)",
        label: "Output A Ch 3",
        isNewLine: false,
      },
      output_power_b_channel3: {
        color: "rgb(124, 179, 241)",
        label: "Output B Ch 3",
        isNewLine: false,
      },
      output_power_c_channel3: {
        color: "rgb(0, 81, 153)",
        label: "Output C Ch 3",
        isNewLine: true,
      },
      output_power_d_channel3: {
        color: "rgb(124, 179, 241)",
        label: "Output D Ch 3",
        isNewLine: false,
      },
      output_power_a_channel4: {
        color: "rgb(161, 80, 170)",
        label: "Output A Ch 4",
        isNewLine: false,
      },
      output_power_b_channel4: {
        color: "rgb(216, 172, 224)",
        label: "Output B Ch 4",
        isNewLine: false,
      },
      output_power_c_channel4: {
        color: "rgb(161, 80, 170)",
        label: "Output C Ch 4",
        isNewLine: true,
      },
      output_power_d_channel4: {
        color: "rgb(216, 172, 224)",
        label: "Output D Ch 4",
        isNewLine: false,
      },
    },
    {
      name: "ABOutputsOffset",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: false,
      titlePrefix: "Sector Overview: ",
      titleSuffix: " Outputs Offset",
      yAxisLabel: "[db]",
      output_offset_channel1: {
        color: "rgb(73, 187, 123)",
        label: "Output Offset Level Ch 1",
        isNewLine: false,
      },
      output_offset_channel2: {
        color: "rgb(177, 68, 30",
        label: "Output Offset Level Ch 2",
        isNewLine: false,
      },
      output_offset_channel3: {
        color: "rgb(0, 81, 153)",
        label: "Output Offset Level Ch 3",
        isNewLine: false,
      },
      output_offset_channel4: {
        color: "rgb(161, 80, 170)",
        label: "Output Offset Level Ch 4",
        isNewLine: false,
      },
    },
    {
      name: "AInOutRSSI",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: false,
      titlePrefix: "Sector Overview: ",
      titleSuffix: " Input & Output RSSI",
      title: "Sector Overview: A Input & Output RSSI\u00A0\u00A0\u00A0",
      yAxisLabel: "[dBm]",
      input_power_channel1: {
        color: "rgb(73, 187, 123)",
        label: "Input Ch 1",
        isNewLine: true,
      },
      input_power_channel2: {
        color: "rgb(177, 68, 30)",
        label: "Input Ch 2",
        isNewLine: true,
      },
      input_power_channel3: {
        color: "rgb(0, 81, 153)",
        label: "Input Ch 3",
        isNewLine: true,
      },
      input_power_channel4: {
        color: "rgb(161, 80, 170)",
        label: "Input Ch 4",
        isNewLine: true,
      },
      output_power_channel1: {
        color: "rgb(126, 230, 0)",
        label: "Output Ch 1",
        isNewLine: false, // true
      },
      output_power_channel2: {
        color: "rgb(234, 143, 0)",
        label: "Output Ch 2",
        isNewLine: false,
      },
      output_power_channel3: {
        color: "rgb(124, 179, 241)",
        label: "Output Ch 3",
        adjustXPos: -8,
        isNewLine: false,
      },
      output_power_channel4: {
        color: "rgb(216, 172, 224)",
        label: "Output Ch 4",
        adjustXPos: -16,
        isNewLine: false,
      },
    },
    {
      name: "ACancellation",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: false,
      titlePrefix: "Sector Overview: ",
      titleSuffix: " Cancellation\u00A0\u00A0\u00A0",
      title: "Sector Overview: A Cancellation\u00A0\u00A0\u00A0",
      yAxisLabel: "[db]",
      adjustLegend: 5,
      cancellation_channel1: {
        color: "rgb(126, 230, 0)",
        label: "Cancellation Ch 1",
        isNewLine: false,
      },
      cancellation_channel2: {
        color: "rgb(234, 143, 0)",
        label: "Cancellation Ch 2",
        isNewLine: false,
      },
      cancellation_channel3: {
        color: "rgb(124, 179, 241)",
        label: "Cancellation Ch 3",
        isNewLine: false,
      },
      cancellation_channel4: {
        color: "rgb(216, 172, 224)",
        label: "Cancellation Ch 4",
        isNewLine: false,
      },
    },
    {
      name: "BInOutRSSI",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: false,
      titlePrefix: "Sector Overview: ",
      titleSuffix: " Input & Output RSSI",
      title: "Sector Overview: B Input & Output RSSI\u00A0\u00A0\u00A0",
      yAxisLabel: "[dBm]",
      input_power_channel1: {
        color: "rgb(73, 187, 123)",
        label: "Input Ch 1",
        isNewLine: true,
      },
      input_power_channel2: {
        color: "rgb(177, 68, 30)",
        label: "Input Ch 2",
        isNewLine: true,
      },
      input_power_channel3: {
        color: "rgb(0, 81, 153)",
        label: "Input Ch 3",
        isNewLine: true,
      },
      input_power_channel4: {
        color: "rgb(161, 80, 170)",
        label: "Input Ch 4",
        isNewLine: true,
      },
      output_power_channel1: {
        color: "rgb(126, 230, 0)",
        label: "Output Ch 1",
        isNewLine: false, // true
      },
      output_power_channel2: {
        color: "rgb(234, 143, 0)",
        label: "Output Ch 2",
        isNewLine: false,
      },
      output_power_channel3: {
        color: "rgb(124, 179, 241)",
        label: "Output Ch 3",
        adjustXPos: -8,
        isNewLine: false,
      },
      output_power_channel4: {
        color: "rgb(216, 172, 224)",
        label: "Output Ch 4",
        adjustXPos: -16,
        isNewLine: false,
      },
    },
    {
      name: "BCancellation",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: false,
      titlePrefix: "Sector Overview: ",
      titleSuffix: " Cancellation\u00A0\u00A0\u00A0",
      title: "Sector Overview: B Cancellation\u00A0\u00A0\u00A0",
      yAxisLabel: "[db]",
      adjustLegend: 5,
      cancellation_channel1: {
        color: "rgb(126, 230, 0)",
        label: "Cancellation Ch 1",
        isNewLine: false,
      },
      cancellation_channel2: {
        color: "rgb(234, 143, 0)",
        label: "Cancellation Ch 2",
        isNewLine: false,
      },
      cancellation_channel3: {
        color: "rgb(124, 179, 241)",
        label: "Cancellation Ch 3",
        isNewLine: false,
      },
      cancellation_channel4: {
        color: "rgb(216, 172, 224)",
        label: "Cancellation Ch 4",
        isNewLine: false,
      },
    },
    {
      name: "CInOutRSSI",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: true,
      titlePrefix: "Sector Overview: ",
      titleSuffix: " Input & Output RSSI",
      title: "Sector Overview: C Input & Output RSSI\u00A0\u00A0\u00A0",
      yAxisLabel: "[dBm]",
      input_power_channel1: {
        color: "rgb(73, 187, 123)",
        label: "Input Ch 1",
        isNewLine: true,
      },
      input_power_channel2: {
        color: "rgb(177, 68, 30)",
        label: "Input Ch 2",
        isNewLine: true,
      },
      input_power_channel3: {
        color: "rgb(0, 81, 153)",
        label: "Input Ch 3",
        isNewLine: true,
      },
      input_power_channel4: {
        color: "rgb(161, 80, 170)",
        label: "Input Ch 4",
        isNewLine: true,
      },
      output_power_channel1: {
        color: "rgb(126, 230, 0)",
        label: "Output Ch 1",
        isNewLine: false, // true
      },
      output_power_channel2: {
        color: "rgb(234, 143, 0)",
        label: "Output Ch 2",
        isNewLine: false,
      },
      output_power_channel3: {
        color: "rgb(124, 179, 241)",
        label: "Output Ch 3",
        adjustXPos: -8,
        isNewLine: false,
      },
      output_power_channel4: {
        color: "rgb(216, 172, 224)",
        label: "Output Ch 4",
        adjustXPos: -16,
        isNewLine: false,
      },
    },
    {
      name: "CCancellation",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: true,
      titlePrefix: "Sector Overview: ",
      titleSuffix: " Cancellation\u00A0\u00A0\u00A0",
      title: "Sector Overview: C Cancellation\u00A0\u00A0\u00A0",
      yAxisLabel: "[db]",
      adjustLegend: 5,
      cancellation_channel1: {
        color: "rgb(126, 230, 0)",
        label: "Cancellation Ch 1",
        isNewLine: false,
      },
      cancellation_channel2: {
        color: "rgb(234, 143, 0)",
        label: "Cancellation Ch 2",
        isNewLine: false,
      },
      cancellation_channel3: {
        color: "rgb(124, 179, 241)",
        label: "Cancellation Ch 3",
        isNewLine: false,
      },
      cancellation_channel4: {
        color: "rgb(216, 172, 224)",
        label: "Cancellation Ch 4",
        isNewLine: false,
      },
    },
    {
      name: "DInOutRSSI",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: true,
      titlePrefix: "Sector Overview: ",
      titleSuffix: " Input & Output RSSI",
      title: "Sector Overview: D Input & Output RSSI\u00A0\u00A0\u00A0",
      yAxisLabel: "[dBm]",
      input_power_channel1: {
        color: "rgb(73, 187, 123)",
        label: "Input Ch 1",
        isNewLine: true,
      },
      input_power_channel2: {
        color: "rgb(177, 68, 30)",
        label: "Input Ch 2",
        isNewLine: true,
      },
      input_power_channel3: {
        color: "rgb(0, 81, 153)",
        label: "Input Ch 3",
        isNewLine: true,
      },
      input_power_channel4: {
        color: "rgb(161, 80, 170)",
        label: "Input Ch 4",
        isNewLine: true,
      },
      output_power_channel1: {
        color: "rgb(126, 230, 0)",
        label: "Output Ch 1",
        isNewLine: false, // true
      },
      output_power_channel2: {
        color: "rgb(234, 143, 0)",
        label: "Output Ch 2",
        isNewLine: false,
      },
      output_power_channel3: {
        color: "rgb(124, 179, 241)",
        label: "Output Ch 3",
        adjustXPos: -8,
        isNewLine: false,
      },
      output_power_channel4: {
        color: "rgb(216, 172, 224)",
        label: "Output Ch 4",
        adjustXPos: -16,
        isNewLine: false,
      },
    },
    {
      name: "DCancellation",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: true,
      titlePrefix: "Sector Overview: ",
      titleSuffix: " Cancellation\u00A0\u00A0\u00A0",
      title: "Sector Overview: D Cancellation\u00A0\u00A0\u00A0",
      yAxisLabel: "[db]",
      adjustLegend: 5,
      cancellation_channel1: {
        color: "rgb(126, 230, 0)",
        label: "Cancellation Ch 1",
        isNewLine: false,
      },
      cancellation_channel2: {
        color: "rgb(234, 143, 0)",
        label: "Cancellation Ch 2",
        isNewLine: false,
      },
      cancellation_channel3: {
        color: "rgb(124, 179, 241)",
        label: "Cancellation Ch 3",
        isNewLine: false,
      },
      cancellation_channel4: {
        color: "rgb(216, 172, 224)",
        label: "Cancellation Ch 4",
        isNewLine: false,
      },
    },
  ];

  var globParentSummaryRRDGraphs = [
    {
      isUCU: false,
      graphNames: [
        "InOutRSSI",
        "Cancellation",
        "AInOutRSSI",
        "ACancellation",
        "BInOutRSSI",
        "BCancellation",
        "CInOutRSSI",
        "CCancellation",
        "DInOutRSSI",
        "DCancellation",
      ],
    },
    {
      isUCU: true,
      graphNames: ["UCUTemperature"],
    },
    {
      isUCU: false,
      graphNames: [
        //'Alarms',
        "ABInputsRSSI",
        "ABInputsOffset",
        "ABOutputRSSI",
        "ABOutputsOffset",
      ],
    },
    {
      isUCU: true,
      graphNames: ["UCURSSI", "UCURSRQ"],
    },
  ];

  var globParentSummaryRRDGraphsPhysicalPort = [
    {
      isUCU: false,
      graphNames: [
        "InOutRSSI",
        "Cancellation",
        "AInOutRSSI",
        "ACancellation",
        "BInOutRSSI",
        "BCancellation",
        "CInOutRSSI",
        "CCancellation",
        "DInOutRSSI",
        "DCancellation",
      ],
    },
    {
      isUCU: false,
      graphNames: [
        //'Alarms',
        "ABInputsRSSI",
        "ABInputsOffset",
        "ABOutputRSSI",
        "ABOutputsOffset",
      ],
    },
  ];

  var globRRDPimGraphs = [
    {
      name: "PIMInOutRSSI",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: false,
      titlePrefix: "Suspected PIM: ",
      titleSuffix: " Input & Output RSSI Bin ",
      yAxisLabel: "[dBm]",
      a_in: {
        color: "rgb(73, 187, 123)",
        label: "A In",
        adjustValXPos: 12,
        isNewLine: false,
      },
      b_in: {
        color: "rgb(177, 68, 30)",
        label: "B In",
        adjustXPos: 4,
        adjustValXPos: 12,
        isNewLine: false,
      },
      c_in: {
        color: "rgb(0, 81, 153)",
        label: "C In",
        adjustXPos: 8,
        adjustValXPos: 12,
        isNewLine: false,
      },
      d_in: {
        color: "rgb(161, 80, 170)",
        label: "D In",
        adjustXPos: 12,
        adjustValXPos: 12,
        isNewLine: true,
      },
      a_out: {
        color: "rgb(126, 230, 0)",
        label: "A Out",
        adjustValXPos: 4,
        isNewLine: false, // true
      },
      b_out: {
        color: "rgb(234, 143, 0)",
        label: "B Out",
        adjustXPos: -4,
        adjustValXPos: 4,
        isNewLine: false,
      },
      c_out: {
        color: "rgb(124, 179, 241)",
        label: "C Out",
        adjustXPos: -8,
        adjustValXPos: 4,
        isNewLine: false,
      },
      d_out: {
        color: "rgb(216, 172, 224)",
        label: "D Out",
        adjustXPos: -12,
        adjustValXPos: 4,
        isNewLine: false,
      },
    },
    {
      name: "PIMCancellation",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: false,
      titlePrefix: "Suspected PIM: ",
      titleSuffix: " Cancellation Bin ",
      yAxisLabel: "[db]",
      adjustLegend: 5,
      cancellation_channel1: {
        color: "rgb(126, 230, 0)",
        label: "Cancellation A",
        isNewLine: false,
      },
      cancellation_channel2: {
        color: "rgb(234, 143, 0)",
        label: "Cancellation B",
        isNewLine: false,
      },
      cancellation_channel3: {
        color: "rgb(124, 179, 241)",
        label: "Cancellation C",
        isNewLine: false,
      },
      cancellation_channel4: {
        color: "rgb(216, 172, 224)",
        label: "Cancellation D",
        isNewLine: false,
      },
    },
  ];

  var globRRDPimBinDiffGraphs = [
    {
      name: "PIMBinDiffInOutRSSI",
      isGraphPerAnt: false,
      isGraphForEachAntPair: false,
      is4AntOnly: false,
      titlePrefix: "Suspected PIM: ",
      titleSuffix: " Input & Output RSSI Bin Diff ",
      yAxisLabel: "[dBm]",
      a_in: {
        color: "rgb(73, 187, 123)",
        label: "A In",
        adjustValXPos: 12,
        isNewLine: false,
      },
      b_in: {
        color: "rgb(177, 68, 30)",
        label: "B In",
        adjustXPos: 4,
        adjustValXPos: 12,
        isNewLine: false,
      },
      c_in: {
        color: "rgb(0, 81, 153)",
        label: "C In",
        adjustXPos: 8,
        adjustValXPos: 12,
        isNewLine: false,
      },
      d_in: {
        color: "rgb(161, 80, 170)",
        label: "D In",
        adjustXPos: 12,
        adjustValXPos: 12,
        isNewLine: true,
      },
      a_out: {
        color: "rgb(126, 230, 0)",
        label: "A Out",
        adjustValXPos: 4,
        isNewLine: false, // true
      },
      b_out: {
        color: "rgb(234, 143, 0)",
        label: "B Out",
        adjustXPos: -4,
        adjustValXPos: 4,
        isNewLine: false,
      },
      c_out: {
        color: "rgb(124, 179, 241)",
        label: "C Out",
        adjustXPos: -8,
        adjustValXPos: 4,
        isNewLine: false,
      },
      d_out: {
        color: "rgb(216, 172, 224)",
        label: "D Out",
        adjustXPos: -12,
        adjustValXPos: 4,
        isNewLine: false,
      },
    },
  ];

  var globAjaxRequest = false;

  var globIsParentSummaryRRDGraphs = false;

  var globIsRRDTimeavgRect = false;
  var globRRDGraphsZoomDates = [];

  var globIsUserStrictPassword = false;
  var globIsChangePasswordOK = false;
  var globIsMustChangeTempPassword = false;
  var globIsMustChangeExpiredPassword = false;
  var globIsOtpValidationProcess = false;
  var globIsChangePasswordOtpValidationProcess = false;
  var globIsOtpValidationProcessUserId = -1;

  var globDbmAxisInfo;

  var globOptixModeRectHeight = 5;

  var globTDGraphsLookupForFilter = [];

  var globCurrentGraphObject = null;
  var globCurrentGraphObjectFinalPosIndex = null;
  // var globCurrentRRDGraphsObjectFinalPosIndex = [];
  var globCurrentRRDGraphsObjectLastXPosTimestamp = [];
  var globLastSpectrogramRect = null;
  var globIsSpectrogramKeyboardEvent = false;

  var globTDGraphsHoverElements = null;

  var globNodesInBypass = [];

  var globWebifAdminPassUpdateTimer = null;

  var globDeviceInfoIsEdit = false;
  var globDeviceEditKey = false;
  var globDeviceInfoOriginalText = "";
  var globDeviceInfoIsEditDataChanged = false;

  // ++ Elements
  var $UserName = $("#UserName");
  var $DateTime = $("#DateTime");

  var $LoginWindow = $("#LoginWindow");
  var $LoginChangePasswordWindow = $("#LoginChangePasswordWindow");
  var $LoginButton = $("#LoginButton");
  var $LoginChangePasswordButton = $("#LoginChangePasswordButton");
  var $LogoutButton = $("#LogoutButton");

  var $StatusAreaLabel = $("#StatusAreaLabel");

  var $TreeRefreshButton = $("#TreeRefreshButton");

  var $TreeArea = $("#TreeArea");
  var $TreeAjaxRefresh = $("#TreeAjaxRefresh");

  var $TreeGraph = $("#TreeGraph");

  var $TabGraphs = $("#TabGraphs");
  var $TabGraphsContent = $("#TabGraphsContent");

  var $TabRRDGraphs = $("#TabRRDGraphs");
  var $TabRRDGraphsContent = $("#TabRRDGraphsContent");
  var $TabRRDContentControlsStartDate = $("#TabRRDContentControlsStartDate");
  var $TabRRDContentControlsStartDateIcon = $(
    "#TabRRDContentControlsStartDateIcon"
  );
  var $TabRRDContentControlsEndDate = $("#TabRRDContentControlsEndDate");
  var $TabRRDContentControlsEndDateIcon = $(
    "#TabRRDContentControlsEndDateIcon"
  );
  var $TabRRDContentControlsShowLast = $("#TabRRDContentControlsShowLast");
  var $TabRRDContentControlsPowerFilterToggle = $(
    "#TabRRDContentControlsPowerFilterToggle"
  );
  var $TabRRDContentControlsSuspectedPIMToggle = $(
    "#TabRRDContentControlsSuspectedPimSelectorToggle"
  );
  var $TabRRDContentControlsGo = $("#TabRRDContentControlsGo");
  var $TabRRDContentGraphsContainer = $("#TabRRDContentGraphsContainer");

  var globTabRRDContentGraphsContainerScrollPos = 0;

  var isRRDPreDate = true;
  var RRDGraphsContainerRect,
    RRDNumOfPixelsForTimeAxis,
    RRDSecPerPixel,
    RRDGraphWidth,
    RRDGraphHeight;
  var RRDAxisTooltipElements = [];

  var globalIsRRDPowerFilter = true;
  var globalRRDPowerFilterMinVal = parseInt(
    $("#TabRRDContentControlsPoweFilterMin").val()
  );
  var globalRRDPowerFilterMaxVal = parseInt(
    $("#TabRRDContentControlsPoweFilterMax").val()
  );

  var globalIsRRDSuspectedPim = false;

  var $TabSpectrogram = $("#TabSpectrograms");
  var $TabSpectrogramsContent = $("#TabSpectrogramsContent");
  var $TabSpectrogramsContentControlsStartDate = $(
    "#TabSpectrogramsContentControlsStartDate"
  );
  var $TabSpectrogramsContentControlsStartDateIcon = $(
    "#TabSpectrogramsContentControlsStartDateIcon"
  );
  var $TabSpectrogramsContentControlsEndDate = $(
    "#TabSpectrogramsContentControlsEndDate"
  );
  var $TabSpectrogramsContentControlsEndDateIcon = $(
    "#TabSpectrogramsContentControlsEndDateIcon"
  );
  var $TabSpectrogramsContentControlsShowLast = $(
    "#TabSpectrogramsContentControlsShowLast"
  );
  var $TabSpectrogramsContentControlsPowerFilterToggle = $(
    "#TabSpectrogramsContentControlsPowerFilterToggle"
  );
  var $TabSpectrogramsContentControlsGo = $(
    "#TabSpectrogramsContentControlsGo"
  );
  var $TabSpectrogramsContentGraphsContainer = $(
    "#TabSpectrogramsContentGraphsContainer"
  );

  var isSpectrogramPre = true;
  var spectrogramTooltipElements = [];
  var spectrogramAxisTooltipElements = [];
  var spectrogramTDAxisTooltipElements = [];

  var globalIsSpectrogramsPowerFilter = true;
  var globalSpectrogramsPowerFilterMinVal = parseInt(
    $("#TabSpectrogramsContentControlsPoweFilterMin").val()
  );
  var globalSpectrogramsPowerFilterMaxVal = parseInt(
    $("#TabSpectrogramsContentControlsPoweFilterMax").val()
  );
  // var globalSpectrogramsStartBin;
  // var globalSpectrogramsEndBin;

  var $TabNodePadContentControlsStartDate = $(
    "#TabNodePadContentControlsStartDate"
  );
  var $TabNodePadContentControlsStartDateIcon = $(
    "#TabNodePadContentControlsStartDateIcon"
  );
  var $TabNodePadContentControlsEndDate = $(
    "#TabNodePadContentControlsEndDate"
  );
  var $TabNodePadContentControlsEndDateIcon = $(
    "#TabNodePadContentControlsEndDateIcon"
  );
  var $TabNodePadContentControlsShowLast = $(
    "#TabNodePadContentControlsShowLast"
  );
  var $TabNodePadContentControlsGo = $("#TabNodePadContentControlsGo");

  var isNodePadPreDate = true;

  var graphTitleElements = {
    isInit: false,
    two_d: null,
    a_in: null,
    a_out: null,
    b_in: null,
    b_out: null,
    c_in: null,
    c_out: null,
    d_in: null,
    d_out: null,
    avg_in: null,
    avg_out: null,
  };
  var isWin1TD,
    win1TDType,
    isSpectrogramsWin1Vertical,
    isSpectrogramsWin1Horizontal,
    globColormap;

  var isSpectrogramsCancEnabled, spectrogramsCancTypeName;

  var $TabMap = $("#TabMap");
  var $TabMapContent = $("#TabMapContent");
  var $TabEventL = $("#TabEventL");
  var $TabEventLContent = $("#TabEventLContent");
  var $TabUserAudit = $("#TabUserAudit");
  var $TabUserAuditContent = $("#TabUserAuditContent");
  var $TabReports = $("#TabReports");
  var $TabRemoteM = $("#TabRemoteM");
  var $TabRemoteMContent = $("#TabRemoteMContent");
  var $TabRemoteT = $("#TabRemoteT");
  var $TabDeviceInfo = $("#TabDeviceInfo");
  var $TabDeviceInfoContent = $("#TabDeviceInfoContent");
  var $TabUserM = $("#TabUserM");
  var $TabUserMContent = $("#TabUserMContent");
  var $TabNodePad = $("#TabNodePad");
  var $TabNodePadContent = $("#TabNodePadContent");
  var $TabWebifAdminPassM = $("#TabWebifAdminPassM");
  var $TabWebifAdminPassMContent = $("#TabWebifAdminPassMContent");
  var $TabEmptyContent = $("#TabEmptyContent");

  var $TabOptixMode = $("#TabOptixMode");
  var $TabOptixModeContent = $("#TabOptixModeContent");
  var $TabOptixModeContentControlsStartDate = $(
    "#TabOptixModeContentControlsStartDate"
  );
  var $TabOptixModeContentControlsStartDateIcon = $(
    "#TabOptixModeContentControlsStartDateIcon"
  );
  var $TabOptixModeContentControlsEndDate = $(
    "#TabOptixModeContentControlsEndDate"
  );
  var $TabOptixModeContentControlsEndDateIcon = $(
    "#TabOptixModeContentControlsEndDateIcon"
  );
  var $TabOptixModeContentControlsShowLast = $(
    "#TabOptixModeContentControlsShowLast"
  );
  var $TabOptixModeContentControlsGo = $("#TabOptixModeContentControlsGo");
  var $TabOptixModeContentGraphsContainer = $(
    "#TabOptixModeContentGraphsContainer"
  );

  var isInternalsParentPreDate = true;
  var $TabInternalsContentContainerParentStartDate = $(
    "#TabInternalsContentContainerParentStartDate"
  );
  var $TabInternalsContentContainerParentStartDateIcon = $(
    "#TabInternalsContentContainerParentStartDateIcon"
  );
  var $TabInternalsContentContainerParentEndDate = $(
    "#TabInternalsContentContainerParentEndDate"
  );
  var $TabInternalsContentContainerParentEndDateIcon = $(
    "#TabInternalsContentContainerParentEndDateIcon"
  );
  var $TabInternalsContentContainerParentShowLast = $(
    "#TabInternalsContentContainerParentShowLast"
  );
  var $TabInternalsContentContainerParentGo = $(
    "#TabInternalsContentContainerParentGo"
  );

  var isInternalsParentPreDateCEH = true;
  var $TabInternalsContentContainerParentStartDateCEH = $(
    "#TabInternalsContentContainerParentStartDateCEH"
  );
  var $TabInternalsContentContainerParentStartDateIconCEH = $(
    "#TabInternalsContentContainerParentStartDateIconCEH"
  );
  var $TabInternalsContentContainerParentEndDateCEH = $(
    "#TabInternalsContentContainerParentEndDateCEH"
  );
  var $TabInternalsContentContainerParentEndDateIconCEH = $(
    "#TabInternalsContentContainerParentEndDateIconCEH"
  );
  var $TabInternalsContentContainerParentShowLastCEH = $(
    "#TabInternalsContentContainerParentShowLastCEH"
  );
  var $TabInternalsContentContainerParentGoCEH = $(
    "#TabInternalsContentContainerParentGoCEH"
  );

  var isInternalsParentPreDateTEH = true;
  var $TabInternalsContentContainerParentStartDateTEH = $(
    "#TabInternalsContentContainerParentStartDateTEH"
  );
  var $TabInternalsContentContainerParentStartDateIconTEH = $(
    "#TabInternalsContentContainerParentStartDateIconTEH"
  );
  var $TabInternalsContentContainerParentEndDateTEH = $(
    "#TabInternalsContentContainerParentEndDateTEH"
  );
  var $TabInternalsContentContainerParentEndDateIconTEH = $(
    "#TabInternalsContentContainerParentEndDateIconTEH"
  );
  var $TabInternalsContentContainerParentShowLastTEH = $(
    "#TabInternalsContentContainerParentShowLastTEH"
  );
  var $TabInternalsContentContainerParentGoTEH = $(
    "#TabInternalsContentContainerParentGoTEH"
  );

  var isOptixModePreDate = true;
  var OptixModeGraphsContainerRect,
    OptixModeNumOfPixelsForTimeAxis,
    OptixModeSecPerPixel,
    OptixModeGraphWidth,
    OptixModeGraphHeight;
  var OptixModeAxisTooltipElements = [];

  // ++ Utils Tab

  var $TabUtils = $("#TabUtils");
  var $TabUtilsContent = $("#TabUtilsContent");
  var $TabUtilsContentContainer = $("#TabUtilsContentContainer");

  var $TabUtilsCmdExecBtn = $("#TabUtilsCmdExecBtn");
  var $TabUtilsCmdExecBtnAjaxImage = $(
    "#TabUtilsCmdExecBtnAjaxImage"
  );
  var $TabUtilsCmdSelect = $("#TabUtilsCmdSelect");
  var $TabUtilsCmdsLoadAjaxImage = $(
    "#TabUtilsCmdsLoadAjaxImage"
  );
  var $TabUtilsCmdSelectOutput = $("#TabUtilsCmdSelectOutput");
  var $TabUtilsScriptRunnerIframe = $("#TabUtilsScriptRunnerIframe");
  // == Utils Tab

  // ++ Internals Tab
  var globInternalsSamplesUpdateTimer = null;

  var $TabInternals = $("#TabInternals");
  var $TabInternalsContent = $("#TabInternalsContent");
  var $TabInternalsContentContainer = $("#TabInternalsContentContainer");

  var $TabInternalsGenerateSampleBtn = $("#TabInternalsGenerateSampleBtn");
  var $TabInternalsGenerateSampleAjaxImage = $(
    "#TabInternalsGenerateSampleAjaxImage"
  );

  var $TabInternalsSamplesDownloadBtn = $("#TabInternalsSamplesDownloadBtn");
  var $TabInternalsDownloadSamplesAjaxImage = $(
    "#TabInternalsDownloadSamplesAjaxImage"
  );

  var $TabInternalsSamplesSelect = $("#TabInternalsSamplesSelect");
  var $TabInternalsSamplesLoadAjaxImage = $(
    "#TabInternalsSamplesLoadAjaxImage"
  );

  var $TabInternalsSamplesDeleteCheckbox = $(
    "#TabInternalsSamplesDeleteCheckbox"
  );
  var $TabInternalsSamplesDeleteBtn = $("#TabInternalsSamplesDeleteBtn");
  var $TabInternalsDeleteSamplesAjaxImage = $(
    "#TabInternalsDeleteSamplesAjaxImage"
  );
  // == Internals Tab

  // ++ Paper Tab
  var $TabPaper = $("#TabPaper");
  var $TabPaperContent = $("#TabPaperContent");
  var $TabPaperContentContainer = $("#TabPaperContentContainer");
  var embeddedPaper = null;
  /* The Paper tab's Dropbox credentials used to be literals here. A bundle is
     served to the browser, so a refresh_token and a client_secret sitting in
     this file were readable by anyone who opened DevTools — they are burned
     and must be revoked in the Dropbox console; deleting them here does not
     un-serve what has already gone out.

     The keys are left empty rather than removed so the object still exists
     and the (currently unreachable) Paper code cannot throw on it. Do not
     refill them here. An OAuth client_secret cannot be held in a browser at
     all: the token exchange in the "paper" case below has to move behind a
     PHP endpoint that keeps the secret server-side and hands back only a
     short-lived access token.

     The old values are NOT repeated here, not even commented out. Minifying
     strips comments from main.bundle.js, but the production build also emits
     main.bundle.js.map, which carries this file's original source verbatim
     and is served publicly — so a commented-out secret still reaches the
     browser, just at a less obvious URL. They are not lost: they are in git
     at 9ddeaf5, via `git show 9ddeaf5:src/js/main.js`. The client_id is the
     one to look up if the app needs finding in the Dropbox console. */
  var dropboxAccessData = {
    refresh_token: "",
    client_id: "",
    client_secret: "",
    lastAccessTimestamp: -1,
    token: -1,
  };
  // == Paper Tab

  var $StatusSuccessButton = $("#StatusSuccessButton");
  var $StatusWarningButton = $("#StatusWarningButton");
  var $StatusErrorButton = $("#StatusErrorButton");
  var $StatusCommButton = $("#StatusCommButton");

  var $NodePadEntries = $("#NodePadEntries");
  var $NodePadNewText = $("#NodePadNewText");
  var $NewNodePadEntrySubmit = $("#NewNodePadEntrySubmit");
  var $NewNodePadEntrySubmitImage = $("#NewNodePadEntrySubmitImage");
  var $NodePadTabChangeWindow = $("#NodePadTabChangeWindow");
  var $NodePadTabChangeWindowDoSwitch = $("#NodePadTabChangeWindowDoSwitch");
  var $NodePadNodeChangeWindow = $("#NodePadNodeChangeWindow");
  var $NodePadNodeChangeWindowSwitchDiscard = $(
    "#NodePadNodeChangeWindowSwitchDiscard"
  );
  var $NodePadNodeChangeWindowSwitchKeep = $(
    "#NodePadNodeChangeWindowSwitchKeep"
  );
  var $NodePadTabDeleteEntries = $("#NodePadTabDeleteEntries");
  var $NodePadTabDeleteEntriesDoDelete = $("#NodePadTabDeleteEntriesDoDelete");
  var $NodePadEntryEditWindow = $("#NodePadEntryEditWindow");

  var spectrogramsContentGraphsContainerRect =
    $TabSpectrogramsContentGraphsContainer[0].getBoundingClientRect();
  var numOfSpectrogramsWindows = 1;

  var $SpectrogramWindow1,
    $SpectrogramWin1ControlsContainer,
    $Win1TD,
    $SpectrogramWin1CancContainer,
    $SpectrogramWin1Canc,
    $SpectrogramsWin1Vertical,
    $SpectrogramsWin1Horizontal,
    $SpectrogramWin1GraphSel1,
    $SpectrogramWin1GraphSel2,
    $SpectrogramWin1GraphSel3,
    $SpectrogramWin1GraphSel4,
    $SpectrogramWin2GraphSel1,
    $SpectrogramWin2GraphSel2,
    $SpectrogramWin2GraphSel3,
    $SpectrogramWin2GraphSel4,
    $SpectrogramWin1GraphsContainer,
    $SpectrogramWindow1TDGraph,
    $SpectrogramWindow1TDGraph2,
    $SpectrogramWindow1GraphElements,
    $SpectrogramWindow2GraphElements;
  var spectrogramWindow1Rect, spectrogramWin1GraphsContainerRect;
  var spectrogramWindow1NumOfGraphs,
    spectrogramWindow2NumOfGraphs,
    spectrogramWindow1GraphWidth,
    spectrogramWindow1GraphHeight,
    spectrogramWindow1NumOfPixelsForTimeAxis;
  var spectrogramWindow1SecPerPixel;
  var globTwoColumnsWidthAdjustment;

  var globIsStartdateShowRunning, globIsEnddateShowRunning;
  var globIsStartdateChangeRunning, globIsEnddateChangeRunning;
  var globRRDIsNOPDatesRangeFuncs,
    globSpectrogramsIsNOPDatesRangeFuncs,
    globOptixModeIsNOPDatesRangeFuncs,
    globPIMReportIsNOPDatesRangeFuncs,
    globCEHReportIsNOPDatesRangeFuncs,
    globTEHReportIsNOPDatesRangeFuncs;
  // == Elements

  // ++ Helpers
  function isRootUser() {
    return globUserData.groupName === "root";
  }

  initUserManagement({
    $: $,
    isRootUser: isRootUser,
    $tab: $TabUserM,
  });

  function isMapHistoryUser() {
    return (
      globUserData.groupName === "root" ||
      globUserData.groupName === "Ubiqam" ||
      globUserData.groupName === "ubiqamAdmin" ||
      globUserData.groupName === "dev" ||
      globUserData.groupName === "Danny"
    );
  }

  function isUbiqamUser() {
    return (
      globUserData.groupName === "root" ||
      globUserData.groupName === "Ubiqam" ||
      globUserData.groupName === "ubiqamAdmin" ||
      globUserData.groupName === "dev" ||
      globUserData.groupName === "Danny"
    );
  }

  function isDebug() {
    return IS_DEBUG;
  }

  /*
   * Parses a d3.request response, returning null instead of throwing.
   *
   * d3-request passes a single-argument callback null when the request fails
   * — see fixCallback in lib/d3/d3.js — so every call site parsing
   * data.response directly threw "Cannot read properties of null" the moment
   * the network dropped.
   * The throw landed before the callback's own uiOff() call, which left the
   * tab's spinner up and, on the graph tabs, globAjaxRequest stuck true so
   * later requests were refused. Only a page reload recovered.
   *
   * The parse is guarded too: a PHP fatal or a proxy error page comes back as
   * HTML and threw a SyntaxError here with the same consequences.
   *
   * Every caller already branches on a falsy result, so returning null lets
   * their existing "no data" path clear the UI and report it.
   */
  /*
   * Clamps an SVG rect span to zero.
   *
   * The OPTiX overlay sizes each bar as tScale(next) - tScale(current), but
   * tScale's domain is [end, start] — descending — so that subtraction is
   * only positive while mode_data happens to arrive newest-first. Nothing
   * enforces that order, and when it comes the other way every bar computes
   * negative and the browser rejects the attribute with
   * "<rect> attribute width: A negative value is not valid", once per bar.
   *
   * A rejected attribute leaves the bar at zero size, so clamping renders
   * exactly what renders today and only removes the console noise. It does
   * NOT repair the geometry: bars that come out negative are still not drawn.
   * Fixing that properly means anchoring each rect at the smaller of the two
   * scale positions and using the absolute span, which needs checking against
   * data that actually reproduces the ordering.
   */
  function svgSpan(value) {
    var n = parseFloat(value);

    return isFinite(n) && n > 0 ? n : 0;
  }

  function parseXhrJson(xhr) {
    if (!xhr) return null;

    try {
      return JSON.parse(xhr.response);
    } catch (err) {
      return null;
    }
  }

  function showLoginWindow() {
    $("#LoginOtpCode").val("");
    $("#LoginOtpCodeControl").addClass("hidden");

    $("#LoginUsername").val("");
    $("#LoginUsername").prop("disabled", false);

    $("#LoginPassword").val("");
    $("#LoginPassword").prop("disabled", false);

    $("#LoginButton").prop("disabled", false);
    $LoginChangePasswordButton.prop("disabled", false);

    $LoginWindow.modal({
      keyboard: false,
      backdrop: "static",
    });
  }

  function hideLoginWindow() {
    $LoginWindow.modal("hide");
  }

  function prepareLoginChangePasswordWindow() {
    if (globIsUserStrictPassword) {
      $("#LoginChangePasswordExtendedReq").removeClass("hidden");
    } else {
      $("#LoginChangePasswordExtendedReq").addClass("hidden");
    }

    $("#LoginChangePassword").val("");
    $("#LoginChangePassword").css("border-color", "red");

    $("#LoginChangePasswordVerify").val("");
    $("#LoginChangePasswordVerify").css("border-color", "red");

    setColorWarningOrOk($("#LoginChangePasswordReqLength"), false);

    if (globIsUserStrictPassword) {
      setColorWarningOrOk($("#LoginChangePasswordReqAlpha"), false);
      setColorWarningOrOk($("#LoginChangePasswordReqNumeric"), false);
      setColorWarningOrOk($("#LoginChangePasswordReqSpecial"), false);
      $("#LoginChangePasswordReqUnique").removeClass("text-danger");
    }

    if (globIsMustChangeTempPassword) {
      $("#UserLoginChangePasswordError").text(
        "Temporary password must be changed."
      );
      $("#UserLoginChangePasswordError").removeClass("hidden");

      $("#LoginChangePasswordCancelButton").prop("disabled", true);
    } else if (globIsMustChangeExpiredPassword) {
      $("#UserLoginChangePasswordError").text(
        "Expired password must be changed."
      );
      $("#UserLoginChangePasswordError").removeClass("hidden");

      $("#LoginChangePasswordCancelButton").prop("disabled", true);
    } else {
      $("#UserLoginChangePasswordError").text("");
      $("#LoginChangePasswordCancelButton").prop("disabled", false);
    }
  }

  function showLoginChangePasswordWindow() {
    $LoginChangePasswordWindow.modal({
      keyboard: false,
      backdrop: "static",
    });

    $LoginChangePasswordWindow
      .data("bs.modal")
      .$backdrop.css("background-color", "rgba(0,0,0,0)");
  }

  function hideLoginChangePasswordWindow() {
    $LoginChangePasswordWindow.modal("hide");
  }

  function updateDateTime() {
    var now = new Date();

    if (now - globLastTimeCheck > DATE_TIME_UPODATE_INTERVAL * 2) {
      // Resolve issues that might happen after computer suspend
      // console.log("*** After sleep. Refreshing tree. ***"); // DDD
      globIsCreateTree = false;
      setTreeRefreshInterval();
      createTree();
    }
    // else {
    // console.log('now - globLastTimeCheck: ', now - globLastTimeCheck,
    // '(globLastTimeCheck + (DATE_TIME_UPODATE_INTERVAL * 2)):',
    // (globLastTimeCheck + (DATE_TIME_UPODATE_INTERVAL * 2)), (now -
    // globLastTimeCheck) > (DATE_TIME_UPODATE_INTERVAL * 2));
    // }

    globLastTimeCheck = now;

    var stime = moment.tz(globServerTimezone);
    $DateTime.text(stime.format("ddd, DD MMM YYYY HH:mm z"));
  }

  function isUserRole(role) {
    var isRole = false;

    if (globUserData.role.indexOf(role) > -1) {
      isRole = true;
    }

    return isRole;
  }

  function enableUserTabs() {
    $TabGraphs.addClass("hidden");
    $TabGraphsContent.text("");
    $TabGraphsContent.addClass("hidden");

    if (isUserRole("NewGraphs")) {
      $TabRRDGraphs.removeClass("hidden");
    } else {
      $TabRRDGraphs.addClass("hidden");
    }

    if (isUserRole("Spectrograms")) {
      $TabSpectrogram.removeClass("hidden");
    } else {
      $TabSpectrogram.addClass("hidden");
    }

    if (isUserRole("Remote")) {
      $TabRemoteM.removeClass("hidden");
    } else {
      $TabRemoteM.addClass("hidden");
    }

    if (isUserRole("EventLog")) {
      $TabEventL.removeClass("hidden");
    } else {
      $TabEventL.addClass("hidden");
    }

    if (isUserRole("UserAudit")) {
      $TabUserAudit.removeClass("hidden");
    } else {
      $TabUserAudit.addClass("hidden");
    }

    if (isUserRole("DeviceInfo")) {
      $TabDeviceInfo.removeClass("hidden");
    } else {
      $TabDeviceInfo.addClass("hidden");
    }

    if (isUserRole("MapInfo") && !IS_ON_PREMISE) {
      $TabMap.removeClass("hidden");
    } else {
      $TabMap.addClass("hidden");
    }

    if (isUserRole("NodePad")) {
      $TabNodePad.removeClass("hidden");
    } else {
      $TabNodePad.addClass("hidden");
    }

    if (isRootUser()) {
      $TabUserM.removeClass("hidden");
    } else {
      $TabUserM.addClass("hidden");
    }

    // if (isUbiqamUser()) {
    if (isUserRole("OptixMode")) {
      $TabOptixMode.removeClass("hidden");
    } else {
      $TabOptixMode.addClass("hidden");
    }

    if (isUserRole("Internals")) {
      $TabInternals.removeClass("hidden");
    } else {
      $TabInternals.addClass("hidden");
    }

    if ((isUserRole("Utils")) || (isUbiqamUser())) {
      $TabUtils.removeClass("hidden");
    } else {
      $TabUtils.addClass("hidden");
    }

    // if (isUbiqamUser()) {
    //   $TabPaper.removeClass("hidden");
    // }

    if (isUserRole("Webif Admin User Management")) {
      $TabWebifAdminPassM.removeClass("hidden");
    } else {
      $TabWebifAdminPassM.addClass("hidden");
    }
  }

  function checkSetPrevDateRangeContainingTab(tab) {
    var nodeData = getNodeData(globCurrentNode);

    if (
      tab === "rrdgraphs" ||
      tab === "spectrographs" ||
      tab === "nodepad" ||
      tab === "optixmode" ||
      (tab === "internals" &&
        (isParentGroupNode(nodeData) || isGroupNode(nodeData)))
    ) {
      globPrevDateRangeContainingTab = tab;
    }
  }

  function isHasPrevDateRangeContainingTab(dateControls) {
    var retVal = false;
    if (globPrevDateRangeContainingTab !== "") {
      if (globPrevDateRangeContainingTab === "rrdgraphs") {
        if ($("#TabRRDContentControlsRange").prop("checked")) {
          if (
            $TabRRDContentControlsStartDate.data("DateTimePicker").date() &&
            $TabRRDContentControlsEndDate.data("DateTimePicker").date()
          ) {
            dateControls["startDate"] = $TabRRDContentControlsStartDate;
            dateControls["endDate"] = $TabRRDContentControlsEndDate;

            retVal = true;
          }
        }
      } else if (globPrevDateRangeContainingTab === "spectrographs") {
        if ($("#TabSpectrogramsContentControlsRange").prop("checked")) {
          if (
            $TabSpectrogramsContentControlsStartDate
              .data("DateTimePicker")
              .date() &&
            $TabSpectrogramsContentControlsEndDate.data("DateTimePicker").date()
          ) {
            dateControls["startDate"] =
              $TabSpectrogramsContentControlsStartDate;
            dateControls["endDate"] = $TabSpectrogramsContentControlsEndDate;

            retVal = true;
          }
        }
      } else if (globPrevDateRangeContainingTab === "nodepad") {
        if ($("#TabNodePadContentControlsRange").prop("checked")) {
          if (
            $TabNodePadContentControlsStartDate.data("DateTimePicker").date() &&
            $TabNodePadContentControlsEndDate.data("DateTimePicker").date()
          ) {
            dateControls["startDate"] = $TabNodePadContentControlsStartDate;
            dateControls["endDate"] = $TabNodePadContentControlsEndDate;

            retVal = true;
          }
        }
      } else if (globPrevDateRangeContainingTab === "optixmode") {
        if ($("#TabOptixModeContentControlsRange").prop("checked")) {
          if (
            $TabOptixModeContentControlsStartDate
              .data("DateTimePicker")
              .date() &&
            $TabOptixModeContentControlsEndDate.data("DateTimePicker").date()
          ) {
            dateControls["startDate"] = $TabOptixModeContentControlsStartDate;
            dateControls["endDate"] = $TabOptixModeContentControlsEndDate;

            retVal = true;
          }
        }
      } else if (globPrevDateRangeContainingTab === "internals") {
        if ($("#TabInternalsContentContainerParentRange").prop("checked")) {
          if (
            $TabInternalsContentContainerParentStartDate
              .data("DateTimePicker")
              .date() &&
            $TabInternalsContentContainerParentEndDate
              .data("DateTimePicker")
              .date()
          ) {
            dateControls["startDate"] =
              $TabInternalsContentContainerParentStartDate;
            dateControls["endDate"] =
              $TabInternalsContentContainerParentEndDate;

            retVal = true;
          }
        }
      }
    }

    return retVal;
  }

  function enableTabContent(tab) {
    if (globIsNodePadEntryEdit) {
      $NodePadEntryEditWindow.modal({
        keyboard: false,
        backdrop: "static",
      });

      return false;
    } else if (globDeviceInfoIsEdit) {
      $("#DeviceInfoEntryEditWindow").modal({
        keyboard: false,
        backdrop: "static",
      });

      return false;
    } else if (tab !== globCurrentTab) {
      if (
        globCurrentTab === "nodepad" &&
        globIsNodePadDataChanged &&
        !globIsAllowNodePadDataDiscard
      ) {
        globLastTabChangeRequest = tab;

        $NodePadTabChangeWindow.modal({
          keyboard: false,
          backdrop: "static",
        });
      } else {
        if (globSpectrogramsUpdateTimer) {
          clearTimeout(globSpectrogramsUpdateTimer);
          globSpectrogramsUpdateTimer = null;
        }

        if (globInternalsSamplesUpdateTimer) {
          clearInterval(globInternalsSamplesUpdateTimer);
          globInternalsSamplesUpdateTimer = null;
        }

        if (globInternalsSamplesUpdateTimer) {
          clearTimeout(globWebifAdminPassUpdateTimer);
          globWebifAdminPassUpdateTimer = null;
        }

        globIsAllowNodePadDataDiscard = false;
        globLastTabChangeRequest = "";

        // $('#GraphsPOC').addClass('hidden');
        $TabGraphsContent.addClass("hidden");
        $TabRRDGraphsContent.addClass("hidden");
        $TabSpectrogramsContent.addClass("hidden");
        $TabRemoteMContent.addClass("hidden");
        $TabEventLContent.addClass("hidden");
        $TabUserAuditContent.addClass("hidden");
        $TabDeviceInfoContent.addClass("hidden");
        $TabUserMContent.addClass("hidden");
        $TabMapContent.addClass("hidden");
        $TabNodePadContent.addClass("hidden");
        $TabOptixModeContent.addClass("hidden");
        $TabInternalsContent.addClass("hidden");
        $TabUtilsContent.addClass("hidden");
        $TabUtilsScriptRunnerIframe.attr("src", "about:blank");
        $('a[href="#TabUtilsContentContainerCmdTabContent"]').tab("show");
        $TabPaperContent.addClass("hidden");
        $TabWebifAdminPassMContent.addClass("hidden");

        $TabGraphs.removeClass("active");
        $TabRRDGraphs.removeClass("active");
        $TabSpectrogram.removeClass("active");
        $TabRemoteM.removeClass("active");
        $TabEventL.removeClass("active");
        $TabUserAudit.removeClass("active");
        $TabDeviceInfo.removeClass("active");
        $TabUserM.removeClass("active");
        $TabMap.removeClass("active");
        $TabNodePad.removeClass("active");
        $TabOptixMode.removeClass("active");
        $TabInternals.removeClass("active");
        $TabUtils.removeClass("active");
        $TabPaper.removeClass("active");
        $TabWebifAdminPassM.removeClass("active");

        $TabRemoteMContent.text(""); // clear possible EMS content
        // leftover
        // ++ TD Graphs
        globTabRRDContentGraphsContainerScrollPos = 0;

        if (dtGraphsSearchTimer) {
          clearTimeout(dtGraphsSearchTimer);
        }

        // $('#RRDFilterSearch').val('');
        // == TD Graphs

        globRRDGraphsZoomDates = [];

        if (globCurrentTab !== "") {
          checkSetPrevDateRangeContainingTab(globCurrentTab); // If switching from a tab that has a date range save it for the date range sync feature
        }

        switch (tab) {
          case "graphs":
            globCurrentTab = "graphs";
            $TabGraphs.addClass("active");
            // $TabGraphsContent.text('');
            $TabGraphsContent.removeClass("hidden");

            // $('#GraphsPOC').removeClass('hidden');

            break;
          case "rrdgraphs":
            globCurrentTab = "rrdgraphs";
            $TabRRDGraphs.addClass("active");
            // $TabRRDGraphsContent.text('');
            $TabRRDGraphsContent.removeClass("hidden");

            break;
          case "spectrographs":
            globCurrentTab = "spectrographs";
            $TabSpectrogram.addClass("active");
            // $TabSpectrogramsContent.text('');
            $TabSpectrogramsContent.removeClass("hidden");

            break;
          case "remotem":
            globCurrentTab = "remotem";
            $TabRemoteM.addClass("active");
            $TabRemoteMContent.text("");
            $TabRemoteMContent.removeClass("hidden");

            break;
          case "eventlog":
            globCurrentTab = "eventlog";
            $TabEventL.addClass("active");
            $TabEventLContent.text("");
            $TabEventLContent.removeClass("hidden");

            break;
          case "useraudit":
            globCurrentTab = "useraudit";
            $TabUserAudit.addClass("active");
            $TabUserAuditContent.text("");
            $TabUserAuditContent.removeClass("hidden");

            break;
          case "deviceinfo":
            globCurrentTab = "deviceinfo";
            $TabDeviceInfo.addClass("active");
            $TabDeviceInfoContent.text("");
            $TabDeviceInfoContent.removeClass("hidden");

            break;
          case "userm":
            globCurrentTab = "userm";
            $TabUserM.addClass("active");
            $TabUserMContent.removeClass("hidden");

            break;
          case "mapinfo":
            globCurrentTab = "mapinfo";
            $TabMap.addClass("active");
            $TabMapContent.text("");
            $TabMapContent.removeClass("hidden");

            break;
          case "nodepad":
            globCurrentTab = "nodepad";
            $TabNodePad.addClass("active");
            // $TabNodePadContent.text('');
            $TabNodePadContent.removeClass("hidden");

            break;
          case "optixmode":
            globCurrentTab = "optixmode";
            $TabOptixMode.addClass("active");
            // $TabOptixModeContent.text('');
            $TabOptixModeContent.removeClass("hidden");

            break;
          case "internals":
            globCurrentTab = "internals";
            $TabInternals.addClass("active");
            $TabInternalsContent.removeClass("hidden");

            break;
          case "utils":
            globCurrentTab = "utils";
            $TabUtils.addClass("active");
            $TabUtilsContent.removeClass("hidden");

            break;
          case "paper":
            globCurrentTab = "paper";
            $TabPaper.addClass("active");
            $TabPaperContent.removeClass("hidden");

            break;
          case "remoteadminm":
            globCurrentTab = "remoteadminm";
            $TabWebifAdminPassM.addClass("active");
            $TabWebifAdminPassMContent.removeClass("hidden");

            break;
        }
      }
    }
  }

  /*
   * All four take the result of getNodeData(), which returns null for a
   * physical port node by design — it skips its whole lookup for any id
   * containing "PPort". Every tab handler asks "what kind of node is this?"
   * before deciding what to load, so an unguarded nodeData.id threw
   * "Cannot read properties of null" on all 13 tabs the moment a port node
   * (the ucuNNNN-1..4 rows) was selected and a tab was then clicked.
   *
   * A null node is not any of these kinds, so false is the honest answer and
   * it lets the callers' existing "nothing to show" paths run.
   *
   * act_name is null on container nodes such as Unassigned, so it is checked
   * separately from id rather than assumed to be a string.
   */
  function isUCU(nodeData) {
    if (!nodeData || !nodeData.act_name) {
      return false;
    }

    return (
      nodeData.id.indexOf("un_") == 0 && nodeData.act_name.indexOf("-ucu") != -1
    );
  }

  function isLinkNode(nodeData) {
    if (!nodeData || !nodeData.act_name) {
      return false;
    }

    return (
      nodeData.id.indexOf("un_") == 0 &&
      nodeData.act_name.indexOf("-ucu") === -1
    );
  }

  function isGroupNode(nodeData) {
    if (!nodeData) {
      return false;
    }

    return nodeData.id.indexOf("D_") == 0 && !isPhysicalPortNode(nodeData.id);
  }

  function isParentGroupNode(nodeData) {
    if (!nodeData) {
      return false;
    }

    return nodeData.id.indexOf("L_") == 0;
  }

  function isPhysicalPortNode(id) {
    if (id.indexOf("PPort") != -1) {
      return true;
    } else {
      return false;
    }
  }

  /*
   * Graph titles used act_name (ucu7037 / ucu7037-ucu) which never updates
   * when the tree node is renamed. node_name is the rename; strip the
   * leftover "-ucu" suffix when the operator appended to the original name.
   */
  function formatUcuGraphName(ucuNodeData) {
    if (!ucuNodeData) {
      return "";
    }

    var name = ucuNodeData.node_name || "";
    var act = ucuNodeData.act_name || "";
    var dash = act.indexOf("-");
    var unitId = dash > -1 ? act.substring(0, dash) : act;

    if (name && act && name !== act && name.indexOf(act) === 0) {
      return unitId + name.substring(act.length);
    }

    if (name && name !== act) {
      return name;
    }

    return unitId || name;
  }

  function findUcuNodeDataByDeviceName(deviceName) {
    var found = null;

    if (!deviceName) {
      return null;
    }

    function search(treeData) {
      if (!treeData || !treeData.treeNodesData) {
        return;
      }

      _.forEach(treeData.treeNodesData, function (n) {
        if (
          n &&
          n.act_name &&
          isUCU(n) &&
          n.act_name.indexOf(deviceName + "-") === 0
        ) {
          found = n;
        }
      });
    }

    search(globTreeData);

    if (!found && globTreeData && globTreeData.un) {
      search(globTreeData.un);
    }

    return found;
  }

  function findUcuNodeData(nodeData) {
    if (!nodeData) {
      return null;
    }

    if (isUCU(nodeData)) {
      return nodeData;
    }

    if (nodeData.act_name) {
      var dash = nodeData.act_name.indexOf("-");
      var deviceName =
        dash > -1 ? nodeData.act_name.substring(0, dash) : nodeData.act_name;
      var byName = findUcuNodeDataByDeviceName(deviceName);

      if (byName) {
        return byName;
      }
    }

    return null;
  }

  function getDeviceGraphDisplayName(deviceName) {
    var ucuNode = findUcuNodeDataByDeviceName(deviceName);
    if (ucuNode && ucuNode.parent) {
      var groupNode = getNodeData(ucuNode.parent);
      if (groupNode && groupNode.node_name) {
        return groupNode.node_name;
      }

      var jsParent = $TreeGraph.jstree(true).get_node(ucuNode.parent);
      if (jsParent && jsParent.text) {
        return jsParent.text;
      }
    }

    var selected = getNodeData(globCurrentNode);
    if (
      selected &&
      selected.node_name &&
      deviceName &&
      selected.node_name.indexOf(deviceName) === 0
    ) {
      return selected.node_name;
    }

    var formatted = formatUcuGraphName(ucuNode);
    if (formatted) {
      return formatted;
    }

    return deviceName || "";
  }

  function getGraphNodeTitle(nodeData) {
    var deviceName = "";
    if (nodeData && nodeData.act_name) {
      var dash = nodeData.act_name.indexOf("-");
      deviceName =
        dash > -1 ? nodeData.act_name.substring(0, dash) : nodeData.act_name;
    } else if (nodeData && isGroupNode(nodeData) && nodeData.node_name) {
      return nodeData.node_name;
    }

    var unitName = getDeviceGraphDisplayName(deviceName);

    if (!nodeData || isUCU(nodeData) || isGroupNode(nodeData)) {
      return unitName || (nodeData && nodeData.node_name) || "";
    }

    if (nodeData.node_name) {
      return unitName ? unitName + " " + nodeData.node_name : nodeData.node_name;
    }

    return unitName;
  }

  function portLetterToNumber(portLetter) {
    var portNumber = "NA";

    if (portLetter === "A") {
      portNumber = 2;
    } else if (portLetter === "B") {
      portNumber = 1;
    } else if (portLetter === "C") {
      portNumber = 0;
    } else if (portLetter === "D") {
      portNumber = 3;
    }

    return portNumber;
  }

  function getPresetPeriodSecondsFromSelection(presetPeriodSelection) {
    var presetPeriodSeconds = -1;

    switch (presetPeriodSelection) {
      case "1hour":
        presetPeriodSeconds = 3600;
        break;
      case "2hours":
        presetPeriodSeconds = 7200;
        break;
      case "4hours":
        presetPeriodSeconds = 14400;
        break;
      case "6hours":
        presetPeriodSeconds = 21600;
        break;
      case "12hours":
        presetPeriodSeconds = 43200;
        break;
      case "1day":
        presetPeriodSeconds = 86400;
        break;
      case "3days":
        presetPeriodSeconds = 259200;
        break;
      case "1week":
        presetPeriodSeconds = 604800;
        break;
      case "2weeks":
        presetPeriodSeconds = 1209600;
        break;
      case "1month":
        presetPeriodSeconds = 2419200;
        break;
      case "3months":
        presetPeriodSeconds = 7257600;
        break;
      case "4months":
        presetPeriodSeconds = 9676800;
        break;
    }

    return presetPeriodSeconds;
  }

  function getTimestamp() {
    // Format YYYY-MM-DD_HH-Minutes-Seconds
    // Example "2026-03-25_02-10-21"
    const now = new Date();
    const pad = n => String(n).padStart(2, '0');

    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Jerusalem',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).formatToParts(now);

    const get = type => parts.find(p => p.type === type).value;

    return `${get('year')}-${get('month')}-${get('day')}_${get('hour')}-${get('minute')}-${get('second')}`;
  }
  // == Helpers

  function getNodeData(id) {
    var nodeData = null;

    if (!isPhysicalPortNode(id)) {
      /* The payload differs by user: adminservice only attaches the "un"
         (Unassigned) branch for root, and getTreeData() returns false when its
         start node does not resolve — which a group with a Starting View Node
         can cause. Either way this ran on something that was not an object and
         threw "Cannot read properties of null (reading 'treeNodesData')" as
         soon as a non-root user selected a node. hasOwnProperty("un") did not
         help: the key can be present and still hold null. */
      function findNodeData(treeData) {
        var findNodeData = null;

        if (!treeData) {
          return null;
        }

        _.forEach(treeData.treeNodesData, function (treeNodesData, key) {
          if (treeNodesData.id === id) {
            findNodeData = treeNodesData;
          }
        });

        return findNodeData;
      }

      nodeData = findNodeData(globTreeData);

      if (!nodeData) {
        if (globTreeData && globTreeData.un) {
          nodeData = findNodeData(globTreeData.un);
        }
      }
    }

    return nodeData;
  }

  function getHData(parentId) {
    var nodeData = null;

    if (!isPhysicalPortNode(parentId)) {
      /* Same guard as getNodeData: globTreeData is not guaranteed to be an
         object for every user. */
      function findNodeData(treeData) {
        var findNodeData = null;

        if (!treeData) {
          return null;
        }

        _.forEach(treeData.treeDataH, function (entry, key) {
          if (entry.parent === parentId) {
            findNodeData = entry;
          }
        });

        return findNodeData;
      }

      nodeData = findNodeData(globTreeData);
    }

    return nodeData;
  }

  function isIgnoredNode(id) {
    if (isDebug()) {
      console.log("isIgnoredNode: ", id); // DDD
    }

    var ignoredNodes = globUserData.ignoredNodes
      ? globUserData.ignoredNodes.split(",")
      : [];

    return ignoredNodes.indexOf(id.trim()) > -1;
  }

  function isInheritedIgnoredNode(id) {
    if (isDebug()) {
      console.log("isInheritedIgnoredNode: ", id); // DDD
    }

    var isInheritedIgnore = false;

    var ignoredNodes = globUserData.ignoredNodes
      ? globUserData.ignoredNodes.split(",")
      : [];

    _.forEach(ignoredNodes, function (ignoredNode, key) {
      var nodeChildren = $TreeGraph.jstree("get_node", ignoredNode).children_d;

      _.forEach(nodeChildren, function (nodeChild, key) {
        if (nodeChild === id && !isIgnoredNode(nodeChild)) {
          isInheritedIgnore = true;
        }
      });
    });

    return isInheritedIgnore;
  }

  function isDeletedNode(id) {
    if (isPhysicalPortNode(id)) {
      return false;
    } else {
      var nodeData = getNodeData(id);

      return nodeData.delete === "1";
    }
  }

  function isNodeInBypass(id) {
    if (isPhysicalPortNode(id)) {
      return false;
    } else {
      var nodeData = getNodeData(id);

      return nodeData.isBypass === 1;
    }
  }

  function IsSiblingsWithCommError(id) {
    var siblings = $("#TreeGraph").jstree(
      "get_node",
      $("#TreeGraph").jstree("get_node", id).parent
    ).children;
    var hasSiblingsWithCommError = false;

    _.forEach(siblings, function (sibling, key) {
      if (
        id !== sibling &&
        !(globIgnoredPropegated.indexOf(sibling) > -1) &&
        !isIgnoredNode(sibling) &&
        getNodeData(sibling).communication_status === "1"
      ) {
        if (isDebug()) {
          console.log(
            "IsSiblingsWithCommError: for id = ",
            id,
            ", sibling's id = ",
            sibling,
            "is ignoredprop sib = ",
            globIgnoredPropegated.indexOf(sibling) > -1,
            ", hasSiblingsWithCommError = true"
          ); // DDD
          console.log("globIgnoredPropegated: ", globIgnoredPropegated); // DDD
          console.log(
            "cond: ",
            !(globIgnoredPropegated.indexOf(sibling) > -1) &&
            getNodeData(sibling).communication_status === "1"
          ); // DDD
        }

        hasSiblingsWithCommError = true;
      }
    });

    return hasSiblingsWithCommError;
  }

  function isHas4AntData(nodeData) {
    if (!nodeData) return false;
    return nodeData.is4Ant === "1" ? true : false;
  }

  function isHas4AntGraphType(graphTypes) {
    var retVal = false;

    if (graphTypes) {
      if (
        graphTypes.indexOf("c_in") !== -1 ||
        graphTypes.indexOf("c_out") !== -1 ||
        graphTypes.indexOf("d_in") !== -1 ||
        graphTypes.indexOf("d_out") !== -1
      ) {
        retVal = true;
      }
    }

    return retVal;
  }

  function getNodeIcon(
    id,
    commStatus,
    alarmStatus,
    isInheritedIgnore,
    isChildInBypass
  ) {
    var nodeIcon = "";
    var isDeleted = id === "root" || id === "un" ? false : isDeletedNode(id);
    var isIgnored = isIgnoredNode(id);

    var nodeType = id.trim().substr(0, 1);

    if (isInheritedIgnore) {
      nodeIcon = ICON_ALL_NODE_IGNORED_INHERIT;
    } else {
      switch (nodeType) {
        case "r":
        case "L":
          if (isDeleted) {
            nodeIcon = ICON_V_NODE_DELETED;
          } else if (isIgnored) {
            nodeIcon = ICON_V_NODE_IGNORED;
          } else {
            nodeIcon = ICON_V_NODE;
          }

          break;
        case "D":
          if (isDeleted) {
            nodeIcon = ICON_D_NODE_DELETED;
          } else if (isIgnored) {
            nodeIcon = ICON_D_NODE_IGNORED;
          } else {
            nodeIcon = ICON_D_NODE;
          }

          break;
        case "u":
          if (isDeleted) {
            nodeIcon = ICON_N_NODE_DELETED;
          } else if (isIgnored) {
            nodeIcon = ICON_N_NODE_IGNORED;
          } else {
            nodeIcon = ICON_N_NODE;
          }

          break;
        default:
          // Unrecognized id prefix (e.g. malformed/legacy id): fall back to the
          // generic node icon instead of leaving nodeIcon empty, which used to
          // produce an invalid path like "green.png" (missing "images/" prefix)
          // that 404s and renders as a blank icon in the tree.
          nodeIcon = ICON_N_NODE;

          break;
      }
    }

    // if (isDebug()) {
    // console.log('nodeType: ', id, nodeType); // DDD
    // }

    if (!isIgnored && !isInheritedIgnore && !isDeleted) {
      if (alarmStatus) {
        nodeIcon += alarmStatus;
      } else {
        nodeIcon += "green";
      }

      var isCommStatusError = commStatus === "1" || commStatus === true;

      if (isCommStatusError) {
        nodeIcon += "cross";
      }
    }

    if (
      !isIgnored &&
      !isInheritedIgnore &&
      (isRootUser() || isUserRole("OptixMode"))
    ) {
      if (
        isChildInBypass ||
        (!isCommStatusError && (!alarmStatus || alarmStatus === "green"))
      ) {
        if (isNodeInBypass(id) || isChildInBypass) {
          nodeIcon = nodeIcon + "_bypass";

          if (globNodesInBypass.indexOf(id) === -1) {
            globNodesInBypass.push(id);
          }
        }
      }
    }

    // Safety net: never emit a bare filename (e.g. "green.png") without the
    // "images/" folder — such a path 404s against the current page URL and
    // renders as a blank tree icon instead of falling back to anything visible.
    if (nodeIcon.indexOf("images/") !== 0) {
      nodeIcon = ICON_N_NODE + (nodeIcon || "green");
    }

    nodeIcon += ".svg";

    if (isDebug()) {
      console.log("getNodeIcon: ", id, commStatus, alarmStatus, nodeIcon); // DDD
    }

    return nodeIcon;
  }

  function setNodeIcon(
    id,
    commStatus,
    alarmStatus,
    isInheritedIgnore,
    isChildInBypass
  ) {
    var theIcon = getNodeIcon(
      id,
      commStatus,
      alarmStatus,
      isInheritedIgnore,
      isChildInBypass
    );

    // $('#' + nodeParensts[n] +
    // '>a').find('.jstree-themeicon').css('background-image', 'url(' +
    // theIcon + ')');

    $TreeGraph.jstree("set_icon", id, theIcon);
  }

  function propogateBypassStatus() {
    var nodeParents;
    var parentsInBypass = [];

    globNodesInBypass.forEach(function (nodeId) {
      nodeParents = $TreeGraph.jstree(true).get_node(nodeId).parents;

      nodeParents.forEach(function (parentId) {
        if (parentId != "#" && parentsInBypass.indexOf(parentId) === -1) {
          parentsInBypass.push(parentId);
        }
      });
    });

    var nodesIcon;
    var nodesIconExtension;
    parentsInBypass.forEach(function (parentId) {
      nodesIcon = $TreeGraph.jstree("get_icon", parentId);
      nodesIconExtension = nodesIcon.substr(-4);

      nodesIcon =
        nodesIcon.substr(0, nodesIcon.length - 4) +
        "_bypass" +
        nodesIconExtension;
      $TreeGraph.jstree("set_icon", parentId, nodesIcon);
    });
  }

  function DisplayDeviceStatus() {
    var color;

    _.forOwn(globTreeStatusOverlays, function (statusGroupNode, key) {
      var statusGroupEl = document.getElementById(statusGroupNode.id);
      if (statusGroupEl) {
        color =
          globLinkStatusModeGraphs["status" + statusGroupNode.status].color;

        var statusIconEl = statusGroupEl.querySelector(
          ".jstree-themeicon-custom"
        );
        statusIconEl.style.position = "relative";
        var statusOverlay = document.createElement("i");
        statusOverlay.className = "tree-status-overlay";
        statusOverlay.style.border = "5px solid " + color;
        statusIconEl.appendChild(statusOverlay);
      }
    });
  }

  function propogateDeviceStatus() {
    var nodeParents;
    var parentsForStatus = [];
    var color;

    globTreeStatusOverlays.forEach(function (statusGroupNode) {
      // get_node() returns false when the id isn't in the current tree (e.g.
      // stale status data for a node that no longer exists); skip it instead of
      // dereferencing undefined .parents.
      var statusNode = $TreeGraph.jstree(true).get_node(statusGroupNode.id);
      if (!statusNode) {
        return;
      }
      nodeParents = statusNode.parents;

      nodeParents.forEach(function (parentNodeId) {
        if (
          parentNodeId != "#" &&
          !parentsForStatus.find(
            (parentStatusGroupNode) => parentStatusGroupNode.id === parentNodeId
          )
        ) {
          parentsForStatus.push({
            id: parentNodeId,
            status: statusGroupNode.status,
          });
        } else {
          var indx = parentsForStatus.findIndex(
            (parentStatusGroupNode) => parentStatusGroupNode.id === parentNodeId
          );
          if (indx != -1) {
            if (parentsForStatus[indx].status != statusGroupNode.status) {
              parentsForStatus[indx].status = 0;
            }
          }
        }
      });
    });

    parentsForStatus.forEach(function (parentStatusGroupNode) {
      var statusGroupEl = document.getElementById(parentStatusGroupNode.id);
      if (statusGroupEl) {
        color =
          globLinkStatusModeGraphs["status" + parentStatusGroupNode.status]
            .color;

        var statusIconEl = statusGroupEl.querySelector(
          ".jstree-themeicon-custom"
        );
        statusIconEl.style.position = "relative";
        var statusOverlay = document.createElement("i");
        statusOverlay.className = "tree-status-overlay";
        statusOverlay.style.border = "5px solid " + color;
        statusIconEl.appendChild(statusOverlay);
      }
    });
  }

  function getDeviceLocation(nodeData, nodeParent) {
    var theLocation = null;

    if (nodeData && isUCU(nodeData)) {
      if (parseFloat(nodeData.latitude) && parseFloat(nodeData.longitude)) {
        theLocation = {
          id: nodeData.id,
          node_name: nodeData.node_name,
          alarm_status: nodeData.alarm_status,
          communication_status: nodeData.communication_status,
          lat: parseFloat(nodeData.latitude),
          lng: parseFloat(nodeData.longitude),
        };
      }
    } else {
      var parentTreeData = $TreeGraph.jstree("get_node", nodeParent);

      if (isPhysicalPortNode(parentTreeData.id)) {
        parentTreeData = $TreeGraph.jstree("get_node", parentTreeData.parent);
      }

      _.forEach(parentTreeData.children, function (child, key) {
        if (!isPhysicalPortNode(child)) {
          var childNodeData = getNodeData(child);

          if (isUCU(childNodeData)) {
            if (childNodeData.latitude && childNodeData.longitude) {
              theLocation = {
                id: childNodeData.id,
                node_name: childNodeData.node_name,
                alarm_status: childNodeData.alarm_status,
                communication_status: childNodeData.communication_status,
                lat: parseFloat(childNodeData.latitude),
                lng: parseFloat(childNodeData.longitude),
              };
            }
          }
        }
      });
    }

    return theLocation;
  }

  function getMapMarkerIcon(theLocation) {
    var markerIcon = null;

    if (theLocation.communication_status === "1") {
      switch (theLocation.alarm_status) {
        case "green":
          markerIcon = MARKER_ICON_OK_COMMERR;

          break;
        case "orange":
          markerIcon = MARKER_ICON_WARNING_COMMERR;

          break;
        case "red":
          markerIcon = MARKER_ICON_ERROR_COMMERR;

          break;
      }
    } else {
      switch (theLocation.alarm_status) {
        case "green":
          markerIcon = MARKER_ICON_OK;

          break;
        case "orange":
          markerIcon = MARKER_ICON_WARNING;

          break;
        case "red":
          markerIcon = MARKER_ICON_ERROR;

          break;
      }
    }

    return markerIcon;
  }

  function showTree() {
    // if (isDebug()) {
    // console.log('treeData:', globTreeData); // DDD
    // }

    var moveNodes = {};

    function showATree(treeData) {
      // getTreeData() returns false when its start node isn't in custom_tree
      // (e.g. a stale userViewTree root, or no "un"/Unassigned node for root).
      // Bail out instead of dereferencing a boolean (false.Ancestry ->
      // undefined -> .trim() throws) and aborting the whole tree build.
      if (!treeData || typeof treeData !== "object") {
        return;
      }

      var nodeIcon = "";

      function getTreeDataHParents() {
        var treeDataHParents = [];

        _.forEach(treeData.treeDataH, function (treeDataHNode, key) {
          treeDataHParents.push(treeDataHNode.parent);
        });

        return treeDataHParents;
      }

      function getDetachedNodes(p) {
        if (isDebug()) {
          console.log("Checking detacheds for: ", p); // DDD
        }

        var detachedNodes = [];
        var treeDataHParents;

        if (treeData.hasOwnProperty("treeDataH")) {
          treeDataHParents = getTreeDataHParents();
        } else {
          treeDataHParents = [p];
        }

        _.forEach(treeData.treeNodesData, function (treeNodeData, key) {
          if (
            treeNodeData.parent === p &&
            treeDataHParents.indexOf(treeNodeData.id) === -1
          ) {
            if (isDebug()) {
              console.log(
                "Detached: ",
                treeNodeData,
                treeDataHParents,
                treeDataHParents.indexOf(treeNodeData.id)
              ); // DDD
            }

            detachedNodes.push(treeNodeData.id);
          }
        });

        return detachedNodes;
      }

      // ++ Ancestry: begin tree.
      // Truthy check (not just !== "") so an undefined/null Ancestry - which
      // getTreeData can return for a node - doesn't throw on .trim() and abort
      // the whole tree build.
      if (treeData.Ancestry) {
        var ancestryIds = treeData.Ancestry.trim().split(",");

        ancestryIds.reverse();

        _.forEach(ancestryIds, function (ancestryId, key) {
          if (ancestryId !== "root" && ancestryId !== "un") {
            var aNodeData = getNodeData(ancestryId);

            nodeIcon = getNodeIcon(
              ancestryId,
              aNodeData.communication_status,
              aNodeData.alarm_status
            );

            html +=
              '<li id="' +
              ancestryId +
              '" data-jstree=\'{"icon":"' +
              nodeIcon +
              '"}\' data-treeid="' +
              aNodeData.treeid +
              '" data-pid="' +
              aNodeData.pid +
              '">' +
              aNodeData.node_name +
              "<ul>";
          }
        });
      }
      // == Ancestry: begin tree.

      nodeIcon = getNodeIcon(treeData.id, null);
      var nodeData = getNodeData(treeData.id);

      html +=
        '<li id="' +
        treeData.id +
        '" data-jstree=\'{"icon":"' +
        nodeIcon +
        '"}\' data-treeid="' +
        nodeData.treeid +
        '" data-pid="' +
        nodeData.pid +
        '">' +
        nodeData.node_name;

      html += "<ul>";

      if (treeData.hasOwnProperty("treeDataH")) {
        _.forEach(treeData.treeDataH, function (treeDataHNode, key) {
          if (!isDeletedNode(treeDataHNode.parent) || isRootUser()) {
            var pNodeData = getNodeData(treeDataHNode.parent);
            var isDGroupNode = treeDataHNode.parent.substr(0, 1) == "D";

            nodeIcon = getNodeIcon(
              treeDataHNode.parent,
              pNodeData.communication_status,
              pNodeData.alarm_status
            );

            html +=
              '<li id="' +
              treeDataHNode.parent +
              '" data-jstree=\'{"icon":"' +
              nodeIcon +
              '"}\' data-treeid="' +
              pNodeData.treeid +
              '" data-pid="' +
              pNodeData.pid +
              '">' +
              pNodeData.node_name;

            var childIds = [];
            if (treeDataHNode.ids) {
              childIds = treeDataHNode.ids.split(",");
            }

            if (isDGroupNode) {
              html += "<ul>";

              var ucuChildId = -1;
              var ucuChildNodeData;
              var ucuName = "";

              if (treeDataHNode.ids) {
                _.forEach(childIds, function (childId, key) {
                  var childNodeData = getNodeData(childId);

                  if (isUCU(childNodeData)) {
                    ucuChildId = childId;
                    ucuChildNodeData = getNodeData(ucuChildId);
                  }
                });

                if (ucuChildId != -1) {
                  ucuName = ucuChildNodeData.node_name.substr(
                    0,
                    ucuChildNodeData.node_name.indexOf("-")
                  );
                }
              }

              var parentGroupIcon = nodeIcon;

              for (var physicalPort = 1; physicalPort < 5; ++physicalPort) {
                html +=
                  '<li id="' +
                  treeDataHNode.parent +
                  "PPort" +
                  physicalPort +
                  '" data-jstree=\'{"icon":"' +
                  parentGroupIcon +
                  "\"}'" +
                  ">" +
                  ucuName +
                  "-" +
                  physicalPort;
                html += "<ul>";

                if (treeDataHNode.ids) {
                  var numOfPortChildren = 0;
                  _.forEach(childIds, function (childId, key) {
                    var childNodeData = getNodeData(childId);

                    if (childNodeData.physPort == physicalPort) {
                      ++numOfPortChildren;

                      nodeIcon = getNodeIcon(
                        childId,
                        childNodeData.communication_status,
                        childNodeData.alarm_status
                      );

                      var displayName;
                      if (childNodeData.node_name != childNodeData.act_name) {
                        displayName = childNodeData.node_name
                          .replace(childNodeData.act_name, "")
                          .trim();
                      } else {
                        displayName = childNodeData.node_name;
                      }

                      html +=
                        '<li id="' +
                        childId +
                        '" data-jstree=\'{"icon":"' +
                        nodeIcon +
                        '"}\' data-treeid="' +
                        childNodeData.treeid +
                        '" data-pid="' +
                        childNodeData.pid +
                        '">' +
                        displayName +
                        "</li>";

                      if (isUserRole("Display Status In Tree")) {
                        if (childNodeData.linkStatus != "0") {
                          globTreeStatusOverlays.push({
                            id: childId,
                            status: parseInt(childNodeData.linkStatus),
                          });
                        }
                      }
                    }
                  });

                  /*
                  if (!numOfPortChildren) {
                    var childNodeData = getNodeData(childIds[0]);
                    var placeholderUniqueName = 'placeholder-' + treeDataHNode.parent + '-PPort-' + physicalPort;
                    //html += '<li class="hidden" id="' + placeholderUniqueName + '" data-jstree=\'{"icon":"images/circlegreen.png"}\' data-treeid="' + childIds[0] + '" data-pid="' + childIds[0] + '">Placeholder ' + childNodeData.node_name + '</li>';
                    html += '<li class="hidden" id="' + placeholderUniqueName + '" data-jstree=\'{"icon":"images/circlegreen.svg"}\' data-treeid="' + placeholderUniqueName + '" data-pid="' + placeholderUniqueName + '">' + placeholderUniqueName + '</li>';
                  }
                  */
                }

                html += "</ul>";
                html += "</li>";
              }

              if (treeDataHNode.ids) {
                // UCU node
                if (ucuChildId != -1) {
                  nodeIcon = getNodeIcon(
                    ucuChildId,
                    ucuChildNodeData.communication_status,
                    ucuChildNodeData.alarm_status
                  );

                  html +=
                    '<li id="' +
                    ucuChildId +
                    '" data-jstree=\'{"icon":"' +
                    nodeIcon +
                    '"}\' data-treeid="' +
                    ucuChildNodeData.treeid +
                    '" data-pid="' +
                    ucuChildNodeData.pid +
                    '">' +
                    ucuChildNodeData.node_name +
                    "</li>";
                }
              }

              html += "</ul>";
            } else {
              if (treeDataHNode.ids) {
                html += "<ul>";
                _.forEach(childIds, function (childId, key) {
                  if (!isDeletedNode(childId) || isRootUser()) {
                    var cNodeData = getNodeData(childId);

                    if (isDebug()) {
                      console.log(
                        "To move: ",
                        childId,
                        treeData.treeDataH
                          ? treeDataHNode.parent
                          : "No treeDataH"
                      ); // DDD
                    }

                    if (
                      treeData.treeDataH.findIndex(
                        (el) => el.parent === childId
                      ) === -1
                    ) {
                      var nodeIcon = getNodeIcon(
                        childId,
                        cNodeData.communication_status,
                        cNodeData.alarm_status
                      );

                      html +=
                        '<li id="' +
                        cNodeData.id +
                        '" data-jstree=\'{"icon":"' +
                        nodeIcon +
                        '"}\' data-treeid="' +
                        cNodeData.treeid +
                        '" data-pid="' +
                        cNodeData.pid +
                        '">' +
                        cNodeData.node_name;
                    }

                    moveNodes[childId] = treeData.treeDataH
                      ? treeDataHNode.parent
                      : "No treeDataH";
                  }
                });
                html += "</ul>";
              }
            }

            html += "</li>";
          }
        });
      }

      var detachedNodes = getDetachedNodes(treeData.id);
      // if (isDebug()) {
      // console.log(detachedNodes); // DDD
      // }

      _.forEach(detachedNodes, function (detachedNode, key) {
        if (!isDeletedNode(detachedNode) || isRootUser()) {
          nodeIcon = getNodeIcon(detachedNode);
          var dNodeData = getNodeData(detachedNode);

          html +=
            '<li id="' +
            detachedNode +
            '" data-jstree=\'{"icon":"' +
            nodeIcon +
            '"}\' data-treeid="' +
            dNodeData.treeid +
            '" data-pid="' +
            dNodeData.pid +
            '">' +
            dNodeData.node_name +
            "</li>";
        }
      });

      html += "</ul></li>";

      // ++ Ancestry: close tree.
      if (treeData.Ancestry) {
        nodeIcon = "";
        ancestryIds = treeData.Ancestry.trim().split(",");

        _.forEach(ancestryIds, function (ancestryId, key) {
          html += "</ul></li>";
        });
      }
      // == Ancestry: close tree.
    }

    globNodesInBypass = [];

    var html = "<ul>";

    showATree(globTreeData);

    if (globTreeData.hasOwnProperty("un")) {
      showATree(globTreeData.un);
    }

    html += "</ul>";

    $TreeGraph.html(html);

    globTreeStatusOverlaysReady = true;

    return moveNodes;
  }

  function checkCommStatusTreeNode(id) {
    $TreeGraph.jstree("check_node", id);
  }

  function checkifCommStatusTreeNode(id) {
    if (getNodeData(id).communication_status === "1") {
      checkCommStatusTreeNode(id);
    }
  }

  function checkifPropogateCommStatusTreeNode(id) {
    checkifCommStatusTreeNode(id);

    var nodeData = $TreeGraph.jstree("get_node", id);

    _.forEach(nodeData.children_d, function (child, key) {
      checkifCommStatusTreeNode(child);
    });
  }

  function uncheckCommStatusTreeNode(id) {
    $TreeGraph.jstree("uncheck_node", id);
  }

  function uncheckPropogateCommStatusTreeNode(id) {
    $TreeGraph.jstree("uncheck_node", id);

    var nodeData = $TreeGraph.jstree("get_node", id);

    _.forEach(nodeData.children_d, function (child, key) {
      $TreeGraph.jstree("uncheck_node", child);
    });
  }

  function checkAllCommStatusTreeNodes() {
    function checkNodes(treeNodesData) {
      _.forEach(treeNodesData, function (treeNodeData, key) {
        if (
          treeNodeData.communication_status === "1" &&
          !isIgnoredNode(treeNodeData.id) &&
          !isInheritedIgnoredNode(treeNodeData.id) &&
          !isDeletedNode(treeNodeData.id)
        ) {
          // if (isDebug()) {
          // console.log('checkAllCommStatusTreeNodes: ',
          // treeNodeData, ' is 1'); // DDD
          // }

          $TreeGraph.jstree("check_node", treeNodeData.id);
          ++numOfCommErrors;
        }
      });
    }

    var numOfCommErrors = 0;

    checkNodes(globTreeData.treeNodesData);

    if (globTreeData.hasOwnProperty("un")) {
      checkNodes(globTreeData.un.treeNodesData);
    }

    return numOfCommErrors;
  }

  function propogateTreeIgnoredIcons() {
    var ignoredNodes = globUserData.ignoredNodes
      ? globUserData.ignoredNodes.split(",")
      : [];

    _.forEach(ignoredNodes, function (ignoredNode, key) {
      var nodeChildren = $TreeGraph.jstree("get_node", ignoredNode).children_d;

      _.forEach(nodeChildren, function (nodeChild, key) {
        if (!isIgnoredNode(nodeChild)) {
          globIgnoredPropegated.push(nodeChild);

          setNodeIcon(nodeChild, null, null, true);
        }
      });
    });
  }

  // function unpropogateTreeIgnoredIcons(id) {
  // var nodeChildren = $TreeGraph.jstree('get_node', id).children_d;
  //
  // _.forEach(nodeChildren, function(nodeChild, key) {
  // if (!isIgnoredNode(nodeChild)) {
  // var nodeData = getNodeData(nodeChild);
  // setNodeIcon(nodeChild, nodeData.communication_status,
  // nodeData.alarm_status);
  // }
  // });
  // }

  function propogateAlarmStatus() {
    function getConsolidatedParentIcon(highestAlarmStatus, currentNodeIcon) {
      var currentIsGreen = currentNodeIcon.indexOf("green") > -1;
      var currentIsOrange = currentNodeIcon.indexOf("orange") > -1;

      var newIcon = null;

      switch (highestAlarmStatus) {
        case "orange":
          if (currentIsGreen) {
            newIcon = currentNodeIcon.replace("green", "orange");
          }
          break;
        case "red":
          if (currentIsGreen) {
            newIcon = currentNodeIcon.replace("green", "red");
          } else if (currentIsOrange) {
            newIcon = currentNodeIcon.replace("orange", "red");
          }

          break;
      }

      return newIcon;
    }

    _.forEach(globTreeData.treeDataH, function (treeH, key) {
      if (treeH.parent.substring(0, 2) === "D_") {
        if (
          !isIgnoredNode(treeH.parent) &&
          !isInheritedIgnoredNode(treeH.parent) &&
          !isDeletedNode(treeH.parent)
        ) {
          if (isDebug()) {
            console.log("propogateAlarmStatus: work node = ", treeH.parent); // DDD

            console.log("isIgnoredNode: ", isIgnoredNode(treeH.parent));
            console.log(
              "isInheritedIgnoredNode: ",
              isInheritedIgnoredNode(treeH.parent)
            );
            console.log("isDeletedNode: ", isDeletedNode(treeH.parent));
          }

          var parentTreeData = $TreeGraph.jstree("get_node", treeH.parent);
          // console.log(parentTreeData); // DDD

          var highestAlarmStatus = "green";

          _.forEach(parentTreeData.children_d, function (childId, key) {
            if (!isPhysicalPortNode(childId)) {
              if (
                !isIgnoredNode(childId) &&
                !isInheritedIgnoredNode(childId) &&
                !isDeletedNode(childId)
              ) {
                var childNodeData = getNodeData(childId);

                switch (childNodeData.alarm_status) {
                  case "orange":
                    if (highestAlarmStatus === "green") {
                      highestAlarmStatus = "orange";
                    }
                    break;
                  case "red":
                    if (
                      highestAlarmStatus === "green" ||
                      highestAlarmStatus === "orange"
                    ) {
                      highestAlarmStatus = "red";
                    }
                    break;
                }
              }
            }
          });

          if (highestAlarmStatus !== "green") {
            // console.log('Parnet: ', treeH.parent, '
            // highestAlarmStatus: ', highestAlarmStatus); // DDD

            var newIcon = getConsolidatedParentIcon(
              highestAlarmStatus,
              parentTreeData.icon
            );

            if (newIcon) {
              $TreeGraph.jstree("set_icon", treeH.parent, newIcon);
            }

            _.forEach(parentTreeData.parents, function (parentNode, key) {
              if (parentNode !== "#") {
                // console.log('Checking parentNode: ',
                // parentNode);

                var parentParentTreeData = $TreeGraph.jstree(
                  "get_node",
                  parentNode
                );
                // console.log(parentParentTreeData); DDD

                var newIcon = getConsolidatedParentIcon(
                  highestAlarmStatus,
                  parentParentTreeData.icon
                );

                if (newIcon) {
                  $TreeGraph.jstree("set_icon", parentNode, newIcon);
                }
              }
            });
          }
        }
      }
    });
  }

  function addTreeIgnoredNode(id) {
    if (globUserData.ignoredNodes.length > 0) {
      globUserData.ignoredNodes += "," + id;
    } else {
      globUserData.ignoredNodes = id;
    }
  }

  function removeTreeIgnoredNode(id) {
    if (globUserData.ignoredNodes.indexOf(id) == 0) {
      globUserData.ignoredNodes = globUserData.ignoredNodes.replace(id, "");

      if (globUserData.ignoredNodes.indexOf(",") === 0) {
        globUserData.ignoredNodes = globUserData.ignoredNodes.substr(1);
      }
    } else {
      globUserData.ignoredNodes = globUserData.ignoredNodes.replace(
        "," + id,
        ""
      );
    }
  }

  function collect() {
    var ret = {};
    var len = arguments.length;

    for (var i = 0; i < len; i++) {
      for (var p in arguments[i]) {
        if (arguments[i].hasOwnProperty(p)) {
          ret[p] = arguments[i][p];
        }
      }
    }
    return ret;
  }

  function createUCULocationHistoryPrevControl() {
    var controlButton = document.createElement("button");

    // Set CSS for the control.
    controlButton.style.backgroundColor = "#fff";
    controlButton.style.border = "2px solid #fff";
    controlButton.style.borderRadius = "3px";
    controlButton.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
    controlButton.style.color = "rgb(25,25,25)";
    controlButton.style.cursor = "pointer";
    controlButton.style.fontFamily = "Roboto,Arial,sans-serif";
    controlButton.style.fontSize = "14px";
    controlButton.style.lineHeight = "38px";
    controlButton.style.margin = "8px 0 22px";
    controlButton.style.padding = "0 5px";
    controlButton.style.textAlign = "center";

    controlButton.textContent = "Prev";
    controlButton.title = "Click to select previous location";
    controlButton.type = "button";

    // Setup the click event listeners: simply set the map to Chicago.
    controlButton.addEventListener("click", () => {
      if (globMapMarkersCurrentMarker < globMapMarkers.length - 1) {
        ++globMapMarkersCurrentMarker;
        google.maps.event.trigger(
          globMapMarkers[globMapMarkersCurrentMarker].marker,
          "click"
        );
      }
    });

    return controlButton;
  }

  function createUCULocationHistoryNextControl() {
    var controlButton = document.createElement("button");

    // Set CSS for the control.
    controlButton.style.backgroundColor = "#fff";
    controlButton.style.border = "2px solid #fff";
    controlButton.style.borderRadius = "3px";
    controlButton.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
    controlButton.style.color = "rgb(25,25,25)";
    controlButton.style.cursor = "pointer";
    controlButton.style.fontFamily = "Roboto,Arial,sans-serif";
    controlButton.style.fontSize = "14px";
    controlButton.style.lineHeight = "38px";
    controlButton.style.margin = "8px 0 22px 10px";
    controlButton.style.padding = "0 5px";
    controlButton.style.textAlign = "center";

    controlButton.textContent = "Next";
    controlButton.title = "Click to select next location";
    controlButton.type = "button";

    // Setup the click event listeners: simply set the map to Chicago.
    controlButton.addEventListener("click", () => {
      if (globMapMarkersCurrentMarker > 0) {
        --globMapMarkersCurrentMarker;
        google.maps.event.trigger(
          globMapMarkers[globMapMarkersCurrentMarker].marker,
          "click"
        );
      }
    });

    return controlButton;
  }

  function displayUCULocationHistory(nodeData) {
    enableTabContent("mapinfo");
    $TabMapContent.html("").css("background-color", "white");

    $.post(
      "adminservice.php",
      {
        method: "getUcuLocationHistory",
        childId: nodeData.treeid,
      },
      function (geolocationHistory) {
        if (geolocationHistory) {
          $("#TabMap").tab("show");
          globMapMarkers = [];
          globMapMarkersCurrentMarker = 0;

          globMap = new google.maps.Map($TabMapContent[0], {
            center: {
              lat: geolocationHistory["data"][0].lat,
              lng: geolocationHistory["data"][0].lng,
            },
            zoom: 11, // 1: World, 5: Landmass/continent, 10:
            // City, 15: Streets, 20: Buildings
            draggable: true,
            scaleControl: true,
            fullscreenControl: false,
          });

          var mapBounds = new google.maps.LatLngBounds();

          _.forEach(geolocationHistory["data"], function (aLocation, key) {
            var numOfLocations = geolocationHistory["data"].length;

            var markerIcon;
            if (key === 0) {
              markerIcon = MARKER_ICON_HISTORY_CURRENT;
            } else if (key <= 4 * (numOfLocations / 5)) {
              markerIcon = MARKER_ICON_HISTORY;
            } else {
              markerIcon = MARKER_ICON_HISTORY_OLDEST;
            }

            var animationVal = key === 0 ? google.maps.Animation.BOUNCE : null;
            var labelVal = (-key).toString(); // (-(numOfLocations
            // -
            // key)).toString();

            var marker = new google.maps.Marker({
              map: globMap,
              position: new google.maps.LatLng(aLocation.lat, aLocation.lng),
              icon: {
                url: markerIcon,
              },
              animation: animationVal,
              draggable: true,
              title: labelVal + ": " + aLocation.lastUpdate,
              label: labelVal,
            });

            globMapMarkers.push({
              location: aLocation,
              marker: marker,
            });

            mapBounds.extend(marker.position);

            // ++ Events
            globMap.addListener("click", function () {
              globMap.fitBounds(mapBounds);
            });

            _.forEach(globMapMarkers, function (marker, key) {
              // console.log(marker); // DDD

              google.maps.event.addListener(
                marker.marker,
                "click",
                (function (marker) {
                  return function (e) {
                    globMap.setCenter(marker.marker.getPosition());
                    globMap.setZoom(11);
                  };
                })(marker)
              );
            });
            // == Events
          });

          if (geolocationHistory["data"].length > 1) {
            globMap.fitBounds(mapBounds);
          }

          var centerControlDiv = document.createElement("div");
          var centerControl = createUCULocationHistoryPrevControl();
          centerControlDiv.appendChild(centerControl);

          var centerControl = createUCULocationHistoryNextControl();
          centerControlDiv.appendChild(centerControl);

          globMap.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(
            centerControlDiv
          );
        }
      },
      "json"
    );
  }

  /* The ids of every branch expanded right now, read off the live tree.

     globUserData.openNodes is only what the server had at login and is never
     refreshed, so it cannot be used to restore state across a rebuild. It
     stays the fallback for the first build of the session, when there is no
     tree to read from. */
  function getOpenTreeNodes() {
    var tree = $TreeGraph.jstree(true);

    if (!tree) {
      return globUserData && globUserData.openNodes
        ? globUserData.openNodes.split(",")
        : [];
    }

    var openNodes = [];

    // Flat json comes out depth-first, so parents precede their children and
    // the list can be replayed in this order.
    _.forEach(
      tree.get_json("#", { flat: true, no_data: true }),
      function (node) {
        if (node.state && node.state.opened) {
          openNodes.push(node.id);
        }
      }
    );

    return openNodes;
  }

  /* setTreeOpen.php owns the persisted list, but globUserData is filled in once
     at login, so keep the in-memory copy current as well - it is what
     getOpenTreeNodes() falls back to when the tree is gone. */
  function rememberTreeOpenState(nodeId, isOpen) {
    var openNodes = globUserData.openNodes
      ? globUserData.openNodes.split(",").filter(function (id) {
          return id !== nodeId;
        })
      : [];

    if (isOpen) {
      openNodes.push(nodeId);
    }

    globUserData.openNodes = openNodes.join(",");
  }

  function createTree() {
    if (globIsRenaming || globCheckOpen || globIsCreateTree) {
      return;
    }

    globIsCreateTree = true;
    globTreeStatusOverlaysReady = false;
    globTreeStatusOverlays = [];

    updateLastTreeUpdateTime();

    var currentSelectedNode = globCurrentNode;

    // Has to be read before the rebuild below throws the current tree away.
    var openNodes = getOpenTreeNodes();

    globSaveTreeScrollTop = $TreeArea.scrollTop();

    $TreeGraph.addClass("hidden");
    $TreeAjaxRefresh.removeClass("hidden");

    /* The old tree used to be destroyed here, before the request went out. A
       request that then failed — a dropped connection, DNS not resolving —
       left the sidebar with no tree at all and nothing to rebuild from, since
       destroy() empties the element. The .fail() handler un-hid an empty box.

       Worse, it did not recover. globTreeData still held the previous payload,
       so the next attempt took this branch again and destroyed on top of the
       wreckage; jstree then initialised over the residue and threw
       "Cannot read properties of undefined (reading 'className')" out of its
       own _redraw. Only a page reload cleared it, and the refresh button just
       produced another one of those.

       The teardown now happens in the success path, once there is data to
       replace the tree with. A failed refresh leaves the working tree alone. */
    $.post(
      "adminservice.php",
      {
        method: "getTreeData",
      },
      function (data) {
       try {
        globTreeData = data;
        window.ubid.data.treeData = globTreeData;

        // Tear the previous tree down only now, immediately before rebuilding,
        // and only if one is really instantiated.
        if ($TreeGraph.jstree(true)) {
          $TreeGraph.jstree("destroy");
        }

        var moveNodes = showTree();
        if (isDebug()) {
          console.log("startApp: moveNodes = ", moveNodes); // DDD
        }

        var tree = $TreeGraph.jstree({
          core: {
            animation: 0,
            multiple: false,
            check_callback: function (
              operation,
              node,
              node_parent,
              node_position,
              more
            ) {
              if (isDebug()) {
                console.log(
                  "\ncheck_callback: operation = ",
                  operation,
                  ", node = ",
                  node,
                  ", node_parent = ",
                  node_parent,
                  ", node_position: ",
                  node_position,
                  ", more = ",
                  more
                );
              }

              if (operation === "move_node" && !globIsCreateTree) {
                if (globUserData.role.indexOf("Change Location") !== -1) {
                  // globUserData.edittree can be empty when a group has no
                  // "Starting Edit Node" configured (common for the root
                  // group on a fresh install). get_node("") returns false, and
                  // the checks below would then dereference a missing node and
                  // throw, making every move fail with the red X. Fall back to
                  // the whole tree ("root") so moves stay permitted.
                  var treeEditNode = globUserData.edittree
                    ? $TreeGraph.jstree("get_node", globUserData.edittree)
                    : false;

                  if (!treeEditNode) {
                    treeEditNode = $TreeGraph.jstree("get_node", "root");
                  }

                  // A node dragged out of the "Unassigned" (un) branch is not
                  // part of the editable subtree yet, but root must be able to
                  // assign it into a location. Treat descendants of "un" as
                  // movable sources so the drop persists via moveNode.php.
                  var unRootNode = $TreeGraph.jstree("get_node", "un");
                  var isFromUnassigned =
                    typeof unRootNode !== "undefined" &&
                    unRootNode &&
                    typeof unRootNode.children_d !== "undefined" &&
                    unRootNode.children_d.indexOf(node.id) !== -1;

                  if (
                    typeof treeEditNode.children_d !== "undefined" &&
                    treeEditNode.children_d.indexOf(node.id) == -1 &&
                    !isFromUnassigned
                  ) {
                    return false;
                  }

                  if (
                    typeof more.ref !== "undefined" &&
                    treeEditNode.children_d.indexOf(more.ref.id) == -1
                  ) {
                    if (more.ref.id != treeEditNode.id) {
                      return false;
                    }
                  }

                  if (node_parent.id == "#") {
                    return false;
                  }

                  if (
                    typeof more.ref !== "undefined" &&
                    (more.ref.id.indexOf("un_") == 0 ||
                      more.ref.id.indexOf("D_") > -1)
                  ) {
                    return false;
                  }

                  if (node.id.indexOf("un_") == 0) {
                    return false;
                  }

                  clearTreeRefreshInterval();
                  return true;
                } else {
                  return false;
                }
              }

              return true; // allow all other operations
            },
          },
          plugins: [
            "checkbox",
            "search",
            "contextmenu",
            "sort",
            "dnd",
            "conditionalselect",
          ],
          conditionalselect: function (node, e) {
            // console.log(node, e); // DDD
            if (globDeviceInfoIsEdit) {
              $("#DeviceInfoEntryEditWindow").modal({
                keyboard: false,
                backdrop: "static",
              });

              return false;
            } else if (globIsNodePadEntryEdit) {
              $NodePadEntryEditWindow.modal({
                keyboard: false,
                backdrop: "static",
              });

              return false;
            } else if (
              globCurrentTab === "nodepad" &&
              globIsNodePadDataChanged &&
              !globIsAllowNodePadDataDiscard
            ) {
              globLastNodeChangeRequest = node.id;

              $NodePadNodeChangeWindow.modal({
                keyboard: false,
                backdrop: "static",
              });

              return false;
            } else {
              globIsAllowNodePadDataDiscard = false;

              return true;
            }
          },
          checkbox: {
            tie_selection: false,
            three_state: false,
            cascade: "up+undetermined",
            visible: false,
            whole_node: false,
          },
          search: {
            fuzzy: false,
            show_only_matches: true,
            show_only_matches_children: true,
          },
          // "contextmenu": {
          // "items": function($node) {
          // var tree = $TreeGraph.jstree(true);
          //
          // }
          // }
          contextmenu: {
            items: function ($node) {
              var tree = $TreeGraph.jstree(true);

              var treeEditNode = tree.get_node(globUserData.edittree);

              var nodeData = getNodeData($node.id);

              /* getNodeData() returns null for a physical port node by design —
                 it skips its lookup for any id containing PPort. The Properties
                 submenu reads act_name straight off it to label the entry, so
                 right-clicking one of the ucuNNNN-1..4 rows threw
                 "Cannot read properties of null (reading 'act_name')" before
                 the menu could even be built. Predates the migration; the old
                 site does it too.

                 The node's own tree text is the right label when there is no
                 device record behind it — it is what the user just clicked. */
              var nodeActName = nodeData ? nodeData.act_name : $node.text;

              if (isDebug()) {
                console.log(
                  "contextmenu: editNode: ",
                  treeEditNode,
                  "node: ",
                  $node
                ); // DDD
              }

              if (
                typeof treeEditNode.children_d !== "undefined" &&
                treeEditNode.children_d.indexOf($node.id) == -1 &&
                $node.id != globUserData.edittree
              ) {
                return {};
              }

              var menu = "";

              if (
                $node.id.indexOf("un_") == 0 &&
                $node.id != "root" &&
                $node.id != "un"
              ) {
                // Device node (link or UCU) // $node.text.indexOf("-")>-1||$node.parents.length>=3)
                var isMatDownloadAllowed = false;
                if (isUbiqamUser()) {
                  isMatDownloadAllowed = true;
                }

                // ++ Mat menu
                var matDownloadMenu = {
                  _disabled: true,
                  separator_before: true,
                  separator_after: true,
                  label: "Download Mat Zip",
                };
                if (isMatDownloadAllowed) {
                  matDownloadMenu = {
                    separator_before: true,
                    separator_after: true,
                    label: "Download Mat Zip",
                    action: function (obj) {
                      // console.log($node, nodeData);

                      // No device record behind a physical port node, so there
                      // is nothing to export or delete for it. getNodeData()
                      // returns null there and these fields would throw.
                      if (!nodeData) {
                        return;
                      }

                      if (
                        globCurrentTab !== "spectrographs" &&
                        globCurrentTab !== "rrdgraphs"
                      ) {
                        alert(
                          'Must be in either "TD Graphs" or "Spectrograms" tab!'
                        );
                      } else {
                        var startDate = -1;
                        var endDate = -1;
                        var startDateNY = -1;
                        var endDateNY = -1;
                        var presetPeriod = 0;
                        var isInZoom = false;

                        if (globCurrentTab === "rrdgraphs") {
                          if (globRRDGraphsZoomDates.length) {
                            isInZoom = true;
                          }

                          if (isRRDPreDate && !isInZoom) {
                            presetPeriod = $TabRRDContentControlsShowLast.val();
                          } else {
                            endDate = $TabRRDContentControlsStartDate
                              .data("DateTimePicker")
                              .date();
                            startDate = $TabRRDContentControlsEndDate
                              .data("DateTimePicker")
                              .date();
                          }
                        } else if (globCurrentTab === "spectrographs") {
                          if (globSpectrogramsGraphsZoomDates.length) {
                            isInZoom = true;
                          }

                          if (isSpectrogramPre && !isInZoom) {
                            presetPeriod =
                              $TabSpectrogramsContentControlsShowLast.val();
                          } else {
                            endDate = $TabSpectrogramsContentControlsStartDate
                              .data("DateTimePicker")
                              .date();
                            startDate = $TabSpectrogramsContentControlsEndDate
                              .data("DateTimePicker")
                              .date();
                          }
                        }

                        if (
                          isInZoom ||
                          !(
                            (globCurrentTab === "rrdgraphs" && isRRDPreDate) ||
                            (globCurrentTab === "spectrographs" &&
                              isSpectrogramPre)
                          )
                        ) {
                          if (endDate) {
                            // endDateNY = moment.tz(moment.tz(endDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
                            endDateNY = moment
                              .tz(
                                endDate.format("YYYY-MM-DD HH:mm"),
                                globServerTimezone
                              )
                              .unix();
                          }

                          if (startDate) {
                            // startDateNY = moment.tz(moment.tz(startDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
                            startDateNY = moment
                              .tz(
                                startDate.format("YYYY-MM-DD HH:mm"),
                                globServerTimezone
                              )
                              .unix();
                          }
                        }

                        $.post(
                          "adminservice.php",
                          {
                            method: "getMatZip",
                            nodeNameAct: nodeData.act_name,
                            isUCU: isUCU(nodeData) ? 1 : 0,
                            presetPeriod: presetPeriod
                              ? "last" + presetPeriod
                              : 0,
                            startDate: startDateNY,
                            endDate: endDateNY,
                          },
                          function (retData) {
                            if (retData.isOkay) {
                              var link = document.createElement("a");
                              link.style = "display: none";
                              link.href =
                                window.location.href.substring(
                                  0,
                                  window.location.href.lastIndexOf("/")
                                ) + "/matDownload.php";
                              link.download =
                                retData.unitName +
                                "-ttyS" +
                                retData.unitPortNumber +
                                "-" +
                                retData.endDate +
                                "-" +
                                retData.startDate +
                                ".zip";
                              link.click();
                            }
                          }
                        );
                      }
                    },
                  };
                }
                // == Mat menu

                // ++ Data export menu
                var dataExportMenu = {
                  _disabled: true,
                  separator_before: true,
                  separator_after: true,
                  label: "Download Export Data",
                };
                if (isMatDownloadAllowed) {
                  dataExportMenu = {
                    separator_before: true,
                    separator_after: true,
                    label: "Download Export Data",
                    action: function (obj) {
                      // console.log($node, nodeData);

                      // No device record behind a physical port node, so there
                      // is nothing to export or delete for it. getNodeData()
                      // returns null there and these fields would throw.
                      if (!nodeData) {
                        return;
                      }

                      if (
                        globCurrentTab !== "spectrographs" &&
                        globCurrentTab !== "rrdgraphs"
                      ) {
                        alert(
                          'Must be in either "TD Graphs" or "Spectrograms" tab!'
                        );
                      } else {
                        var startDate = -1;
                        var endDate = -1;
                        var startDateNY = -1;
                        var endDateNY = -1;
                        var presetPeriod = 0;
                        var isInZoom = false;

                        if (globCurrentTab === "rrdgraphs") {
                          if (globRRDGraphsZoomDates.length) {
                            isInZoom = true;
                          }

                          if (isRRDPreDate && !isInZoom) {
                            presetPeriod = $TabRRDContentControlsShowLast.val();
                          } else {
                            endDate = $TabRRDContentControlsStartDate
                              .data("DateTimePicker")
                              .date();
                            startDate = $TabRRDContentControlsEndDate
                              .data("DateTimePicker")
                              .date();
                          }
                        } else if (globCurrentTab === "spectrographs") {
                          if (globSpectrogramsGraphsZoomDates.length) {
                            isInZoom = true;
                          }

                          if (isSpectrogramPre && !isInZoom) {
                            presetPeriod =
                              $TabSpectrogramsContentControlsShowLast.val();
                          } else {
                            endDate = $TabSpectrogramsContentControlsStartDate
                              .data("DateTimePicker")
                              .date();
                            startDate = $TabSpectrogramsContentControlsEndDate
                              .data("DateTimePicker")
                              .date();
                          }
                        }

                        if (
                          isInZoom ||
                          !(
                            (globCurrentTab === "rrdgraphs" && isRRDPreDate) ||
                            (globCurrentTab === "spectrographs" &&
                              isSpectrogramPre)
                          )
                        ) {
                          if (endDate) {
                            // endDateNY = moment.tz(moment.tz(endDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
                            endDateNY = moment
                              .tz(
                                endDate.format("YYYY-MM-DD HH:mm"),
                                globServerTimezone
                              )
                              .unix();
                          }

                          if (startDate) {
                            // startDateNY = moment.tz(moment.tz(startDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
                            startDateNY = moment
                              .tz(
                                startDate.format("YYYY-MM-DD HH:mm"),
                                globServerTimezone
                              )
                              .unix();
                          }
                        }

                        $.post(
                          "adminservice.php",
                          {
                            method: "getUbiviewDataExport",
                            nodeNameAct: nodeData.act_name,
                            isUCU: isUCU(nodeData) ? 1 : 0,
                            presetPeriod: presetPeriod
                              ? "last" + presetPeriod
                              : 0,
                            startDate: startDateNY,
                            endDate: endDateNY,
                          },
                          function (retData) {
                            if (retData.isOkay) {
                              var link = document.createElement("a");
                              link.style = "display: none";
                              link.href =
                                window.location.href.substring(
                                  0,
                                  window.location.href.lastIndexOf("/")
                                ) + "/dataExportDownload.php";
                              // link.download = retData.unitName + "-ttyS" + retData.unitPortNumber + "-" + retData.endDate + "-" + retData.startDate + ".zip";

                              link.download =
                                retData.unitName + "_UbiviewDataExport_" + retData.timeSpan + ".zip";

                              link.click();
                            }
                          }
                        );
                      }
                    },
                  };
                }
                // == Data export menu

                if (
                  globUserData.role.indexOf("Rename") == -1 &&
                  globUserData.role.indexOf("Ignore") == -1
                ) {
                  if (isUserRole("ClearAlarms")) {
                    menu = {
                      "Clear Communication Alarm": {
                        separator_before: true,
                        separator_after: false,
                        label: "Clear Communication Alarm",
                        action: function (obj) {
                          var childId = $("#" + $node.id).attr("data-treeid");

                          $.post(
                            "adminservice.php",
                            {
                              method: "clearCommAlarm",
                              childId: childId,
                              customTreeId: $node.id,
                              nodeDisplayName: $node.text,
                            },
                            function (data) {
                              if (data) {
                                globIsManualTreeRefresh = true;

                                setTreeRefreshInterval();
                                createTree();
                              }
                            },
                            "json"
                          );
                        },
                      },
                      "Clear Alarms": {
                        separator_before: false,
                        separator_after: true,
                        label: "Clear Alarms",
                        action: function (obj) {
                          // console.log($node); //
                          // DDD

                          var childId = $("#" + $node.id).attr("data-treeid");

                          $.post(
                            "adminservice.php",
                            {
                              method: "clearAlarms",
                              childId: childId,
                              customTreeId: $node.id,
                              nodeDisplayName: $node.text,
                            },
                            function (data) {
                              if (data) {
                                globIsManualTreeRefresh = true;

                                setTreeRefreshInterval();
                                createTree();
                              }
                            },
                            "json"
                          );
                        },
                      },
                    };

                    if (isMapHistoryUser()) {
                      if (isUCU(nodeData)) {
                        menu = collect(menu, {
                          "UCU Location History": {
                            separator_before: false,
                            separator_after: true,
                            label: "UCU Location History",
                            action: function (obj) {
                              displayUCULocationHistory(nodeData);
                            },
                          },
                        });
                      }
                    }

                    if (isMatDownloadAllowed) {
                      menu = collect(
                        menu,
                        {
                          MatZipFile: matDownloadMenu,
                        },
                        {
                          DataExportFile: dataExportMenu,
                        },
                        {
                          Properties: {
                            separator_before: false,
                            separator_after: false,
                            label: "Properties",
                            submenu: {
                              act: {
                                separator_before: false,
                                separator_after: false,
                                label: "" + nodeActName,
                              },
                            },
                          },
                        }
                      );
                    } else {
                      menu = collect(menu, {
                        Properties: {
                          separator_before: false,
                          separator_after: false,
                          label: "Properties",
                          submenu: {
                            act: {
                              separator_before: false,
                              separator_after: false,
                              label: "" + nodeActName,
                            },
                          },
                        },
                      });
                    }

                    return menu;
                  } else {
                    menu = {};

                    if (isMapHistoryUser()) {
                      if (isUCU(nodeData)) {
                        menu = collect(menu, {
                          "UCU Location History": {
                            separator_before: false,
                            separator_after: true,
                            label: "UCU Location History",
                            action: function (obj) {
                              displayUCULocationHistory(nodeData);
                            },
                          },
                        });
                      }
                    }

                    if (isMatDownloadAllowed) {
                      menu = collect(
                        menu,
                        {
                          MatZipFile: matDownloadMenu,
                        },
                        {
                          DataExportFile: dataExportMenu,
                        },
                        {
                          Properties: {
                            separator_before: false,
                            separator_after: false,
                            label: "Properties",
                            submenu: {
                              act: {
                                separator_before: false,
                                separator_after: false,
                                label: "" + nodeActName,
                              },
                            },
                          },
                        }
                      );
                    } else {
                      menu = collect(menu, {
                        Properties: {
                          separator_before: false,
                          separator_after: false,
                          label: "Properties",
                          submenu: {
                            act: {
                              separator_before: false,
                              separator_after: false,
                              label: "" + nodeActName,
                            },
                          },
                        },
                      });
                    }

                    return menu;
                  }
                }

                if (globUserData.role.indexOf("Ignore") == -1) {
                  if (isUserRole("ClearAlarms")) {
                    menu = {
                      Rename: {
                        separator_before: false,
                        separator_after: false,
                        label: "Rename",
                        action: function (obj) {
                          globIsRenaming = true;
                          clearTreeRefreshInterval();

                          tree.edit($node);
                        },
                      },
                      "Clear Communication Alarm": {
                        separator_before: true,
                        separator_after: false,
                        label: "Clear Communication Alarm",
                        action: function (obj) {
                          var childId = $("#" + $node.id).attr("data-treeid");

                          $.post(
                            "adminservice.php",
                            {
                              method: "clearCommAlarm",
                              childId: childId,
                              customTreeId: $node.id,
                              nodeDisplayName: $node.text,
                            },
                            function (data) {
                              if (data) {
                                globIsManualTreeRefresh = true;

                                setTreeRefreshInterval();
                                createTree();
                              }
                            },
                            "json"
                          );
                        },
                      },
                      "Clear Alarms": {
                        separator_before: false,
                        separator_after: true,
                        label: "Clear Alarms",
                        action: function (obj) {
                          // console.log($node); //
                          // DDD

                          var childId = $("#" + $node.id).attr("data-treeid");

                          $.post(
                            "adminservice.php",
                            {
                              method: "clearAlarms",
                              childId: childId,
                              customTreeId: $node.id,
                              nodeDisplayName: $node.text,
                            },
                            function (data) {
                              if (data) {
                                globIsManualTreeRefresh = true;

                                setTreeRefreshInterval();
                                createTree();
                              }
                            },
                            "json"
                          );
                        },
                      },
                    };

                    if (isRootUser()) {
                      if (isUCU(nodeData)) {
                        menu = collect(menu, {
                          "UCU Location History": {
                            separator_before: false,
                            separator_after: true,
                            label: "UCU Location History",
                            action: function (obj) {
                              displayUCULocationHistory(nodeData);
                            },
                          },
                        });
                      }
                    }

                    if (isMatDownloadAllowed) {
                      menu = collect(
                        menu,
                        {
                          MatZipFile: matDownloadMenu,
                        },
                        {
                          DataExportFile: dataExportMenu,
                        },
                        {
                          Properties: {
                            separator_before: false,
                            separator_after: false,
                            label: "Properties",
                            submenu: {
                              act: {
                                separator_before: false,
                                separator_after: false,
                                label: "" + nodeActName,
                              },
                            },
                          },
                        }
                      );
                    } else {
                      menu = collect(menu, {
                        Properties: {
                          separator_before: false,
                          separator_after: false,
                          label: "Properties",
                          submenu: {
                            act: {
                              separator_before: false,
                              separator_after: false,
                              label: "" + nodeActName,
                            },
                          },
                        },
                      });
                    }

                    return menu;
                  } else {
                    menu = {
                      Rename: {
                        separator_before: false,
                        separator_after: false,
                        label: "Rename",
                        action: function (obj) {
                          globIsRenaming = true;
                          clearTreeRefreshInterval();

                          tree.edit($node);
                        },
                      },
                    };

                    if (isMapHistoryUser()) {
                      if (isUCU(nodeData)) {
                        menu = collect(menu, {
                          "UCU Location History": {
                            separator_before: false,
                            separator_after: true,
                            label: "UCU Location History",
                            action: function (obj) {
                              displayUCULocationHistory(nodeData);
                            },
                          },
                        });
                      }
                    }

                    if (isMatDownloadAllowed) {
                      menu = collect(
                        menu,
                        {
                          MatZipFile: matDownloadMenu,
                        },
                        {
                          DataExportFile: dataExportMenu,
                        },
                        {
                          Properties: {
                            separator_before: false,
                            separator_after: false,
                            label: "Properties",
                            submenu: {
                              act: {
                                separator_before: false,
                                separator_after: false,
                                label: "" + nodeActName,
                              },
                            },
                          },
                        }
                      );
                    } else {
                      menu = collect(menu, {
                        Properties: {
                          separator_before: false,
                          separator_after: false,
                          label: "Properties",
                          submenu: {
                            act: {
                              separator_before: false,
                              separator_after: false,
                              label: "" + nodeActName,
                            },
                          },
                        },
                      });
                    }

                    return menu;
                  }
                }

                if (isUserRole("ClearAlarms")) {
                  menu = {
                    Rename: {
                      separator_before: false,
                      separator_after: false,
                      label: "Rename",
                      action: function (obj) {
                        globIsRenaming = true;
                        clearTreeRefreshInterval();

                        tree.edit($node);
                      },
                    },
                    Ignore: {
                      separator_before: false,
                      separator_after: false,
                      label:
                        (globUserData.ignoredNodes.indexOf($node.id) == 0 ||
                          globUserData.ignoredNodes.indexOf("," + $node.id) > -1
                          ? "Remove "
                          : "") + "Ignore",
                      action: function (obj) {
                        $.post(
                          "setIgnore.php",
                          {
                            node: $node.id,
                            ignore: globUserData.ignoredNodes.indexOf($node.id),
                          },
                          function (result) {
                            if (isDebug()) {
                              console.log("Ignore result: ", result); // DDD
                            }

                            if (
                              globUserData.ignoredNodes.indexOf($node.id) ==
                              0 ||
                              globUserData.ignoredNodes.indexOf(
                                "," + $node.id
                              ) > -1
                            ) {
                              removeTreeIgnoredNode($node.id);
                              // setNodeIcon($node.id,
                              // nodeData.communication_status
                              // ||
                              // $TreeGraph.jstree('is_undetermined',
                              // $node.id));

                              // unpropogateTreeIgnoredIcons($node.id);
                              // checkifPropogateCommStatusTreeNode($node.id);
                            } else {
                              addTreeIgnoredNode($node.id);
                              // setNodeIcon($node.id);

                              // propogateTreeIgnoredIcons();
                              // uncheckPropogateCommStatusTreeNode($node.id);
                            }

                            createTree();

                            // $TreeGraph.jstree('deselect_all');
                            $TreeGraph.jstree(
                              "select_node",
                              globCurrentNode,
                              false
                            );
                          }
                        );
                      },
                    },
                    "Clear Communication Alarm": {
                      separator_before: true,
                      separator_after: false,
                      label: "Clear Communication Alarm",
                      action: function (obj) {
                        var childId = $("#" + $node.id).attr("data-treeid");

                        $.post(
                          "adminservice.php",
                          {
                            method: "clearCommAlarm",
                            childId: childId,
                            customTreeId: $node.id,
                            nodeDisplayName: $node.text,
                          },
                          function (data) {
                            if (data) {
                              globIsManualTreeRefresh = true;

                              setTreeRefreshInterval();
                              createTree();
                            }
                          },
                          "json"
                        );
                      },
                    },
                    "Clear Alarms": {
                      separator_before: false,
                      separator_after: true,
                      label: "Clear Alarms",
                      action: function (obj) {
                        // console.log($node); // DDD

                        var childId = $("#" + $node.id).attr("data-treeid");

                        $.post(
                          "adminservice.php",
                          {
                            method: "clearAlarms",
                            childId: childId,
                            customTreeId: $node.id,
                            nodeDisplayName: $node.text,
                          },
                          function (data) {
                            if (data) {
                              globIsManualTreeRefresh = true;

                              setTreeRefreshInterval();
                              createTree();
                            }
                          },
                          "json"
                        );
                      },
                    },
                  };

                  if (isMapHistoryUser()) {
                    if (isUCU(nodeData)) {
                      menu = collect(menu, {
                        "UCU Location History": {
                          separator_before: false,
                          separator_after: true,
                          label: "UCU Location History",
                          action: function (obj) {
                            displayUCULocationHistory(nodeData);
                          },
                        },
                      });
                    }
                  }

                  if (isMatDownloadAllowed) {
                    menu = collect(
                      menu,
                      {
                        MatZipFile: matDownloadMenu,
                      },
                      {
                        DataExportFile: dataExportMenu,
                      },
                      {
                        Properties: {
                          separator_before: false,
                          separator_after: false,
                          label: "Properties",
                          submenu: {
                            act: {
                              separator_before: false,
                              separator_after: false,
                              label: "" + nodeActName,
                            },
                            ignoreState: {
                              separator_before: false,
                              separator_after: false,
                              label:
                                "Ignore : " +
                                (globUserData.ignoredNodes.indexOf($node.id) >
                                  -1
                                  ? "Yes"
                                  : "No"),
                            },
                          },
                        },
                      }
                    );
                  } else {
                    menu = collect(menu, {
                      Properties: {
                        separator_before: false,
                        separator_after: false,
                        label: "Properties",
                        submenu: {
                          act: {
                            separator_before: false,
                            separator_after: false,
                            label: "" + nodeActName,
                          },
                          ignoreState: {
                            separator_before: false,
                            separator_after: false,
                            label:
                              "Ignore : " +
                              (globUserData.ignoredNodes.indexOf($node.id) > -1
                                ? "Yes"
                                : "No"),
                          },
                        },
                      },
                    });
                  }

                  return menu;
                } else {
                  menu = {
                    Rename: {
                      separator_before: false,
                      separator_after: false,
                      label: "Rename",
                      action: function (obj) {
                        globIsRenaming = true;
                        clearTreeRefreshInterval();

                        tree.edit($node);
                      },
                    },
                    Ignore: {
                      separator_before: false,
                      separator_after: false,
                      label:
                        (globUserData.ignoredNodes.indexOf($node.id) == 0 ||
                          globUserData.ignoredNodes.indexOf("," + $node.id) > -1
                          ? "Remove "
                          : "") + "Ignore",
                      action: function (obj) {
                        $.post(
                          "setIgnore.php",
                          {
                            node: $node.id,
                            ignore: globUserData.ignoredNodes.indexOf($node.id),
                          },
                          function (result) {
                            if (isDebug()) {
                              console.log("Ignore result: ", result); // DDD
                            }

                            if (
                              globUserData.ignoredNodes.indexOf($node.id) ==
                              0 ||
                              globUserData.ignoredNodes.indexOf(
                                "," + $node.id
                              ) > -1
                            ) {
                              removeTreeIgnoredNode($node.id);
                              // setNodeIcon($node.id,
                              // nodeData.communication_status
                              // ||
                              // $TreeGraph.jstree('is_undetermined',
                              // $node.id));

                              // unpropogateTreeIgnoredIcons($node.id);
                              // checkifPropogateCommStatusTreeNode($node.id);
                            } else {
                              addTreeIgnoredNode($node.id);
                              // setNodeIcon($node.id);

                              // propogateTreeIgnoredIcons();
                              // uncheckPropogateCommStatusTreeNode($node.id);
                            }

                            createTree();

                            // $TreeGraph.jstree('deselect_all');
                            $TreeGraph.jstree(
                              "select_node",
                              globCurrentNode,
                              false
                            );
                          }
                        );
                      },
                    },
                  };

                  if (isMapHistoryUser()) {
                    if (isUCU(nodeData)) {
                      menu = collect(menu, {
                        "UCU Location History": {
                          separator_before: false,
                          separator_after: true,
                          label: "UCU Location History",
                          action: function (obj) {
                            displayUCULocationHistory(nodeData);
                          },
                        },
                      });
                    }
                  }

                  if (isMatDownloadAllowed) {
                    menu = collect(
                      menu,
                      {
                        MatZipFile: matDownloadMenu,
                      },
                      {
                        DataExportFile: dataExportMenu,
                      },
                      {
                        Properties: {
                          separator_before: false,
                          separator_after: false,
                          label: "Properties",
                          submenu: {
                            act: {
                              separator_before: false,
                              separator_after: false,
                              label: "" + nodeActName,
                            },
                            ignoreState: {
                              separator_before: false,
                              separator_after: false,
                              label:
                                "Ignore : " +
                                (globUserData.ignoredNodes.indexOf($node.id) >
                                  -1
                                  ? "Yes"
                                  : "No"),
                            },
                          },
                        },
                      }
                    );
                  } else {
                    menu = collect(menu, {
                      Properties: {
                        separator_before: false,
                        separator_after: false,
                        label: "Properties",
                        submenu: {
                          act: {
                            separator_before: false,
                            separator_after: false,
                            label: "" + nodeActName,
                          },
                          ignoreState: {
                            separator_before: false,
                            separator_after: false,
                            label:
                              "Ignore : " +
                              (globUserData.ignoredNodes.indexOf($node.id) > -1
                                ? "Yes"
                                : "No"),
                          },
                        },
                      },
                    });
                  }

                  return menu;
                }
              }

              if (
                $node.id.indexOf("L_") == -1 &&
                $node.id != "root" &&
                $node.id != "un"
              ) {
                // Device group // $node.text.indexOf("-")>-1||$node.parents.length>=3)
                // if (isDebug()) {
                // console.log(globUserData.role); // DDD
                // }

                var isDeleteHistoryAllowed = false;
                if (isUbiqamUser()) {
                  isDeleteHistoryAllowed = true;
                  isMatDownloadAllowed = true;
                }

                var deleteHistoryMenu = {
                  _disabled: true,
                  separator_before: false,
                  separator_after: false,
                  label: "Delete History",
                };
                if (isDeleteHistoryAllowed) {
                  deleteHistoryMenu = {
                    separator_before: false,
                    separator_after: false,
                    label: "Delete History",
                    action: function (obj) {
                      // console.log($node, nodeData);

                      // No device record behind a physical port node, so there
                      // is nothing to export or delete for it. getNodeData()
                      // returns null there and these fields would throw.
                      if (!nodeData) {
                        return;
                      }

                      $.post(
                        "adminservice.php",
                        {
                          method: "deleteGroupHistory",
                          customTreeId: nodeData.id,
                          nodeNameAct: nodeData.act_name,
                          childIds: $node.children.join(","),
                        },
                        function (result) {
                          enableTabContent("mapinfo");

                          $TreeGraph.jstree("deselect_all");
                          $TreeGraph.jstree(
                            "select_node",
                            globCurrentNode,
                            false
                          );

                          console.log(result);
                        }
                      );
                    },
                  };
                }

                if (globUserData.role.indexOf("Rename") > -1) {
                  menu = {
                    Rename: {
                      separator_before: false,
                      separator_after: false,
                      label: "Rename",
                      action: function (obj) {
                        globIsRenaming = true;
                        clearTreeRefreshInterval();

                        tree.edit($node);
                      },
                    },
                  };
                }
                if (globUserData.role.indexOf("Ignore") > -1) {
                  if (menu == "") {
                    menu = {
                      Ignore: {
                        separator_before: false,
                        separator_after: false,
                        label:
                          (globUserData.ignoredNodes.indexOf($node.id) == 0 ||
                            globUserData.ignoredNodes.indexOf("," + $node.id) > -1
                            ? "Remove "
                            : "") + "Ignore",
                        action: function (obj) {
                          $.post(
                            "setIgnore.php",
                            {
                              node: $node.id,
                              ignore: globUserData.ignoredNodes.indexOf(
                                $node.id
                              ),
                            },
                            function (result) {
                              if (isDebug()) {
                                console.log("Ignore result: ", result); // DDD
                              }

                              if (
                                globUserData.ignoredNodes.indexOf($node.id) ==
                                0 ||
                                globUserData.ignoredNodes.indexOf(
                                  "," + $node.id
                                ) > -1
                              ) {
                                removeTreeIgnoredNode($node.id);
                                // setNodeIcon($node.id,
                                // nodeData.communication_status
                                // ||
                                // $TreeGraph.jstree('is_undetermined',
                                // $node.id));

                                // unpropogateTreeIgnoredIcons($node.id);
                                // checkifPropogateCommStatusTreeNode($node.id);
                              } else {
                                addTreeIgnoredNode($node.id);
                                // setNodeIcon($node.id);

                                // propogateTreeIgnoredIcons();
                                // uncheckPropogateCommStatusTreeNode($node.id);
                              }

                              createTree();

                              // $TreeGraph.jstree('deselect_all');
                              $TreeGraph.jstree(
                                "select_node",
                                globCurrentNode,
                                false
                              );
                            }
                          );
                        },
                      },
                      DeleteHistory: deleteHistoryMenu,
                      Properties: {
                        separator_before: true,
                        separator_after: false,
                        label: "Properties",
                        submenu: {
                          act: {
                            separator_before: false,
                            separator_after: false,
                            label: "" + nodeActName,
                          },
                          ignoreState: {
                            separator_before: false,
                            separator_after: false,
                            label:
                              "Ignore : " +
                              (globUserData.ignoredNodes.indexOf($node.id) > -1
                                ? "Yes"
                                : "No"),
                          },
                        },
                      },
                    };
                  } else {
                    if (isDebug()) {
                      console.log("kk"); // DDD
                    }

                    menu = collect(menu, {
                      Ignore: {
                        separator_before: false,
                        separator_after: false,
                        label:
                          (globUserData.ignoredNodes.indexOf($node.id) == 0 ||
                            globUserData.ignoredNodes.indexOf("," + $node.id) > -1
                            ? "Remove "
                            : "") + "Ignore",
                        action: function (obj) {
                          $.post(
                            "setIgnore.php",
                            {
                              node: $node.id,
                              ignore: globUserData.ignoredNodes.indexOf(
                                $node.id
                              ),
                            },
                            function (result) {
                              if (isDebug()) {
                                console.log("Ignore result: ", result); // DDD
                              }

                              if (
                                globUserData.ignoredNodes.indexOf($node.id) ==
                                0 ||
                                globUserData.ignoredNodes.indexOf(
                                  "," + $node.id
                                ) > -1
                              ) {
                                removeTreeIgnoredNode($node.id);
                                // setNodeIcon($node.id,
                                // nodeData.communication_status
                                // ||
                                // $TreeGraph.jstree('is_undetermined',
                                // $node.id));

                                // unpropogateTreeIgnoredIcons($node.id);
                                // checkifPropogateCommStatusTreeNode($node.id);
                              } else {
                                addTreeIgnoredNode($node.id);
                                // setNodeIcon($node.id);

                                // propogateTreeIgnoredIcons();
                                // uncheckPropogateCommStatusTreeNode($node.id);
                              }

                              createTree();

                              // $TreeGraph.jstree('deselect_all');
                              $TreeGraph.jstree(
                                "select_node",
                                globCurrentNode,
                                false
                              );
                            }
                          );
                        },
                      },
                      DeleteHistory: deleteHistoryMenu,
                      Properties: {
                        separator_before: true,
                        separator_after: false,
                        label: "Properties",
                        submenu: {
                          act: {
                            separator_before: false,
                            separator_after: false,
                            label: "" + nodeActName,
                          },
                          ignoreState: {
                            separator_before: false,
                            separator_after: false,
                            label:
                              "Ignore : " +
                              (globUserData.ignoredNodes.indexOf($node.id) > -1
                                ? "Yes"
                                : "No"),
                          },
                        },
                      },
                    });
                  }
                }

                if (globUserData.role.indexOf("Ignore") == -1) {
                  if (menu == "") {
                    menu = {
                      DeleteHistory: deleteHistoryMenu,
                      Properties: {
                        separator_before: true,
                        separator_after: false,
                        label: "Properties",
                        submenu: {
                          act: {
                            separator_before: false,
                            separator_after: false,
                            label: "" + nodeActName,
                          },
                        },
                      },
                    };
                  } else {
                    menu = collect(menu, {
                      DeleteHistory: deleteHistoryMenu,
                      Properties: {
                        separator_before: true,
                        separator_after: false,
                        label: "Properties",
                        submenu: {
                          act: {
                            separator_before: false,
                            separator_after: false,
                            label: "" + nodeActName,
                          },
                        },
                      },
                    });
                  }
                }

                if (isDebug()) {
                  console.log("Menu: ", menu); // DDD
                }

                return menu;
              }

              var menu = "";

              // if (isDebug()) {
              // console.log(globUserData.role); // DDD
              // }

              if (globUserData.role.indexOf("Create") > -1) {
                menu = {
                  Create: {
                    separator_before: false,
                    separator_after: false,
                    label: "Create",
                    action: function (obj) {
                      // $node =
                      // tree.create_node($node,{"id":"L_j1_"+tree._cnt,"text":"New
                      // Node","icon":"images/Default.png"});
                      globIsRenaming = true;
                      clearTreeRefreshInterval();

                      $node = tree.create_node($node, {
                        text: "New Node",
                        icon: ICON_V_NODE + "green.svg",
                      });

                      // console.log($node+" :+");

                      if (isDebug()) {
                        console.log(
                          "Context menu create node: set_id",
                          $node + " : " + tree.set_id($node, "L_" + $node)
                        );
                      }
                      // $.post("setId.php", {id:"L_"+
                      // $node,old_id:$node},
                      // function(result){
                      // alert(result);
                      // });

                      tree.set_id($node, "L_" + $node);
                      tree.edit(
                        "L_" + $node,
                        "",
                        function (n, status, isCancel) {
                          globCurrentNode = "L_" + $node;
                          $TreeGraph.jstree(
                            "select_node",
                            globCurrentNode,
                            false
                          );

                          // if (status && !isCancel) {
                          // 	globIsRenaming = false;
                          // 	globCurrentNode = "L_" + $node;

                          // 	setTreeRefreshInterval();
                          // 	createTree();
                          // 	$TreeGraph.jstree('select_node', globCurrentNode, false);
                          // }
                        }
                      );
                    },
                  },
                };
              }

              if (globUserData.role.indexOf("Rename") > -1) {
                if (menu == "") {
                  menu = {
                    Rename: {
                      separator_before: false,
                      separator_after: false,
                      label: "Rename",
                      action: function (obj) {
                        globIsRenaming = true;
                        clearTreeRefreshInterval();

                        tree.edit($node);
                      },
                    },
                  };
                } else {
                  menu = collect(menu, {
                    Rename: {
                      separator_before: false,
                      separator_after: false,
                      label: "Rename",
                      action: function (obj) {
                        globIsRenaming = true;
                        clearTreeRefreshInterval();

                        tree.edit($node);
                      },
                    },
                  });
                }
              }
              if (globUserData.role.indexOf("Ignore") > -1) {
                if (menu == "") {
                  menu = {
                    Ignore: {
                      separator_before: false,
                      separator_after: false,
                      label:
                        (globUserData.ignoredNodes.indexOf($node.id) == 0 ||
                          globUserData.ignoredNodes.indexOf("," + $node.id) > -1
                          ? "Remove "
                          : "") + "Ignore",
                      action: function (obj) {
                        $.post(
                          "setIgnore.php",
                          {
                            node: $node.id,
                            ignore: globUserData.ignoredNodes.indexOf($node.id),
                          },
                          function (result) {
                            if (isDebug()) {
                              console.log("Ignore result: ", result); // DDD
                            }

                            if (
                              globUserData.ignoredNodes.indexOf($node.id) ==
                              0 ||
                              globUserData.ignoredNodes.indexOf(
                                "," + $node.id
                              ) > -1
                            ) {
                              removeTreeIgnoredNode($node.id);
                              // setNodeIcon($node.id,
                              // nodeData.communication_status
                              // ||
                              // $TreeGraph.jstree('is_undetermined',
                              // $node.id));

                              // unpropogateTreeIgnoredIcons($node.id);
                              // checkifPropogateCommStatusTreeNode($node.id);
                            } else {
                              addTreeIgnoredNode($node.id);
                              // setNodeIcon($node.id);

                              // propogateTreeIgnoredIcons();
                              // uncheckPropogateCommStatusTreeNode($node.id);
                            }

                            createTree();

                            // $TreeGraph.jstree('deselect_all');
                            $TreeGraph.jstree(
                              "select_node",
                              globCurrentNode,
                              false
                            );
                          }
                        );
                      },
                    },
                    Properties: {
                      separator_before: false,
                      separator_after: false,
                      label: "Properties",
                      submenu: {
                        ignoreState: {
                          separator_before: false,
                          separator_after: false,
                          label:
                            "Ignore : " +
                            (globUserData.ignoredNodes.indexOf($node.id) > -1
                              ? "Yes"
                              : "No"),
                        },
                      },
                    },
                  };
                } else {
                  menu = collect(menu, {
                    Ignore: {
                      separator_before: false,
                      separator_after: false,
                      label:
                        (globUserData.ignoredNodes.indexOf($node.id) == 0 ||
                          globUserData.ignoredNodes.indexOf("," + $node.id) > -1
                          ? "Remove "
                          : "") + "Ignore",
                      action: function (obj) {
                        $.post(
                          "setIgnore.php",
                          {
                            node: $node.id,
                            ignore: globUserData.ignoredNodes.indexOf($node.id),
                          },
                          function (result) {
                            if (isDebug()) {
                              console.log("Ignore result: ", result); // DDD
                            }

                            if (
                              globUserData.ignoredNodes.indexOf($node.id) ==
                              0 ||
                              globUserData.ignoredNodes.indexOf(
                                "," + $node.id
                              ) > -1
                            ) {
                              removeTreeIgnoredNode($node.id);
                              // setNodeIcon($node.id,
                              // nodeData.communication_status
                              // ||
                              // $TreeGraph.jstree('is_undetermined',
                              // $node.id));

                              // unpropogateTreeIgnoredIcons($node.id);
                              // checkifPropogateCommStatusTreeNode($node.id);
                            } else {
                              addTreeIgnoredNode($node.id);
                              // setNodeIcon($node.id);

                              // propogateTreeIgnoredIcons();
                              // uncheckPropogateCommStatusTreeNode($node.id);
                            }

                            createTree();

                            // $TreeGraph.jstree('deselect_all');
                            $TreeGraph.jstree(
                              "select_node",
                              globCurrentNode,
                              false
                            );
                          }
                        );
                      },
                    },
                    Properties: {
                      separator_before: false,
                      separator_after: false,
                      label: "Properties",
                      submenu: {
                        ignoreState: {
                          separator_before: false,
                          separator_after: false,
                          label:
                            "Ignore : " +
                            (globUserData.ignoredNodes.indexOf($node.id) > -1
                              ? "Yes"
                              : "No"),
                        },
                      },
                    },
                  });
                }
              }

              var TreeExportMenuEntry = {
                TreeExport: {
                  separator_before: true,
                  separator_after: false,
                  label: "Tree Export",
                  action: function (obj) {
                    TreeExportGo();
                  },
                },
              };
              if (menu == "") {
                menu = TreeExportMenuEntry;
              } else {
                menu = collect(menu, TreeExportMenuEntry);
              }

              if (isDebug()) {
                console.log("Menu: ", menu);
              }

              return menu;
            },
          },
        });

        _.forOwn(moveNodes, function (moveNode, key) {
          if (isDebug()) {
            console.log("Moving: ", key, "to ", moveNode); // DDD
          }

          $TreeGraph.jstree(true).move_node(key, moveNode);
        });

        // $TreeGraph.jstree(true).open_all();

        bindTreeEvents();

        if (isUserRole("Display Status In Tree")) {
          globTreeStatusOverlaysReadyTimer = setInterval(function () {
            if (
              document.readyState != "loading" &&
              globTreeStatusOverlaysReady
            ) {
              clearInterval(globTreeStatusOverlaysReadyTimer);

              DisplayDeviceStatus();
              propogateDeviceStatus();
            }
          }, 1 * 1000);
          // Propogate status overlay...
        }

        globNumCommStatusErrors = checkAllCommStatusTreeNodes();
        propogateAlarmStatus();
        propogateTreeIgnoredIcons();

        globCheckOpen = true;

        _.forEach(openNodes, function (openNode, key) {
          var aNode = openNode.trim();

          if (aNode !== "") {
            $TreeGraph.jstree("open_node", aNode);
          }
        });

        globCheckOpen = false;

        $TreeAjaxRefresh.addClass("hidden");
        $TreeGraph.removeClass("hidden");
        $TreeGraph.jstree("select_node", currentSelectedNode);
        $TreeArea.scrollTop(globSaveTreeScrollTop);

        updateCommStatus();
        commErrorNodesDisplay();

        var searchTxt = $("#NodeSearch").val();
        if (searchTxt != "") {
          $TreeGraph.jstree("search", searchTxt);
        }

        propogateBypassStatus();
       } catch (err) {
        // A throw anywhere while building the tree (jstree init, status
        // overlays, open_node, select_node, ...) is NOT routed to .fail() by
        // jQuery. Without this catch it would leave globIsCreateTree /
        // globCheckOpen stuck true and the "Loading" spinner up, so the
        // manual refresh button and auto-refresh timer both early-return at
        // the createTree() guard forever and only a full page reload recovers.
        console.log("!!! createTree: build failed: ", err); // DDD
       } finally {
        globCheckOpen = false;
        globIsCreateTree = false;
        globIsManualTreeRefresh = false;
        $TreeAjaxRefresh.addClass("hidden");
        $TreeGraph.removeClass("hidden");

        // Re-select the current node AFTER guards are cleared so the tab
        // content handler actually runs (during createTree the select_node
        // at line above fires while globIsCreateTree is still true, so the
        // tab switch cases skip content loading).
        if (currentSelectedNode) {
          setTimeout(function () {
            $TreeGraph.jstree("deselect_all");
            $TreeGraph.jstree("select_node", currentSelectedNode);
          }, 0);
        }
       }
      },
      "json"
    ).fail(function (e) {
      // Silenced: the 5-minute auto-refresh means one dropped request is
      // routine on a slow link, and the recovery below already handles it,
      // so this only put red in the console for something self-healing.
      // Wrap in isDebug() rather than deleting if it is ever needed again.
      // console.log("!!! post::getTreeData failed: ", e); // DDD
      // Restore the panel so a transient network error doesn't leave the tree
      // stuck on "Loading"; also clear the guard flags so a retry can run.
      globCheckOpen = false;
      globIsCreateTree = false;
      $TreeAjaxRefresh.addClass("hidden");
      $TreeGraph.removeClass("hidden");
    });
  }

  function updateCommStatus() {
    $StatusCommButton.text(globNumCommStatusErrors);

    if (globNumCommStatusErrors === 0) {
      $StatusCommButton.removeClass("btn-danger").addClass("btn-success");
    } else {
      $StatusCommButton.removeClass("btn-success").addClass("btn-danger");
    }
  }

  // function rwdAdjust() {
  // if ($(window).width() <= 480) {
  // $StatusAreaLabel.text('Alarms:');
  // $TabRemoteM.text('Remote M');
  // }
  // }

  function getNextTreeRefresh() {
    if (!globTreeUpdateTimer) {
      return -1;
    }

    return (
      (globLastTreeUpdateTime
        ? TREE_UPODATE_INTERVAL - (_.now() - globLastTreeUpdateTime)
        : 0) /
      1000 /
      60
    ).toFixed(2);
  }

  function clearTreeRefreshInterval() {
    if (globTreeUpdateTimer) {
      clearInterval(globTreeUpdateTimer);

      globTreeUpdateTimer = null;
    }
  }

  function updateLastTreeUpdateTime() {
    globLastTreeUpdateTime = _.now();
    ubid.data.lastTreeUpdateTime = globLastTreeUpdateTime;
  }

  function setTreeRefreshInterval() {
    clearTreeRefreshInterval();

    globTreeUpdateTimer = setInterval(createTree, TREE_UPODATE_INTERVAL);

    updateLastTreeUpdateTime();
  }

  function tabSpectrogramsContentControlsGo(e, datesRange) {
    globIsSpectrogramKeyboardEvent = false;

    if ($SpectrogramWindow1 && $SpectrogramWin1GraphsContainer) {
      spectrogramWindow1Rect = $SpectrogramWindow1[0].getBoundingClientRect();
      spectrogramWin1GraphsContainerRect = $SpectrogramWin1GraphsContainer[0].getBoundingClientRect();
    }

    if (globSpectrogramsUpdateTimer) {
      clearTimeout(globSpectrogramsUpdateTimer);

      globSpectrogramsUpdateTimer = null;
    }

    globIs2DFrozen = false;
    win1TDType = $Win1TD.val();
    isWin1TD = win1TDType !== "none";

    isSpectrogramsWin1Vertical = $SpectrogramsWin1Vertical.prop("checked");
    isSpectrogramsWin1Horizontal = $SpectrogramsWin1Horizontal.prop("checked");

    var graph1 = $SpectrogramWin1GraphSel1.val();
    var graph2 = $SpectrogramWin1GraphSel2.val();
    var graph3 = $SpectrogramWin1GraphSel3.val();
    var graph4 = $SpectrogramWin1GraphSel4.val();

    var dataTypes = "";
    dataTypes +=
      graph1 + ";" + (graph2 + ";") + (graph3 + ";") + (graph4 + ";");
    dataTypes = dataTypes.replace(/-;/g, "");
    if (dataTypes.charAt(dataTypes.length - 1) === ";") {
      dataTypes = dataTypes.substring(0, dataTypes.length - 1);
    }
    // console.log('dataTypes = ', dataTypes);

    var nodeData = getNodeData(globCurrentNode);
    if (!nodeData) return;
    globIs4AntDevice = isHas4AntData(nodeData);

    if (globIs4AntDevice) {
      var RGraph1 = $SpectrogramWin2GraphSel1.val();
      var RGraph2 = $SpectrogramWin2GraphSel2.val();
      var RGraph3 = $SpectrogramWin2GraphSel3.val();
      var RGraph4 = $SpectrogramWin2GraphSel4.val();

      var dataTypesR = "";
      dataTypesR +=
        RGraph1 + ";" + (RGraph2 + ";") + (RGraph3 + ";") + (RGraph4 + ";");
      dataTypesR = dataTypesR.replace(/-;/g, "");
      if (dataTypesR.charAt(dataTypesR.length - 1) === ";") {
        dataTypesR = dataTypesR.substring(0, dataTypesR.length - 1);
      }
      // console.log('dataTypesR = ', dataTypesR);
    }

    // ++ Canc.
    isSpectrogramsCancEnabled = false;
    if (win1TDType == "avg") {
      if (
        dataTypes.search("a_out") != -1 ||
        dataTypes.search("b_out") != -1 ||
        dataTypes.search("c_out") != -1 ||
        dataTypes.search("d_out") != -1 ||
        dataTypes.search("avg_out") != -1
      ) {
        spectrogramsCancTypeName = $SpectrogramWin1Canc.val();

        if (spectrogramsCancTypeName != "normal") {
          isSpectrogramsCancEnabled = true;
        }
      }
    }
    // == Canc.

    spectrogramWindow1NumOfGraphs =
      Utils.numOfOccurences(dataTypes, ";") + (isWin1TD ? 1 : 0);
    // console.log('numOfGraphs: ', spectrogramWindow1NumOfGraphs);

    if (globIs4AntDevice) {
      spectrogramWindow2NumOfGraphs =
        Utils.numOfOccurences(dataTypesR, ";") + (isWin1TD ? 1 : 0);
      // console.log('numOfGraphs on right: ',
      // spectrogramWindow2NumOfGraphs);
    } else {
      spectrogramWindow2NumOfGraphs = 0;
    }

    var maxNumOfGraphsToDrawForBothColumns = Math.max(
      spectrogramWindow1NumOfGraphs,
      spectrogramWindow2NumOfGraphs
    );

    if (
      spectrogramWindow1NumOfGraphs == 0 ||
      (spectrogramWindow1NumOfGraphs == 1 && isWin1TD)
    ) {
      if (
        (!isWin1TD && spectrogramWindow2NumOfGraphs == 1) ||
        (isWin1TD && spectrogramWindow2NumOfGraphs > 1)
      ) {
        var tmpSpectrogramWindow1NumOfGraphs = spectrogramWindow1NumOfGraphs;
        spectrogramWindow1NumOfGraphs = spectrogramWindow2NumOfGraphs;
        spectrogramWindow2NumOfGraphs = 0;

        var tmpDataTypes = dataTypes;
        dataTypes = dataTypesR;
        dataTypesR = tmpDataTypes;
      }
    }

    var startDate = -1;
    var endDate = -1;
    var presetPeriod = 0;
    var presetPeriodSeconds = 0;

    if (!datesRange) {
      if (isSpectrogramPre) {
        presetPeriod = $TabSpectrogramsContentControlsShowLast.val();
        // console.log('presetPeriod: ', presetPeriod);

        presetPeriodSeconds = getPresetPeriodSecondsFromSelection(presetPeriod);
      } else {
        endDate = $("#TabSpectrogramsContentControlsStartDate")
          .data("DateTimePicker")
          .date();
        if (endDate) {
          // endDate = moment.tz(moment.tz(endDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
          endDate = moment
            .tz(endDate.format("YYYY-MM-DD HH:mm"), globServerTimezone)
            .unix();
        }

        startDate = $("#TabSpectrogramsContentControlsEndDate")
          .data("DateTimePicker")
          .date();
        if (startDate) {
          // startDate = moment.tz(moment.tz(startDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
          startDate = moment
            .tz(startDate.format("YYYY-MM-DD HH:mm"), globServerTimezone)
            .unix();
        }

        console.log(startDate, endDate);
      }
    } else {
      startDate = Math.round(datesRange.startDate);
      endDate = Math.round(datesRange.endDate);
    }

    spectrogramWindow1GraphHeight = Math.ceil(
      (spectrogramWin1GraphsContainerRect.height -
        globGraphRectInlineSpace * 2 -
        (isSpectrogramsWin1Horizontal
          ? (maxNumOfGraphsToDrawForBothColumns - 1) * globGraphBetweenSpace
          : 0)) /
      (isSpectrogramsWin1Horizontal ? maxNumOfGraphsToDrawForBothColumns : 1)
    );

    spectrogramWindow1GraphWidth = Math.ceil(
      (spectrogramWin1GraphsContainerRect.width -
        globGraphRectInlineSpace *
        (isSpectrogramsWin1Horizontal
          ? 2
          : 1 + maxNumOfGraphsToDrawForBothColumns)) /
      (isSpectrogramsWin1Horizontal ? 1 : maxNumOfGraphsToDrawForBothColumns)
    );

    var isSpectrogramDisplay2Columns = false;
    if (
      globIs4AntDevice &&
      spectrogramWindow1NumOfGraphs > 0 + (isWin1TD ? 1 : 0) &&
      spectrogramWindow2NumOfGraphs > 0 + (isWin1TD ? 1 : 0)
    ) {
      isSpectrogramDisplay2Columns = true;
      spectrogramWindow1GraphWidth /= 2;
    }

    if (IS_DEBUG) {
      console.log(
        "spectrogramWindow1GraphWidth = ",
        spectrogramWindow1GraphWidth,
        ", spectrogramWindow1GraphHeight = ",
        spectrogramWindow1GraphHeight
      );
    }

    if (isSpectrogramsWin1Horizontal) {
      spectrogramWindow1NumOfPixelsForTimeAxis =
        spectrogramWindow1GraphHeight - graphMargin.bottom - graphMargin.top; // DDD
      // margin.top?
    } else {
      spectrogramWindow1NumOfPixelsForTimeAxis =
        spectrogramWindow1GraphWidth - graphMargin.left; // DDD
      // -
      // margin.left?
    }

    spectrogramWindow1SecPerPixel = Math.abs(
      Math.ceil(
        (isSpectrogramPre && !datesRange
          ? presetPeriodSeconds
          : startDate - endDate) / spectrogramWindow1NumOfPixelsForTimeAxis
      )
    );

    if (IS_DEBUG) {
      console.log(
        isSpectrogramsWin1Vertical ? "Vertical" : "Horizontal",
        ", presetPeriodSeconds = ",
        presetPeriodSeconds,
        ", startDate = ",
        startDate,
        ", endDate = ",
        endDate,
        ", spectrogramWindow1NumOfPixelsForTimeAxis = ",
        spectrogramWindow1NumOfPixelsForTimeAxis,
        "spectrogramWindow1SecPerPixel = ",
        spectrogramWindow1SecPerPixel
      );
    }

    if (isSpectrogramsWin1Vertical) {
      addTitleElements();
    }

    if (datesRange) {
      getUbifixSpectrogramData(
        dataTypes,
        dataTypesR,
        false,
        startDate,
        endDate,
        true,
        isSpectrogramDisplay2Columns
      );
    } else {
      getUbifixSpectrogramData(
        dataTypes,
        dataTypesR,
        presetPeriod,
        startDate,
        endDate,
        false,
        isSpectrogramDisplay2Columns
      );
    }
  }

  function tabNodePadGraphsContentControlsGo(e, isDeleteEntries) {
    var startDate = -1;
    var endDate = -1;
    var presetPeriod = 0;
    var presetPeriodSeconds = 0;

    var textFilter = $("#TabNodePadContentControlsTextFilter").val();

    if (isNodePadPreDate) {
      presetPeriod = $TabNodePadContentControlsShowLast.val();
      // console.log('presetPeriod: ', presetPeriod);

      presetPeriodSeconds = getPresetPeriodSecondsFromSelection(presetPeriod);
    } else {
      endDate = $TabNodePadContentControlsStartDate
        .data("DateTimePicker")
        .date();
      if (endDate) {
        // endDate = moment.tz(moment.tz(endDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
        endDate = moment
          .tz(endDate.format("YYYY-MM-DD HH:mm"), globServerTimezone)
          .unix();
      }

      startDate = $TabNodePadContentControlsEndDate
        .data("DateTimePicker")
        .date();
      if (startDate) {
        // startDate = moment.tz(moment.tz(startDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
        startDate = moment
          .tz(startDate.format("YYYY-MM-DD HH:mm"), globServerTimezone)
          .unix();
      }

      // console.log(startDate, endDate);
    }

    enableNodePadContent();

    if (isDeleteEntries) {
      deleteNodepadEntries(presetPeriod, startDate, endDate, textFilter);
    } else {
      fetchNodepadEntries(presetPeriod, startDate, endDate, textFilter);
    }
  }

  function getChildrenTree(startNodeId) {
    if (startNodeId.indexOf("D_") == 0) {
      var dChildren = $TreeGraph.jstree(true).get_children_dom(startNodeId);
      var dChildrenArray = [];

      for (var i = 0; i < dChildren.length; ++i) {
        dChildrenArray.push(dChildren[i].id);
      }

      return dChildrenArray;
    } else if (startNodeId.indexOf("L_") == 0) {
      var subChildren = $TreeGraph.jstree(true).get_children_dom(startNodeId);

      var retVal = [];

      for (var i = 0; i < subChildren.length; ++i) {
        var ret = getChildrenTree(subChildren[i].id);
        retVal = retVal.concat(ret);
      }

      return retVal;
    }
  }

  function tabOptixModeGraphsContentControlsGo(datesRange) {
    var startDate = -1;
    var endDate = -1;
    var presetPeriod = 0;
    var presetPeriodSeconds = 0;

    var nodeData = getNodeData(globCurrentNode);
    if (!nodeData) return;

    var isPhysicalPort = globCurrentNode && isPhysicalPortNode(globCurrentNode);
    var isImmediateParent =
      !isPhysicalPort && nodeData.id.indexOf("D_") === 0 ? true : false;
    var isHighLevelParent =
      !isPhysicalPort &&
        (nodeData.id.indexOf("L_") === 0 ||
          nodeData.id === "root" ||
          // "un" (Unassigned) is a container like root, not a device. Leaving
          // it out sent it down the single-device branch, which walks up two
          // levels for a grandparent it does not have: get_node("#").parent is
          // null, get_node(null) returns false, and false.children_d is
          // undefined — hence "Cannot read properties of undefined (reading
          // 'filter')" on OPTiX. It also has act_name null, which reached the
          // backend as the string "null" and produced a 500.
          nodeData.id === "un")
        ? true
        : false;

    if (!datesRange) {
      if (isOptixModePreDate) {
        presetPeriod = $TabOptixModeContentControlsShowLast.val();
        // console.log('presetPeriod: ', presetPeriod);

        presetPeriodSeconds = getPresetPeriodSecondsFromSelection(presetPeriod);
      } else {
        endDate = $TabOptixModeContentControlsStartDate
          .data("DateTimePicker")
          .date();
        if (endDate) {
          // endDate = moment.tz(moment.tz(endDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
          endDate = moment
            .tz(endDate.format("YYYY-MM-DD HH:mm"), globServerTimezone)
            .unix();
        }

        startDate = $TabOptixModeContentControlsEndDate
          .data("DateTimePicker")
          .date();
        if (startDate) {
          // startDate = moment.tz(moment.tz(startDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
          startDate = moment
            .tz(startDate.format("YYYY-MM-DD HH:mm"), globServerTimezone)
            .unix();
        }

        console.log(startDate, endDate);
      }
    } else {
      startDate = Math.round(datesRange.startDate);
      endDate = Math.round(datesRange.endDate);
    }

    OptixModeGraphHeight = 265; // 281; // III

    OptixModeGraphWidth =
      Math.ceil(
        OptixModeGraphsContainerRect.width - globGraphRectInlineSpace * 2
      ) - 10;

    OptixModeNumOfPixelsForTimeAxis = OptixModeGraphWidth - graphMargin.left;
    // console.log('OptixModeNumOfPixelsForTimeAxis  = ', OptixModeNumOfPixelsForTimeAxis);

    OptixModeSecPerPixel = Math.abs(
      Math.ceil(
        (isOptixModePreDate && !datesRange
          ? presetPeriodSeconds
          : startDate - endDate) / OptixModeNumOfPixelsForTimeAxis
      )
    );
    // console.log('OptixModeSecPerPixel  = ', OptixModeSecPerPixel);

    // ++ Determine nodes
    var children;
    var childrenNames = [];

    if (isHighLevelParent) {
      // var list = getChildrenTree(globCurrentNode);

      children = $TreeGraph.jstree(true).get_node(globCurrentNode).children_d;

      children = children.filter(function (el) {
        return el.indexOf("D_") != 0 && el.indexOf("L_") != 0;
      });
    } else if (isImmediateParent) {
      // children = $TreeGraph.jstree(true).get_children_dom(globCurrentNode);
      children = $TreeGraph.jstree(true).get_node(globCurrentNode).children_d;
    } else if (isPhysicalPort) {
      var nodeJSTreeData = $TreeGraph.jstree(true).get_node(globCurrentNode);

      children = $TreeGraph
        .jstree(true)
        .get_node(nodeJSTreeData.parent).children_d;
    } else {
      var nodeJSTreeData = $TreeGraph.jstree(true).get_node(globCurrentNode);
      var nodeData = getNodeData(nodeJSTreeData.id);

      if (isUCU(nodeData)) {
        children = $TreeGraph
          .jstree(true)
          .get_node(nodeJSTreeData.parent).children_d;
      } else {
        children = $TreeGraph
          .jstree(true)
          .get_node(
            $TreeGraph.jstree(true).get_node(nodeJSTreeData.parent).parent
          ).children_d;
      }
    }

    //  ++ Remove UCUs, physical port nodes and non OPTiX devices (22xx)
    children = children.filter(function (el) {
      if (isPhysicalPortNode(el)) {
        return false;
      } else {
        var nodeData = getNodeData(el);

        return (
          !isUCU(nodeData) &&
          parseInt(nodeData.act_name.substring(3, 7)) >= 2200
        );
      }
    });
    //  == Remove UCUs and non OPTiX devices (22xx)

    if (!children.length) {
      displayOptixModeMsg("No OPTiX devices were found (>= 22xx).");
    } else {
      for (var i = 0; i < children.length; ++i) {
        nodeData = getNodeData(children[i]);

        childrenNames.push(nodeData.act_name);
      }

      childrenNames.sort();

      // ++ Create device query
      var devicesQuery = [];
      var currentDeviceName = "";
      var deviceName;

      for (var i = 0; i < childrenNames.length; ++i) {
        deviceName = childrenNames[i].substring(
          0,
          childrenNames[i].indexOf("-")
        );

        if (deviceName != currentDeviceName) {
          currentDeviceName = deviceName;

          devicesQuery.push({
            deviceName: currentDeviceName,
            nodes: [childrenNames[i]],
          });
        } else {
          devicesQuery[devicesQuery.length - 1].nodes.push(childrenNames[i]);
        }
      }
      // == Create device query

      // var childrenJSON = JSON.stringify(childrenNames);
      var devicesQueryJSON = JSON.stringify(devicesQuery);
      // == Determine nodes

      if (datesRange) {
        getUbifixOptixModeData(false, startDate, endDate, devicesQueryJSON);
      } else {
        getUbifixOptixModeData(
          presetPeriod,
          startDate,
          endDate,
          devicesQueryJSON
        );
      }
    }
  }

  function tabRRDGraphsContentControlsGo(e, datesRange, isImmediateParent) {
    // RRDTimer
    // if (globSpectrogramsUpdateTimer) {
    // clearTimeout(globSpectrogramsUpdateTimer);
    //
    // globSpectrogramsUpdateTimer = null;
    // }

    RRDGraphsContainerRect = $TabRRDContentGraphsContainer[0].getBoundingClientRect();

    var startDate = -1;
    var endDate = -1;
    var presetPeriod = 0;
    var presetPeriodSeconds = 0;

    var isPhysicalPort = isPhysicalPortNode(globCurrentNode);

    var nodeData;
    if (!isPhysicalPort) {
      nodeData = getNodeData(globCurrentNode);
      if (!nodeData) return;
    }

    if (!datesRange) {
      if (isRRDPreDate) {
        presetPeriod = $TabRRDContentControlsShowLast.val();
        // console.log('presetPeriod: ', presetPeriod);

        presetPeriodSeconds = getPresetPeriodSecondsFromSelection(presetPeriod);
      } else {
        endDate = $TabRRDContentControlsStartDate.data("DateTimePicker").date();
        if (endDate) {
          // endDate = moment.tz(moment.tz(endDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
          endDate = moment
            .tz(endDate.format("YYYY-MM-DD HH:mm"), globServerTimezone)
            .unix();
        }

        startDate = $TabRRDContentControlsEndDate.data("DateTimePicker").date();
        if (startDate) {
          // startDate = moment.tz(moment.tz(startDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
          startDate = moment
            .tz(startDate.format("YYYY-MM-DD HH:mm"), globServerTimezone)
            .unix();
        }

        // console.log(startDate, endDate);
      }
    } else {
      startDate = Math.round(datesRange.startDate);
      endDate = Math.round(datesRange.endDate);
    }

    RRDGraphHeight = 265; // 281; // III

    RRDGraphWidth =
      Math.ceil(RRDGraphsContainerRect.width - globGraphRectInlineSpace * 2) -
      10;

    RRDNumOfPixelsForTimeAxis = RRDGraphWidth - graphMargin.left;
    // console.log('RRDNumOfPixelsForTimeAxis  = ', RRDNumOfPixelsForTimeAxis);

    RRDSecPerPixel = Math.abs(
      Math.ceil(
        (isRRDPreDate && !datesRange
          ? presetPeriodSeconds
          : startDate - endDate) / RRDNumOfPixelsForTimeAxis
      )
    );
    // console.log('RRDSecPerPixel  = ', RRDSecPerPixel);

    if (isPhysicalPort) {
      globIsParentSummaryRRDGraphs = true;

      if (datesRange) {
        getParentSummaryRRDData(false, startDate, endDate, true, true);
      } else {
        getParentSummaryRRDData(presetPeriod, startDate, endDate, false, true);
      }
    } else if (isImmediateParent || globIsHighLevelParent) {
      globIsParentSummaryRRDGraphs = true;

      if (datesRange) {
        getParentSummaryRRDData(false, startDate, endDate, true);
      } else {
        getParentSummaryRRDData(presetPeriod, startDate, endDate);
      }
    } else {
      if (isUCU(nodeData)) {
        getUCURRDData(presetPeriod, startDate, endDate);
      } else {
        if (datesRange) {
          getUbifixRRDData(false, startDate, endDate, true);
        } else {
          getUbifixRRDData(presetPeriod, startDate, endDate);
        }
      }
    }
  }

  function tabInternalsUCUHandler() {
    tabUcuInternalsPrmUpdate();

    tabInternalsSampleListRefresh();

    tabInternalsURebootAddressFill();
    $("#TabInternalsURebootMsg").text("");
    $("#TabInternalsURebootMsg").addClass("hidden");

    if (!globInternalsSamplesUpdateTimer) {
      globInternalsSamplesUpdateTimer = setInterval(
        tabInternalsSampleListRefresh,
        INTERNALS_SAMPLES_UPODATE_INTERVAL
      );
    }
  }

  function tabInternalsUMUHandler() {
    tabInternalsPrmCurrentUpdate();
    tabInternalsPrmHistoryUpdate();
  }

  function initSpectrogramsTab() {
    $TabSpectrogramsContentControlsStartDate.datetimepicker({
      useCurrent: false, // Important! See issue #1075
      sideBySide: true,
      allowInputToggle: true,
      toolbarPlacement: "bottom",
      showTodayButton: true,
      showClear: true,
      format: "DD MMM YYYY HH:mm",
      widgetPositioning: {
        horizontal: "left",
        vertical: "bottom",
      },
    });

    $TabSpectrogramsContentControlsEndDate.datetimepicker({
      useCurrent: false, // Important! See issue #1075
      sideBySide: true,
      allowInputToggle: true,
      toolbarPlacement: "bottom",
      showTodayButton: true,
      showClear: true,
      format: "DD MMM YYYY HH:mm",
      widgetPositioning: {
        horizontal: "left",
        vertical: "bottom",
      },
    });

    globIsStartdateShowRunning =
      globIsStartdateChangeRunning =
      globIsEnddateShowRunning =
      globIsEnddateChangeRunning =
      0;

    $TabSpectrogramsContentControlsStartDateIcon.on("click", function () {
      $TabSpectrogramsContentControlsStartDate.data("DateTimePicker").show();
    });

    $TabSpectrogramsContentControlsEndDateIcon.on("click", function () {
      $TabSpectrogramsContentControlsEndDate.data("DateTimePicker").show();
    });

    $TabSpectrogramsContentControlsStartDate.on("dp.show", function (e) {
      $("body")
        .find(".bootstrap-datetimepicker-widget:last")
        .css({ top: "2.2em" });

      if (!globSpectrogramsIsNOPDatesRangeFuncs) {
        ++globIsStartdateShowRunning;

        // console.log('TabSpectrogramsContentControlsStartDate
        // dp.show');

        if (
          !$TabSpectrogramsContentControlsStartDate
            .data("DateTimePicker")
            .date()
        ) {
          var nowCloud = moment().tz(globServerTimezone);
          var localCloudTime = moment(
            new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
          );
          var localCloudTimeMin = localCloudTime
            .clone()
            .hours(localCloudTime.hours() - 1);

          $TabSpectrogramsContentControlsStartDate
            .data("DateTimePicker")
            .maxDate(localCloudTimeMin);
          $TabSpectrogramsContentControlsStartDate
            .data("DateTimePicker")
            .date(localCloudTimeMin);

          $TabSpectrogramsContentControlsEndDate
            .data("DateTimePicker")
            .maxDate(localCloudTime);
          $TabSpectrogramsContentControlsEndDate
            .data("DateTimePicker")
            .minDate(localCloudTime);
          $TabSpectrogramsContentControlsEndDate
            .data("DateTimePicker")
            .date(localCloudTime);
        }

        --globIsStartdateShowRunning;
      }
    });

    $TabSpectrogramsContentControlsStartDate.on("dp.change", function (e) {
      if (!globSpectrogramsIsNOPDatesRangeFuncs) {
        ++globIsStartdateChangeRunning;

        // console.log('TabSpectrogramsContentControlsStartDate
        // dp.change');
        // console.log('globIsStartdateShowRunning',
        // globIsStartdateShowRunning, 'globIsEnddateShowRunning',
        // globIsEnddateShowRunning, 'globIsEnddateChangeRunning',
        // globIsEnddateChangeRunning)

        if (
          !(
            globIsStartdateShowRunning ||
            globIsEnddateShowRunning ||
            globIsEnddateChangeRunning
          )
        ) {
          // console.log(globIsStartdateChangeRunning); // DDD

          var dateTime = e.date;

          if (dateTime) {
            dateTime = dateTime.hours(dateTime.hours() + 1);

            $TabSpectrogramsContentControlsEndDate
              .data("DateTimePicker")
              .minDate(dateTime);
          }
        }

        --globIsStartdateChangeRunning;
      }

      if (
        isAnySpectrogramGraphSelected() &&
        $TabSpectrogramsContentControlsStartDate
          .data("DateTimePicker")
          .date() &&
        $TabSpectrogramsContentControlsEndDate.data("DateTimePicker").date()
      ) {
        $TabSpectrogramsContentControlsGo.prop("disabled", false);
      } else {
        $TabSpectrogramsContentControlsGo.prop("disabled", true);
      }
    });

    $TabSpectrogramsContentControlsEndDate.on("dp.show", function (e) {
      $("body")
        .find(".bootstrap-datetimepicker-widget:last")
        .css({ top: "2.2em" });

      if (!globSpectrogramsIsNOPDatesRangeFuncs) {
        ++globIsEnddateShowRunning;

        // console.log('TabSpectrogramsContentControlsEndDate dp.show');

        var nowCloud = moment().tz(globServerTimezone);
        var localCloudTime = moment(
          new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
        );

        $TabSpectrogramsContentControlsEndDate
          .data("DateTimePicker")
          .maxDate(localCloudTime);

        if (
          !$TabSpectrogramsContentControlsEndDate.data("DateTimePicker").date()
        ) {
          var localCloudTimeMin = localCloudTime
            .clone()
            .hours(localCloudTime.hours() - 1);

          $TabSpectrogramsContentControlsStartDate
            .data("DateTimePicker")
            .maxDate(localCloudTimeMin);
          $TabSpectrogramsContentControlsStartDate
            .data("DateTimePicker")
            .date(localCloudTimeMin);

          $TabSpectrogramsContentControlsEndDate
            .data("DateTimePicker")
            .minDate(localCloudTime);
          $TabSpectrogramsContentControlsEndDate
            .data("DateTimePicker")
            .date(localCloudTime);
        }

        --globIsEnddateShowRunning;
      }
    });

    $TabSpectrogramsContentControlsEndDate.on("dp.change", function (e) {
      if (!globSpectrogramsIsNOPDatesRangeFuncs) {
        ++globIsEnddateChangeRunning;

        // console.log('TabSpectrogramsContentControlsEndDate
        // dp.change');
        // console.log('globIsStartdateShowRunning',
        // globIsStartdateShowRunning, 'globIsEnddateShowRunning',
        // globIsEnddateShowRunning, 'globIsStartdateChangeRunning',
        // globIsStartdateChangeRunning)

        if (
          !(
            globIsStartdateShowRunning ||
            globIsEnddateShowRunning ||
            globIsStartdateChangeRunning
          )
        ) {
          // console.log(globIsEnddateChangeRunning); // DDD

          var dateTime = e.date;

          if (dateTime) {
            dateTime = dateTime.hours(dateTime.hours() - 1);

            $TabSpectrogramsContentControlsStartDate
              .data("DateTimePicker")
              .maxDate(dateTime);
          }
        }

        --globIsEnddateChangeRunning;
      }

      if (
        isAnySpectrogramGraphSelected() &&
        $TabSpectrogramsContentControlsStartDate
          .data("DateTimePicker")
          .date() &&
        $TabSpectrogramsContentControlsEndDate.data("DateTimePicker").date()
      ) {
        $TabSpectrogramsContentControlsGo.prop("disabled", false);
      } else {
        $TabSpectrogramsContentControlsGo.prop("disabled", true);
      }
    });

    $("#TabSpectrogramsContentControlsPre").on("click", function (e) {
      enableSpectrogramsPreDateUI();

      if (isAnySpectrogramGraphSelected()) {
        $TabSpectrogramsContentControlsGo.prop("disabled", false);
      }
    });

    $("#TabSpectrogramsContentControlsRange").on("click", function (e) {
      enableSpectrogramsDateRangeUI();

      if (
        !(
          $TabSpectrogramsContentControlsStartDate
            .data("DateTimePicker")
            .date() &&
          $TabSpectrogramsContentControlsEndDate.data("DateTimePicker").date()
        )
      ) {
        $TabSpectrogramsContentControlsGo.prop("disabled", true);
      }
    });

    $TabSpectrogramsContentControlsGo.on(
      "click",
      tabSpectrogramsContentControlsGo
    );

    // $TabSpectrogramsContentGraphsContainer
    // spectrogramsContentGraphsContainerRect
    if (numOfSpectrogramsWindows > 1) {
      // Not used currently
      var windowHeight =
        spectrogramsContentGraphsContainerRect.height /
        numOfSpectrogramsWindows;
      var windowWidth =
        spectrogramsContentGraphsContainerRect.width / numOfSpectrogramsWindows;
    } else {
      var aWindow = document.createElement("div");
      aWindow.id = "SpectrogramWindow1";
      // aWindow.style.maxWidth = "90%";
      aWindow.style.height = "100%";

      aWindow.innerHTML = '<div id="SpectrogramWin1GraphsContainer"></div>';

      $TabSpectrogramsContentGraphsContainer.append(aWindow);

      $SpectrogramWindow1 = $(aWindow);
      $SpectrogramWin1ControlsContainer = $(
        "#SpectrogramWin1ControlsContainer"
      );
      $Win1TD = $("#Win1TD");

      $SpectrogramWin1CancContainer = $("#SpectrogramWin1CancContainer");
      $SpectrogramWin1Canc = $("#SpectrogramWin1Canc");
      if (isUbiqamUser()) {
        $SpectrogramWin1CancContainer.show();
      } else {
        $SpectrogramWin1CancContainer.hide();
      }

      $SpectrogramsWin1Vertical = $("#SpectrogramsWin1Vertical");
      $SpectrogramsWin1Horizontal = $("#SpectrogramsWin1Horizontal");
      $SpectrogramWin1GraphsContainer = $("#SpectrogramWin1GraphsContainer");
      $SpectrogramWin1GraphSel1 = $("#SpectrogramWin1GraphSel1");
      $SpectrogramWin1GraphSel2 = $("#SpectrogramWin1GraphSel2");
      $SpectrogramWin1GraphSel3 = $("#SpectrogramWin1GraphSel3");
      $SpectrogramWin1GraphSel4 = $("#SpectrogramWin1GraphSel4");
      $SpectrogramWin2GraphSel1 = $("#SpectrogramWin2GraphSel1");
      $SpectrogramWin2GraphSel2 = $("#SpectrogramWin2GraphSel2");
      $SpectrogramWin2GraphSel3 = $("#SpectrogramWin2GraphSel3");
      $SpectrogramWin2GraphSel4 = $("#SpectrogramWin2GraphSel4");

      $SpectrogramWin1ControlsContainer.on(
        "change",
        "#SpectrogramWin1GraphSel1, #SpectrogramWin2GraphSel1, #SpectrogramWin1GraphSel2, #SpectrogramWin2GraphSel2, #SpectrogramWin1GraphSel3, #SpectrogramWin2GraphSel3, #SpectrogramWin1GraphSel4, #SpectrogramWin2GraphSel4",
        function (e) {
          // console.log(e);

          if (isAnySpectrogramGraphSelected()) {
            if (
              isSpectrogramPre ||
              ($TabSpectrogramsContentControlsStartDate
                .data("DateTimePicker")
                .date() &&
                $TabSpectrogramsContentControlsEndDate
                  .data("DateTimePicker")
                  .date())
            ) {
              $TabSpectrogramsContentControlsGo.prop("disabled", false);
            }
          } else {
            $TabSpectrogramsContentControlsGo.prop("disabled", true);
          }
        }
      );
    }

    $("#Win1ColormapSel").on("change", function onColormapChange(e) {
      globColormap = $("#Win1ColormapSel").val();

      IS_JET_COLORS = globColormap === "jet";
    });

    $TabSpectrogramsContentControlsPowerFilterToggle.on("change", function (e) {
      var isUIEnabled =
        $TabSpectrogramsContentControlsPowerFilterToggle[0].checked === true;

      enableSpectrogramsPowerFilterUI(isUIEnabled);
    });

    addToolTipsElements();
  }

  function enableRRDPreDateUI() {
    isRRDPreDate = true;

    $TabRRDContentControlsStartDate.find("input").prop("disabled", true);
    $TabRRDContentControlsEndDate.find("input").prop("disabled", true);
    $TabRRDContentControlsShowLast.prop("disabled", false);
    $TabRRDContentControlsShowLast.removeClass("grayed-out");
    $TabRRDContentControlsGo.prop("disabled", false);
  }

  function enableRRDDateRangeUI() {
    isRRDPreDate = false;

    $TabRRDContentControlsStartDate.find("input").prop("disabled", false);
    $TabRRDContentControlsEndDate.find("input").prop("disabled", false);
    $TabRRDContentControlsShowLast.prop("disabled", true);
    $TabRRDContentControlsShowLast.addClass("grayed-out");
  }

  function enableOptixModePreDateUI() {
    isOptixModePreDate = true;

    $TabOptixModeContentControlsStartDate.find("input").prop("disabled", true);
    $TabOptixModeContentControlsEndDate.find("input").prop("disabled", true);
    $TabOptixModeContentControlsShowLast.prop("disabled", false);
    $TabOptixModeContentControlsShowLast.removeClass("grayed-out");
    $TabOptixModeContentControlsGo.prop("disabled", false);
  }

  function enableOptixModeDateRangeUI() {
    isOptixModePreDate = false;

    $TabOptixModeContentControlsStartDate.find("input").prop("disabled", false);
    $TabOptixModeContentControlsEndDate.find("input").prop("disabled", false);
    $TabOptixModeContentControlsShowLast.prop("disabled", true);
    $TabOptixModeContentControlsShowLast.addClass("grayed-out");
  }

  function enableInternalsParentPreDateUI() {
    isInternalsParentPreDate = true;

    $TabInternalsContentContainerParentStartDate
      .find("input")
      .prop("disabled", true);
    $TabInternalsContentContainerParentEndDate
      .find("input")
      .prop("disabled", true);
    $TabInternalsContentContainerParentShowLast.prop("disabled", false);
    $TabInternalsContentContainerParentShowLast.removeClass("grayed-out");
    $TabInternalsContentContainerParentGo.prop("disabled", false);
  }

  function enableInternalsParentDateRangeUI() {
    isInternalsParentPreDate = false;

    $TabInternalsContentContainerParentStartDate
      .find("input")
      .prop("disabled", false);
    $TabInternalsContentContainerParentEndDate
      .find("input")
      .prop("disabled", false);
    $TabInternalsContentContainerParentShowLast.prop("disabled", true);
    $TabInternalsContentContainerParentShowLast.addClass("grayed-out");
  }

  function enableInternalsParentPreDateUICEH() {
    isInternalsParentPreDateCEH = true;

    $TabInternalsContentContainerParentStartDateCEH
      .find("input")
      .prop("disabled", true);
    $TabInternalsContentContainerParentEndDateCEH
      .find("input")
      .prop("disabled", true);
    $TabInternalsContentContainerParentShowLastCEH.prop("disabled", false);
    $TabInternalsContentContainerParentShowLastCEH.removeClass("grayed-out");
    $TabInternalsContentContainerParentGoCEH.prop("disabled", false);
  }

  function enableInternalsParentDateRangeUICEH() {
    isInternalsParentPreDateCEH = false;

    $TabInternalsContentContainerParentStartDateCEH
      .find("input")
      .prop("disabled", false);
    $TabInternalsContentContainerParentEndDateCEH
      .find("input")
      .prop("disabled", false);
    $TabInternalsContentContainerParentShowLastCEH.prop("disabled", true);
    $TabInternalsContentContainerParentShowLastCEH.addClass("grayed-out");
  }

  function enableInternalsParentPreDateUITEH() {
    isInternalsParentPreDateTEH = true;

    $TabInternalsContentContainerParentStartDateTEH
      .find("input")
      .prop("disabled", true);
    $TabInternalsContentContainerParentEndDateTEH
      .find("input")
      .prop("disabled", true);
    $TabInternalsContentContainerParentShowLastTEH.prop("disabled", false);
    $TabInternalsContentContainerParentShowLastTEH.removeClass("grayed-out");
    $TabInternalsContentContainerParentGoTEH.prop("disabled", false);
  }

  function enableInternalsParentDateRangeUITEH() {
    isInternalsParentPreDateTEH = false;

    $TabInternalsContentContainerParentStartDateTEH
      .find("input")
      .prop("disabled", false);
    $TabInternalsContentContainerParentEndDateTEH
      .find("input")
      .prop("disabled", false);
    $TabInternalsContentContainerParentShowLastTEH.prop("disabled", true);
    $TabInternalsContentContainerParentShowLastTEH.addClass("grayed-out");
  }

  function enableSpectrogramsPreDateUI() {
    isSpectrogramPre = true;

    $TabSpectrogramsContentControlsStartDate
      .find("input")
      .prop("disabled", true);
    $TabSpectrogramsContentControlsEndDate.find("input").prop("disabled", true);
    $TabSpectrogramsContentControlsShowLast.prop("disabled", false);
    $TabSpectrogramsContentControlsShowLast.removeClass("grayed-out");
  }

  function enableSpectrogramsDateRangeUI() {
    isSpectrogramPre = false;

    $TabSpectrogramsContentControlsStartDate
      .find("input")
      .prop("disabled", false);
    $TabSpectrogramsContentControlsEndDate
      .find("input")
      .prop("disabled", false);
    $TabSpectrogramsContentControlsShowLast.prop("disabled", true);
    $TabSpectrogramsContentControlsShowLast.addClass("grayed-out");
  }

  function enableNodePadPreDateUI() {
    isNodePadPreDate = true;

    $TabNodePadContentControlsStartDate.find("input").prop("disabled", true);
    $TabNodePadContentControlsEndDate.find("input").prop("disabled", true);
    $TabNodePadContentControlsShowLast.prop("disabled", false);
    $TabNodePadContentControlsShowLast.removeClass("grayed-out");
  }

  function enableNodePadDateRangeUI() {
    isNodePadPreDate = false;

    $TabNodePadContentControlsStartDate.find("input").prop("disabled", false);
    $TabNodePadContentControlsEndDate.find("input").prop("disabled", false);
    $TabNodePadContentControlsShowLast.prop("disabled", true);
    $TabNodePadContentControlsShowLast.addClass("grayed-out");
  }

  function enableRRDPowerFilterUI(isEnabled) {
    if (isEnabled) {
      $("#TabRRDContentControlsPoweFilterMin").prop("disabled", false);
      $("#TabRRDContentControlsPoweFilterMax").prop("disabled", false);

      globalRRDPowerFilterMinVal = parseInt(
        $("#TabRRDContentControlsPoweFilterMin").val()
      );
      globalRRDPowerFilterMaxVal = parseInt(
        $("#TabRRDContentControlsPoweFilterMax").val()
      );

      if (
        !isNaN(globalRRDPowerFilterMinVal) &&
        !isNaN(globalRRDPowerFilterMaxVal)
      ) {
        globalIsRRDPowerFilter = true;
      } else {
        globalIsRRDPowerFilter = false;
      }
    } else {
      globalIsRRDPowerFilter = false;

      $("#TabRRDContentControlsPoweFilterMin").prop("disabled", true);
      $("#TabRRDContentControlsPoweFilterMax").prop("disabled", true);
    }
  }

  function enableSpectrogramsPowerFilterUI(isEnabled) {
    if (isEnabled) {
      $("#TabSpectrogramsContentControlsPoweFilterMin").prop("disabled", false);
      $("#TabSpectrogramsContentControlsPoweFilterMax").prop("disabled", false);

      globalSpectrogramsPowerFilterMinVal = parseInt(
        $("#TabSpectrogramsContentControlsPoweFilterMin").val()
      );
      globalSpectrogramsPowerFilterMaxVal = parseInt(
        $("#TabSpectrogramsContentControlsPoweFilterMax").val()
      );

      if (
        !isNaN(globalSpectrogramsPowerFilterMinVal) ||
        !isNaN(globalSpectrogramsPowerFilterMaxVal)
      ) {
        globalIsSpectrogramsPowerFilter = true;
      } else {
        globalIsSpectrogramsPowerFilter = false;
      }
    } else {
      globalIsSpectrogramsPowerFilter = false;

      $("#TabSpectrogramsContentControlsPoweFilterMin").prop("disabled", true);
      $("#TabSpectrogramsContentControlsPoweFilterMax").prop("disabled", true);
    }
  }

  function initNodePadTab() {
    $TabNodePadContentControlsStartDate.datetimepicker({
      useCurrent: false, // Important! See issue #1075
      sideBySide: true,
      allowInputToggle: true,
      toolbarPlacement: "bottom",
      showTodayButton: true,
      showClear: true,
      format: "DD MMM YYYY HH:mm",
    });

    $TabNodePadContentControlsEndDate.datetimepicker({
      useCurrent: false, // Important! See issue #1075
      sideBySide: true,
      allowInputToggle: true,
      toolbarPlacement: "bottom",
      showTodayButton: true,
      showClear: true,
      format: "DD MMM YYYY HH:mm",
    });

    $TabNodePadContentControlsStartDateIcon.on("click", function () {
      $TabNodePadContentControlsStartDate.data("DateTimePicker").show();
    });

    $TabNodePadContentControlsEndDateIcon.on("click", function () {
      $TabNodePadContentControlsEndDate.data("DateTimePicker").show();
    });

    $TabNodePadContentControlsStartDate.on("dp.show", function (e) {
      $("body")
        .find(".bootstrap-datetimepicker-widget:last")
        .css({ top: "2.2em" });

      // if (!globRRDIsNOPDatesRangeFuncs) {
      ++globIsStartdateShowRunning;

      // console.log('TabRRDContentControlsStartDate dp.show');

      if (
        !$TabNodePadContentControlsStartDate.data("DateTimePicker").maxDate()
      ) {
        var nowCloud = moment().tz(globServerTimezone);
        var localCloudTime = moment(
          new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
        );
        var localCloudTimeMin = localCloudTime
          .clone()
          .hours(localCloudTime.hours() - 1);

        $TabNodePadContentControlsStartDate
          .data("DateTimePicker")
          .maxDate(localCloudTimeMin);
        $TabNodePadContentControlsStartDate
          .data("DateTimePicker")
          .date(localCloudTimeMin);

        $TabNodePadContentControlsEndDate
          .data("DateTimePicker")
          .maxDate(localCloudTime);
        $TabNodePadContentControlsEndDate
          .data("DateTimePicker")
          .minDate(localCloudTime);
        $TabNodePadContentControlsEndDate
          .data("DateTimePicker")
          .date(localCloudTime);
      }

      --globIsStartdateShowRunning;
      // }
    });

    $TabNodePadContentControlsStartDate.on("dp.change", function (e) {
      // if (!globRRDIsNOPDatesRangeFuncs) {
      ++globIsStartdateChangeRunning;

      // console.log('TabRRDContentControlsStartDate dp.change');
      // console.log('globIsStartdateShowRunning',
      // globIsStartdateShowRunning, 'globIsEnddateShowRunning',
      // globIsEnddateShowRunning, 'globIsEnddateChangeRunning',
      // globIsEnddateChangeRunning)

      if (
        !(
          globIsStartdateShowRunning ||
          globIsEnddateShowRunning ||
          globIsEnddateChangeRunning
        )
      ) {
        // console.log(globIsStartdateChangeRunning); // DDD

        var dateTime = e.date;

        if (dateTime) {
          dateTime = dateTime.hours(dateTime.hours() + 1);

          $TabNodePadContentControlsEndDate
            .data("DateTimePicker")
            .minDate(dateTime);
        }
      }

      --globIsStartdateChangeRunning;
      // }

      if (
        $TabNodePadContentControlsStartDate.data("DateTimePicker").date() &&
        $TabNodePadContentControlsEndDate.data("DateTimePicker").date()
      ) {
        $TabNodePadContentControlsGo.prop("disabled", false);
      } else {
        $TabNodePadContentControlsGo.prop("disabled", true);
      }
    });

    $TabNodePadContentControlsEndDate.on("dp.show", function (e) {
      $("body")
        .find(".bootstrap-datetimepicker-widget:last")
        .css({ top: "2.2em" });

      // if (!globRRDIsNOPDatesRangeFuncs) {
      ++globIsEnddateShowRunning;

      // console.log('TabRRDContentControlsEndDate dp.show');

      var nowCloud = moment().tz(globServerTimezone);
      var localCloudTime = moment(
        new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
      );

      $TabNodePadContentControlsEndDate
        .data("DateTimePicker")
        .maxDate(localCloudTime);

      if (!$TabNodePadContentControlsEndDate.data("DateTimePicker").date()) {
        var localCloudTimeMin = localCloudTime
          .clone()
          .hours(localCloudTime.hours() - 1);

        $TabNodePadContentControlsStartDate
          .data("DateTimePicker")
          .maxDate(localCloudTimeMin);
        $TabNodePadContentControlsStartDate
          .data("DateTimePicker")
          .date(localCloudTimeMin);

        $TabNodePadContentControlsEndDate
          .data("DateTimePicker")
          .minDate(localCloudTime);
        $TabNodePadContentControlsEndDate
          .data("DateTimePicker")
          .date(localCloudTime);
      }

      --globIsEnddateShowRunning;
      // }
    });

    $TabNodePadContentControlsEndDate.on("dp.change", function (e) {
      // if (!globRRDIsNOPDatesRangeFuncs) {
      ++globIsEnddateChangeRunning;

      // console.log('TabRRDContentControlsEndDate dp.change');
      // console.log('globIsStartdateShowRunning',
      // globIsStartdateShowRunning, 'globIsEnddateShowRunning',
      // globIsEnddateShowRunning, 'globIsStartdateChangeRunning',
      // globIsStartdateChangeRunning)

      if (
        !(
          globIsStartdateShowRunning ||
          globIsEnddateShowRunning ||
          globIsStartdateChangeRunning
        )
      ) {
        // console.log(globIsEnddateChangeRunning); // DDD

        var dateTime = e.date;

        if (dateTime) {
          dateTime = dateTime.hours(dateTime.hours() - 1);

          $TabNodePadContentControlsStartDate
            .data("DateTimePicker")
            .maxDate(dateTime);
        }
      }

      --globIsEnddateChangeRunning;
      // }

      if (
        $TabNodePadContentControlsStartDate.data("DateTimePicker").date() &&
        $TabNodePadContentControlsEndDate.data("DateTimePicker").date()
      ) {
        $TabNodePadContentControlsGo.prop("disabled", false);
      } else {
        $TabNodePadContentControlsGo.prop("disabled", true);
      }
    });

    $("#TabNodePadContentControlsPre").on("click", function (e) {
      enableNodePadPreDateUI();

      $TabNodePadContentControlsGo.prop("disabled", false);

      // tabNodePadGraphsContentControlsGo();
    });

    $("#TabNodePadContentControlsRange").on("click", function (e) {
      enableNodePadDateRangeUI();

      if (
        !(
          $TabNodePadContentControlsStartDate.data("DateTimePicker").date() &&
          $TabNodePadContentControlsEndDate.data("DateTimePicker").date()
        )
      ) {
        $TabNodePadContentControlsGo.prop("disabled", true);
      }
    });

    $TabNodePadContentControlsShowLast.on("change", function (e) {
      tabNodePadGraphsContentControlsGo();
    });

    $TabNodePadContentControlsGo.on("click", tabNodePadGraphsContentControlsGo);
  }

  function initRRDTab() {
    if (isUbiqamUser()) {
      $("#RRDSuspectedPimSelector").show();
      globalIsRRDSuspectedPim =
        $TabRRDContentControlsSuspectedPIMToggle[0].checked === true;
    } else {
      $("#RRDSuspectedPimSelector").hide();
      globalIsRRDSuspectedPim = false;
    }

    $TabRRDContentControlsStartDate.datetimepicker({
      useCurrent: false, // Important! See issue #1075
      sideBySide: true,
      allowInputToggle: true,
      toolbarPlacement: "bottom",
      showTodayButton: true,
      showClear: true,
      format: "DD MMM YYYY HH:mm",
    });

    $TabRRDContentControlsEndDate.datetimepicker({
      useCurrent: false, // Important! See issue #1075
      sideBySide: true,
      allowInputToggle: true,
      toolbarPlacement: "bottom",
      showTodayButton: true,
      showClear: true,
      format: "DD MMM YYYY HH:mm",
    });

    $TabRRDContentControlsStartDateIcon.on("click", function () {
      $TabRRDContentControlsStartDate.data("DateTimePicker").show();
    });

    $TabRRDContentControlsEndDateIcon.on("click", function () {
      $TabRRDContentControlsEndDate.data("DateTimePicker").show();
    });

    $TabRRDContentControlsStartDate.on("dp.show", function (e) {
      $("body")
        .find(".bootstrap-datetimepicker-widget:last")
        .css({ top: "2.2em" });

      if (!globRRDIsNOPDatesRangeFuncs) {
        ++globIsStartdateShowRunning;

        // console.log('TabRRDContentControlsStartDate dp.show');

        if (!$TabRRDContentControlsStartDate.data("DateTimePicker").maxDate()) {
          var nowCloud = moment().tz(globServerTimezone);
          var localCloudTime = moment(
            new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
          );
          var localCloudTimeMin = localCloudTime
            .clone()
            .hours(localCloudTime.hours() - 1);

          $TabRRDContentControlsStartDate
            .data("DateTimePicker")
            .maxDate(localCloudTimeMin);
          $TabRRDContentControlsStartDate
            .data("DateTimePicker")
            .date(localCloudTimeMin);

          $TabRRDContentControlsEndDate
            .data("DateTimePicker")
            .maxDate(localCloudTime);
          $TabRRDContentControlsEndDate
            .data("DateTimePicker")
            .minDate(localCloudTime);
          $TabRRDContentControlsEndDate
            .data("DateTimePicker")
            .date(localCloudTime);
        }

        --globIsStartdateShowRunning;
      }
    });

    $TabRRDContentControlsStartDate.on("dp.change", function (e) {
      if (!globRRDIsNOPDatesRangeFuncs) {
        ++globIsStartdateChangeRunning;

        // console.log('TabRRDContentControlsStartDate dp.change');
        // console.log('globIsStartdateShowRunning',
        // globIsStartdateShowRunning, 'globIsEnddateShowRunning',
        // globIsEnddateShowRunning, 'globIsEnddateChangeRunning',
        // globIsEnddateChangeRunning)

        if (
          !(
            globIsStartdateShowRunning ||
            globIsEnddateShowRunning ||
            globIsEnddateChangeRunning
          )
        ) {
          // console.log(globIsStartdateChangeRunning); // DDD

          var dateTime = e.date;

          if (dateTime) {
            dateTime = dateTime.hours(dateTime.hours() + 1);

            $TabRRDContentControlsEndDate
              .data("DateTimePicker")
              .minDate(dateTime);
          }
        }

        --globIsStartdateChangeRunning;
      }

      if (
        isAnySpectrogramGraphSelected() &&
        $TabRRDContentControlsStartDate.data("DateTimePicker").date() &&
        $TabRRDContentControlsEndDate.data("DateTimePicker").date()
      ) {
        $TabRRDContentControlsGo.prop("disabled", false);
      } else {
        $TabRRDContentControlsGo.prop("disabled", true);
      }
    });

    $TabRRDContentControlsEndDate.on("dp.show", function (e) {
      $("body")
        .find(".bootstrap-datetimepicker-widget:last")
        .css({ top: "2.2em" });

      if (!globRRDIsNOPDatesRangeFuncs) {
        ++globIsEnddateShowRunning;

        // console.log('TabRRDContentControlsEndDate dp.show');

        var nowCloud = moment().tz(globServerTimezone);
        var localCloudTime = moment(
          new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
        );

        $TabRRDContentControlsEndDate
          .data("DateTimePicker")
          .maxDate(localCloudTime);

        if (!$TabRRDContentControlsEndDate.data("DateTimePicker").date()) {
          var localCloudTimeMin = localCloudTime
            .clone()
            .hours(localCloudTime.hours() - 1);

          $TabRRDContentControlsStartDate
            .data("DateTimePicker")
            .maxDate(localCloudTimeMin);
          $TabRRDContentControlsStartDate
            .data("DateTimePicker")
            .date(localCloudTimeMin);

          $TabRRDContentControlsEndDate
            .data("DateTimePicker")
            .minDate(localCloudTime);
          $TabRRDContentControlsEndDate
            .data("DateTimePicker")
            .date(localCloudTime);
        }

        --globIsEnddateShowRunning;
      }
    });

    $TabRRDContentControlsEndDate.on("dp.change", function (e) {
      if (!globRRDIsNOPDatesRangeFuncs) {
        ++globIsEnddateChangeRunning;

        // console.log('TabRRDContentControlsEndDate dp.change');
        // console.log('globIsStartdateShowRunning',
        // globIsStartdateShowRunning, 'globIsEnddateShowRunning',
        // globIsEnddateShowRunning, 'globIsStartdateChangeRunning',
        // globIsStartdateChangeRunning)

        if (
          !(
            globIsStartdateShowRunning ||
            globIsEnddateShowRunning ||
            globIsStartdateChangeRunning
          )
        ) {
          // console.log(globIsEnddateChangeRunning); // DDD

          var dateTime = e.date;

          if (dateTime) {
            dateTime = dateTime.hours(dateTime.hours() - 1);

            $TabRRDContentControlsStartDate
              .data("DateTimePicker")
              .maxDate(dateTime);
          }
        }

        --globIsEnddateChangeRunning;
      }

      if (
        isAnySpectrogramGraphSelected() &&
        $TabRRDContentControlsStartDate.data("DateTimePicker").date() &&
        $TabRRDContentControlsEndDate.data("DateTimePicker").date()
      ) {
        $TabRRDContentControlsGo.prop("disabled", false);
      } else {
        $TabRRDContentControlsGo.prop("disabled", true);
      }
    });

    $("#TabRRDContentControlsPre").on("click", function (e) {
      enableRRDPreDateUI();

      globRRDGraphsZoomDates = [];

      if (globIsParentSummaryRRDGraphs) {
        tabRRDGraphsContentControlsGo(null, null, true);
      } else {
        tabRRDGraphsContentControlsGo();
      }
    });

    $("#TabRRDContentControlsRange").on("click", function (e) {
      enableRRDDateRangeUI();

      if (
        !(
          $TabRRDContentControlsStartDate.data("DateTimePicker").date() &&
          $TabRRDContentControlsEndDate.data("DateTimePicker").date()
        )
      ) {
        $TabRRDContentControlsGo.prop("disabled", true);
      }
    });

    $TabRRDContentControlsShowLast.on("change", function (e) {
      if (globAjaxRequest) {
        globAjaxRequest.abort();
        globAjaxRequest = false;
        rrdAjaxUi(false);
        globIsParentSummaryRRDGraphs = false;
      }

      $TabRRDContentControlsGo.focus();

      globRRDGraphsZoomDates = [];

      if (globIsParentSummaryRRDGraphs) {
        tabRRDGraphsContentControlsGo(null, null, true);
      } else {
        tabRRDGraphsContentControlsGo();
      }
    });

    $TabRRDContentControlsPowerFilterToggle.on("change", function (e) {
      var isUIEnabled =
        $TabRRDContentControlsPowerFilterToggle[0].checked === true;

      enableRRDPowerFilterUI(isUIEnabled);
    });

    $TabRRDContentControlsSuspectedPIMToggle.on("change", function (e) {
      var isUIEnabled =
        $TabRRDContentControlsSuspectedPIMToggle[0].checked === true;

      globalIsRRDSuspectedPim = isUIEnabled;
    });

    $TabRRDContentControlsGo.on("click", function (e) {
      globRRDGraphsZoomDates = [];

      if (globIsParentSummaryRRDGraphs) {
        tabRRDGraphsContentControlsGo(null, null, true);
      } else {
        tabRRDGraphsContentControlsGo();
      }
    });

    addRRDToolTipsElements();
  }

  function initOptixModeTab() {
    $TabOptixModeContentControlsStartDate.datetimepicker({
      useCurrent: false, // Important! See issue #1075
      sideBySide: true,
      allowInputToggle: true,
      toolbarPlacement: "bottom",
      showTodayButton: true,
      showClear: true,
      format: "DD MMM YYYY HH:mm",
    });

    $TabOptixModeContentControlsEndDate.datetimepicker({
      useCurrent: false, // Important! See issue #1075
      sideBySide: true,
      allowInputToggle: true,
      toolbarPlacement: "bottom",
      showTodayButton: true,
      showClear: true,
      format: "DD MMM YYYY HH:mm",
    });

    $TabOptixModeContentControlsStartDateIcon.on("click", function () {
      $TabOptixModeContentControlsStartDate.data("DateTimePicker").show();
    });

    $TabOptixModeContentControlsEndDateIcon.on("click", function () {
      $TabOptixModeContentControlsEndDate.data("DateTimePicker").show();
    });

    $TabOptixModeContentControlsStartDate.on("dp.show", function (e) {
      $("body")
        .find(".bootstrap-datetimepicker-widget:last")
        .css({ top: "2.2em" });

      if (!globOptixModeIsNOPDatesRangeFuncs) {
        ++globIsStartdateShowRunning;

        // console.log('TabOptixModeContentControlsStartDate dp.show');

        if (
          !$TabOptixModeContentControlsStartDate
            .data("DateTimePicker")
            .maxDate()
        ) {
          var nowCloud = moment().tz(globServerTimezone);
          var localCloudTime = moment(
            new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
          );
          var localCloudTimeMin = localCloudTime
            .clone()
            .hours(localCloudTime.hours() - 1);

          $TabOptixModeContentControlsStartDate
            .data("DateTimePicker")
            .maxDate(localCloudTimeMin);
          $TabOptixModeContentControlsStartDate
            .data("DateTimePicker")
            .date(localCloudTimeMin);

          $TabOptixModeContentControlsEndDate
            .data("DateTimePicker")
            .maxDate(localCloudTime);
          $TabOptixModeContentControlsEndDate
            .data("DateTimePicker")
            .minDate(localCloudTime);
          $TabOptixModeContentControlsEndDate
            .data("DateTimePicker")
            .date(localCloudTime);
        }

        --globIsStartdateShowRunning;
      }
    });

    $TabOptixModeContentControlsStartDate.on("dp.change", function (e) {
      if (!globOptixModeIsNOPDatesRangeFuncs) {
        ++globIsStartdateChangeRunning;

        // console.log('TabRRDContentControlsStartDate dp.change');
        // console.log('globIsStartdateShowRunning',
        // globIsStartdateShowRunning, 'globIsEnddateShowRunning',
        // globIsEnddateShowRunning, 'globIsEnddateChangeRunning',
        // globIsEnddateChangeRunning)

        if (
          !(
            globIsStartdateShowRunning ||
            globIsEnddateShowRunning ||
            globIsEnddateChangeRunning
          )
        ) {
          // console.log(globIsStartdateChangeRunning); // DDD

          var dateTime = e.date;

          if (dateTime) {
            dateTime = dateTime.hours(dateTime.hours() + 1);

            $TabOptixModeContentControlsEndDate
              .data("DateTimePicker")
              .minDate(dateTime);
          }
        }

        --globIsStartdateChangeRunning;
      }

      if (
        $TabOptixModeContentControlsStartDate.data("DateTimePicker").date() &&
        $TabOptixModeContentControlsEndDate.data("DateTimePicker").date()
      ) {
        $TabOptixModeContentControlsGo.prop("disabled", false);
      } else {
        $TabOptixModeContentControlsGo.prop("disabled", true);
      }
    });

    $TabOptixModeContentControlsEndDate.on("dp.show", function (e) {
      $("body")
        .find(".bootstrap-datetimepicker-widget:last")
        .css({ top: "2.2em" });

      if (!globOptixModeIsNOPDatesRangeFuncs) {
        ++globIsEnddateShowRunning;

        // console.log('TabOptixModeContentControlsEndDate dp.show');

        var nowCloud = moment().tz(globServerTimezone);
        var localCloudTime = moment(
          new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
        );

        $TabOptixModeContentControlsEndDate
          .data("DateTimePicker")
          .maxDate(localCloudTime);

        if (
          !$TabOptixModeContentControlsEndDate.data("DateTimePicker").date()
        ) {
          var localCloudTimeMin = localCloudTime
            .clone()
            .hours(localCloudTime.hours() - 1);

          $TabOptixModeContentControlsStartDate
            .data("DateTimePicker")
            .maxDate(localCloudTimeMin);
          $TabOptixModeContentControlsStartDate
            .data("DateTimePicker")
            .date(localCloudTimeMin);

          $TabOptixModeContentControlsEndDate
            .data("DateTimePicker")
            .minDate(localCloudTime);
          $TabOptixModeContentControlsEndDate
            .data("DateTimePicker")
            .date(localCloudTime);
        }

        --globIsEnddateShowRunning;
      }
    });

    $TabOptixModeContentControlsEndDate.on("dp.change", function (e) {
      if (!globOptixModeIsNOPDatesRangeFuncs) {
        ++globIsEnddateChangeRunning;

        // console.log('TabOptixModeContentControlsEndDate dp.change');
        // console.log('globIsStartdateShowRunning',
        // globIsStartdateShowRunning, 'globIsEnddateShowRunning',
        // globIsEnddateShowRunning, 'globIsStartdateChangeRunning',
        // globIsStartdateChangeRunning)

        if (
          !(
            globIsStartdateShowRunning ||
            globIsEnddateShowRunning ||
            globIsStartdateChangeRunning
          )
        ) {
          // console.log(globIsEnddateChangeRunning); // DDD

          var dateTime = e.date;
          Go();
          if (dateTime) {
            dateTime = dateTime.hours(dateTime.hours() - 1);

            $TabOptixModeContentControlsStartDate
              .data("DateTimePicker")
              .maxDate(dateTime);
          }
        }

        --globIsEnddateChangeRunning;
      }

      if (
        $TabOptixModeContentControlsStartDate.data("DateTimePicker").date() &&
        $TabOptixModeContentControlsEndDate.data("DateTimePicker").date()
      ) {
        $TabOptixModeContentControlsGo.prop("disabled", false);
      } else {
        $TabOptixModeContentControlsGo.prop("disabled", true);
      }
    });

    $("#TabOptixModeContentControlsPre").on("click", function (e) {
      enableOptixModePreDateUI();

      globRRDGraphsZoomDates = [];

      tabOptixModeGraphsContentControlsGo();
    });

    $("#TabOptixModeContentControlsRange").on("click", function (e) {
      enableOptixModeDateRangeUI();

      if (
        !(
          $TabOptixModeContentControlsStartDate.data("DateTimePicker").date() &&
          $TabOptixModeContentControlsEndDate.data("DateTimePicker").date()
        )
      ) {
        $TabOptixModeContentControlsGo.prop("disabled", true);
      }
    });

    $TabOptixModeContentControlsShowLast.on("change", function (e) {
      $TabOptixModeContentControlsGo.focus();

      globRRDGraphsZoomDates = [];

      tabOptixModeGraphsContentControlsGo();
    });

    $TabOptixModeContentControlsGo.on("click", function (e) {
      globRRDGraphsZoomDates = [];

      tabOptixModeGraphsContentControlsGo();
    });
  }

  function initRemoteAdminMngTab() {
    $("#TabWebifAdminPassMDownloadSiteCSVGo").on("click", function (e) {
      TabRemoteAdminMngDownloadSiteCSVGo();
    });

    $("#TabTabWebifAdminPassMFileUploadGo").on("click", function (e) {
      TabTabWebifAdminPassMFileUploadGo();
    });
  }

  function saveBlob(filename, data) {
    var blob = new Blob([data], {
      type: "text/csv",
    });

    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, filename);
    } else {
      var elem = window.document.createElement("a");
      elem.href = window.URL.createObjectURL(blob);
      elem.download = filename;
      document.body.appendChild(elem);
      elem.click();

      setTimeout(() => {
        document.body.removeChild(elem);
        window.URL.revokeObjectURL(elem.href);
      }, 1000);
    }
  }

  function TabRemoteAdminMngDownloadSiteCSVGo() {
    $("#TabWebifAdminPassMDownloadSiteCSVGo").prop("disabled", true);
    $("#TabWebifAdminPassMDownloadSiteCSVGoAjaxImage").removeClass("hidden");

    var sitesList = globTreeData.FamiliyTree.split(",")
      .filter(function (val) {
        return val.startsWith("D_");
      })
      .sort();
    var reportList = [];
    var index = 0;

    sitesList.forEach(function (deviceNodeId) {
      ++index;
      var deviceNodeData = getNodeData(deviceNodeId);
      var deviceNodeHData = getHData(deviceNodeId);

      var devicePath = "";
      $TreeGraph
        .jstree(true)
        .get_node(deviceNodeId)
        .parents.forEach(function (parentId, index, array) {
          // if ((parentId != '#') && (parentId != 'L_j1_609'))  { // # = root, L_j1_609 = USA
          if (index < array.length - 2) {
            // Remove # and first node. In ATT's case it is L_j1_609 = USA
            var parentNodeData = getNodeData(parentId);

            devicePath = parentNodeData.node_name + "/" + devicePath;
          }
        });
      devicePath += deviceNodeData.node_name;

      var unitName = deviceNodeHData.nodeNames
        .split(",")
        .filter(function (val) {
          return val.endsWith("-ucu");
        })[0];
      unitName = unitName ? unitName.substr(0, 7) : "";

      reportList.push({
        index: index,
        path: devicePath,
        // actualName: deviceNodeData.act_name,
        actualName: unitName,
        pass: "",
      });
    });

    var reportText = "#,Device Path, Actual Device Name, Admin Password\n";
    reportList.forEach(function (entry) {
      reportText +=
        entry.index +
        "," +
        entry.path +
        "," +
        entry.actualName +
        "," +
        entry.pass +
        "\n";
    });

    var now = new Date()
      .toLocaleString("en-US")
      .replaceAll("/", "-")
      .replaceAll(", ", "-")
      .replace(" ", "-");
    saveBlob("SitesAdminAccessReport_" + now + ".csv", reportText);

    $("#TabWebifAdminPassMDownloadSiteCSVGo").prop("disabled", false);
    $("#TabWebifAdminPassMDownloadSiteCSVGoAjaxImage").addClass("hidden");
  }

  function displayWebifAdminPassMsg(isDisplay, msg) {
    if (isDisplay) {
      $("#TabWebifAdminPassMExecuteMsg")[0].innerHTML = msg;
      $("#TabWebifAdminPassMExecuteMsgContainer").removeClass("hidden");
    } else {
      $("#TabWebifAdminPassMExecuteMsg")[0].innerHTML = "";
      $("#TabWebifAdminPassMExecuteMsgContainer").addClass("hidden");
    }
  }

  function webifAdminPassUpdaterGUIDisable(isEnable) {
    if (isEnable) {
      $("#TabTabWebifAdminPassMUploadFile").prop("disabled", true);
      $("#TabTabWebifAdminPassMFileUploadGo").prop("disabled", true);
      $("#TabWebifAdminPassMGoAjaxImage").removeClass("hidden");
    } else {
      $("#TabTabWebifAdminPassMUploadFile").prop("disabled", false);
      $("#TabTabWebifAdminPassMFileUploadGo").prop("disabled", false);
      $("#TabWebifAdminPassMGoAjaxImage").addClass("hidden");
    }
  }

  function webifAdminPassUpdaterEnableReportChecker() {
    var passChangeCookie = Utils.getCookie("webifAdminPassChange");
    if (passChangeCookie != "") {
      var passChangeMsgCookie = Utils.getCookie("webifAdminPassChangeMsg");

      webifAdminPassUpdaterGUIDisable(true);
      displayWebifAdminPassMsg(true, passChangeMsgCookie);

      globWebifAdminPassUpdateTimer = setTimeout(
        webifAdminPassUpdaterStatusChecker,
        1 * 1000
      );
    } else {
      clearTimeout(globWebifAdminPassUpdateTimer);
      globWebifAdminPassUpdateTimer = null;

      webifAdminPassUpdaterGUIDisable(false);
      displayWebifAdminPassMsg(false);
    }
  }

  function webifAdminPassUpdaterStatusChecker() {
    $.post(
      "adminservice.php",
      {
        method: "webifAdminPassChangeStatus",
      },
      function (data) {
        if (data.isReady) {
          clearTimeout(globWebifAdminPassUpdateTimer);
          globWebifAdminPassUpdateTimer = null;

          Utils.deleteCookie("webifAdminPassChange");
          Utils.deleteCookie("webifAdminPassChangeMsg");

          webifAdminPassUpdaterGUIDisable(false);
          $("#TabTabWebifAdminPassMUploadFile").val(null);

          displayWebifAdminPassMsg(true, "Report is ready. Downloading...");
          saveBlob(data.dataFileName + "-report.csv", data.csvReport);
          displayWebifAdminPassMsg(true, "Report downloaded.");
        } else {
          globWebifAdminPassUpdateTimer = setTimeout(
            webifAdminPassUpdaterStatusChecker,
            60 * 1000
          );
        }
      }
    );
  }

  function TabTabWebifAdminPassMFileUploadGo() {
    var fileName = $("#TabTabWebifAdminPassMUploadFile").val();

    if (fileName !== "") {
      webifAdminPassUpdaterGUIDisable(true);
      displayWebifAdminPassMsg(false);

      var fd = new FormData();
      var file = $("#TabTabWebifAdminPassMUploadFile")[0].files[0];
      fd.append("file", file);
      fd.append("method", "webifAdminPassChange");

      $.ajax({
        url: "adminservice.php",
        type: "post",
        data: fd,
        contentType: false,
        processData: false,
        success: function (response) {
          if (response["isOkay"]) {
            var runningMsg = "";

            // if (response["noActualName"].length) {
            // 	runningMsg += "Errror: devices with no actual name: " + response["noActualName"].join(",") + "<br>";
            // }

            // if (response["notATTDevice"].length) {
            // 	runningMsg += "Errror: non-ATT devices: " + response["notATTDevice"].join(",") + "<br>";
            // }

            // if (runningMsg != "") {
            // 	runningMsg += "<br>";
            // }

            runningMsg += "Start time = " + response.startTime + "<br>";
            var estimatedRuntime = Math.ceil(
              (response.nofRunDevices * 15) / 60
            );
            estimatedRuntime = estimatedRuntime > 0 ? estimatedRuntime : 1;
            runningMsg +=
              "Estimated running time = " +
              estimatedRuntime +
              " minutes. Report will download automatically when ready.";

            displayWebifAdminPassMsg(true, runningMsg);

            Utils.setCookie(
              "webifAdminPassChange",
              response.transactionId + "|" + response.startTime,
              90
            );
            Utils.setCookie("webifAdminPassChangeMsg", runningMsg, 90);
            globWebifAdminPassUpdateTimer = setTimeout(
              webifAdminPassUpdaterStatusChecker,
              60 * 1000
            );
          } else {
            if (response["errorReason"] == "Running") {
              displayWebifAdminPassMsg(
                true,
                "Error: password update is already running from a different location. Please wait until the operation completes."
              );
            } else if (response["errorReason"] == "InvalidFileFormat") {
              displayWebifAdminPassMsg(
                true,
                "Error: file format seems invalid. Please use (edit) downloaded site CSV file to perform password updates."
              );
            }

            webifAdminPassUpdaterGUIDisable(false);
          }
        },
        error: function () {
          displayWebifAdminPassMsg(
            true,
            "Error: password update request failed. Please retry."
          );
          webifAdminPassUpdaterGUIDisable(false);
        },
        complete: function () { },
      });
    }
  }

  function TreeExportGo() {
    var devQuery = getDeviceQuery();
    var devQueryData = [];

    var devicePath;
    devQuery.forEach(function (dev) {
      devicePath = "";
      $TreeGraph
        .jstree(true)
        .get_node(dev.ucuId)
        .parents.every(function (parentId, index, array) {
          if (index < array.length - 2) {
            // Remove # and first node. For ubiqam it is root, as an example, in ATT's case it is L_j1_609 = USA
            var parentNodeData = getNodeData(parentId);

            if (parentNodeData) {
              devicePath = parentNodeData.node_name + ":" + devicePath;
            }
          }

          if (parentId == globCurrentNode) {
            return false;
          } else {
            return true;
          }
        });
      devicePath = devicePath.slice(0, -1);

      devQueryData.push({
        ucuId: dev.ucuId,
        actualName: dev.deviceName,
        devicePath: devicePath,
        link1SPPId: dev.nodesIds[0],
        nodes: dev.nodes,
        nodesDisplayNames: dev.nodesDisplayNames,
      });
    });

    var devicesQueryDataJSON = JSON.stringify(devQueryData);

    var startingNodeName = getNodeData(globCurrentNode).node_name;

    $.post(
      "adminservice.php",
      {
        method: "getTreeExport",
        deviceQueryData: devicesQueryDataJSON,
        isUbiqamUser: isUbiqamUser(),
      },
      function (retData) {
        if (retData.isOkay) {
          var link = document.createElement("a");
          link.style = "display: none";
          link.href =
            window.location.href.substring(
              0,
              window.location.href.lastIndexOf("/")
            ) +
            "/pimReportDownload.php?fileName=" +
            retData.reportFileName;
          link.download = startingNodeName + "-TreeExport.csv";
          link.click();
        }
      }
    );
  }

  function tabInternalsGenerateSampleGo() {
    $TabInternalsGenerateSampleBtn.prop("disabled", true);
    $TabInternalsGenerateSampleAjaxImage.removeClass("hidden");

    var nodeData = getNodeData(globCurrentNode);
    var deviceName = nodeData.act_name.substring(
      0,
      nodeData.act_name.search("-ucu")
    );

    $.post(
      "adminservice.php",
      {
        method: "internalsGenerateSampleData",
        deviceName: deviceName,
      },
      function (data) {
        if (data) {
          tabInternalsSampleListRefresh();

          if (!globInternalsSamplesUpdateTimer) {
            globInternalsSamplesUpdateTimer = setInterval(
              tabInternalsSampleListRefresh,
              INTERNALS_SAMPLES_UPODATE_INTERVAL
            );
          }
        }

        $TabInternalsGenerateSampleBtn.prop("disabled", false);
        $TabInternalsGenerateSampleAjaxImage.addClass("hidden");
      }
    );
  }

  function tabInternalsNParserGo() {
    hideInternalsParsersMsg();
    ParsersOperationRunningUi(true);

    const presetPeriod = $("#TabInternalsNParserContentPeriodSelect").val();

    var req = d3
      .request("adminservice.php")
      .header("X-Requested-With", "XMLHttpRequest")
      .header("Content-Type", "application/x-www-form-urlencoded")
      .header("Accept", "application/json");

    req.send(
      "POST",
      "method=getNodePadParserReport&presetPeriod=last" + presetPeriod,
      function xhrPost(data) {
        var retData = parseXhrJson(data);

        ParsersOperationRunningUi(false);

        if (retData) {
          var link = document.createElement("a");
          link.style = "display: none";
          link.href =
            window.location.href.substring(
              0,
              window.location.href.lastIndexOf("/")
            ) +
            "/pimReportDownload.php?fileName=" +
            retData.reportFileName;

          link.download =
            "NodePadParserRoot_" +
            retData.presetPeriod +
            "_" +
            retData.endDateText.replaceAll(" ", "_").replaceAll(":", "-") +
            ".txt";
          link.click();
        } else {
          displayInternalsParsersMsg("An error occured getting the report.");
        }
      }
    );
  }

  function TabInternalsParsersPrmsExportGo() {
    hideInternalsParsersMsg();
    ParsersOperationRunningUi(true);

    const presetPeriod = $("#TabInternalsNParserContentPeriodSelect").val();
    const ExportMode = $('input[name="TabInternalsParsersPrmsExportMode"]:checked').val();

    var req = d3
      .request("adminservice.php")
      .header("X-Requested-With", "XMLHttpRequest")
      .header("Content-Type", "application/x-www-form-urlencoded")
      .header("Accept", "application/json");

    req.send(
      "POST",
      "method=TabInternalsParsersPrmsExportGo&presetPeriod=last" + presetPeriod + "&ExportMode=" + ExportMode,
      function xhrPost(data) {
        var retData = parseXhrJson(data);

        ParsersOperationRunningUi(false);

        if (retData) {
          var link = document.createElement("a");
          link.style = "display: none";
          link.href =
            window.location.href.substring(
              0,
              window.location.href.lastIndexOf("/")
            ) +
            "/pimReportDownload.php?fileName=" +
            retData.reportFileName;

          if (ExportMode === "History") {
            link.download =
              "PrmsParserRoot_" +
              retData.presetPeriod +
              "_" +
              retData.endDateText.replaceAll(" ", "_").replaceAll(":", "-") +
              ".csv";
          } else {
            link.download =
              "PrmsParserRoot_AllCurrent_" + getTimestamp() + ".csv";
          }
          link.click();
        } else {
          displayInternalsParsersMsg("An error occured getting the report.");
        }
      }
    );
  }

  function tabInternalsURebootGo() {
    $("#TabInternalsURebootContentGo").prop("disabled", true);
    $("#TabInternalsURebootAjaxImage").removeClass("hidden");
    $("#TabInternalsURebootMsg").addClass("hidden");

    var deviceIP = $("#TabInternalsURebootContentDeviceIp").val();

    $.post(
      "adminservice.php",
      {
        method: "internalsUReboot",
        deviceIp: deviceIP,
      },
      function (data) {
        if (!data.isOkay && data.reason !== "NA") {
          $("#TabInternalsURebootMsg").text(data.reason);
          $("#TabInternalsURebootMsg").removeClass("hidden");
        }

        $("#TabInternalsURebootContentGo").prop("disabled", false);
        $("#TabInternalsURebootAjaxImage").addClass("hidden");
      }
    );
  }

  function tabInternalsDownloadSamplesGo(values) {
    $TabInternalsSamplesDownloadBtn.prop("disabled", true);
    $TabInternalsDownloadSamplesAjaxImage.removeClass("hidden");

    var nodeData = getNodeData(globCurrentNode);
    var deviceName = nodeData.act_name.substring(
      0,
      nodeData.act_name.search("-ucu")
    );

    $.post(
      "adminservice.php",
      {
        method: "internalsDownloadSamples",
        deviceName: deviceName,
        samplesFileList: JSON.stringify(values),
      },
      function (data) {
        if (data.isOkay) {
          var link = document.createElement("a");
          link.style = "display: none";
          link.href =
            window.location.href.substring(
              0,
              window.location.href.lastIndexOf("/")
            ) + "/sampleFilesDownload.php";
          link.download = data.deviceName + "-sampleFiles.zip";
          link.click();
        }

        $TabInternalsSamplesDownloadBtn.prop("disabled", false);
        $TabInternalsDownloadSamplesAjaxImage.addClass("hidden");
      }
    );
  }

  function TabInternalsDBDownloadGo() {
    $("#TabInternalsDBContentDBDownloadGo").prop("disabled", true);
    $("#TabInternalsDBDownloadGoAjaxImage").removeClass("hidden");

    var nodeData = getNodeData(globCurrentNode);
    var deviceName = nodeData.act_name.substring(
      0,
      nodeData.act_name.search("-ucu")
    );

    $.post(
      "adminservice.php",
      {
        method: "internalsDBDownload",
        deviceName: deviceName,
      },
      function (data) {
        if (data.isOkay) {
          var link = document.createElement("a");
          link.style = "display: none";
          link.href =
            window.location.href.substring(
              0,
              window.location.href.lastIndexOf("/")
            ) +
            "/dbFileDownload.php?deviceName=" +
            deviceName;
          link.download = data.deviceName + "-SystemCommands.db";
          link.click();
        }

        $("#TabInternalsDBContentDBDownloadGo").prop("disabled", false);
        $("#TabInternalsDBDownloadGoAjaxImage").addClass("hidden");
      }
    );
  }

  function TabInternalsDBUploadGo() {
    var fileName = $("#TabInternalsDBUploadFile").val();

    if (fileName !== "") {
      $("#TabInternalsDBUploadGo").prop("disabled", true);
      $("#TabInternalsDBUploadGoAjaxImage").removeClass("hidden");

      var fd = new FormData();
      var file = $("#TabInternalsDBUploadFile")[0].files[0];
      fd.append("file", file);

      var nodeData = getNodeData(globCurrentNode);
      var deviceName = nodeData.act_name.substring(
        0,
        nodeData.act_name.search("-ucu")
      );
      fd.append("deviceName", deviceName);

      fd.append("method", "internalsDBUpload");

      $.ajax({
        url: "adminservice.php",
        type: "post",
        data: fd,
        contentType: false,
        processData: false,
        success: function (response) {
          if (response != 0) {
          } else {
            alert("file not uploaded");
          }
        },
        complete: function () {
          $("#TabInternalsDBUploadGo").prop("disabled", false);
          $("#TabInternalsDBUploadGoAjaxImage").addClass("hidden");
        },
      });
    }
  }

  function tabInternalsSampleListUpdate(data) {
    $TabInternalsSamplesSelect.empty();

    if (data.fileList && Array.isArray(data.fileList)) {
      data["fileList"].forEach(function (fileName, key) {
        $TabInternalsSamplesSelect.append(
          $("<option>", {
            value: fileName,
            text:
              fileName +
              " (" +
              (data["fileSizeList"][key] / 1024 / 1024).toFixed(2) +
              "MB)",
          }).addClass("data-sample-entry")
        );
      });
    }
  }

  function tabInternalsURebootAddressFill() {
    var nodeData = getNodeData(globCurrentNode);
    var emsIP = getNodeData(nodeData.parent).ip;

    $("#TabInternalsURebootContentDeviceIp").val(emsIP);
  }

  function tabInternalsSampleListRefresh() {
    $TabInternalsSamplesLoadAjaxImage.removeClass("hidden");

    var nodeData = getNodeData(globCurrentNode);
    var deviceName = nodeData.act_name.substring(
      0,
      nodeData.act_name.search("-ucu")
    );

    var req = d3
      .request("adminservice.php")
      .header("X-Requested-With", "XMLHttpRequest")
      .header("Content-Type", "application/x-www-form-urlencoded")
      .header("Accept", "application/json");

    req.send(
      "POST",
      "method=internalsGetSamplesList&deviceName=" + deviceName,
      function xhrPost(data) {
        data = parseXhrJson(data);

        if (data) {
          tabInternalsSampleListUpdate(data);
        }

        $TabInternalsSamplesLoadAjaxImage.addClass("hidden");
      }
    );
  }

  function tabInternalsPrmCurrentUpdate() {
    var nodeData = getNodeData(globCurrentNode);

    $("#TabInternalsContentContainerUMUPrmsCurrentTabContent").text("");

    $.post(
      "adminservice.php",
      {
        method: "getPrmsCurrent",
        nodeNameAct: nodeData.act_name,
        isHistory: 0,
      },
      function (data) {
        if (data) {
          $("#TabInternalsContentContainerUMUPrmsCurrentTabContent").html(DOMPurify.sanitize(data));

          $("#currentPrmsTable").DataTable({
            order: [[0, "asc"]],
          });
        }
      }
    );
  }

  function tabInternalsPrmHistoryUpdate() {
    var nodeData = getNodeData(globCurrentNode);

    $("#TabInternalsContentContainerUMUPrmsHistoryTabContent").text("");

    $.post(
      "adminservice.php",
      {
        method: "getPrmsCurrent",
        nodeNameAct: nodeData.act_name,
        isHistory: 1,
      },
      function (data) {
        if (data) {
          $("#TabInternalsContentContainerUMUPrmsHistoryTabContent").html(DOMPurify.sanitize(data));

          $("#historyPrmsTable").DataTable({
            order: [[0, "asc"]],
          });
        }
      }
    );
  }

  function tabUcuInternalsPrmUpdate() {
    var nodeData = getNodeData(globCurrentNode);

    $("#TabInternalsUCUPrmsTabContent").text("");

    $.post(
      "adminservice.php",
      {
        method: "getPrmsCurrent",
        nodeNameAct: nodeData.act_name,
        isUcu: 1,
      },
      function (data) {
        if (data) {
          $("#TabInternalsUCUPrmsTabContent").html(DOMPurify.sanitize(data));

          $("#ucuPrmsTable").DataTable({
            order: [[0, "asc"]],
          });
        }
      }
    );
  }

  function tabInternalsDeleteSamplesGo(values) {
    $TabInternalsSamplesDeleteBtn.prop("disabled", true);
    $TabInternalsSamplesDeleteCheckbox.prop("checked", false);
    $TabInternalsDeleteSamplesAjaxImage.removeClass("hidden");

    var nodeData = getNodeData(globCurrentNode);
    var deviceName = nodeData.act_name.substring(
      0,
      nodeData.act_name.search("-ucu")
    );

    $.post(
      "adminservice.php",
      {
        method: "internalsDeleteSamples",
        deviceName: deviceName,
        samplesFileList: JSON.stringify(values),
      },
      function (data) {
        if (data) {
          tabInternalsSampleListRefresh();
        }

        $TabInternalsDeleteSamplesAjaxImage.addClass("hidden");
      }
    );
  }

  function initInternalsTab() {
    $TabInternalsGenerateSampleBtn.on("click", function (e) {
      tabInternalsGenerateSampleGo();
    });

    $TabInternalsSamplesSelect.on("change", function (e) {
      var values = $TabInternalsSamplesSelect.val();

      if (Array.isArray(values)) {
        if (globInternalsSamplesUpdateTimer) {
          clearInterval(globInternalsSamplesUpdateTimer);

          globInternalsSamplesUpdateTimer = null;
        }
      } else {
        if (!globInternalsSamplesUpdateTimer) {
          globInternalsSamplesUpdateTimer = setInterval(
            tabInternalsSampleListRefresh,
            INTERNALS_SAMPLES_UPODATE_INTERVAL
          );
        }
      }
    });

    $TabInternalsSamplesDownloadBtn.on("click", function (e) {
      var values = $TabInternalsSamplesSelect.val();

      if (Array.isArray(values)) {
        tabInternalsDownloadSamplesGo(values);
      }
    });

    $TabInternalsSamplesDeleteCheckbox.on("change", function (e) {
      var isChecked = e.target.checked;

      if (isChecked) {
        $TabInternalsSamplesDeleteBtn.prop("disabled", false);
      } else {
        $TabInternalsSamplesDeleteBtn.prop("disabled", true);
      }
    });

    $TabInternalsSamplesDeleteBtn.on("click", function (e) {
      var values = $TabInternalsSamplesSelect.val();

      if (Array.isArray(values)) {
        tabInternalsDeleteSamplesGo(values);
      }
    });

    $("#TabInternalsURebootContentGo").on("click", function (e) {
      tabInternalsURebootGo();
    });

    $("#TabInternalsDBContentDBDownloadGo").on("click", function (e) {
      TabInternalsDBDownloadGo();
    });

    $("#TabInternalsDBUploadGo").on("click", function (e) {
      TabInternalsDBUploadGo();
    });

    // ++ Group/Parent PIM report internals
    $TabInternalsContentContainerParentStartDate.datetimepicker({
      useCurrent: false, // Important! See issue #1075
      sideBySide: true,
      allowInputToggle: true,
      toolbarPlacement: "bottom",
      showTodayButton: true,
      showClear: true,
      format: "DD MMM YYYY HH:mm",
    });

    $TabInternalsContentContainerParentEndDate.datetimepicker({
      useCurrent: false, // Important! See issue #1075
      sideBySide: true,
      allowInputToggle: true,
      toolbarPlacement: "bottom",
      showTodayButton: true,
      showClear: true,
      format: "DD MMM YYYY HH:mm",
    });

    $TabInternalsContentContainerParentStartDateIcon.on("click", function () {
      $TabInternalsContentContainerParentStartDate
        .data("DateTimePicker")
        .show();
    });

    $TabInternalsContentContainerParentEndDateIcon.on("click", function () {
      $TabInternalsContentContainerParentEndDate.data("DateTimePicker").show();
    });

    $TabInternalsContentContainerParentStartDate.on("dp.show", function (e) {
      $("body")
        .find(".bootstrap-datetimepicker-widget:last")
        .css({ top: "2.2em" });

      if (!globPIMReportIsNOPDatesRangeFuncs) {
        ++globIsStartdateShowRunning;

        // console.log('TabInternalsContentContainerParentStartDate dp.show');

        if (
          !$TabInternalsContentContainerParentStartDate
            .data("DateTimePicker")
            .maxDate()
        ) {
          var nowCloud = moment().tz(globServerTimezone);
          var localCloudTime = moment(
            new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
          );
          var localCloudTimeMin = localCloudTime
            .clone()
            .hours(localCloudTime.hours() - 1);

          $TabInternalsContentContainerParentStartDate
            .data("DateTimePicker")
            .maxDate(localCloudTimeMin);
          $TabInternalsContentContainerParentStartDate
            .data("DateTimePicker")
            .date(localCloudTimeMin);

          $TabInternalsContentContainerParentEndDate
            .data("DateTimePicker")
            .maxDate(localCloudTime);
          $TabInternalsContentContainerParentEndDate
            .data("DateTimePicker")
            .minDate(localCloudTime);
          $TabInternalsContentContainerParentEndDate
            .data("DateTimePicker")
            .date(localCloudTime);
        }

        --globIsStartdateShowRunning;
      }
    });

    $TabInternalsContentContainerParentStartDate.on("dp.change", function (e) {
      if (!globPIMReportIsNOPDatesRangeFuncs) {
        ++globIsStartdateChangeRunning;

        // console.log('TabRRDContentControlsStartDate dp.change');
        // console.log('globIsStartdateShowRunning',
        // globIsStartdateShowRunning, 'globIsEnddateShowRunning',
        // globIsEnddateShowRunning, 'globIsEnddateChangeRunning',
        // globIsEnddateChangeRunning)

        if (
          !(
            globIsStartdateShowRunning ||
            globIsEnddateShowRunning ||
            globIsEnddateChangeRunning
          )
        ) {
          // console.log(globIsStartdateChangeRunning); // DDD

          var dateTime = e.date;

          if (dateTime) {
            dateTime = dateTime.hours(dateTime.hours() + 1);

            $TabInternalsContentContainerParentEndDate
              .data("DateTimePicker")
              .minDate(dateTime);
          }
        }

        --globIsStartdateChangeRunning;
      }

      if (
        $TabInternalsContentContainerParentStartDate
          .data("DateTimePicker")
          .date() &&
        $TabInternalsContentContainerParentEndDate.data("DateTimePicker").date()
      ) {
        $TabInternalsContentContainerParentGo.prop("disabled", false);
      } else {
        $TabInternalsContentContainerParentGo.prop("disabled", true);
      }
    });

    $TabInternalsContentContainerParentEndDate.on("dp.show", function (e) {
      $("body")
        .find(".bootstrap-datetimepicker-widget:last")
        .css({ top: "2.2em" });

      if (!globPIMReportIsNOPDatesRangeFuncs) {
        ++globIsEnddateShowRunning;

        // console.log('TabInternalsContentContainerParentEndDate dp.show');

        var nowCloud = moment().tz(globServerTimezone);
        var localCloudTime = moment(
          new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
        );

        $TabInternalsContentContainerParentEndDate
          .data("DateTimePicker")
          .maxDate(localCloudTime);

        if (
          !$TabInternalsContentContainerParentEndDate
            .data("DateTimePicker")
            .date()
        ) {
          var localCloudTimeMin = localCloudTime
            .clone()
            .hours(localCloudTime.hours() - 1);

          $TabInternalsContentContainerParentStartDate
            .data("DateTimePicker")
            .maxDate(localCloudTimeMin);
          $TabInternalsContentContainerParentStartDate
            .data("DateTimePicker")
            .date(localCloudTimeMin);

          $TabInternalsContentContainerParentEndDate
            .data("DateTimePicker")
            .minDate(localCloudTime);
          $TabInternalsContentContainerParentEndDate
            .data("DateTimePicker")
            .date(localCloudTime);
        }

        --globIsEnddateShowRunning;
      }
    });

    $TabInternalsContentContainerParentEndDate.on("dp.change", function (e) {
      if (!globPIMReportIsNOPDatesRangeFuncs) {
        ++globIsEnddateChangeRunning;

        // console.log('TabInternalsContentContainerParentEndDate dp.change');
        // console.log('globIsStartdateShowRunning',
        // globIsStartdateShowRunning, 'globIsEnddateShowRunning',
        // globIsEnddateShowRunning, 'globIsStartdateChangeRunning',
        // globIsStartdateChangeRunning)

        if (
          !(
            globIsStartdateShowRunning ||
            globIsEnddateShowRunning ||
            globIsStartdateChangeRunning
          )
        ) {
          // console.log(globIsEnddateChangeRunning); // DDD

          var dateTime = e.date;

          if (dateTime) {
            dateTime = dateTime.hours(dateTime.hours() - 1);

            $TabInternalsContentContainerParentStartDate
              .data("DateTimePicker")
              .maxDate(dateTime);
          }
        }

        --globIsEnddateChangeRunning;
      }

      if (
        $TabInternalsContentContainerParentStartDate
          .data("DateTimePicker")
          .date() &&
        $TabInternalsContentContainerParentEndDate.data("DateTimePicker").date()
      ) {
        $TabInternalsContentContainerParentGo.prop("disabled", false);
      } else {
        $TabInternalsContentContainerParentGo.prop("disabled", true);
      }
    });

    $("#TabInternalsContentContainerParentPreContainer").on(
      "click",
      function (e) {
        enableInternalsParentPreDateUI();

        // tabPIMReportContentControlsGo();
      }
    );

    $("#TabInternalsContentContainerParentRangeContainer").on(
      "click",
      function (e) {
        enableInternalsParentDateRangeUI();

        if (
          !(
            $TabInternalsContentContainerParentStartDate
              .data("DateTimePicker")
              .date() &&
            $TabInternalsContentContainerParentEndDate
              .data("DateTimePicker")
              .date()
          )
        ) {
          $TabInternalsContentContainerParentGo.prop("disabled", true);
        }
      }
    );

    $TabInternalsContentContainerParentShowLast.on("change", function (e) {
      $TabInternalsContentContainerParentGo.focus();

      // tabPIMReportContentControlsGo();
    });

    $TabInternalsContentContainerParentGo.on("click", function (e) {
      tabPIMReportContentControlsGo();
    });
    // == Group/Parent PIM report internals

    // ++ Group/Parent CEH report internals
    $TabInternalsContentContainerParentStartDateCEH.datetimepicker({
      useCurrent: false, // Important! See issue #1075
      sideBySide: true,
      allowInputToggle: true,
      toolbarPlacement: "bottom",
      showTodayButton: true,
      showClear: true,
      format: "DD MMM YYYY HH:mm",
    });

    $TabInternalsContentContainerParentEndDateCEH.datetimepicker({
      useCurrent: false, // Important! See issue #1075
      sideBySide: true,
      allowInputToggle: true,
      toolbarPlacement: "bottom",
      showTodayButton: true,
      showClear: true,
      format: "DD MMM YYYY HH:mm",
    });

    $TabInternalsContentContainerParentStartDateIconCEH.on(
      "click",
      function () {
        $TabInternalsContentContainerParentStartDateCEH
          .data("DateTimePicker")
          .show();
      }
    );

    $TabInternalsContentContainerParentEndDateIconCEH.on("click", function () {
      $TabInternalsContentContainerParentEndDateCEH
        .data("DateTimePicker")
        .show();
    });

    $TabInternalsContentContainerParentStartDateCEH.on("dp.show", function (e) {
      $("body")
        .find(".bootstrap-datetimepicker-widget:last")
        .css({ top: "2.2em" });

      if (!globCEHReportIsNOPDatesRangeFuncs) {
        ++globIsStartdateShowRunning;

        // console.log('TabInternalsContentContainerParentStartDate dp.show');

        if (
          !$TabInternalsContentContainerParentStartDateCEH
            .data("DateTimePicker")
            .maxDate()
        ) {
          var nowCloud = moment().tz(globServerTimezone);
          var localCloudTime = moment(
            new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
          );
          var localCloudTimeMin = localCloudTime
            .clone()
            .hours(localCloudTime.hours() - 1);

          $TabInternalsContentContainerParentStartDateCEH
            .data("DateTimePicker")
            .maxDate(localCloudTimeMin);
          $TabInternalsContentContainerParentStartDateCEH
            .data("DateTimePicker")
            .date(localCloudTimeMin);

          $TabInternalsContentContainerParentEndDateCEH
            .data("DateTimePicker")
            .maxDate(localCloudTime);
          $TabInternalsContentContainerParentEndDateCEH
            .data("DateTimePicker")
            .minDate(localCloudTime);
          $TabInternalsContentContainerParentEndDateCEH
            .data("DateTimePicker")
            .date(localCloudTime);
        }

        --globIsStartdateShowRunning;
      }
    });

    $TabInternalsContentContainerParentStartDateCEH.on(
      "dp.change",
      function (e) {
        if (!globCEHReportIsNOPDatesRangeFuncs) {
          ++globIsStartdateChangeRunning;

          // console.log('TabRRDContentControlsStartDate dp.change');
          // console.log('globIsStartdateShowRunning',
          // globIsStartdateShowRunning, 'globIsEnddateShowRunning',
          // globIsEnddateShowRunning, 'globIsEnddateChangeRunning',
          // globIsEnddateChangeRunning)

          if (
            !(
              globIsStartdateShowRunning ||
              globIsEnddateShowRunning ||
              globIsEnddateChangeRunning
            )
          ) {
            // console.log(globIsStartdateChangeRunning); // DDD

            var dateTime = e.date;

            if (dateTime) {
              dateTime = dateTime.hours(dateTime.hours() + 1);

              $TabInternalsContentContainerParentEndDateCEH
                .data("DateTimePicker")
                .minDate(dateTime);
            }
          }

          --globIsStartdateChangeRunning;
        }

        if (
          $TabInternalsContentContainerParentStartDateCEH
            .data("DateTimePicker")
            .date() &&
          $TabInternalsContentContainerParentEndDateCEH
            .data("DateTimePicker")
            .date()
        ) {
          $TabInternalsContentContainerParentGoCEH.prop("disabled", false);
        } else {
          $TabInternalsContentContainerParentGoCEH.prop("disabled", true);
        }
      }
    );

    $TabInternalsContentContainerParentEndDateCEH.on("dp.show", function (e) {
      $("body")
        .find(".bootstrap-datetimepicker-widget:last")
        .css({ top: "2.2em" });

      if (!globCEHReportIsNOPDatesRangeFuncs) {
        ++globIsEnddateShowRunning;

        // console.log('TabInternalsContentContainerParentEndDate dp.show');

        var nowCloud = moment().tz(globServerTimezone);
        var localCloudTime = moment(
          new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
        );

        $TabInternalsContentContainerParentEndDateCEH
          .data("DateTimePicker")
          .maxDate(localCloudTime);

        if (
          !$TabInternalsContentContainerParentEndDateCEH
            .data("DateTimePicker")
            .date()
        ) {
          var localCloudTimeMin = localCloudTime
            .clone()
            .hours(localCloudTime.hours() - 1);

          $TabInternalsContentContainerParentStartDateCEH
            .data("DateTimePicker")
            .maxDate(localCloudTimeMin);
          $TabInternalsContentContainerParentStartDateCEH
            .data("DateTimePicker")
            .date(localCloudTimeMin);

          $TabInternalsContentContainerParentEndDateCEH
            .data("DateTimePicker")
            .minDate(localCloudTime);
          $TabInternalsContentContainerParentEndDateCEH
            .data("DateTimePicker")
            .date(localCloudTime);
        }

        --globIsEnddateShowRunning;
      }
    });

    $TabInternalsContentContainerParentEndDateCEH.on("dp.change", function (e) {
      if (!globCEHReportIsNOPDatesRangeFuncs) {
        ++globIsEnddateChangeRunning;

        // console.log('TabInternalsContentContainerParentEndDate dp.change');
        // console.log('globIsStartdateShowRunning',
        // globIsStartdateShowRunning, 'globIsEnddateShowRunning',
        // globIsEnddateShowRunning, 'globIsStartdateChangeRunning',
        // globIsStartdateChangeRunning)

        if (
          !(
            globIsStartdateShowRunning ||
            globIsEnddateShowRunning ||
            globIsStartdateChangeRunning
          )
        ) {
          // console.log(globIsEnddateChangeRunning); // DDD

          var dateTime = e.date;

          if (dateTime) {
            dateTime = dateTime.hours(dateTime.hours() - 1);

            $TabInternalsContentContainerParentStartDateCEH
              .data("DateTimePicker")
              .maxDate(dateTime);
          }
        }

        --globIsEnddateChangeRunning;
      }

      if (
        $TabInternalsContentContainerParentStartDateCEH
          .data("DateTimePicker")
          .date() &&
        $TabInternalsContentContainerParentEndDateCEH
          .data("DateTimePicker")
          .date()
      ) {
        $TabInternalsContentContainerParentGoCEH.prop("disabled", false);
      } else {
        $TabInternalsContentContainerParentGoCEH.prop("disabled", true);
      }
    });

    $("#TabInternalsContentContainerParentPreContainerCEH").on(
      "click",
      function (e) {
        enableInternalsParentPreDateUICEH();

        // tabCEHReportContentControlsGo();
      }
    );

    $("#TabInternalsContentContainerParentRangeContainerCEH").on(
      "click",
      function (e) {
        enableInternalsParentDateRangeUICEH();

        if (
          !(
            $TabInternalsContentContainerParentStartDateCEH
              .data("DateTimePicker")
              .date() &&
            $TabInternalsContentContainerParentEndDateCEH
              .data("DateTimePicker")
              .date()
          )
        ) {
          $TabInternalsContentContainerParentGoCEH.prop("disabled", true);
        }
      }
    );

    $TabInternalsContentContainerParentShowLastCEH.on("change", function (e) {
      $TabInternalsContentContainerParentGoCEH.focus();

      // tabCEHReportContentControlsGo();
    });

    $TabInternalsContentContainerParentGoCEH.on("click", function (e) {
      tabCEHReportContentControlsGo();
    });
    // == Group/Parent CEH report internals

    // ++ Group/Parent TEH report internals
    $TabInternalsContentContainerParentStartDateTEH.datetimepicker({
      useCurrent: false, // Important! See issue #1075
      sideBySide: true,
      allowInputToggle: true,
      toolbarPlacement: "bottom",
      showTodayButton: true,
      showClear: true,
      format: "DD MMM YYYY HH:mm",
    });

    $TabInternalsContentContainerParentEndDateTEH.datetimepicker({
      useCurrent: false, // Important! See issue #1075
      sideBySide: true,
      allowInputToggle: true,
      toolbarPlacement: "bottom",
      showTodayButton: true,
      showClear: true,
      format: "DD MMM YYYY HH:mm",
    });

    $TabInternalsContentContainerParentStartDateIconTEH.on(
      "click",
      function () {
        $TabInternalsContentContainerParentStartDateTEH
          .data("DateTimePicker")
          .show();
      }
    );

    $TabInternalsContentContainerParentEndDateIconTEH.on("click", function () {
      $TabInternalsContentContainerParentEndDateTEH
        .data("DateTimePicker")
        .show();
    });

    $TabInternalsContentContainerParentStartDateTEH.on("dp.show", function (e) {
      $("body")
        .find(".bootstrap-datetimepicker-widget:last")
        .css({ top: "2.2em" });

      if (!globTEHReportIsNOPDatesRangeFuncs) {
        ++globIsStartdateShowRunning;

        // console.log('TabInternalsContentContainerParentStartDate dp.show');

        if (
          !$TabInternalsContentContainerParentStartDateTEH
            .data("DateTimePicker")
            .maxDate()
        ) {
          var nowCloud = moment().tz(globServerTimezone);
          var localCloudTime = moment(
            new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
          );
          var localCloudTimeMin = localCloudTime
            .clone()
            .hours(localCloudTime.hours() - 1);

          $TabInternalsContentContainerParentStartDateTEH
            .data("DateTimePicker")
            .maxDate(localCloudTimeMin);
          $TabInternalsContentContainerParentStartDateTEH
            .data("DateTimePicker")
            .date(localCloudTimeMin);

          $TabInternalsContentContainerParentEndDateTEH
            .data("DateTimePicker")
            .maxDate(localCloudTime);
          $TabInternalsContentContainerParentEndDateTEH
            .data("DateTimePicker")
            .minDate(localCloudTime);
          $TabInternalsContentContainerParentEndDateTEH
            .data("DateTimePicker")
            .date(localCloudTime);
        }

        --globIsStartdateShowRunning;
      }
    });

    $TabInternalsContentContainerParentStartDateTEH.on(
      "dp.change",
      function (e) {
        if (!globTEHReportIsNOPDatesRangeFuncs) {
          ++globIsStartdateChangeRunning;

          // console.log('TabRRDContentControlsStartDate dp.change');
          // console.log('globIsStartdateShowRunning',
          // globIsStartdateShowRunning, 'globIsEnddateShowRunning',
          // globIsEnddateShowRunning, 'globIsEnddateChangeRunning',
          // globIsEnddateChangeRunning)

          if (
            !(
              globIsStartdateShowRunning ||
              globIsEnddateShowRunning ||
              globIsEnddateChangeRunning
            )
          ) {
            // console.log(globIsStartdateChangeRunning); // DDD

            var dateTime = e.date;

            if (dateTime) {
              dateTime = dateTime.hours(dateTime.hours() + 1);

              $TabInternalsContentContainerParentEndDateTEH
                .data("DateTimePicker")
                .minDate(dateTime);
            }
          }

          --globIsStartdateChangeRunning;
        }

        if (
          $TabInternalsContentContainerParentStartDateTEH
            .data("DateTimePicker")
            .date() &&
          $TabInternalsContentContainerParentEndDateTEH
            .data("DateTimePicker")
            .date()
        ) {
          $TabInternalsContentContainerParentGoTEH.prop("disabled", false);
        } else {
          $TabInternalsContentContainerParentGoTEH.prop("disabled", true);
        }
      }
    );

    $TabInternalsContentContainerParentEndDateTEH.on("dp.show", function (e) {
      $("body")
        .find(".bootstrap-datetimepicker-widget:last")
        .css({ top: "2.2em" });

      if (!globTEHReportIsNOPDatesRangeFuncs) {
        ++globIsEnddateShowRunning;

        // console.log('TabInternalsContentContainerParentEndDate dp.show');

        var nowCloud = moment().tz(globServerTimezone);
        var localCloudTime = moment(
          new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
        );

        $TabInternalsContentContainerParentEndDateTEH
          .data("DateTimePicker")
          .maxDate(localCloudTime);

        if (
          !$TabInternalsContentContainerParentEndDateTEH
            .data("DateTimePicker")
            .date()
        ) {
          var localCloudTimeMin = localCloudTime
            .clone()
            .hours(localCloudTime.hours() - 1);

          $TabInternalsContentContainerParentStartDateTEH
            .data("DateTimePicker")
            .maxDate(localCloudTimeMin);
          $TabInternalsContentContainerParentStartDateTEH
            .data("DateTimePicker")
            .date(localCloudTimeMin);

          $TabInternalsContentContainerParentEndDateTEH
            .data("DateTimePicker")
            .minDate(localCloudTime);
          $TabInternalsContentContainerParentEndDateTEH
            .data("DateTimePicker")
            .date(localCloudTime);
        }

        --globIsEnddateShowRunning;
      }
    });

    $TabInternalsContentContainerParentEndDateTEH.on("dp.change", function (e) {
      if (!globTEHReportIsNOPDatesRangeFuncs) {
        ++globIsEnddateChangeRunning;

        // console.log('TabInternalsContentContainerParentEndDate dp.change');
        // console.log('globIsStartdateShowRunning',
        // globIsStartdateShowRunning, 'globIsEnddateShowRunning',
        // globIsEnddateShowRunning, 'globIsStartdateChangeRunning',
        // globIsStartdateChangeRunning)

        if (
          !(
            globIsStartdateShowRunning ||
            globIsEnddateShowRunning ||
            globIsStartdateChangeRunning
          )
        ) {
          // console.log(globIsEnddateChangeRunning); // DDD

          var dateTime = e.date;

          if (dateTime) {
            dateTime = dateTime.hours(dateTime.hours() - 1);

            $TabInternalsContentContainerParentStartDateTEH
              .data("DateTimePicker")
              .maxDate(dateTime);
          }
        }

        --globIsEnddateChangeRunning;
      }

      if (
        $TabInternalsContentContainerParentStartDateTEH
          .data("DateTimePicker")
          .date() &&
        $TabInternalsContentContainerParentEndDateTEH
          .data("DateTimePicker")
          .date()
      ) {
        $TabInternalsContentContainerParentGoTEH.prop("disabled", false);
      } else {
        $TabInternalsContentContainerParentGoTEH.prop("disabled", true);
      }
    });

    $("#TabInternalsContentContainerParentPreContainerTEH").on(
      "click",
      function (e) {
        enableInternalsParentPreDateUITEH();

        // tabTEHReportContentControlsGo();
      }
    );

    $("#TabInternalsContentContainerParentRangeContainerTEH").on(
      "click",
      function (e) {
        enableInternalsParentDateRangeUITEH();

        if (
          !(
            $TabInternalsContentContainerParentStartDateTEH
              .data("DateTimePicker")
              .date() &&
            $TabInternalsContentContainerParentEndDateTEH
              .data("DateTimePicker")
              .date()
          )
        ) {
          $TabInternalsContentContainerParentGoTEH.prop("disabled", true);
        }
      }
    );

    $TabInternalsContentContainerParentShowLastTEH.on("change", function (e) {
      $TabInternalsContentContainerParentGoTEH.focus();

      // tabTEHReportContentControlsGo();
    });

    $TabInternalsContentContainerParentGoTEH.on("click", function (e) {
      tabTempHunterReportContentControlsGo();
    });
    // == Group/Parent TEH report internals

    // ++ Group/Parent NodePad Parser internals
    $("#TabInternalsNParserGo").on("click", function (e) {
      tabInternalsNParserGo();
    });

    $("#TabInternalsParsersPrmsExportGo").on("click", function (e) {
      TabInternalsParsersPrmsExportGo();
    });
    // == Group/Parent NodePad Parser internals
  }

  // ++ Utils Tab
  function tabUtilsCmdExecuteGo(value) {
    $TabUtilsCmdExecBtn.prop("disabled", true);
    $TabUtilsCmdExecBtnAjaxImage.removeClass("hidden");

    $TabUtilsCmdSelectOutput.html("");

    // ** No need for deviceName now as running only prod cmds
    // ** If will add remote SSH commands, need to check why in Madrid nodeData.act_name for root is empty
    // var nodeData = getNodeData(globCurrentNode);

    // var deviceName = "";
    // if (globCurrentNode.startsWith("D_")) {
    //   deviceName = nodeData.act_name;
    // } else { "un_"
    //   deviceName = nodeData.act_name.substring(
    //     0,
    //     nodeData.act_name.search("-")
    //   );
    // }

    $.post(
      "adminservice.php",
      {
        method: "utilsCmdExecute",
        // deviceName: deviceName,
        cmd: JSON.stringify(value),
      },
      function (data) {
        if (data) {
          data = escapeHtml(data).replaceAll("\n", "<br>");
          $TabUtilsCmdSelectOutput.html(data);
        }

        $TabUtilsCmdExecBtn.prop("disabled", false);
        $TabUtilsCmdExecBtnAjaxImage.addClass("hidden");
      }
    );
  }

  function initUtilsTab() {
    $TabUtilsCmdExecBtn.on("click", function (e) {
      var value = $TabUtilsCmdSelect.val();

      if (value) {
        tabUtilsCmdExecuteGo(value);
      }
    });

    $('a[href="#TabUtilsContentContainerScriptRunnerTabContent"]').on("click", function () {
      var baseUrl = $TabUtilsScriptRunnerIframe.data("src");
      var sep = baseUrl.indexOf("?") >= 0 ? "&" : "?";
      $TabUtilsScriptRunnerIframe.attr("src", baseUrl + sep + "_=" + Date.now());
    });

    $('a[href="#TabUtilsContentContainerCmdTabContent"]').on("click", function () {
      $TabUtilsScriptRunnerIframe.attr("src", "about:blank");
    });
  }
  // == Utils Tab

  function getDeviceQuery() {
    var children;
    var childrenNames = [];
    var devicesQuery = [];

    var nodeData = getNodeData(globCurrentNode);
    var isPhysicalPort = globCurrentNode && isPhysicalPortNode(globCurrentNode);
    var isImmediateParent =
      !isPhysicalPort && nodeData.id.indexOf("D_") === 0 ? true : false;
    var isHighLevelParent =
      !isPhysicalPort &&
        (nodeData.id.indexOf("L_") === 0 ||
          nodeData.id === "root" ||
          // "un" (Unassigned) is a container like root, not a device. Leaving
          // it out sent it down the single-device branch, which walks up two
          // levels for a grandparent it does not have: get_node("#").parent is
          // null, get_node(null) returns false, and false.children_d is
          // undefined — hence "Cannot read properties of undefined (reading
          // 'filter')" on OPTiX. It also has act_name null, which reached the
          // backend as the string "null" and produced a 500.
          nodeData.id === "un")
        ? true
        : false;

    if (isHighLevelParent) {
      // var list = getChildrenTree(globCurrentNode);

      children = $TreeGraph.jstree(true).get_node(globCurrentNode).children_d;

      children = children.filter(function (el) {
        return el.indexOf("D_") != 0 && el.indexOf("L_") != 0;
      });
    } else if (isImmediateParent) {
      // children = $TreeGraph.jstree(true).get_children_dom(globCurrentNode);
      children = $TreeGraph.jstree(true).get_node(globCurrentNode).children_d;
    } else if (isPhysicalPort) {
      var nodeJSTreeData = $TreeGraph.jstree(true).get_node(globCurrentNode);

      children = $TreeGraph
        .jstree(true)
        .get_node(nodeJSTreeData.parent).children_d;
    } else {
      var nodeJSTreeData = $TreeGraph.jstree(true).get_node(globCurrentNode);
      var nodeData = getNodeData(nodeJSTreeData.id);

      if (isUCU(nodeData)) {
        children = $TreeGraph
          .jstree(true)
          .get_node(nodeJSTreeData.parent).children_d;
      } else {
        children = $TreeGraph
          .jstree(true)
          .get_node(
            $TreeGraph.jstree(true).get_node(nodeJSTreeData.parent).parent
          ).children_d;
      }
    }

    //  ++ Remove UCUs, physical port nodes and non OPTiX devices (22xx)
    children = children.filter(function (el) {
      if (isPhysicalPortNode(el)) {
        return false;
      } else {
        var nodeData = getNodeData(el);

        return (
          !isUCU(nodeData) &&
          parseInt(nodeData.act_name.substring(3, 7)) >= 2200
        );
      }
    });
    //  == Remove UCUs and non OPTiX devices (22xx)

    if (!children.length) {
      devicesQuery = -1;
    } else {
      for (var i = 0; i < children.length; ++i) {
        nodeData = getNodeData(children[i]);

        childrenNames.push({
          nodeId: nodeData.id,
          nodeName: nodeData.act_name,
          nodeDisplayName: nodeData.node_name,
          id: nodeData.id,
        });
      }

      childrenNames.sort();

      // ++ Create device query
      var currentDeviceName = "";
      var deviceName;

      for (var i = 0; i < childrenNames.length; ++i) {
        deviceName = childrenNames[i].nodeName.substring(
          0,
          childrenNames[i].nodeName.indexOf("-")
        );

        if (deviceName != currentDeviceName) {
          currentDeviceName = deviceName;

          nodeData = getNodeData(childrenNames[i].id);
          children = $TreeGraph
            .jstree(true)
            .get_node(nodeData.parent).children_d;
          var ucuId = children[children.length - 1];

          devicesQuery.push({
            deviceName: currentDeviceName,
            nodesIds: [childrenNames[i].nodeId],
            nodes: [childrenNames[i].nodeName],
            nodesDisplayNames: [childrenNames[i].nodeDisplayName],
            ucuId: ucuId,
          });
        } else {
          devicesQuery[devicesQuery.length - 1].nodesIds.push(
            childrenNames[i].nodeId
          );
          devicesQuery[devicesQuery.length - 1].nodes.push(
            childrenNames[i].nodeName
          );
          devicesQuery[devicesQuery.length - 1].nodesDisplayNames.push(
            childrenNames[i].nodeDisplayName
          );
        }
      }
      // == Create device query
    }

    return devicesQuery;
  }

  function tabTempHunterReportContentControlsGo() {
    var startDate = -1;
    var endDate = -1;
    var presetPeriod = 0;
    var isValidParams = true;
    var validationErrorMsg = "";

    var nodeData = getNodeData(globCurrentNode);

    var isUCUMinTempEnabled =
      $("#TabInternalsContentContainerParentContentMinTempTEHCheckbox")[0]
        .checked === true;
    var isUCUMinTempAnd =
      $("#TabInternalsContentContainerParentContentMinTempTEHCheckboxAndOr")[0]
        .checked === true;
    var isHPSMinTempEnabled =
      $("#TabInternalsContentContainerParentContentHPSMinTempTEHCheckbox")[0]
        .checked === true;
    var isHPSMinTempAnd =
      $(
        "#TabInternalsContentContainerParentContentHPSMinTempTEHCheckboxAndOr"
      )[0].checked === true;

    // ++ Validate parameters
    // Power
    if (isUCUMinTempEnabled) {
      var UCUMinTempEnabledVal = parseInt(
        $("#TabInternalsContentContainerParentContentMinTempTEH").val()
      );

      if (isNaN(UCUMinTempEnabledVal)) {
        isValidParams = false;

        validationErrorMsg +=
          "UCU temperature:  'Min Temperature ' value is not a valid number<br>";
      }
    }
    if (isHPSMinTempEnabled) {
      var HPSMinTempEnabledVal = parseInt(
        $("#TabInternalsContentContainerParentContentHPSMinTempTEH").val()
      );

      if (isNaN(HPSMinTempEnabledVal)) {
        isValidParams = false;

        validationErrorMsg +=
          "HPS Temperature:  'Min Temperature ' value is not a valid number<br>";
      }
    }

    var eventGroupingVal = parseInt(
      $(
        "#TabInternalsContentContainerParentContentEventGroupingThresholdTEH"
      ).val()
    );
    if (isNaN(eventGroupingVal) || eventGroupingVal === 0) {
      isValidParams = false;

      validationErrorMsg +=
        "Event Grouping:  'Event Grouping Threshold' value is not a valid number<br>";
    }

    var minEventDurationVal = parseInt(
      $(
        "#TabInternalsContentContainerParentContentEventMinimalDurationTEH"
      ).val()
    );
    if (isNaN(minEventDurationVal) || minEventDurationVal === 0) {
      isValidParams = false;

      validationErrorMsg +=
        "Minimal Event Duration:  'Minimal Duration for Event' value is not a valid number<br>";
    }

    if (!isUCUMinTempEnabled && !isHPSMinTempEnabled) {
      isValidParams = false;

      validationErrorMsg +=
        "At least one of the UCU or HPS temperature options must be enabled<br>";
    }
    // == Validate parameters

    if (!isValidParams) {
      displayInternalsTEHReportMsg(validationErrorMsg);
    } else {
      hideInternalsTEHReportMsg();

      var requestData = {
        groupNodeName: nodeData.node_name,
        temp: {
          isUCUMinTempEnabled: isUCUMinTempEnabled,
          isUCUMinTempAnd: isUCUMinTempAnd,
          UCUMinTempEnabledVal: UCUMinTempEnabledVal,
          isHPSMinTempEnabled: isHPSMinTempEnabled,
          isHPSMinTempAnd: isHPSMinTempAnd,
          HPSMinTempEnabledVal: HPSMinTempEnabledVal,
        },
        eventGroupingVal: eventGroupingVal,
        minEventDurationVal: minEventDurationVal,
      };

      if (isInternalsParentPreDateTEH) {
        presetPeriod = $TabInternalsContentContainerParentShowLastTEH.val();
      } else {
        endDate = $TabInternalsContentContainerParentStartDateTEH
          .data("DateTimePicker")
          .date();
        if (endDate) {
          // endDate = moment.tz(moment.tz(endDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
          endDate = moment
            .tz(endDate.format("YYYY-MM-DD HH:mm"), globServerTimezone)
            .unix();
        }

        startDate = $TabInternalsContentContainerParentEndDateTEH
          .data("DateTimePicker")
          .date();
        if (startDate) {
          // startDate = moment.tz(moment.tz(startDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
          startDate = moment
            .tz(startDate.format("YYYY-MM-DD HH:mm"), globServerTimezone)
            .unix();
        }

        // console.log(startDate, endDate);
      }

      var devQuery;
      if ((devQuery = getDeviceQuery()) == -1) {
        displayInternalsTEHReportMsg("No OPTiX devices were found (>= 22xx)."); // display pim report msg
      } else {
        var devQueryData = [];

        devQuery.forEach(function (dev) {
          devQueryData.push({
            deviceName: dev.deviceName,
          });
        });

        var devicesQueryJSON = JSON.stringify(devQueryData);
        var requestDataJSON = JSON.stringify(requestData);

        getTEHReportData(
          presetPeriod,
          startDate,
          endDate,
          devicesQueryJSON,
          requestDataJSON
        );
      }
    }
  }

  function tabCEHReportContentControlsGo() {
    var startDate = -1;
    var endDate = -1;
    var presetPeriod = 0;
    var isValidParams = true;
    var validationErrorMsg = "";

    var nodeData = getNodeData(globCurrentNode);

    var isMinInputPowerEnabled =
      $("#TabInternalsContentContainerParentContentMinInputPowerCEHCheckbox")[0]
        .checked === true;
    var isMinInputPowerAnd =
      $(
        "#TabInternalsContentContainerParentContentMinInputPowerCEHCheckboxAndOr"
      )[0].checked === true;
    var isMinOutputPowerEnabled =
      $(
        "#TabInternalsContentContainerParentContentMinOutputPowerCEHCheckbox"
      )[0].checked === true;
    var isMinOutputPowerAnd =
      $(
        "#TabInternalsContentContainerParentContentMinOutputPowerCEHCheckboxAndOr"
      )[0].checked === true;
    var isMaxInputPowerEnabled =
      $("#TabInternalsContentContainerParentContentMaxInputPowerCEHCheckbox")[0]
        .checked === true;
    var isMaxInputPowerAnd =
      $(
        "#TabInternalsContentContainerParentContentMaxInputPowerCEHCheckboxAndOr"
      )[0].checked === true;
    var isMaxOutputPowerEnabled =
      $(
        "#TabInternalsContentContainerParentContentMaxOutputPowerCEHCheckbox"
      )[0].checked === true;
    var isMaxOutputPowerAnd =
      $(
        "#TabInternalsContentContainerParentContentMaxOutputPowerCEHCheckboxAndOr"
      )[0].checked === true;

    var isAntennasAll =
      $("#TabInternalsContentContainerParentContentAntennaCEHCheckboxAllAny")[0]
        .checked === true;

    var isCancMinLevelEnabled =
      $("#TabInternalsContentContainerParentContentMinCancLevelCEHCheckbox")[0]
        .checked === true;
    var isCancMinLevelAnd =
      $(
        "#TabInternalsContentContainerParentContentMinCancLevelCEHCheckboxAndOr"
      )[0].checked === true;

    // ++ Validate parameters
    // Power
    if (isMinInputPowerEnabled) {
      var minInputPowerEnabledVal = parseInt(
        $("#TabInternalsContentContainerParentContentMinInputPowerCEH").val()
      );

      if (isNaN(minInputPowerEnabledVal)) {
        isValidParams = false;

        validationErrorMsg +=
          "Power:  'Min Input Power ' value is not a valid number<br>";
      }
    }
    if (isMinOutputPowerEnabled) {
      var minOutputPowerEnabledVal = parseInt(
        $("#TabInternalsContentContainerParentContentMinOutputPowerCEH").val()
      );

      if (isNaN(minOutputPowerEnabledVal)) {
        isValidParams = false;

        validationErrorMsg +=
          "Power:  'Min Output Power' value is not a valid number<br>";
      }
    }
    if (isMaxInputPowerEnabled) {
      var maxInputPowerEnabledVal = parseInt(
        $("#TabInternalsContentContainerParentContentMaxInputPowerCEH").val()
      );

      if (isNaN(maxInputPowerEnabledVal)) {
        isValidParams = false;

        validationErrorMsg +=
          "Power:  'Max Input Power ' value is not a valid number<br>";
      }
    }
    if (isMaxOutputPowerEnabled) {
      var maxOutputPowerEnabledVal = parseInt(
        $("#TabInternalsContentContainerParentContentMaxOutputPowerCEH").val()
      );

      if (isNaN(maxOutputPowerEnabledVal)) {
        isValidParams = false;

        validationErrorMsg +=
          "Power:  'Max Output Power' value is not a valid number<br>";
      }
    }

    // Cancellation Level
    if (isCancMinLevelEnabled) {
      var cancMinLevelEnabledVal = parseInt(
        $("#TabInternalsContentContainerParentContentMinCancLevelCEH").val()
      );

      if (isNaN(cancMinLevelEnabledVal)) {
        isValidParams = false;

        validationErrorMsg +=
          "Cancellation Level:  'Min Level' value is not a valid number<br>";
      }
    }

    var eventGroupingVal = parseInt(
      $(
        "#TabInternalsContentContainerParentContentEventGroupingThresholdCEH"
      ).val()
    );
    if (isNaN(eventGroupingVal) || eventGroupingVal === 0) {
      isValidParams = false;

      validationErrorMsg +=
        "Event Grouping:  'Event Grouping Threshold' value is not a valid number<br>";
    }

    var minEventDurationVal = parseInt(
      $(
        "#TabInternalsContentContainerParentContentEventMinimalDurationCEH"
      ).val()
    );
    if (isNaN(minEventDurationVal) || minEventDurationVal === 0) {
      isValidParams = false;

      validationErrorMsg +=
        "Minimal Event Duration:  'Minimal Duration for Event' value is not a valid number<br>";
    }

    if (
      !isMinInputPowerEnabled &&
      !isMinOutputPowerEnabled &&
      !isMaxInputPowerEnabled &&
      !isMaxOutputPowerEnabled &&
      !isCancMinLevelEnabled
    ) {
      isValidParams = false;

      validationErrorMsg +=
        "At least one of the Power or Cancellation Leveloptions must be enabled<br>";
    }
    // == Validate parameters

    if (!isValidParams) {
      displayInternalsCEHReportMsg(validationErrorMsg);
    } else {
      hideInternalsCEHReportMsg();

      var requestData = {
        groupNodeName: nodeData.node_name,
        power: {
          isMinInputPowerEnabled: isMinInputPowerEnabled,
          isMinInputPowerAnd: isMinInputPowerAnd,
          minInputPowerVal: minInputPowerEnabledVal,
          isMinOutputPowerEnabled: isMinOutputPowerEnabled,
          isMinOutputPowerAnd: isMinOutputPowerAnd,
          minOutputPowerVal: minOutputPowerEnabledVal,
          isMaxInputPowerEnabled: isMaxInputPowerEnabled,
          isMaxInputPowerAnd: isMaxInputPowerAnd,
          maxInputPowerVal: maxInputPowerEnabledVal,
          isMaxOutputPowerEnabled: isMaxOutputPowerEnabled,
          isMaxOutputPowerAnd: isMaxOutputPowerAnd,
          maxOutputPowerVal: maxOutputPowerEnabledVal,
        },
        antenna: {
          isAntennasAll: isAntennasAll,
        },
        cancLevel: {
          isCancMinLevelEnabled: isCancMinLevelEnabled,
          isCancMinLevelAnd: isCancMinLevelAnd,
          cancMinLevelVal: cancMinLevelEnabledVal,
        },
        eventGroupingVal: eventGroupingVal,
        minEventDurationVal: minEventDurationVal,
      };

      if (isInternalsParentPreDateCEH) {
        presetPeriod = $TabInternalsContentContainerParentShowLastCEH.val();
      } else {
        endDate = $TabInternalsContentContainerParentStartDateCEH
          .data("DateTimePicker")
          .date();
        if (endDate) {
          // endDate = moment.tz(moment.tz(endDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
          endDate = moment
            .tz(endDate.format("YYYY-MM-DD HH:mm"), globServerTimezone)
            .unix();
        }

        startDate = $TabInternalsContentContainerParentEndDateCEH
          .data("DateTimePicker")
          .date();
        if (startDate) {
          // startDate = moment.tz(moment.tz(startDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
          startDate = moment
            .tz(startDate.format("YYYY-MM-DD HH:mm"), globServerTimezone)
            .unix();
        }

        // console.log(startDate, endDate);
      }

      var devQuery;
      if ((devQuery = getDeviceQuery()) == -1) {
        displayInternalsCEHReportMsg("No OPTiX devices were found (>= 22xx)."); // display pim report msg
      } else {
        var devQueryData = [];

        devQuery.forEach(function (dev) {
          devQueryData.push({
            actualName: dev.deviceName,
            nodes: dev.nodes,
          });
        });

        var devicesQueryJSON = JSON.stringify(devQueryData);
        var requestDataJSON = JSON.stringify(requestData);

        getCEHReportData(
          presetPeriod,
          startDate,
          endDate,
          devicesQueryJSON,
          requestDataJSON
        );
      }
    }
  }

  function tabPIMReportContentControlsGo() {
    var startDate = -1;
    var endDate = -1;
    var presetPeriod = 0;
    var isValidParams = true;
    var validationErrorMsg = "";

    var nodeData = getNodeData(globCurrentNode);

    var isInputPowerLBinEnabled =
      $("#TabInternalsContentContainerParentContentLBinMinInputCheckbox")[0]
        .checked === true;
    var isInputPowerLBinAnd =
      $(
        "#TabInternalsContentContainerParentContentLBinMinInputCheckboxAndOr"
      )[0].checked === true;
    var isInputPowerHBinEnabled =
      $("#TabInternalsContentContainerParentContentHBinMinInputCheckbox")[0]
        .checked === true;
    var isInputPowerHBinAnd =
      $(
        "#TabInternalsContentContainerParentContentHBinMinInputCheckboxAndOr"
      )[0].checked === true;

    var isCancLevelLBinEnabled =
      $("#TabInternalsContentContainerParentContentLBinMinCancCheckbox")[0]
        .checked === true;
    var isCancLevelLBinAnd =
      $("#TabInternalsContentContainerParentContentLBinMinCancCheckboxAndOr")[0]
        .checked === true;
    var isCancLevelHBinEnabled =
      $("#TabInternalsContentContainerParentContentHBinMinCancCheckbox")[0]
        .checked === true;
    var isCancLevelHBinAnd =
      $("#TabInternalsContentContainerParentContentHBinMinCancCheckboxAndOr")[0]
        .checked === true;

    var isMinAbsEnabled =
      $("#TabInternalsContentContainerParentContentMinAbsCheckbox")[0]
        .checked === true;
    var isMinAbsAnd =
      $("#TabInternalsContentContainerParentContentMinAbsCheckboxAndOr")[0]
        .checked === true;

    // ++ Validate parameters
    if (isInputPowerLBinEnabled) {
      var inputPowerLBinVal = parseInt(
        $("#TabInternalsContentContainerParentContentLBinMinInput").val()
      );

      if (isNaN(inputPowerLBinVal)) {
        isValidParams = false;

        validationErrorMsg +=
          "Input Power:  'Min Input Power Lower Bin' value is not a valid number<br>";
      }
    }
    if (isInputPowerHBinEnabled) {
      var inputPowerHBinVal = parseInt(
        $("#TabInternalsContentContainerParentContentHBinMinInput").val()
      );

      if (isNaN(inputPowerHBinVal)) {
        isValidParams = false;

        validationErrorMsg +=
          "Input Power:  'Min Input Power Higher Bin' value is not a valid number<br>";
      }
    }

    if (isCancLevelLBinEnabled) {
      var cancLevelLBinVal = parseInt(
        $("#TabInternalsContentContainerParentContentLBinMinCanc").val()
      );

      if (isNaN(cancLevelLBinVal)) {
        isValidParams = false;

        validationErrorMsg +=
          "Cancellation Level:  'Min Level Lower Bin' value is not a valid number<br>";
      }
    }
    if (isCancLevelHBinEnabled) {
      var cancLevelHBinVal = parseInt(
        $("#TabInternalsContentContainerParentContentHBinMinCanc").val()
      );

      if (isNaN(cancLevelHBinVal)) {
        isValidParams = false;

        validationErrorMsg +=
          "Cancellation Level:  'Min Level Higher Bin' value is not a valid number<br>";
      }
    }

    if (isMinAbsEnabled) {
      var minAbsVal = parseInt(
        $("#TabInternalsContentContainerParentContentLBinMinAbs").val()
      );

      if (isNaN(minAbsVal)) {
        isValidParams = false;

        validationErrorMsg +=
          "ABS Level:  'Min Level' value is not a valid number<br>";
      }
    }

    var eventGroupingVal = parseInt(
      $(
        "#TabInternalsContentContainerParentContentEventGroupingThreshold"
      ).val()
    );
    if (isNaN(eventGroupingVal) || eventGroupingVal === 0) {
      isValidParams = false;

      validationErrorMsg +=
        "Event Grouping:  'Event Grouping Threshold' value is not a valid number<br>";
    }

    var minEventDurationVal = parseInt(
      $("#TabInternalsContentContainerParentContentEventMinimalDuration").val()
    );
    if (isNaN(minEventDurationVal) || minEventDurationVal === 0) {
      isValidParams = false;

      validationErrorMsg +=
        "Minimal Event Duration:  'Minimal Duration for Event' value is not a valid number<br>";
    }

    if (
      !isInputPowerLBinEnabled &&
      !isInputPowerHBinEnabled &&
      !isCancLevelLBinEnabled &&
      !isCancLevelHBinEnabled &&
      !isMinAbsEnabled
    ) {
      isValidParams = false;

      validationErrorMsg +=
        "At least one of the Input Power or Cancellation Level or ABS Level options must be enabled<br>";
    }
    // == Validate parameters

    if (!isValidParams) {
      displayInternalsPIMReportMsg(validationErrorMsg);
    } else {
      hideInternalsPIMReportMsg();

      var requestData = {
        groupNodeName: nodeData.node_name,
        inputPower: {
          isInputPowerLBinEnabled: isInputPowerLBinEnabled,
          isInputPowerLBinAnd: isInputPowerLBinAnd,
          inputPowerLBinVal: inputPowerLBinVal,
          isInputPowerHBinEnabled: isInputPowerHBinEnabled,
          isInputPowerHBinAnd: isInputPowerHBinAnd,
          inputPowerHBinVal: inputPowerHBinVal,
        },
        cancLevel: {
          isCancLevelLBinEnabled: isCancLevelLBinEnabled,
          isCancLevelLBinAnd: isCancLevelLBinAnd,
          cancLevelLBinVal: cancLevelLBinVal,
          isCancLevelHBinEnabled: isCancLevelHBinEnabled,
          isCancLevelHBinAnd: isCancLevelHBinAnd,
          cancLevelHBinVal: cancLevelHBinVal,
        },
        minAbs: {
          isMinAbsEnabled: isMinAbsEnabled,
          isMinAbsAnd: isMinAbsAnd,
          minAbsVal: minAbsVal,
        },
        eventGroupingVal: eventGroupingVal,
        minEventDurationVal: minEventDurationVal,
      };

      if (isInternalsParentPreDate) {
        presetPeriod = $TabInternalsContentContainerParentShowLast.val();
        // console.log('presetPeriod: ', presetPeriod);
      } else {
        endDate = $TabInternalsContentContainerParentStartDate
          .data("DateTimePicker")
          .date();
        if (endDate) {
          // endDate = moment.tz(moment.tz(endDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
          endDate = moment
            .tz(endDate.format("YYYY-MM-DD HH:mm"), globServerTimezone)
            .unix();
        }

        startDate = $TabInternalsContentContainerParentEndDate
          .data("DateTimePicker")
          .date();
        if (startDate) {
          // startDate = moment.tz(moment.tz(startDate.format('YYYY-MM-DD HH:mm'), "America/New_York"), 'Asia/Jerusalem').unix();
          startDate = moment
            .tz(startDate.format("YYYY-MM-DD HH:mm"), globServerTimezone)
            .unix();
        }

        console.log(startDate, endDate);
      }

      var devQuery;
      if ((devQuery = getDeviceQuery()) == -1) {
        displayInternalsPIMReportMsg("No OPTiX devices were found (>= 22xx)."); // display pim report msg
      } else {
        var devQueryData = [];

        devQuery.forEach(function (dev) {
          devQueryData.push({
            actualName: dev.deviceName,
            nodes: dev.nodes,
          });
        });

        var devicesQueryJSON = JSON.stringify(devQueryData);
        var requestDataJSON = JSON.stringify(requestData);

        getPIMReportData(
          presetPeriod,
          startDate,
          endDate,
          devicesQueryJSON,
          requestDataJSON
        );
      }
    }
  }

  function addToolTipsElements() {
    var i;

    for (i = 0; i < 9; ++i) {
      // was 5 without right column support
      spectrogramTooltipElements.push(
        d3
          .select("#TabSpectrogramsContent")
          .append("div")
          .property("id", "SpectrogramTooltip" + i)
          .style("visibility", "hidden")
          .style("position", "fixed")
          .style("z-index", "10")
          //.style("background", (i === 4) ? 'rgba(0,0,0,0.5)' : 'rgba(255,255,255,0.5)')
          .style("background", "rgba(255,255,255,0.5)")
          // .style("background", 'rgba(0,0,0,0.2)')
          .style("border", "1px solid lightgray")
          .style("border-radius", "2px")
          .style("padding", "2px 3px")
          // .style('color', (i === 4) ? 'white' : 'black')
          .style("color", "black")
        // .style('color', 'white')
      );
    }

    for (i = 0; i < 2; ++i) {
      spectrogramAxisTooltipElements.push(
        d3
          .select("#TabSpectrogramsContent")
          .append("div")
          .property("id", "SpectrogramAxisTooltip" + i)
          .style("visibility", "hidden")
          .style("position", "fixed")
          .style("z-index", "10")
          .style("background", "rgba(0,0,0,0.5)")
          // .style("background", 'rgba(0,0,0,0.2)')
          .style("border", "1px solid lightgray")
          .style("border-radius", "2px")
          .style("padding", "2px 3px")
          .style("color", "white")
        // .style('color', 'white')
      );
    }

    for (i = 0; i < 2; ++i) {
      spectrogramTDAxisTooltipElements.push(
        d3
          .select("#TabSpectrogramsContent")
          .append("div")
          .property("id", "SpectrogramAxis2DTooltip" + i)
          .style("visibility", "hidden")
          .style("position", "fixed")
          .style("z-index", "10")
          .style("background", "rgba(0,0,0,0.5)")
          // .style("background", 'rgba(0,0,0,0.2)')
          .style("border", "1px solid lightgray")
          .style("border-radius", "2px")
          .style("padding", "2px 3px")
          .style("color", "white")
        // .style('color', 'white')
      );
    }
  }

  function addRRDToolTipsElements() {
    for (var i = 0; i < 2; ++i) {
      RRDAxisTooltipElements.push(
        d3
          .select("#TabRRDGraphsContent")
          .append("div")
          .style("visibility", "hidden")
          .style("position", "fixed")
          .style("z-index", "10")
          .style("background", "rgba(0,0,0,0.5)")
          // .style("background", 'rgba(0,0,0,0.2)')
          .style("border", "1px solid lightgray")
          .style("border-radius", "2px")
          .style("padding", "2px 3px")
          .style("color", "white")
        // .style('color', 'white')
      );
    }
  }

  function hideTitleElements() {
    if (graphTitleElements.isInit) {
      graphTitleElements["two_d"].style("visibility", "hidden");
      graphTitleElements["a_in"].style("visibility", "hidden");
      graphTitleElements["a_out"].style("visibility", "hidden");
      graphTitleElements["b_in"].style("visibility", "hidden");
      graphTitleElements["b_out"].style("visibility", "hidden");
      graphTitleElements["c_in"].style("visibility", "hidden");
      graphTitleElements["c_out"].style("visibility", "hidden");
      graphTitleElements["d_in"].style("visibility", "hidden");
      graphTitleElements["d_out"].style("visibility", "hidden");
      graphTitleElements["avg_in"].style("visibility", "hidden");
      graphTitleElements["avg_out"].style("visibility", "hidden");
    }
  }

  function addTitleElements() {
    if (!graphTitleElements.isInit) {
      graphTitleElements["two_d"] = d3
        .select("#TabSpectrogramsContent")
        .append("div")
        .attr("id", "SpectrogramGraphTitleTwoD")
        .style("visibility", "hidden")
        .style("position", "fixed")
        .style("z-index", "10");

      graphTitleElements["a_in"] = d3
        .select("#TabSpectrogramsContent")
        .append("div")
        .attr("id", "SpectrogramGraphTitleAIn")
        .style("visibility", "hidden")
        .style("position", "fixed")
        .style("z-index", "10");

      graphTitleElements["a_out"] = d3
        .select("#TabSpectrogramsContent")
        .append("div")
        .attr("id", "SpectrogramGraphTitleAOut")
        .style("visibility", "hidden")
        .style("position", "fixed")
        .style("z-index", "10");

      graphTitleElements["b_in"] = d3
        .select("#TabSpectrogramsContent")
        .append("div")
        .attr("id", "SpectrogramGraphTitleBIn")
        .style("visibility", "hidden")
        .style("position", "fixed")
        .style("z-index", "10");

      graphTitleElements["b_out"] = d3
        .select("#TabSpectrogramsContent")
        .append("div")
        .attr("id", "SpectrogramGraphTitleBOut")
        .style("visibility", "hidden")
        .style("position", "fixed")
        .style("z-index", "10");

      graphTitleElements["c_in"] = d3
        .select("#TabSpectrogramsContent")
        .append("div")
        .attr("id", "SpectrogramGraphTitleBIn")
        .style("visibility", "hidden")
        .style("position", "fixed")
        .style("z-index", "10");

      graphTitleElements["c_out"] = d3
        .select("#TabSpectrogramsContent")
        .append("div")
        .attr("id", "SpectrogramGraphTitleBOut")
        .style("visibility", "hidden")
        .style("position", "fixed")
        .style("z-index", "10");

      graphTitleElements["d_in"] = d3
        .select("#TabSpectrogramsContent")
        .append("div")
        .attr("id", "SpectrogramGraphTitleBIn")
        .style("visibility", "hidden")
        .style("position", "fixed")
        .style("z-index", "10");

      graphTitleElements["d_out"] = d3
        .select("#TabSpectrogramsContent")
        .append("div")
        .attr("id", "SpectrogramGraphTitleBOut")
        .style("visibility", "hidden")
        .style("position", "fixed")
        .style("z-index", "10");

      graphTitleElements["avg_in"] = d3
        .select("#TabSpectrogramsContent")
        .append("div")
        .attr("id", "SpectrogramGraphTitleAvgIn")
        .style("visibility", "hidden")
        .style("position", "fixed")
        .style("z-index", "10");

      graphTitleElements["avg_out"] = d3
        .select("#TabSpectrogramsContent")
        .append("div")
        .attr("id", "SpectrogramGraphTitleAvgOut")
        .style("visibility", "hidden")
        .style("position", "fixed")
        .style("z-index", "10");

      graphTitleElements.isInit = true;
    }
  }

  function isAnySpectrogramGraphSelected() {
    var numOfActualGraphs = 0;
    for (var i = 1; i < 5; ++i) {
      if (
        $("#SpectrogramWin1GraphSel" + i)[0].selectedIndex > 0 ||
        $("#SpectrogramWin2GraphSel" + i)[0].selectedIndex > 0
      ) {
        ++numOfActualGraphs;
      }
    }

    return numOfActualGraphs;
  }

  function removeSpectrograms4AntOptions(selectEl) {
    selectEl.find("option[value='c_in']").remove();
    selectEl.find("option[value='c_out']").remove();
    selectEl.find("option[value='d_in']").remove();
    selectEl.find("option[value='d_out']").remove();
  }

  function addSpectrograms4AntOptions(selectEl) {
    if (selectEl.find("option[value='c_in']").length === 0) {
      selectEl
        .find("option[value='b_out']")
        .after("<option value='c_in'>C In</option>");
      selectEl
        .find("option[value='c_in']")
        .after("<option value='c_out'>C Out</option>");
      selectEl
        .find("option[value='c_out']")
        .after("<option value='d_in'>D In</option>");
      selectEl
        .find("option[value='d_in']")
        .after("<option value='d_out'>D Out</option>");
    }
  }

  function setSpectrogramDefaultOption(selectEl, optionName) {
    selectEl
      .find("option")
      .filter(function () {
        return $(this).text() == optionName;
      })
      .prop("selected", true);
  }

  function enableSpectrogramsContent(
    is4Ant,
    isSelectDefaultGraphs,
    isSelectOnly2AntGraphs
  ) {
    $SpectrogramWin1GraphsContainer[0].innerHTML = "";
    $("#TabSpectrogramsContentMainTitleNodeName").text("");
    $("#TabSpectrogramsContentMainTitleTimeRange").text("");
    $("#TabSpectrogramsContentMsgContainer").addClass("hidden");
    $("#TabSpectrogramsContentMsgOuterContainer").addClass("hidden");
    $("#TabSpectrogramsContentControls").removeClass("hidden");
    $TabSpectrogramsContentGraphsContainer.removeClass("hidden");
    $("#SpectrogramColorScale").removeClass("hidden");
    $("#SpectrogramFiller").removeClass("hidden");

    /*
    if (globCurrentNode != null) {
      var nodeData = getNodeData(globCurrentNode);
      is4Ant = isHas4AntData(nodeData);
    }
    */

    if (is4Ant) {
      $("#SpectrogramWindow1").css("width", "88%");
      $("#SpectrogramColorScaleContainer").css("width", "88%");
      $("#SpectrogramFiller").css("width", "12%");
      $("#SpectrogramWin1ControlsContainer").css("width", "12%");

      $("#SpectrogramWin1GraphSel1Container").css("margin-left", "0px");
      $("#SpectrogramWin1GraphSel2Container").css("margin-left", "0px");
      $("#SpectrogramWin1GraphSel3Container").css("margin-left", "0px");
      $("#SpectrogramWin1GraphSel4Container").css("margin-left", "0px");
      $("#SpectrogramWin2GraphSel1Container").css("display", "inline-block");
      $("#SpectrogramWin2GraphSel2Container").css("display", "inline-block");
      $("#SpectrogramWin2GraphSel3Container").css("display", "inline-block");
      $("#SpectrogramWin2GraphSel4Container").css("display", "inline-block");

      addSpectrograms4AntOptions($SpectrogramWin1GraphSel1);
      addSpectrograms4AntOptions($SpectrogramWin1GraphSel2);
      addSpectrograms4AntOptions($SpectrogramWin1GraphSel3);
      addSpectrograms4AntOptions($SpectrogramWin1GraphSel4);
      addSpectrograms4AntOptions($SpectrogramWin2GraphSel1);
      addSpectrograms4AntOptions($SpectrogramWin2GraphSel2);
      addSpectrograms4AntOptions($SpectrogramWin2GraphSel3);
      addSpectrograms4AntOptions($SpectrogramWin2GraphSel4);

      if (isSelectDefaultGraphs) {
        if (isSelectOnly2AntGraphs) {
          setSpectrogramDefaultOption($SpectrogramWin1GraphSel1, "A In");
          setSpectrogramDefaultOption($SpectrogramWin1GraphSel2, "B In");
          setSpectrogramDefaultOption($SpectrogramWin1GraphSel3, "A Out");
          setSpectrogramDefaultOption($SpectrogramWin1GraphSel4, "B Out");
          setSpectrogramDefaultOption($SpectrogramWin2GraphSel1, "----");
          setSpectrogramDefaultOption($SpectrogramWin2GraphSel2, "----");
          setSpectrogramDefaultOption($SpectrogramWin2GraphSel3, "----");
          setSpectrogramDefaultOption($SpectrogramWin2GraphSel4, "----");
        } else {
          // setSpectrogramDefaultOption($SpectrogramWin1GraphSel1, 'C In');
          // setSpectrogramDefaultOption($SpectrogramWin1GraphSel2, 'D In');
          // setSpectrogramDefaultOption($SpectrogramWin1GraphSel3, 'C Out');
          // setSpectrogramDefaultOption($SpectrogramWin1GraphSel4, 'D Out');
          // setSpectrogramDefaultOption($SpectrogramWin2GraphSel1, 'A In');
          // setSpectrogramDefaultOption($SpectrogramWin2GraphSel2, 'B In');
          // setSpectrogramDefaultOption($SpectrogramWin2GraphSel3, 'A Out');
          // setSpectrogramDefaultOption($SpectrogramWin2GraphSel4, 'B Out');

          setSpectrogramDefaultOption($SpectrogramWin1GraphSel1, "B In");
          setSpectrogramDefaultOption($SpectrogramWin1GraphSel2, "D In");
          setSpectrogramDefaultOption($SpectrogramWin1GraphSel3, "B Out");
          setSpectrogramDefaultOption($SpectrogramWin1GraphSel4, "D Out");
          setSpectrogramDefaultOption($SpectrogramWin2GraphSel1, "A In");
          setSpectrogramDefaultOption($SpectrogramWin2GraphSel2, "C In");
          setSpectrogramDefaultOption($SpectrogramWin2GraphSel3, "A Out");
          setSpectrogramDefaultOption($SpectrogramWin2GraphSel4, "C Out");
        }
      }
    } else {
      $("#SpectrogramWindow1").css("width", "90%");
      $("#SpectrogramColorScaleContainer").css("width", "90%");
      $("#SpectrogramFiller").css("width", "10%");
      $("#SpectrogramWin1ControlsContainer").css("width", "10%");

      $("#SpectrogramWin2GraphSel1Container").css("display", "none");
      $("#SpectrogramWin2GraphSel2Container").css("display", "none");
      $("#SpectrogramWin2GraphSel3Container").css("display", "none");
      $("#SpectrogramWin2GraphSel4Container").css("display", "none");
      $("#SpectrogramWin1GraphSel1Container").css("margin-left", "10px");
      $("#SpectrogramWin1GraphSel2Container").css("margin-left", "10px");
      $("#SpectrogramWin1GraphSel3Container").css("margin-left", "10px");
      $("#SpectrogramWin1GraphSel4Container").css("margin-left", "10px");

      removeSpectrograms4AntOptions($SpectrogramWin1GraphSel1);
      removeSpectrograms4AntOptions($SpectrogramWin1GraphSel2);
      removeSpectrograms4AntOptions($SpectrogramWin1GraphSel3);
      removeSpectrograms4AntOptions($SpectrogramWin1GraphSel4);
      removeSpectrograms4AntOptions($SpectrogramWin2GraphSel1);
      removeSpectrograms4AntOptions($SpectrogramWin2GraphSel2);
      removeSpectrograms4AntOptions($SpectrogramWin2GraphSel3);
      removeSpectrograms4AntOptions($SpectrogramWin2GraphSel4);

      if (isSelectDefaultGraphs) {
        setSpectrogramDefaultOption($SpectrogramWin1GraphSel1, "A In");
        setSpectrogramDefaultOption($SpectrogramWin1GraphSel2, "B In");
        setSpectrogramDefaultOption($SpectrogramWin1GraphSel3, "A Out");
        setSpectrogramDefaultOption($SpectrogramWin1GraphSel4, "B Out");
        setSpectrogramDefaultOption($SpectrogramWin2GraphSel1, "----");
        setSpectrogramDefaultOption($SpectrogramWin2GraphSel2, "----");
        setSpectrogramDefaultOption($SpectrogramWin2GraphSel3, "----");
        setSpectrogramDefaultOption($SpectrogramWin2GraphSel4, "----");
      }
    }

    drawColorScale();
  }

  function displaySpectrogramsMsg(msg, keepControls) {
    if (keepControls) {
      $("#TabSpectrogramsContentMsg")[0].innerHTML = msg;
      $("#TabSpectrogramsContentMsgContainer").removeClass("hidden");
    } else {
      $("#TabSpectrogramsContentOuterMsg")[0].innerHTML = msg;
      $("#TabSpectrogramsContentMsgOuterContainer").removeClass("hidden");
    }

    if (!keepControls) {
      $("#TabSpectrogramsContentControls").addClass("hidden");
      $TabSpectrogramsContentGraphsContainer.addClass("hidden");
      $("#SpectrogramColorScale").addClass("hidden");
      $("#SpectrogramFiller").addClass("hidden");
    } else {
      $SpectrogramWin1GraphsContainer[0].innerHTML = "";
      $("#TabSpectrogramsContentMainTitleNodeName").text("");
      $("#TabSpectrogramsContentMainTitleTimeRange").text("");
    }
  }

  function displayNodePadMsg(msg, isError) {
    $("#TabNodePadContentMsg")[0].innerHTML = msg;

    if (isError) {
      $("#TabNodePadContentMsg").first().addClass("has-error");
    } else {
      $("#TabNodePadContentMsg").first().removeClass("has-error");
    }

    $("#TabNodePadContentMsgContainer").removeClass("hidden");
  }

  function enableRRDContent() {
    $("#TabRRDGraphsContentMsgContainer").addClass("hidden");
    $("#TabRRDContentControls").removeClass("hidden");
    $TabRRDContentGraphsContainer.removeClass("hidden");
  }

  function enablePaperContent() {
    $("#TabPaperContentMsgContainer").addClass("hidden");
    $TabPaperContentContainer.removeClass("hidden");
  }

  function enableOptixModeContent() {
    $("#TabOptixModeGraphsContentMsgContainer").addClass("hidden");
    $("#TabOptixModeContentControls").removeClass("hidden");
    $TabOptixModeContentGraphsContainer.removeClass("hidden");
  }

  function enableInternalsContent() {
    $("#TabInternalsContentMsgContainer").addClass("hidden");
    $TabInternalsContentContainer.removeClass("hidden");
  }

  function enableUtilsContent() {
    $("#TabUtilsContentMsgContainer").addClass("hidden");
    $TabUtilsContentContainer.removeClass("hidden");
  }

  function enableInternalsContentUCU() {
    $("#TabInternalsContentContainerParent").addClass("hidden");
    $("#TabInternalsContentContainerUMU").addClass("hidden");
    $("#TabInternalsContentContainerUCU").removeClass("hidden");
  }

  function enableInternalsContentUMU() {
    $("#TabInternalsContentContainerParent").addClass("hidden");
    $("#TabInternalsContentContainerUCU").addClass("hidden");
    $("#TabInternalsContentContainerUMU").removeClass("hidden");
  }

  function enableInternalsContentParentGroup() {
    $("#TabInternalsContentContainerUCU").addClass("hidden");
    $("#TabInternalsContentContainerUMU").addClass("hidden");
    $("#TabInternalsContentContainerParentContentMsgContainer").addClass(
      "hidden"
    );
    $("#TabInternalsContentContainerParent").removeClass("hidden");
  }

  function enableNodePadContent() {
    $("#TabNodePadContentControls").removeClass("hidden");
    $("#TabNodePadContentMsgContainer").addClass("hidden");
    $NodePadEntries.html("");
  }

  function displayRRDMsg(msg) {
    $("#TabRRDGraphsContentMsg")[0].innerHTML = msg;
    $("#TabRRDGraphsContentMsgContainer").removeClass("hidden");
    $("#TabRRDContentControls").addClass("hidden");
    $TabRRDContentGraphsContainer.addClass("hidden");
  }

  function displayOptixModeMsg(msg) {
    $("#TabOptixModeGraphsContentMsg")[0].innerHTML = msg;
    $("#TabOptixModeGraphsContentMsgContainer").removeClass("hidden");
    $("#TabOptixModeContentControls").addClass("hidden");
    $TabOptixModeContentGraphsContainer.addClass("hidden");
  }

  function displayInternalsMsg(msg) {
    $("#TabInternalsContentMsg")[0].innerHTML = msg;
    $("#TabInternalsContentMsgContainer").removeClass("hidden");
    $TabInternalsContentContainer.addClass("hidden");
  }

  function displayUtilsMsg(msg) {
    $("#TabUtilsContentMsg")[0].innerHTML = msg;
    $("#TabUtilsContentMsgContainer").removeClass("hidden");
    $TabUtilsContentContainer.addClass("hidden");
  }

  function displayPaperMsg(msg) {
    $("#TabPaperContentMsg")[0].innerHTML = msg;
    $("#TabPaperContentMsgContainer").removeClass("hidden");
    $TabPaperContentContainer.addClass("hidden");
  }

  function displayInternalsPIMReportMsg(msg) {
    $("#TabInternalsContentContainerParentContentMsg")[0].innerHTML = msg;
    $("#TabInternalsContentContainerParentContentMsgContainer").removeClass(
      "hidden"
    );
  }

  function hideInternalsPIMReportMsg() {
    $("#TabInternalsContentContainerParentContentMsgContainer").addClass(
      "hidden"
    );
  }

  function displayInternalsCEHReportMsg(msg) {
    $("#TabInternalsContentContainerParentContentMsgCEH")[0].innerHTML = msg;
    $("#TabInternalsContentContainerParentContentMsgContainerCEH").removeClass(
      "hidden"
    );
  }

  function hideInternalsCEHReportMsg() {
    $("#TabInternalsContentContainerParentContentMsgContainerCEH").addClass(
      "hidden"
    );
  }

  function displayInternalsTEHReportMsg(msg) {
    $("#TabInternalsContentContainerParentContentMsgTEH")[0].innerHTML = msg;
    $("#TabInternalsContentContainerParentContentMsgContainerTEH").removeClass(
      "hidden"
    );
  }

  function hideInternalsTEHReportMsg() {
    $("#TabInternalsContentContainerParentContentMsgContainerTEH").addClass(
      "hidden"
    );
  }

  function displayInternalsParsersMsg(msg) {
    $("#TabInternalsParsersMsg")[0].innerHTML = msg;
    $("#TabInternalsParsersMsgContainer").removeClass(
      "hidden"
    );
  }

  function hideInternalsParsersMsg() {
    $("#TabInternalsParsersMsgContainer").addClass(
      "hidden"
    );
  }

  function drawColorScale() {
    var colorScaleWidth =
      $("#SpectrogramColorScale")[0].getBoundingClientRect().width -
      60 -
      15 -
      20;

    var freqsForColors = [];

    var colorAxisMax;
    if (globColormap === "att") {
      colorAxisMax = ATT_DBM_MAX;
      for (var i = ATT_DBM_MIN; i <= ATT_DBM_MAX; i++) {
        freqsForColors[freqsForColors.length] = i;
      }
    } else if (IS_JET_COLORS) {
      // for (var i = -140; i <= -70; i++) {
      colorAxisMax = -53;
      for (var i = -124; i <= -53; i++) {
        freqsForColors[freqsForColors.length] = i;
      }
    } else {
      colorAxisMax = -83;
      for (var i = -124; i <= -83; i++) {
        freqsForColors[freqsForColors.length] = i;
      }
    }

    var colorWidth = colorScaleWidth / freqsForColors.length;

    d3.select("#SpectrogramColorScale")
      .html("")
      .append("g")
      .property("id", "SpectrogramColorScaleColorBars")
      .attr("transform", "translate(30,5)")
      .selectAll("rect")
      .data(freqsForColors)
      .enter()
      .append("rect")
      .attr("data-power", function drawColorScale_attr1(d, i) {
        return d;
      })
      .attr("x", function drawColorScale_attr2(d, i) {
        return i * colorWidth;
      })
      .attr("y", function drawColorScale_attr3(d, i) {
        return 0;
      })
      .attr("width", svgSpan(colorWidth))
      .attr("height", 20)
      .attr("stroke-width", 0)
      .style("fill", function drawColorScale_fill1(d, i) {
        return spectrogramPowerColor(d);
      });

    var colorScale = d3
      .scaleLinear()
      .domain([-125, colorAxisMax])
      .range([0, colorScaleWidth]); // tdata.data.length *
    // rectWidth]);

    var colorAxis = d3
      .axisBottom()
      .tickValues(
        globColormap === "att" ? freqsForColors : [-125].concat(freqsForColors)
      )
      .scale(colorScale);

    d3.select("#SpectrogramColorScale")
      .append("g")
      .attr("transform", "translate(30,25)")
      .call(colorAxis)
      .selectAll("text")
      .text(function (d, i) {
        if (i % 2 !== 0) {
          return "";
        } else {
          return d;
        }
      });

    // [dBm]
    d3.select("#SpectrogramColorScale")
      .append("g")
      .attr(
        "transform",
        "translate(" +
        (colorWidth * (freqsForColors.length + 1) + 15).toFixed(2) +
        "," +
        41 +
        ")"
      )
      .append("text")
      .style("font-size", ".8em")
      .text("[dBm]");
  }

  function drawGraph(
    tdata,
    graphType,
    isTimeHorizontal,
    el,
    title,
    graphTypesArr,
    isZooming,
    isRColumn,
    isDrawFreq
  ) {
    graphMargin.top = graphMargin.spectrogramsTop;

    // console.log(graphType, el, title);
    if (!tdata.data.length || !tdata.data[0][graphType]) {
      el.innerHTML =
        '<p style="text-align: center; font-size: 1.2em;">There is no data for graph "' +
        title +
        '"</p>';

      return;
    }

    var curentGraphNum = parseInt(el.id.substr(-1), 10);
    var isWin1 = el.id.indexOf("Window1") != -1;
    var numOfGraphs = spectrogramWindow1NumOfGraphs - (isWin1TD ? 1 : 0);
    var numOfGraphsWin2 = spectrogramWindow2NumOfGraphs - (isWin1TD ? 1 : 0);
    var numOfBins = tdata.numOfBins;
    var currentRectEpoch, currentRectBin;
    var isTooltips, toolTipsRectEl, toolTipsRectElCol;
    var hoverTimer = false;
    var isMouseDown = false,
      isTimeavgRect = false,
      isAfterTimeavgRect = false;
    var timeavgRectStartX, timeavgRectEndX, timeavgRectStartY, timeavgRectEndY;
    var mouseDownCoords = {
      x: -1,
      y: -1,
    };
    var actualGraphWidth = spectrogramWindow1GraphWidth;

    if (globIsSpectrogramGotRColumn) {
      actualGraphWidth += globTwoColumnsWidthAdjustment - 0; // -x allows to add spacing between the 2 columns if needed.
    }

    var mouseoverLastCoords = 0;

    var actualGraphHeight = el.getBoundingClientRect().height;

    var yAxisHeight =
      actualGraphHeight -
      (isTimeHorizontal
        ? graphMargin.bottomWide
        : isDrawFreq
          ? graphMargin.bottom
          : 5) -
      graphMargin.top;

    // var rWidth = isTimeHorizontal ? globRectWidth : (actualGraphWidth - graphMargin.left) / (numOfBins - 1);
    var rWidth = isTimeHorizontal
      ? globRectWidth
      : (actualGraphWidth - graphMargin.left) / numOfBins;
    // var rHeight = isTimeHorizontal ? Math.floor(yAxisHeight / (numOfBins
    // - 1)) : globRectHeight;
    // var rHeight = isTimeHorizontal ? (yAxisHeight / (numOfBins - 1)) :
    // globRectHeight;
    var rHeight = isTimeHorizontal ? yAxisHeight / numOfBins : globRectHeight;

    var graphWidth = numOfBins * rWidth;

    globIsSpectrogramTimeavgRect = false;

    if (IS_DEBUG) {
      console.log(
        "drawGraph:: yAxisHeight = ",
        yAxisHeight,
        ", rWidth = ",
        rWidth,
        ", rHeight = ",
        rHeight
      );
    }

    // ++ Title (node name)
    var nodeData = getNodeData("un_" + tdata.childId);
    var actualTitle = getGraphNodeTitle(nodeData);

    $("#TabSpectrogramsContentMainTitleNodeName").text(actualTitle);
    // == Title (node name)

    // ++ Time range title
    var timespanText =
      moment(parseInt(tdata.endMsecEpoch))
        .tz(globServerTimezone)
        .format("MM-DD HH:mm") +
      " - " +
      moment(parseInt(tdata.startMsecEpoch))
        .tz(globServerTimezone)
        .format("MM-DD HH:mm");

    $("#TabSpectrogramsContentMainTitleTimeRange").text(timespanText);

    if (globSpectrogramsGraphsZoomDates.length) {
      $("#TabSpectrogramsContentMainTitleTimeRange").addClass("zoom-color");
    } else {
      $("#TabSpectrogramsContentMainTitleTimeRange").removeClass("zoom-color");
    }
    // == Time range title

    var tScale = d3
      .scaleLinear()
      .domain(
        isTimeHorizontal
          ? [tdata.endMsecEpoch, tdata.startMsecEpoch]
          : [tdata.endMsecEpoch, tdata.startMsecEpoch]
      )
      .range([
        0,
        isTimeHorizontal
          ? spectrogramWindow1GraphWidth - 0 /* rWidth */ - graphMargin.left
          : yAxisHeight - 0 /* rHeight */,
      ])
      .clamp(true);

    // var bScale = d3.scaleLinear()
    // 	.domain(isTimeHorizontal ? [numOfBins, 0] : [0, numOfBins])
    // 	// .range([isTimeHorizontal ? 0 : 0, isTimeHorizontal ? (numOfBins -
    // 	// 1) * rHeight : graphWidth]);
    // 	.range([isTimeHorizontal ? 0 : 0, isTimeHorizontal ? numOfBins * rHeight : graphWidth])
    // 	.clamp(true);

    var spectrogramWindowMsecPerPixel = spectrogramWindow1SecPerPixel * 1000;

    // d3.select(('#' + el.id))
    // .on('mouseover', function mouseout(d, i) {
    // console.log('graph el mouseover');
    // });

    d3.select("#" + el.id + " svg")
      .on("mousedown", function mouseout(d, i) {
        if (tdata.data.length) {
          mouseDownCoords = {
            x: d3.event.clientX,
            y: d3.event.clientY,
          };

          if (d3.event.which === 1) {
            // Left click.
            // console.log('svg mousedown (left click)');

            isMouseDown = true;
            isTimeavgRect = globIsSpectrogramTimeavgRect = false;

            if (!globSpectrogramsUpdateTimer && isSpectrogramPre) {
              globSpectrogramsUpdateTimer = setTimeout(
                tabSpectrogramsContentControlsGo,
                SPECTROGRAMS_UPODATE_INTERVAL
              );
            }

            for (var i = 0; i < $SpectrogramWindow1GraphElements.length; ++i) {
              $(
                "#" +
                $SpectrogramWindow1GraphElements[i][0].id +
                " .timerect-container"
              )[0].style.visibility = "hidden";
            }

            if (isTimeHorizontal) {
              timeRect
                .select(".timerect")
                // .attr('y', d3.mouse(this)[1] + 'px');
                .attr("width", 0 + "px");
            } else {
              timeRect
                .select(".timerect")
                // .attr('y', d3.mouse(this)[1] + 'px');
                .attr("height", 0 + "px");
            }

            d3.event.preventDefault();
          }
        }
      })
      .on("mouseup", function mouseout(d, i) {
        if (tdata.data.length) {
          if (d3.event.which === 1) {
            // Left click.
            // console.log('svg mouseup (left click)');

            if (isTimeavgRect) {
              var mCoordinates = d3.mouse(this);
              var t1, t2;

              if (isTimeHorizontal) {
                timeavgRectEndX = mCoordinates[0] - graphMargin.left;

                t1 = tScale.invert(timeavgRectStartX).toFixed(0) + "";
                t2 = tScale.invert(timeavgRectEndX).toFixed(0) + "";
              } else {
                timeavgRectEndY = mCoordinates[1];

                t1 = tScale.invert(timeavgRectStartY).toFixed(0) + "";
                t2 = tScale.invert(timeavgRectEndY).toFixed(0) + "";
              }

              if (t2 < t1) {
                var tmpVal = t1;
                t1 = t2;
                t2 = tmpVal;
              }

              // console.log(t1, t2);

              var startDate = t2 / 1000;
              var endDate = t1 / 1000;

              if (
                (startDate - endDate) / 60 >=
                SPECTROGRAMS_GRAPH_MIN_MINUTES_FOR_ZOOM
              ) {
                console.log(
                  "Zoom in for startDate = ",
                  startDate,
                  ", endDate = ",
                  endDate
                ); // DDD

                globSpectrogramsGraphsZoomDates.push({
                  startMsecEpoch: parseInt(tdata["startMsecEpoch"]) / 1000,
                  endMsecEpoch: parseInt(tdata["endMsecEpoch"]) / 1000,
                });

                // console.log('Zoom in data',
                // globSpectrogramsGraphsZoomDates); // DDD

                // OOO??? isTimestampInfoVisible = false;

                setTimeout(
                  tabSpectrogramsContentControlsGo(null, {
                    startDate: startDate,
                    endDate: endDate,
                  }),
                  0
                );

                // ++ Dates Range
                var tmpStartTimeCloud = moment.tz(
                  endDate * 1000,
                  globServerTimezone
                );
                var newMomentStartDate = moment(
                  new Date(tmpStartTimeCloud.format("ddd, DD MMM YYYY HH:mm"))
                );

                var tmpEndTimeCloud = moment.tz(
                  startDate * 1000,
                  globServerTimezone
                );
                var newMomentEndDate = moment(
                  new Date(tmpEndTimeCloud.format("ddd, DD MMM YYYY HH:mm"))
                );

                var nowCloud = moment().tz(globServerTimezone);
                var localCloudTime = moment(
                  new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
                );

                globSpectrogramsIsNOPDatesRangeFuncs = true;
                $TabSpectrogramsContentControlsStartDate
                  .data("DateTimePicker")
                  .maxDate(newMomentEndDate);
                $TabSpectrogramsContentControlsEndDate
                  .data("DateTimePicker")
                  .maxDate(localCloudTime);
                $TabSpectrogramsContentControlsEndDate
                  .data("DateTimePicker")
                  .minDate(newMomentStartDate);

                $TabSpectrogramsContentControlsStartDate
                  .data("DateTimePicker")
                  .date(newMomentStartDate);

                $TabSpectrogramsContentControlsEndDate
                  .data("DateTimePicker")
                  .date(newMomentEndDate);
                // == Dates Range
              } else {
                timeRect.style("visibility", "hidden");
              }
            } else {
              // OOO???
            }

            isMouseDown = isTimeavgRect = globIsSpectrogramTimeavgRect = false;
          }
        }
      })
      // .on('mouseover', function mouseout(d, i) {
      // // console.log('svg mouseover');
      // })
      .on("mousemove", function mouseout(d, i) {
        if (tdata.data.length) {
          var graphsId;

          if (
            d3.event.clientX !== mouseDownCoords.x ||
            d3.event.clientY !== mouseDownCoords.y
          ) {
            // console.log('svg mousemove');

            if (!globIsSpectrogramTimeavgRect) {
              isTimeavgRect = isAfterTimeavgRect = false;
            }

            if (isMouseDown) {
              if (isTimeavgRect) {
                timeRect.style("visibility", "visible");

                var mCoordinates = d3.mouse(this);

                if (isTimeHorizontal) {
                  var diffX =
                    mCoordinates[0] - graphMargin.left - timeavgRectStartX;

                  if (diffX >= 0) {
                    timeRect.select(".timerect").attr("width", diffX + "px");
                  } else {
                    timeRect
                      .select(".timerect")
                      .attr("x", mCoordinates[0] - graphMargin.left + "px")
                      .attr("width", Math.abs(diffX) + "px");
                  }
                } else {
                  var diffY = mCoordinates[1] - timeavgRectStartY;

                  if (diffY >= 0) {
                    timeRect.select(".timerect").attr("height", diffY + "px");
                  } else {
                    timeRect
                      .select(".timerect")
                      .attr("y", mCoordinates[1] + "px")
                      .attr("height", Math.abs(diffY) + "px");
                  }
                }

                var t1, t2;

                if (isTimeHorizontal) {
                  timeavgRectEndX = mCoordinates[0] - graphMargin.left;

                  t1 = +tScale.invert(timeavgRectStartX).toFixed(0) + "";
                  t2 = +tScale.invert(timeavgRectEndX).toFixed(0) + "";
                } else {
                  timeavgRectEndY = mCoordinates[1];

                  t1 = +tScale.invert(timeavgRectStartY).toFixed(0) + "";
                  t2 = +tScale.invert(timeavgRectEndY).toFixed(0) + "";
                }

                if (t2 < t1) {
                  var tmpVal = t1;
                  t1 = t2;
                  t2 = tmpVal;
                }

                var startDate = t2 / 1000;
                var endDate = t1 / 1000;

                if (
                  (startDate - endDate) / 60 >=
                  SPECTROGRAMS_GRAPH_MIN_MINUTES_FOR_ZOOM
                ) {
                  timeRect
                    .select(".timerect")
                    .attr("stroke", "rgb(126, 230, 0)") // Green
                    .attr("fill", "rgba(126, 230, 0, 0.3)");
                } else {
                  timeRect
                    .select(".timerect")
                    .attr("stroke", "red")
                    .attr("fill", "rgba(255, 0, 0, 0.3)");
                }
              } else {
                if (globSpectrogramsUpdateTimer) {
                  clearTimeout(globSpectrogramsUpdateTimer);

                  globSpectrogramsUpdateTimer = null;
                }

                crosshairs.style("display", "none");

                if (isTooltips) {
                  if (hoverTimer) {
                    clearTimeout(hoverTimer);
                    hoverTimer = false;
                  }

                  crosshairs.style("display", "none");

                  for (var n = 1; n <= numOfGraphs; ++n) {
                    if (isWin1 && n === curentGraphNum) {
                      continue;
                    }

                    graphsId = "#SpectrogramWindow1Graph" + n;
                    d3.select(graphsId + "Crosshairs").style("display", "none");
                  }

                  for (var n = 1; n <= numOfGraphsWin2; ++n) {
                    if (!isWin1 && n === curentGraphNum) {
                      continue;
                    }

                    graphsId = "#SpectrogramWindow2Graph" + n;
                    d3.select(graphsId + "Crosshairs").style("display", "none");
                  }

                  spectrogramAxisTooltipElements[0].style(
                    "visibility",
                    "hidden"
                  );
                  spectrogramAxisTooltipElements[1].style(
                    "visibility",
                    "hidden"
                  );

                  spectrogramTooltipElements[0].style("visibility", "hidden");

                  for (var n = 0; n < toolTipsRectEl.length; ++n) {
                    spectrogramTooltipElements[n + 1].style(
                      "visibility",
                      "hidden"
                    );
                  }
                }

                var mCoordinates = d3.mouse(this);

                if (isTimeHorizontal) {
                  timeavgRectStartX = mCoordinates[0] - graphMargin.left;

                  timeRect
                    .select(".timerect")
                    .attr("x", timeavgRectStartX + "px");
                } else {
                  timeavgRectStartY = mCoordinates[1];

                  timeRect
                    .select(".timerect")
                    .attr("y", timeavgRectStartY + "px");
                }

                isTimeavgRect =
                  isAfterTimeavgRect =
                  globIsSpectrogramTimeavgRect =
                  true;
              }
            }
          }
        }
      })
      .on("mouseleave", function mouseout(d, i) {
        // console.log('svg mouseleave ' + i); // DDD

        var graphsId;

        globCurrentGraphObject = null;

        if (isTooltips) {
          if (hoverTimer) {
            clearTimeout(hoverTimer);
            hoverTimer = false;
          }

          crosshairs.style("display", "none");

          for (var n = 1; n <= numOfGraphs; ++n) {
            if (isWin1 && n === curentGraphNum) {
              continue;
            }

            graphsId = "#SpectrogramWindow1Graph" + n;
            d3.select(graphsId + "Crosshairs").style("display", "none");
          }

          for (var n = 1; n <= numOfGraphsWin2; ++n) {
            if (!isWin1 && n === curentGraphNum) {
              continue;
            }

            graphsId = "#SpectrogramWindow2Graph" + n;
            d3.select(graphsId + "Crosshairs").style("display", "none");
          }

          spectrogramAxisTooltipElements[0].style("visibility", "hidden");
          spectrogramAxisTooltipElements[1].style("visibility", "hidden");

          spectrogramTooltipElements[0].style("visibility", "hidden");

          for (var n = 0; n < toolTipsRectEl.length; ++n) {
            spectrogramTooltipElements[n + 1].style("visibility", "hidden");
          }
        }

        var mCoordinates = d3.mouse(this);

        var mouseEventDetail = {
          source: "spectrogram",
          coordinates: mCoordinates,
        };

        var mouseoutEvent = new CustomEvent("mouseout", {
          bubbles: true,
          detail: mouseEventDetail,
        });

        if (globIsSpectrogramGotRColumn) {
          // Left TD graph
          $(glob2DRectL.node())[0].dispatchEvent(mouseoutEvent);

          // Right TD graph
          $(glob2DRectR.node())[0].dispatchEvent(mouseoutEvent);
        } else {
          $(glob2DRectL.node())[0].dispatchEvent(mouseoutEvent);
        }

        d3.event.preventDefault();
      })
      .on("contextmenu", function contextmenu(d, i) {
        if (globSpectrogramsGraphsZoomDates.length) {
          var graphsId;

          var zoomOutData = globSpectrogramsGraphsZoomDates.pop();

          // console.log('Zoom out for startDate = ',
          // zoomOutData.startMsecEpoch, ', endDate = ',
          // zoomOutData.endMsecEpoch); // DDD
          // console.log('Zoom in data',
          // globSpectrogramsGraphsZoomDates); // DDD

          crosshairs.style("display", "none");

          if (isTooltips) {
            if (hoverTimer) {
              clearTimeout(hoverTimer);
              hoverTimer = false;
            }

            crosshairs.style("display", "none");

            for (var n = 1; n <= numOfGraphs; ++n) {
              if (isWin1 && n === curentGraphNum) {
                continue;
              }

              graphsId = "#SpectrogramWindow1Graph" + n;
              d3.select(graphsId + "Crosshairs").style("display", "none");
            }

            for (var n = 1; n <= numOfGraphsWin2; ++n) {
              if (!isWin1 && n === curentGraphNum) {
                continue;
              }

              graphsId = "#SpectrogramWindow2Graph" + n;
              d3.select(graphsId + "Crosshairs").style("display", "none");
            }

            spectrogramAxisTooltipElements[0].style("visibility", "hidden");
            spectrogramAxisTooltipElements[1].style("visibility", "hidden");

            spectrogramTooltipElements[0].style("visibility", "hidden");

            for (var n = 0; n < toolTipsRectEl.length; ++n) {
              spectrogramTooltipElements[n + 1].style("visibility", "hidden");
            }
          }

          setTimeout(
            tabSpectrogramsContentControlsGo(null, {
              startDate: zoomOutData.startMsecEpoch,
              endDate: zoomOutData.endMsecEpoch,
            }),
            0
          );

          // ++ Dates Range
          var tmpStartTimeCloud = moment.tz(
            zoomOutData.endMsecEpoch * 1000,
            globServerTimezone
          );
          var newMomentStartDate = moment(
            new Date(tmpStartTimeCloud.format("ddd, DD MMM YYYY HH:mm"))
          );

          var tmpEndTimeCloud = moment.tz(
            zoomOutData.startMsecEpoch * 1000,
            globServerTimezone
          );
          var newMomentEndDate = moment(
            new Date(tmpEndTimeCloud.format("ddd, DD MMM YYYY HH:mm"))
          );

          var nowCloud = moment().tz(globServerTimezone);
          var localCloudTime = moment(
            new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
          );

          globSpectrogramsIsNOPDatesRangeFuncs = true;
          $TabSpectrogramsContentControlsStartDate
            .data("DateTimePicker")
            .maxDate(newMomentEndDate);
          $TabSpectrogramsContentControlsEndDate
            .data("DateTimePicker")
            .minDate(newMomentStartDate);
          $TabSpectrogramsContentControlsEndDate
            .data("DateTimePicker")
            .maxDate(localCloudTime);

          $TabSpectrogramsContentControlsStartDate
            .data("DateTimePicker")
            .date(newMomentStartDate);

          $TabSpectrogramsContentControlsEndDate
            .data("DateTimePicker")
            .date(newMomentEndDate);
          // == Dates Range

          isTimeavgRect =
            isAfterTimeavgRect =
            globIsSpectrogramTimeavgRect =
            true;
        }

        d3.event.preventDefault();
        return false;
      })
      .append("g")
      .selectAll("g")
      .data(tdata.data)
      .enter()
      .append("g")
      .attr("data-epoch", function drawAvgData_attr1(d, i) {
        return d.msec_epoch;
      })
      .attr(
        "transform",
        "translate(" +
        (isRColumn ? graphMargin.leftRColumn : graphMargin.left) +
        "," +
        graphMargin.top +
        ")"
      )
      .each(function drawAvgData_each(d, iTime) {
        // console.log(d, this);

        var rectHeight = rHeight;
        var rectWidth = rWidth;

        if (iTime < tdata.data.length - 1) {
          var timeDiffMsec = Math.abs(
            d.msec_epoch - tdata.data[iTime + 1].msec_epoch
          );

          if (timeDiffMsec <= SPECTROGRAM_GAP_FILL_THRESHOLD_MSEC) {
            if (!isTimeHorizontal) {
              rectHeight = Math.floor(
                timeDiffMsec / spectrogramWindowMsecPerPixel
              );
            } else {
              rectWidth = Math.floor(
                timeDiffMsec / spectrogramWindowMsecPerPixel
              );
            }
          }
        }
        // console.log('rectWidth = ', rectWidth, 'rectHeight = ',
        // rectHeight);

        if (d[graphType].length) {
          d3.select(this)
            .selectAll("rect")
            .data(d[graphType])
            .enter()
            .append("rect")
            // .attr('data-power', function (d, i) {
            // return d;
            // })
            .attr("data-bin", function drawAvgData_attr2(d2, i2) {
              return "bin" + (i2 + 1);
            })
            .attr("x", function drawAvgData_attr3(d2, i2) {
              if (isTimeHorizontal) {
                // return iTime * rWidth;
                return tScale(d.msec_epoch).toFixed(2);
              } else {
                return i2 * rectWidth;
                // return bScale(i2).toFixed(2);
              }
            })
            .attr("y", function drawAvgData_attr4(d2, i2) {
              if (isTimeHorizontal) {
                return yAxisHeight - (i2 + 1) * rectHeight;
                // return bScale(i2).toFixed(2);
              } else {
                // return yAxisHeight - (iTime * rHeight);
                return tScale(d.msec_epoch).toFixed(2);
              }
            })
            .attr("width", svgSpan(rectWidth))
            // .attr('height', rHeight)
            .attr("height", svgSpan(rectHeight))
            .attr("stroke-width", 0)
            .style("fill", function drawAvgData_style1(d2, i2) {
              // if (globalIsSpectrogramsPowerFilter) {
              // 	if (!isNaN(globalSpectrogramsPowerFilterMinVal)) {
              // 		if (d2 < globalSpectrogramsPowerFilterMinVal) {
              // 			return powerToColorScale(-136);
              // 		}
              // 	}

              // 	if (!isNaN(globalSpectrogramsPowerFilterMaxVal)) {
              // 		if (d2 > globalSpectrogramsPowerFilterMaxVal) {
              // 			return powerToColorScale(-136);
              // 		}
              // 	}

              // 	return (IS_JET_COLORS ? powerToJetColorScale(d2) : powerToColorScale(d2));
              // } else {
              return spectrogramPowerColor(d2);
              // }
            });
          // .append('svg:title')
          // .text(function (d, i) {
          // return d;
          // });
        }
      })
      .on("mouseover", function mouseover(d, i) {
        if (!globIsSpectrogramKeyboardEvent) {
          var graphsId;

          globCurrentGraphObject = this;

          var mCoordinates = d3.mouse(this);

          if (
            mCoordinates[0] !== mouseoverLastCoords[0] ||
            mCoordinates[1] !== mouseoverLastCoords[1]
          ) {
            // console.log(mouseoverLastCoords, mCoordinates); //
            // DDD
            mouseoverLastCoords = mCoordinates;

            isTooltips = false;

            if (
              !globIsSpectrogramTimeavgRect &&
              !isTimeavgRect &&
              !isAfterTimeavgRect &&
              d3.event.target.__data__ > noTooltipDbmThreshold
            ) {
              isTooltips = true;
              globLastSpectrogramRect = d3.event.target;

              spectrogramTooltipElements[0].text(
                d3.event.target.__data__ + " dB"
              );
              spectrogramTooltipElements[0].style("visibility", "visible");

              currentRectEpoch =
                d3.event.currentTarget.getAttribute("data-epoch");
              currentRectBin = d3.event.target.getAttribute("data-bin");

              //  ++ Crosshairs
              crosshairs.style("display", null);
              spectrogramAxisTooltipElements[0].style("visibility", "visible");
              spectrogramAxisTooltipElements[1].style("visibility", "visible");

              for (var n = 1; n <= numOfGraphs; ++n) {
                if (isWin1 && n === curentGraphNum) {
                  continue;
                }

                graphsId = "#SpectrogramWindow1Graph" + n;
                d3.select(graphsId + "Crosshairs").style("display", null);
              }

              for (var n = 1; n <= numOfGraphsWin2; ++n) {
                if (!isWin1 && n === curentGraphNum) {
                  continue;
                }

                graphsId = "#SpectrogramWindow2Graph" + n;
                d3.select(graphsId + "Crosshairs").style("display", null);
              }
              //  == Crosshairs

              toolTipsRectEl = [];
              toolTipsRectElCol = [];
              for (var n = 1; n <= numOfGraphs; ++n) {
                if (isWin1 && n === curentGraphNum) {
                  continue;
                }

                graphsId = "#SpectrogramWindow1Graph" + n;

                var tmpEpochRect = document.querySelector(
                  graphsId +
                  ' [data-epoch="' +
                  currentRectEpoch +
                  '"] [data-bin="' +
                  currentRectBin +
                  '"]'
                );
                if (tmpEpochRect) {
                  toolTipsRectEl.push(tmpEpochRect);
                  toolTipsRectElCol.push("LEFT");
                  var opposedText =
                    toolTipsRectEl[toolTipsRectEl.length - 1].__data__;

                  spectrogramTooltipElements[toolTipsRectEl.length].text(
                    opposedText + " dB"
                  );
                  spectrogramTooltipElements[toolTipsRectEl.length].style(
                    "visibility",
                    "visible"
                  );
                } else {
                  spectrogramTooltipElements[n].style("visibility", "visible");
                }
              }
              for (var n = 1; n <= numOfGraphsWin2; ++n) {
                if (!isWin1 && n === curentGraphNum) {
                  continue;
                }

                graphsId = "#SpectrogramWindow2Graph" + n;

                var tmpEpochRect = document.querySelector(
                  graphsId +
                  ' [data-epoch="' +
                  currentRectEpoch +
                  '"] [data-bin="' +
                  currentRectBin +
                  '"]'
                );
                if (tmpEpochRect) {
                  toolTipsRectEl.push(tmpEpochRect);
                  toolTipsRectElCol.push("RIGHT");
                  var opposedText =
                    toolTipsRectEl[toolTipsRectEl.length - 1].__data__;

                  spectrogramTooltipElements[toolTipsRectEl.length].text(
                    opposedText + " dB"
                  );
                  spectrogramTooltipElements[toolTipsRectEl.length].style(
                    "visibility",
                    "visible"
                  );
                } else {
                  spectrogramTooltipElements[n].style("visibility", "visible");
                }
              }

              // if (isWin1TD && (!globIs2DFrozen)) {
              // 	hoverTimer = setTimeout(function () {
              // 		var mouseEventDetail = {
              // 			'source': 'spectrogram',
              // 			'coordinates': mCoordinates
              // 		};

              // 		var mouseoverEvent = new CustomEvent('mouseover', {
              // 			bubbles: true,
              // 			detail: mouseEventDetail
              // 		});

              // 		var mousemoveEvent = new CustomEvent('mousemove', {
              // 			bubbles: true,
              // 			detail: mouseEventDetail
              // 		});

              // 		if (globIsSpectrogramGotRColumn) {
              // 			// Left TD graph
              // 			draw2DGraph(false, tdata, 'timestamphover', isTimeHorizontal, currentRectEpoch);
              // 			$(glob2DRectL.node())[0].dispatchEvent(mouseoverEvent);
              // 			$(glob2DRectL.node())[0].dispatchEvent(mousemoveEvent);

              // 			// Right TD graph
              // 			draw2DGraph(true, tdata, 'timestamphover', isTimeHorizontal, currentRectEpoch);
              // 			$(glob2DRectR.node())[0].dispatchEvent(mouseoverEvent);
              // 			$(glob2DRectR.node())[0].dispatchEvent(mousemoveEvent);
              // 		} else {
              // 			draw2DGraph(false, tdata, 'timestamphover', isTimeHorizontal, currentRectEpoch);
              // 			$(glob2DRectL.node())[0].dispatchEvent(mouseoverEvent);
              // 			$(glob2DRectL.node())[0].dispatchEvent(mousemoveEvent);
              // 		}
              // 	}, 0); // default is 350
              // }
            }
          }
        }

        d3.event.preventDefault();
      })
      .on("mousemove", function mousemove() {
        if (!isMouseDown && isAfterTimeavgRect) {
          isAfterTimeavgRect = false;
        } else if (isTooltips) {
          var gCoordinates = d3
            .select("#" + el.id + " svg g")
            .node()
            .getBoundingClientRect();
          var mCoordinates, mCoordinatesFor2D;

          var isKeyboardEvent = Array.isArray(d3.event.detail);
          var nextLastRect;
          var isRectYChange;

          if (isKeyboardEvent) {
            globIsSpectrogramKeyboardEvent = true;

            // $('#' + el.id + ' svg g').addClass('noCursor');

            if (d3.event.detail[0] == -1) {
              if (!isTimeHorizontal) {
                if (globLastSpectrogramRect.previousSibling !== null) {
                  nextLastRect = globLastSpectrogramRect.previousSibling;
                }
              }
            } else if (d3.event.detail[0] == 1) {
              if (!isTimeHorizontal) {
                if (globLastSpectrogramRect.nextSibling !== null) {
                  nextLastRect = globLastSpectrogramRect.nextSibling;
                }
              }
            }

            if (d3.event.detail[1] == -1) {
              if (!isTimeHorizontal) {
                if (globCurrentGraphObject.previousSibling !== null) {
                  nextLastRect =
                    globCurrentGraphObject.previousSibling.querySelector(
                      '[data-bin="' + currentRectBin + '"]'
                    );

                  globCurrentGraphObject =
                    globCurrentGraphObject.previousSibling;
                }
              }
            } else if (d3.event.detail[1] == 1) {
              if (!isTimeHorizontal) {
                if (globCurrentGraphObject.nextSibling !== null) {
                  nextLastRect =
                    globCurrentGraphObject.nextSibling.querySelector(
                      '[data-bin="' + currentRectBin + '"]'
                    );

                  globCurrentGraphObject = globCurrentGraphObject.nextSibling;
                }
              }
            }

            // Arrow key pressed at an edge: nowhere to move, keep the cursor.
            if (!nextLastRect) {
              return;
            }

            var nextLastRectCoordinates;
            if (nextLastRect) {
              nextLastRectCoordinates = nextLastRect.getBoundingClientRect();

              mCoordinates = [
                nextLastRectCoordinates.left +
                (nextLastRectCoordinates.right -
                  nextLastRectCoordinates.left) /
                2,
                nextLastRectCoordinates.top +
                (nextLastRectCoordinates.bottom -
                  nextLastRectCoordinates.top) /
                2,
              ];
              // mCoordinates = [nextLastRectCoordinates.left, nextLastRectCoordinates.top + ((nextLastRectCoordinates.bottom - nextLastRectCoordinates.top) / 2)];
              mCoordinates[0] -= gCoordinates.left;
              mCoordinates[1] -= gCoordinates.top;

              mCoordinatesFor2D = [
                nextLastRectCoordinates.left - gCoordinates.left,
                nextLastRectCoordinates.top - gCoordinates.top,
              ];
            }

            if (nextLastRect) {
              currentRectEpoch =
                globCurrentGraphObject.getAttribute("data-epoch");
              currentRectBin = nextLastRect.getAttribute("data-bin");

              toolTipsRectEl = [];

              for (var n = 1; n <= numOfGraphs; ++n) {
                if (isWin1 && n === curentGraphNum) {
                  continue;
                }

                var graphsId = "#SpectrogramWindow1Graph" + n;

                var tmpEpochRect = document.querySelector(
                  graphsId +
                  ' [data-epoch="' +
                  currentRectEpoch +
                  '"] [data-bin="' +
                  currentRectBin +
                  '"]'
                );
                if (tmpEpochRect) {
                  toolTipsRectEl.push(tmpEpochRect);
                }
              }

              for (var n = 1; n <= numOfGraphsWin2; ++n) {
                if (!isWin1 && n === curentGraphNum) {
                  continue;
                }

                var graphsId = "#SpectrogramWindow2Graph" + n;

                var tmpEpochRect = document.querySelector(
                  graphsId +
                  ' [data-epoch="' +
                  currentRectEpoch +
                  '"] [data-bin="' +
                  currentRectBin +
                  '"]'
                );
                if (tmpEpochRect) {
                  toolTipsRectEl.push(tmpEpochRect);
                }
              }

              globLastSpectrogramRect = nextLastRect;
            }
          } else {
            globIsSpectrogramKeyboardEvent = false;

            // $('#' + el.id + ' svg g').removeClass('noCursor');

            mCoordinatesFor2D = mCoordinates = d3.mouse(this);
          }

          // ++ Crosshairs
          // ++ Crosshairs Position
          crosshairs
            .select(".x")
            .attr(
              "transform",
              "translate(" + mCoordinates[0] + "," + mCoordinates[1] + ")"
            )
            .attr("y2", yAxisHeight - mCoordinates[1]);

          crosshairs
            .select(".y")
            .attr(
              "transform",
              "translate(" + mCoordinates[0] + "," + mCoordinates[1] + ")"
            )
            .attr("x2", -mCoordinates[0]);

          for (var n = 1; n <= numOfGraphs; ++n) {
            if (isWin1 && n === curentGraphNum) {
              continue;
            }

            graphsId = "#SpectrogramWindow1Graph" + n;

            d3.select(graphsId + "Crosshairs .x")
              .attr(
                "transform",
                "translate(" + mCoordinates[0] + "," + mCoordinates[1] + ")"
              )
              .attr("y2", yAxisHeight - mCoordinates[1]);

            d3.select(graphsId + "Crosshairs .y")
              .attr(
                "transform",
                "translate(" + mCoordinates[0] + "," + mCoordinates[1] + ")"
              )
              .attr("x2", -mCoordinates[0]);
          }

          for (var n = 1; n <= numOfGraphsWin2; ++n) {
            if (!isWin1 && n === curentGraphNum) {
              continue;
            }

            graphsId = "#SpectrogramWindow2Graph" + n;

            d3.select(graphsId + "Crosshairs .x")
              .attr(
                "transform",
                "translate(" + mCoordinates[0] + "," + mCoordinates[1] + ")"
              )
              .attr("y2", yAxisHeight - mCoordinates[1]);

            d3.select(graphsId + "Crosshairs .y")
              .attr(
                "transform",
                "translate(" + mCoordinates[0] + "," + mCoordinates[1] + ")"
              )
              .attr("x2", -mCoordinates[0]);
          }
          // ++ Crosshairs Position

          var freqVal;
          if (isTimeHorizontal) {
            freqVal = yScale.invert(mCoordinates[1]);

            spectrogramAxisTooltipElements[1].text(freqVal.toFixed(2) + " MHz");
          } else {
            // freqVal = xScale.invert(mCoordinates[0]);
            freqVal =
              tdata.freqs.startFreq +
              (currentRectBin.substr(3) - 1) * tdata.freqs.mhzPerBin;

            // spectrogramAxisTooltipElements[0].text(freqVal.toFixed(2) + ' MHz');
            spectrogramAxisTooltipElements[0].text(freqVal.toFixed(2) + " MHz");
          }

          // var timestampVal = parseInt(currentRectEpoch);
          var timestampVal;
          if (isTimeHorizontal) {
            timestampVal = xScale.invert(mCoordinates[0]);

            spectrogramAxisTooltipElements[0].text(
              moment(timestampVal).tz(globServerTimezone).format("MM-DD HH:mm")
            );
          } else {
            timestampVal = yScale.invert(mCoordinates[1]);

            spectrogramAxisTooltipElements[1].text(
              moment(timestampVal).tz(globServerTimezone).format("MM-DD HH:mm")
            );
          }

          // X Axes Tooltip
          spectrogramAxisTooltipElements[0]
            .style(
              "top",
              gCoordinates.bottom -
              (isTimeHorizontal ? graphMargin.top : 0) +
              "px"
            )
            .style("left", mCoordinates[0] + gCoordinates.left + "px");

          // Y Axes Tooltip
          var timestampTooltipCoordinates = spectrogramAxisTooltipElements[1]
            .node()
            .getBoundingClientRect();

          spectrogramAxisTooltipElements[1]
            .style(
              "top",
              mCoordinates[1] +
              gCoordinates.top -
              timestampTooltipCoordinates.height +
              "px"
            )
            .style(
              "left",
              gCoordinates.left - timestampTooltipCoordinates.width + "px"
            );
          // == Crosshairs

          spectrogramTooltipElements[0].text(
            globLastSpectrogramRect.__data__ + " dB"
          );

          spectrogramTooltipElements[0]
            .style("top", mCoordinates[1] + gCoordinates.top - 30 + "px")
            .style("left", mCoordinates[0] + gCoordinates.left + 15 + "px");

          // console.log('d3.event.pageY - 30 = ', d3.event.pageY -
          // 30, ', d3.event.pageX + 15 = ', d3.event.pageX + 15); //
          // DDD

          for (var n = 0; n < toolTipsRectEl.length; ++n) {
            if (toolTipsRectEl[n]) {
              var opposedCoordinates =
                toolTipsRectEl[n].getBoundingClientRect();

              // console.log('opposedCoordinates.top - 30 = ',
              // opposedCoordinates.top - 30, ', d3.event.pageX +
              // 15 = ', d3.event.pageX + 15); // DDD

              if (isKeyboardEvent) {
                var opposedText = toolTipsRectEl[n].__data__;

                spectrogramTooltipElements[n + 1].text(opposedText + " dB");
              }

              var isTooltipInitiatedOnWin2 = el.id.indexOf("Window2") != -1;

              spectrogramTooltipElements[n + 1]
                .style(
                  "top",
                  (isTimeHorizontal
                    ? mCoordinates[1] + gCoordinates.top - 30
                    : opposedCoordinates.top - 30) + "px"
                )
                .style(
                  "left",
                  (isTimeHorizontal ||
                    (isTooltipInitiatedOnWin2 &&
                      toolTipsRectElCol[n] == "LEFT") ||
                    toolTipsRectElCol[n] == "RIGHT"
                    ? opposedCoordinates.left + 15
                    : mCoordinates[0] + gCoordinates.left + 15) + "px"
                );
            }
          }

          //if (isRectYChange) {
          if (isWin1TD && !globIs2DFrozen) {
            hoverTimer = setTimeout(function () {
              var mouseEventDetail = {
                source: "spectrogram",
                coordinates: mCoordinatesFor2D,
                bin: currentRectBin,
              };

              var mouseoverEvent = new CustomEvent("mouseover", {
                bubbles: true,
                detail: mouseEventDetail,
              });

              var mousemoveEvent = new CustomEvent("mousemove", {
                bubbles: true,
                detail: mouseEventDetail,
              });

              if (globIsSpectrogramGotRColumn) {
                // Left TD graph
                draw2DGraph(
                  false,
                  tdata,
                  "timestamphover",
                  isTimeHorizontal,
                  currentRectEpoch
                );
                $(glob2DRectL.node())[0].dispatchEvent(mouseoverEvent);
                $(glob2DRectL.node())[0].dispatchEvent(mousemoveEvent);

                // Right TD graph
                draw2DGraph(
                  true,
                  tdata,
                  "timestamphover",
                  isTimeHorizontal,
                  currentRectEpoch
                );
                $(glob2DRectR.node())[0].dispatchEvent(mouseoverEvent);
                $(glob2DRectR.node())[0].dispatchEvent(mousemoveEvent);
              } else {
                draw2DGraph(
                  false,
                  tdata,
                  "timestamphover",
                  isTimeHorizontal,
                  currentRectEpoch
                );
                $(glob2DRectL.node())[0].dispatchEvent(mouseoverEvent);
                $(glob2DRectL.node())[0].dispatchEvent(mousemoveEvent);
              }
            }, 0); // default is 350
          }
          //}
        }

        d3.event.preventDefault();
      })
      .on("mouseout", function mouseout(d, i) {
        var graphsId;

        var mCoordinates = d3.mouse(this);

        if (
          mCoordinates[0] !== mouseoverLastCoords[0] ||
          mCoordinates[1] !== mouseoverLastCoords[1]
        ) {
          // console.log(mouseoverLastCoords, mCoordinates);

          if (isTooltips) {
            if (hoverTimer) {
              clearTimeout(hoverTimer);
              hoverTimer = false;
            }

            crosshairs.style("display", "none");

            for (var n = 1; n <= numOfGraphs; ++n) {
              if (isWin1 && n === curentGraphNum) {
                continue;
              }

              graphsId = "#SpectrogramWindow1Graph" + n;
              d3.select(graphsId + "Crosshairs").style("display", "none");
            }

            for (var n = 1; n <= numOfGraphsWin2; ++n) {
              if (!isWin1 && n === curentGraphNum) {
                continue;
              }

              graphsId = "#SpectrogramWindow2Graph" + n;
              d3.select(graphsId + "Crosshairs").style("display", "none");
            }

            spectrogramAxisTooltipElements[0].style("visibility", "hidden");
            spectrogramAxisTooltipElements[1].style("visibility", "hidden");

            spectrogramTooltipElements[0].style("visibility", "hidden");

            for (var n = 0; n < toolTipsRectEl.length; ++n) {
              spectrogramTooltipElements[n + 1].style("visibility", "hidden");
            }
          }
        }

        var mouseEventDetail = {
          source: "spectrogram",
          coordinates: mCoordinates,
        };

        var mouseoutEvent = new CustomEvent("mouseout", {
          bubbles: true,
          detail: mouseEventDetail,
        });

        if (globIsSpectrogramGotRColumn) {
          // Left TD graph
          $(glob2DRectL.node())[0].dispatchEvent(mouseoutEvent);

          // Right TD graph
          $(glob2DRectR.node())[0].dispatchEvent(mouseoutEvent);
        } else {
          $(glob2DRectL.node())[0].dispatchEvent(mouseoutEvent);
        }

        d3.event.preventDefault();
      })
      .on("keypress", function contextmenu(d, i) {
        // d.msec_epoch
        if (d3.event.detail === "DoFreeze") {
          if (isWin1TD) {
            currentRectEpoch = d.msec_epoch;

            if (globIs2DFrozen) {
              globIs2DFrozen = false;

              //draw2DGraph(tdata, 'timestamphover', isTimeHorizontal, currentRectEpoch);

              if (!globSpectrogramsUpdateTimer && isSpectrogramPre) {
                globSpectrogramsUpdateTimer = setTimeout(
                  tabSpectrogramsContentControlsGo,
                  SPECTROGRAMS_UPODATE_INTERVAL
                );
              }
            } else if (isTooltips) {
              if (globSpectrogramsUpdateTimer) {
                clearTimeout(globSpectrogramsUpdateTimer);

                globSpectrogramsUpdateTimer = null;
              }

              globIs2DFrozen = true;

              //draw2DGraph(tdata, 'timestamphover', isTimeHorizontal, currentRectEpoch, true);
            }

            d3.event.preventDefault();
          }
        }
      });
    /* .on('contextmenu', function contextmenu(d, i) {
      if (isWin1TD) {
        currentRectEpoch =
        d3.event.currentTarget.getAttribute('data-epoch');
      	
        if (globIs2DFrozen) {
          globIs2DFrozen = false;
        	
          draw2DGraph(tdata, 'timestamphover', isTimeHorizontal, currentRectEpoch);
        	
          if (!globSpectrogramsUpdateTimer && isSpectrogramPre) {
            globSpectrogramsUpdateTimer = setTimeout(tabSpectrogramsContentControlsGo,
                            SPECTROGRAMS_UPODATE_INTERVAL);
          }
        } else if (isTooltips) {
          if (globSpectrogramsUpdateTimer) {
            clearTimeout(globSpectrogramsUpdateTimer);
        	
            globSpectrogramsUpdateTimer = null;
          }
        	
          globIs2DFrozen = true;
        	
          draw2DGraph(tdata, 'timestamphover', isTimeHorizontal, currentRectEpoch, true);
        }
      	
        d3.event.preventDefault();
      }
    }); */

    // Y-Axis
    var yScaleDomain;

    if (isTimeHorizontal) {
      if (tdata.freqs.startFreq === -1 || tdata.freqs.endFreq === -1) {
        yScaleDomain = [0, 0];
      } else {
        yScaleDomain = [tdata.freqs.endFreq, tdata.freqs.startFreq];
      }
    } else {
      yScaleDomain = [tdata.endMsecEpoch, tdata.startMsecEpoch];
    }

    var yScale = d3
      .scaleLinear()
      .domain(yScaleDomain)
      .range([0, yAxisHeight])
      .clamp(true);

    var yAxis;
    if (isTimeHorizontal) {
      yAxis = d3.axisLeft().ticks(12).scale(yScale);

      if (tdata.freqs.startFreq !== -1 && tdata.freqs.endFreq !== -1) {
        yAxis.tickFormat(d3.format(",.2f"));
      }

      d3.select("#" + el.id + " svg")
        .append("g")
        .attr(
          "transform",
          "translate(" + graphMargin.left + "," + graphMargin.top + ")"
        )
        .call(yAxis);

      // MHz label
      d3.select("#" + el.id + " svg")
        .append("g")
        .attr(
          "transform",
          "translate(" + 0 + "," + (yAxisHeight / 2 - 10) + ")"
        )
        .append("text")
        .style("font-size", ".9em")
        .text("MHz");
    } else {
      if (!isRColumn) {
        var timeSeries = [];

        // var xStep = 3600000 * 2; // 3600000 = 1 hour
        var startEpoch = parseInt(tdata.startMsecEpoch);
        var endEpoch = parseInt(tdata.endMsecEpoch);
        var xStep = Math.ceil((startEpoch - endEpoch) / 8);

        for (var j = startEpoch; j >= endEpoch; j -= xStep) {
          timeSeries[timeSeries.length] = j;
        }

        yAxis = d3
          .axisLeft()
          .tickValues(timeSeries)
          // .tickFormat(d3.timeFormat("%Y-%m-%d %H:%M"))
          // .tickFormat(d3.timeFormat("%m-%d %H:%M"))
          .tickFormat(function (d) {
            return moment(d).tz(globServerTimezone).format("MM-DD HH:mm");
          })
          .scale(tScale);

        d3.select("#" + el.id + " svg")
          .append("g")
          .attr(
            "transform",
            "translate(" + graphMargin.left + "," + graphMargin.top + ")"
          )
          .call(yAxis)
          .selectAll("text")
          .style("text-anchor", "end");
      }
    }

    // X-Axis
    var xScaleDomain;

    if (isTimeHorizontal) {
      xScaleDomain = [tdata.endMsecEpoch, tdata.startMsecEpoch];
    } else {
      if (tdata.freqs.startFreq === -1 || tdata.freqs.endFreq === -1) {
        xScaleDomain = [0, 0];
      } else {
        xScaleDomain = [
          tdata.freqs.startFreq,
          tdata.freqs.endFreq + tdata.freqs.mhzPerBin * 0,
        ];
      }
    }

    var xScale = d3
      .scaleLinear()
      .domain(xScaleDomain)
      .range([0, graphWidth])
      .clamp(true);

    var xAxis;
    if (!isTimeHorizontal) {
      if (isDrawFreq) {
        xAxis = d3.axisBottom().ticks(6).scale(xScale);

        if (tdata.freqs.startFreq !== -1 && tdata.freqs.endFreq !== -1) {
          xAxis.tickFormat(d3.format(",.2f"));
        }

        d3.select("#" + el.id + " svg")
          .append("g")
          .attr(
            "transform",
            "translate(" +
            (isRColumn ? graphMargin.leftRColumn : graphMargin.left) +
            "," +
            (yAxisHeight + graphMargin.top - 0) +
            ")"
          )
          .call(xAxis);

        // MHz label
        d3.select("#" + el.id + " svg")
          .append("g")
          .attr(
            "transform",
            "translate(" +
            (graphWidth +
              (isRColumn
                ? graphMargin.leftRColumn - 10
                : graphMargin.left - 30) -
              6) +
            "," +
            (yAxisHeight + graphMargin.top + getFontHeight() + 3) +
            ")"
          )
          .append("text")
          .style("font-size", ".9em")
          .text("MHz");
      } else {
        xAxis = d3.axisBottom().ticks(0).scale(xScale);

        d3.select("#" + el.id + " svg")
          .append("g")
          .attr(
            "transform",
            "translate(" +
            (isRColumn ? graphMargin.leftRColumn : graphMargin.left) +
            "," +
            (yAxisHeight + graphMargin.top - 0) +
            ")"
          )
          .attr("class", "remove-tick-text")
          .call(xAxis);
      }
    } else {
      var timeSeries = [];

      // var xStep = 3600000 * 2; // 3600000 = 1 hour
      var startEpoch = parseInt(tdata.startMsecEpoch);
      var endEpoch = parseInt(tdata.endMsecEpoch);
      var xStep = Math.ceil((startEpoch - endEpoch) / 12);

      for (var k = startEpoch; k >= endEpoch; k -= xStep) {
        timeSeries[timeSeries.length] = k;
      }

      xAxis = d3
        .axisBottom()
        .tickValues(timeSeries)
        // .tickFormat(d3.timeFormat("%Y-%m-%d %H:%M"))
        // .tickFormat(d3.timeFormat("%m-%d %H:%M"))
        .tickFormat(function (d) {
          return moment(d).tz(globServerTimezone).format("MM-DD HH:mm");
        })
        .scale(tScale);

      d3.select("#" + el.id + " svg")
        .append("g")
        .attr(
          "transform",
          "translate(" +
          graphMargin.left +
          "," +
          (yAxisHeight + graphMargin.top - 0) +
          ")"
        )
        .call(xAxis)
        .selectAll("text")
        .style("text-anchor", "end")
        .attr("dx", "-.8em")
        .attr("dy", ".15em")
        .attr("transform", "rotate(-45)");
    }

    // ++ Optix mode
    if (isRootUser() || isUserRole("OptixMode")) {
      var reportThresholdMsec = 5 * 60 * 1000;

      var optixModeContainer = d3
        .select("#" + el.id + " svg")
        .append("g")
        .attr("class", "optixmode")
        // .attr('transform', 'translate(' + ((isRColumn ? graphMargin.leftRColumn :  graphMargin.left) + (!isTimeHorizontal ? graphWidth - globOptixModeRectHeight : 0)) + ',' + (graphMargin.top - (!isTimeHorizontal ? 0 : globOptixModeRectHeight)) + ')');
        .attr(
          "transform",
          "translate(" +
          (!isTimeHorizontal
            ? (isRColumn
              ? graphWidth + graphMargin.leftRColumn
              : actualGraphWidth) - globOptixModeRectHeight
            : 0) +
          "," +
          (graphMargin.top -
            (!isTimeHorizontal ? 0 : globOptixModeRectHeight)) +
          ")"
        );

      optixModeContainer
        .selectAll("g")
        .data(tdata.mode_data)
        .enter()
        .append("g")
        .attr("data-epoch", function drawOptixModeRect_attr1(d, i) {
          return d.start_sec_epoch;
        })
        .append("rect")
        .attr("x", function drawOptixModeRect_attr2(d, i) {
          if (!isTimeHorizontal) {
            return 0;
          } else {
            return tScale(d.start_sec_epoch).toFixed(2);
          }
        })
        .attr("y", function drawOptixModeRect_attr3(d, i) {
          if (!isTimeHorizontal) {
            return tScale(d.start_sec_epoch).toFixed(2);
          } else {
            return 0;
          }
        })
        .attr("width", function (d, i) {
          if (!isTimeHorizontal) {
            return globOptixModeRectHeight;
          } else {
            var rectWidth = 0;

            if (d.latest_update_sec_epoch) {
              if (i < tdata.mode_data.length - 1) {
                if (
                  tdata.mode_data[i + 1].start_sec_epoch -
                  d.latest_update_sec_epoch <=
                  reportThresholdMsec
                ) {
                  rectWidth =
                    tScale(tdata.mode_data[i + 1].start_sec_epoch).toFixed(2) -
                    tScale(d.start_sec_epoch).toFixed(2);
                } else {
                  rectWidth =
                    tScale(d.latest_update_sec_epoch).toFixed(2) -
                    tScale(d.start_sec_epoch).toFixed(2);
                }
              } else {
                rectWidth =
                  tScale(
                    d.latest_update_sec_epoch + reportThresholdMsec
                  ).toFixed(2) - tScale(d.start_sec_epoch).toFixed(2);
              }
            }

            return svgSpan(rectWidth);
          }
        })
        .attr("height", function drawOptixModeRect_attr4(d, i) {
          if (!isTimeHorizontal) {
            var rectHeight = 0;

            if (d.latest_update_sec_epoch) {
              if (i < tdata.mode_data.length - 1) {
                if (
                  tdata.mode_data[i + 1].start_sec_epoch -
                  d.latest_update_sec_epoch <=
                  reportThresholdMsec
                ) {
                  rectHeight =
                    tScale(tdata.mode_data[i + 1].start_sec_epoch).toFixed(2) -
                    tScale(d.start_sec_epoch).toFixed(2);
                } else {
                  rectHeight =
                    tScale(d.latest_update_sec_epoch).toFixed(2) -
                    tScale(d.start_sec_epoch).toFixed(2);
                }
              } else {
                rectHeight =
                  tScale(
                    d.latest_update_sec_epoch + reportThresholdMsec
                  ).toFixed(2) - tScale(d.start_sec_epoch).toFixed(2);
              }
            }

            return svgSpan(rectHeight);
          } else {
            return globOptixModeRectHeight;
          }
        })
        .attr("stroke-width", 0)
        .attr("class", function drawOptixModeRect_class1(d, i) {
          return optixModeClass(d.mode_number);
        })
        .append("title")
        .text(function (d, i) {
          return globOptixModeGraphs["mode" + d.mode_number].title;
        });
    }
    // == Optix mode

    // Title
    if (isTimeHorizontal) {
      var elBoundingRect = $("#" + el.id)[0].getBoundingClientRect();

      graphTitleElements[graphType].text(tdGraphColor[graphType].text);
      graphTitleElements[graphType].style(
        "top",
        elBoundingRect.top - 25 + "px"
      );
      graphTitleElements[graphType].style(
        "left",
        elBoundingRect.left + 10 + elBoundingRect.width / 2 + "px"
      );
      graphTitleElements[graphType].style("visibility", "visible");
    } else {
      d3.select("#" + el.id + " svg")
        .append("text")
        .attr("class", "spectrogram-graph-label")
        // .attr('x', spectrogramWindow1GraphWidth -
        // (globGraphRectInlineSpace * 2))
        // .attr('y', yAxisHeight / 2)
        // .attr("transform", "translate(" + (actualGraphWidth - (globGraphRectInlineSpace * (globIs4AntDevice ? 0.5 : 2))) + "," + (yAxisHeight / 2) + ") rotate(90)")
        .attr(
          "transform",
          "translate(" +
          ((isRColumn
            ? graphWidth + graphMargin.leftRColumn
            : actualGraphWidth) -
            20) +
          "," +
          yAxisHeight / 2 +
          ") rotate(90)"
        ) // zzzz
        .text(tdGraphColor[graphType].text);
    }

    // ++ Crosshairs
    var crosshairs = d3
      .select("#" + el.id + " svg")
      .append("g")
      .property("id", el.id + "Crosshairs")
      .style("display", "none")
      .attr(
        "transform",
        "translate(" +
        (isRColumn ? graphMargin.leftRColumn : graphMargin.left) +
        "," +
        graphMargin.top +
        ")"
      );

    // X line
    crosshairs
      .append("line")
      .attr("class", "x")
      .style("stroke", "black")
      .style("stroke-width", "2px")
      .style("stroke-dasharray", "3,2")
      .style("opacity", 0.9)
      .attr("y1", 0)
      .attr("y2", 0);

    // Y line
    crosshairs
      .append("line")
      .attr("class", "y")
      .style("stroke", "black")
      .style("stroke-width", "2px")
      .style("stroke-dasharray", "3,2")
      .style("opacity", 0.9)
      .attr("x1", 0)
      .attr("x2", 0);
    // == Crosshairs

    // Rect for Time AVG
    var graphGCoordinates = d3
      .select("#" + el.id + " svg g")
      .node()
      .getBoundingClientRect();

    var timeRect = d3
      .select("#" + el.id + " svg")
      .append("g")
      .attr("class", "timerect-container")
      .style("visibility", "hidden")
      .attr(
        "transform",
        "translate(" +
        (isRColumn ? graphMargin.leftRColumn : graphMargin.left) +
        "," +
        graphMargin.top +
        ")"
      );

    timeRect
      .append("rect")
      .attr("class", "timerect")
      .attr("width", svgSpan(isTimeHorizontal ? 0 : graphGCoordinates.width))
      .attr("height", svgSpan(isTimeHorizontal ? graphGCoordinates.height : 0))
      .attr("stroke", "gray")
      .attr("stroke-width", 1)
      // .attr('stroke-dasharray', '10, 5, 4, 5')
      .attr("stroke-dasharray", "3,2")
      .attr("fill", "rgba(200,200,200, 0.3)");
  }

  function getFontHeight() {
    return Number(
      window
        .getComputedStyle(document.body)
        .getPropertyValue("font-size")
        .match(/\d+/)[0]
    );
  }

  function draw2DGraph(
    isRColumn,
    tdata,
    graphType,
    isTimeHorizontal,
    hoverTimestamp,
    isPaused,
    avgInfo,
    isZooming
  ) {
    // var marginTop = isTimeHorizontal ? graphMargin.topWide :
    graphMargin.top = graphMargin.spectrogramsTop;

    var i, j, k;
    var numOfBins = tdata.numOfBins;
    var yAxisHeight =
      spectrogramWindow1GraphHeight - graphMargin.bottom - graphMargin.top;
    var minDBM = 255;
    var maxDBM = -255;
    var data = [];
    var posData = {};
    var posDataFdeq = {};
    var numOfAvgEntries = {};
    var lWidth;
    var lHeight;
    var epochIndex = -1;
    var fdeqEpochIndex = -1;
    var fdeqGraphTypesArr = [];
    var firstGraphTypeContainingData = -1;

    var actualGraphWidth;

    actualGraphWidth = spectrogramWindow1GraphWidth;

    if (globIsSpectrogramGotRColumn) {
      actualGraphWidth += globTwoColumnsWidthAdjustment - 0; // -x allows to add spacing between the 2 columns if needed.
    }

    var $graphEl;
    var graphTypesArr;
    if (isRColumn) {
      $graphEl = $SpectrogramWindow1TDGraph2;
      graphTypesArr = globSpectrogramGraphTypesArrR;
    } else {
      $graphEl = $SpectrogramWindow1TDGraph;
      graphTypesArr = globSpectrogramGraphTypesArrL;
    }

    if (IS_DEBUG) {
      console.log("draw2DGraph:: yAxisHeight = ", yAxisHeight);
    }

    $graphEl.html("");

    var freqDomain;
    if (tdata.freqs.startFreq === -1 || tdata.freqs.endFreq === -1) {
      freqDomain = [0, 0];
    } else {
      if (isTimeHorizontal) {
        freqDomain = [tdata.freqs.endFreq, tdata.freqs.startFreq];
      } else {
        freqDomain = [
          tdata.freqs.startFreq,
          tdata.freqs.endFreq + tdata.freqs.mhzPerBin,
        ];
      }
    }

    // ++ Prepare Data
    if (graphType === "timestamphover") {
      for (j = 0; j < tdata.data.length; ++j) {
        if (tdata.data[j].msec_epoch == hoverTimestamp) {
          epochIndex = j;

          break;
        }
      }
    }

    for (i = 0; i < graphTypesArr.length; ++i) {
      if (graphType === "avg") {
        data[graphTypesArr[i]] = _.range(numOfBins).map(function () {
          return 0;
        });

        numOfAvgEntries[graphTypesArr[i]] = 0;
      } else if (graphType === "lastsample") {
        if (tdata.data.length) {
          data[graphTypesArr[i]] =
            tdata.data[tdata.data.length - 1][graphTypesArr[i]];
        } else {
          data[graphTypesArr[i]] = [];
        }
      } else if (graphType === "timestamphover") {
        if (epochIndex !== -1) {
          data[graphTypesArr[i]] = tdata.data[epochIndex][graphTypesArr[i]];
        } else {
          /* No sample matches the hovered timestamp — the scan above leaves
             epochIndex at -1. Leaving the key unset made it undefined, and the
             "does this graph type have rows" loop below reads .length off it
             without checking, so the whole draw threw. The empty array is what
             the lastsample branch already uses for the same situation. */
          data[graphTypesArr[i]] = [];
        }
      }
    }

    function getSpectrogramGraphType(prop) {
      var spectrogramGraphType = "";

      if (prop == "fdeq_a") {
        spectrogramGraphType = "a_out";
      } else if (prop == "fdeq_b") {
        spectrogramGraphType = "b_out";
      } else if (prop == "fdeq_c") {
        spectrogramGraphType = "c_out";
      } else if (prop == "fdeq_d") {
        spectrogramGraphType = "d_out";
      } else if (prop == "fdeq_avg") {
        spectrogramGraphType = "avg_out";
      }

      return spectrogramGraphType;
    }

    function getTimeStampFDEQ(graphDataTimestamp) {
      var currMsecDiff = 60000;

      fdeqEpochIndex = -1;
      for (j = 0; j < tdata.fdeq.length; ++j) {
        var msecDiff = Math.abs(graphDataTimestamp - tdata.fdeq[j].msec_epoch);

        if (msecDiff <= currMsecDiff) {
          currMsecDiff = msecDiff;
          fdeqEpochIndex = j;
        }
      }

      var tmpData = {};

      if (fdeqEpochIndex != -1) {
        for (var prop in tdata.fdeq[0]) {
          if (tdata.fdeq[0].hasOwnProperty.call(tdata.fdeq[0], prop)) {
            if (
              prop != "msec_epoch" &&
              prop != "fdeq_a_cnt" &&
              prop != "fdeq_b_cnt" &&
              prop != "lastRawMsec"
            ) {
              if (tdata.fdeq[fdeqEpochIndex][prop] != "") {
                var spectrogramGraphType = getSpectrogramGraphType(prop);

                if (graphTypesArr.indexOf(spectrogramGraphType) != -1) {
                  tmpData[prop] = tdata.fdeq[fdeqEpochIndex][prop].slice(0);

                  for (
                    var binNumber = 0;
                    binNumber < tdata.fdeq[fdeqEpochIndex][prop].length;
                    ++binNumber
                  ) {
                    tmpData[prop][binNumber] =
                      tmpData[prop][binNumber] +
                      tdata.data[epochIndex][spectrogramGraphType][binNumber];
                  }
                }
              }
            }
          }
        }
      } else {
        console.log("NO fdeqEpochIndex for timestamp", graphDataTimestamp);
      }

      return tmpData;
    }

    if (graphType === "timestamphover") {
      // FDEQ
      if (isSpectrogramsCancEnabled) {
        var timestampFdeqData = getTimeStampFDEQ(hoverTimestamp);

        for (var prop in timestampFdeqData) {
          if (timestampFdeqData.hasOwnProperty.call(timestampFdeqData, prop)) {
            fdeqGraphTypesArr.push(prop);

            data[prop] = timestampFdeqData[prop];

            if (spectrogramsCancTypeName == "pure") {
              var spectrogramGraphType = getSpectrogramGraphType(prop);
              data[spectrogramGraphType] = [];
            }
          }
        }
      }
    }
    // if (graphType === 'timestamphover') { // FDEQ
    // 	if (isSpectrogramsCancEnabled) {
    // 		var currMsecDiff = 60000;

    // 		fdeqEpochIndex = -1;
    // 		for (j = 0; j < tdata.fdeq.length; ++j) {
    // 			var msecDiff = Math.abs(hoverTimestamp - tdata.fdeq[j].msec_epoch);

    // 			if (msecDiff <= currMsecDiff) {
    // 				currMsecDiff  = msecDiff;
    // 				fdeqEpochIndex = j;
    // 			}
    // 		}

    // 		if (fdeqEpochIndex != -1) {
    // 			for (var prop in tdata.fdeq[0]) {
    // 			    if (tdata.fdeq[0].hasOwnProperty.call(tdata.fdeq[0], prop)) {
    // 			    	if (prop != "msec_epoch") {
    // 			    		if (tdata.fdeq[fdeqEpochIndex][prop] != "") {
    // 			    			var spectrogramGraphType = "";

    // 				    		if (prop == "fdeq_a") {
    // 				    			spectrogramGraphType = "a_out"
    // 				    		} else if (prop == "fdeq_b") {
    // 				    			spectrogramGraphType = "b_out"
    // 				    		} else if (prop == "fdeq_c") {
    // 				    			spectrogramGraphType = "c_out"
    // 				    		} else if (prop == "fdeq_d") {
    // 				    			spectrogramGraphType = "d_out"
    // 				    		} else if (prop == "fdeq_avg") {
    // 				    			spectrogramGraphType = "avg_out"
    // 				    		}

    // 				    		if (graphTypesArr.indexOf(spectrogramGraphType) != -1) {
    // 				    			fdeqGraphTypesArr.push(prop);

    // 				    			data[prop] = tdata.fdeq[fdeqEpochIndex][prop].slice(0);

    // 					    		for (var binNumber = 0; binNumber < tdata.fdeq[fdeqEpochIndex][prop].length; ++binNumber) {
    // 					    			data[prop][binNumber] = data[prop][binNumber] + tdata.data[epochIndex][spectrogramGraphType][binNumber];
    // 					    		}

    // 					    		if (spectrogramsCancTypeName == "pure") {
    // 					    			data[spectrogramGraphType] = [];
    // 					    		}
    // 				    		}
    // 			    		}
    // 			    	}
    // 			    }
    // 			}
    // 		} else {
    // 			console.log("NO fdeqEpochIndex for timestamp", hoverTimestamp);
    // 		}
    // 	}
    // }

    if (graphType === "lastsample") {
      if (tdata.data.length) {
        data["lastSampleTime"] = tdata.data[tdata.data.length - 1].msec_epoch;
      }
    } else if (graphType === "timestamphover") {
      data["timestamp"] = hoverTimestamp;
      data["timestampIndex"] = epochIndex;

      if (isSpectrogramsCancEnabled) {
        data["fdeqTimestampIndex"] = fdeqEpochIndex;
      }
    } else if (graphType === "avg") {
      // ++ AVG graphs' data
      for (i = avgInfo.startIndex; i <= avgInfo.lastIndex; ++i) {
        for (k = 0; k < graphTypesArr.length; ++k) {
          if (tdata.data[i][graphTypesArr[k]].length) {
            ++numOfAvgEntries[graphTypesArr[k]];
          }
        }

        for (j = 0; j < numOfBins; ++j) {
          for (k = 0; k < graphTypesArr.length; ++k) {
            var tmpAvgVal = parseFloat(tdata.data[i][graphTypesArr[k]][j]);

            if (!isNaN(tmpAvgVal)) {
              data[graphTypesArr[k]][j] += tmpAvgVal;
            } else {
              data[graphTypesArr[k]][j] += 0;
            }
          }
        }
      }

      for (j = 0; j < numOfBins; ++j) {
        for (k = 0; k < graphTypesArr.length; ++k) {
          // data[graphTypesArr[k]][j] =
          // parseFloat((data[graphTypesArr[k]][j] /
          // (avgInfo.lastIndex - avgInfo.startIndex +
          // 1)).toFixed(1));
          data[graphTypesArr[k]][j] = parseFloat(
            (
              data[graphTypesArr[k]][j] / numOfAvgEntries[graphTypesArr[k]]
            ).toFixed(1)
          );
        }
      }
      // == AVG graphs' data

      // ++ AVG FDEQa
      if (isSpectrogramsCancEnabled) {
        var numOfFdeqAvgEntries = {};

        for (i = avgInfo.startIndex; i <= avgInfo.lastIndex; ++i) {
          var indexTimestamp = tdata.data[i].msec_epoch;
          epochIndex = i;
          var fdeqTimeStampFdeqDataAtIndex = getTimeStampFDEQ(indexTimestamp);
          const isGotFdeqDataAtIndex =
            Object.keys(fdeqTimeStampFdeqDataAtIndex).length !== 0;

          if (isGotFdeqDataAtIndex) {
            for (var prop in fdeqTimeStampFdeqDataAtIndex) {
              if (fdeqTimeStampFdeqDataAtIndex.hasOwnProperty(prop)) {
                if (data.hasOwnProperty(prop)) {
                  for (
                    var binNumber = 0;
                    binNumber < tdata.fdeq[fdeqEpochIndex][prop].length;
                    ++binNumber
                  ) {
                    data[prop][binNumber] =
                      data[prop][binNumber] +
                      fdeqTimeStampFdeqDataAtIndex[prop][binNumber];
                  }

                  ++numOfFdeqAvgEntries[prop];
                } else {
                  fdeqGraphTypesArr.push(prop);

                  data[prop] = _.range(numOfBins).map(function () {
                    return 0;
                  });

                  numOfFdeqAvgEntries[prop] = 0;
                }
              }
            }
          }
        }

        for (j = 0; j < numOfBins; ++j) {
          for (k = 0; k < fdeqGraphTypesArr.length; ++k) {
            data[fdeqGraphTypesArr[k]][j] = parseFloat(
              (
                data[fdeqGraphTypesArr[k]][j] /
                numOfFdeqAvgEntries[fdeqGraphTypesArr[k]]
              ).toFixed(1)
            );
          }
        }
      }
      // == AVG FDEQa
    }

    for (i = 0; i < graphTypesArr.length; ++i) {
      if (data[graphTypesArr[i]].length) {
        firstGraphTypeContainingData = i;
        break;
      }
    }
    // == Prepare Data

    if (IS_DEBUG) {
      console.log("graphTypesArr = ", graphTypesArr, ", data = ", data);
    }

    // ++ minDBM, maxDBM
    // for (i = 0; i < graphTypesArr.length; ++i) {
    // var tmpExtent = d3.extent(data[graphTypesArr[i]]);
    // minDBM = d3.min([ minDBM ].concat(tmpExtent[0]));
    // maxDBM = d3.max([ maxDBM ].concat(tmpExtent[1]));
    // }
    //
    // minDBM = Math.floor(minDBM - 1);
    // maxDBM = Math.ceil(maxDBM + 1);
    //
    // if (Math.abs(maxDBM - minDBM) < 10) {
    // maxDBM = minDBM + 10;
    // }

    minDBM = globDbmAxisInfo.minDBM;
    maxDBM = globDbmAxisInfo.maxDBM;

    if (globalIsSpectrogramsPowerFilter) {
      if (!isNaN(globalSpectrogramsPowerFilterMinVal)) {
        minDBM = globalSpectrogramsPowerFilterMinVal;
      }

      if (!isNaN(globalSpectrogramsPowerFilterMaxVal)) {
        maxDBM = globalSpectrogramsPowerFilterMaxVal;
      }
    }
    // == minDBM, maxDBM

    if (isTimeHorizontal) {
      // lWidth = Math.floor((actualGraphWidth - graphMargin.left) /
      // Math.abs(Math.ceil((maxDBM - minDBM))));
      // lHeight = Math.floor(yAxisHeight / numOfBins);

      lWidth =
        actualGraphWidth -
        graphMargin.left / Math.abs(Math.ceil(maxDBM - minDBM));
      lHeight = yAxisHeight / numOfBins;
    } else {
      // lWidth = Math.round((actualGraphWidth - graphMargin.left) / numOfBins);
      // lHeight = Math.round(yAxisHeight / Math.abs(Math.ceil((maxDBM - minDBM))));
      lWidth = (actualGraphWidth - graphMargin.left) / numOfBins;
      lHeight = yAxisHeight / Math.abs(Math.ceil(maxDBM - minDBM));

      // lWidth = (actualGraphWidth - graphMargin.left) / numOfBins;
      // lHeight = yAxisHeight / Math.abs(Math.ceil((maxDBM - minDBM)));
    }

    if (IS_DEBUG) {
      console.log("draw2DGraph:: minDBM = ", minDBM, ", maxDBM = ", maxDBM);
      console.log("draw2DGraph:: lWidth = ", lWidth, ", lHeight = ", lHeight);
    }

    var binsLheight = numOfBins * lHeight;

    var dbmScale;
    if (isTimeHorizontal) {
      dbmScale = d3
        .scaleLinear()
        .domain([minDBM, maxDBM])
        .range([0, actualGraphWidth - graphMargin.left]);
    } else {
      dbmScale = d3
        .scaleLinear()
        .domain([minDBM, maxDBM])
        .range([yAxisHeight, graphMargin.top]);
    }

    var freqScale;
    if (!isTimeHorizontal) {
      freqScale = d3
        .scaleLinear()
        .domain(freqDomain)
        .range([0, numOfBins * lWidth]);
    } else {
      freqScale = d3.scaleLinear().domain(freqDomain).range([0, binsLheight]);
    }

    for (i = 0; i < graphTypesArr.length; ++i) {
      posData[graphTypesArr[i]] = [];

      for (j = 0; j < data[graphTypesArr[i]].length; ++j) {
        posData[graphTypesArr[i]].push({
          x: isTimeHorizontal
            ? dbmScale(
              data[graphTypesArr[i]][data[graphTypesArr[i]].length - j - 1]
            ).toFixed(1)
            : j * lWidth,
          y: isTimeHorizontal
            ? binsLheight - (data[graphTypesArr[i]].length - j - 1) * lHeight
            : dbmScale(data[graphTypesArr[i]][j]).toFixed(1),
        });
      }
    }

    for (i = 0; i < fdeqGraphTypesArr.length; ++i) {
      posData[fdeqGraphTypesArr[i]] = [];

      for (j = 0; j < data[fdeqGraphTypesArr[i]].length; ++j) {
        posData[fdeqGraphTypesArr[i]].push({
          x: isTimeHorizontal
            ? dbmScale(
              data[fdeqGraphTypesArr[i]][
              data[fdeqGraphTypesArr[i]].length - j - 1
              ]
            ).toFixed(1)
            : j * lWidth,
          y: isTimeHorizontal
            ? binsLheight -
            (data[fdeqGraphTypesArr[i]].length - j - 1) * lHeight
            : dbmScale(data[fdeqGraphTypesArr[i]][j]).toFixed(1),
        });
      }
    }

    // console.log('posData = ', posData);
    function calcFilteredVal(d) {
      var actualVal = d;

      if (globalIsSpectrogramsPowerFilter) {
        if (!isNaN(globalSpectrogramsPowerFilterMinVal)) {
          if (d < globalSpectrogramsPowerFilterMinVal) {
            actualVal = globalSpectrogramsPowerFilterMinVal;
          }
        }

        if (!isNaN(globalSpectrogramsPowerFilterMaxVal)) {
          if (d > globalSpectrogramsPowerFilterMaxVal) {
            actualVal = globalSpectrogramsPowerFilterMaxVal;
          }
        }
      }

      return actualVal;
    }

    var lineFunc = d3
      .line()
      // .curve(d3.curveBasis)
      .x(function (d, i) {
        if (isTimeHorizontal) {
          var actualVal = calcFilteredVal(d);

          return dbmScale(actualVal).toFixed(1);
        } else {
          return i * lWidth;
        }
      })
      .y(function (d, i) {
        if (isTimeHorizontal) {
          return binsLheight - i * lHeight;
        } else {
          var actualVal = calcFilteredVal(d);

          return dbmScale(actualVal).toFixed(1);
        }
      });

    //var containingG = d3.select(('#' + $SpectrogramWindow1TDGraph[0].id))
    var containingG = d3
      .select("#" + $graphEl[0].id)
      .append("svg")
      .attr("width", "100%")
      .attr("height", "100%");

    // Title and X-Axis label
    if (
      !globIsSpectrogramGotRColumn ||
      (globIsSpectrogramGotRColumn && !isRColumn)
    ) {
      if (isTimeHorizontal) {
        var elBoundingRect = $("#" + $graphEl[0].id)[0].getBoundingClientRect();

        graphTitleElements["two_d"].text(globGraph2DTitle);
        graphTitleElements["two_d"].style(
          "top",
          elBoundingRect.top - 25 + "px"
        );
        graphTitleElements["two_d"].style(
          "left",
          elBoundingRect.left + 10 + elBoundingRect.width / 2 + "px"
        );
        graphTitleElements["two_d"].style("visibility", "visible");
      } else {
        d3.select("#" + $graphEl[0].id + " svg")
          .append("text")
          //.attr('x', actualGraphWidth - (globGraphRectInlineSpace * (globIs4AntDevice ? 0.5 : 2)))
          //.attr('y', yAxisHeight / 2)
          .attr(
            "transform",
            "translate(" +
            (actualGraphWidth -
              globGraphRectInlineSpace * (globIs4AntDevice ? 0.5 : 2)) +
            "," +
            yAxisHeight / 2 +
            ") rotate(90)"
          )
          .text(globGraph2DTitle);
      }
    }

    if (
      !globIsSpectrogramGotRColumn ||
      (globIsSpectrogramGotRColumn && isRColumn)
    ) {
      // MHz label
      d3.select("#" + $graphEl[0].id + " svg")
        .append("text")
        .attr(
          "transform",
          "translate(" +
          (lWidth * numOfBins +
            (isRColumn
              ? graphMargin.leftRColumn - 10
              : graphMargin.left - 20) -
            6) +
          "," +
          (yAxisHeight + graphMargin.top + getFontHeight() + 3) +
          ")"
        )
        .style("font-size", ".9em")
        .text("MHz");
    }

    var rect;
    if (isTimeHorizontal) {
      rect = containingG
        .append("rect")
        .attr(
          "transform",
          "translate(" + graphMargin.left + "," + graphMargin.top + ")"
        )
        .attr("width", svgSpan(actualGraphWidth - graphMargin.left))
        .attr("height", svgSpan(binsLheight))
        .style("fill", "black");
    } else {
      rect = containingG
        .append("rect")
        .attr(
          "transform",
          "translate(" +
          (isRColumn ? graphMargin.leftRColumn : graphMargin.left) +
          "," +
          graphMargin.top * 2 +
          ")"
        )
        .attr("width", svgSpan(lWidth * numOfBins))
        .attr("height", svgSpan(yAxisHeight - graphMargin.top))
        .style("fill", "black");
    }

    if (isRColumn) {
      glob2DRectR = rect;
    } else {
      glob2DRectL = rect;
    }

    var rectCoordinates;
    setTimeout(function set2DRectCoordinates() {
      rectCoordinates = rect.node().getBoundingClientRect();
      // console.log(rectCoordinates);
    }, 500);

    rect
      .style("pointer-events", "all")
      .on("mouseover", function () {
        if (tdata.data.length) {
          focus.style("display", null);

          if (isRColumn) {
            spectrogramTDAxisTooltipElements[1].style("visibility", "visible");
          } else {
            spectrogramTDAxisTooltipElements[0].style("visibility", "visible");
          }

          if (
            !(
              d3.event.detail instanceof Object &&
              !Array.isArray(d3.event.detail)
            )
          ) {
            globCurrentGraphObject = this;
          }
        }
      })
      .on("mouseout", function () {
        if (tdata.data.length) {
          var isEventFrom2DColumn = false;
          if (
            d3.event.detail instanceof Object &&
            !Array.isArray(d3.event.detail)
          ) {
            if (d3.event.detail.source === "2D") {
              isEventFrom2DColumn = true;
            }
          }

          focus.style("display", "none");

          if (isRColumn) {
            spectrogramTDAxisTooltipElements[1].style("visibility", "hidden");
          } else {
            spectrogramTDAxisTooltipElements[0].style("visibility", "hidden");
          }

          if (
            !(
              d3.event.detail instanceof Object &&
              !Array.isArray(d3.event.detail)
            )
          ) {
            globCurrentGraphObject = null;
          }

          if (!isEventFrom2DColumn && globIsSpectrogramGotRColumn) {
            var mouseEventDetail = {
              source: "2D",
            };

            var mouseoutEvent = new CustomEvent("mouseout", {
              bubbles: true,
              detail: mouseEventDetail,
            });

            if (isRColumn) {
              $(glob2DRectL.node())[0].dispatchEvent(mouseoutEvent);
            } else {
              if (glob2DRectR) {
                $(glob2DRectR.node())[0].dispatchEvent(mouseoutEvent);
              }
            }
          }
        }
      })
      .on("mousemove", function mousemove() {
        if (tdata.data.length) {
          var mCoordinates;
          var isKeyboardEvent;
          var isEventFrom2DColumn = false;

          if (
            d3.event.detail instanceof Object &&
            !Array.isArray(d3.event.detail)
          ) {
            // console.log('object');
            mCoordinates = d3.event.detail.coordinates;

            isKeyboardEvent = false;

            if (d3.event.detail.source === "2D") {
              isEventFrom2DColumn = true;
            }
          } else {
            // console.log('NO object');
            mCoordinates = d3.mouse(this);

            isKeyboardEvent = Array.isArray(d3.event.detail);
          }

          // console.log(d3.event.detail, isKeyboardEvent);

          if (!isKeyboardEvent) {
            /* firstGraphTypeContainingData stays -1 when no graph type has any
               rows. graphTypesArr[-1] is undefined, posData[undefined] is
               undefined, and d3's bisector reads .length off its array — so
               every mousemove over such a graph threw "Cannot read properties
               of undefined (reading 'length')", once per event.

               The enclosing "if (tdata.data.length)" does not prevent it: that
               only says the response carried rows, while each individual graph
               type can still be empty. A long period over a quiet device is
               enough — a 3 month view of an idle sector reproduces it.

               There is no point to snap the crosshair to, so leave it alone. */
            if (
              firstGraphTypeContainingData < 0 ||
              !posData[graphTypesArr[firstGraphTypeContainingData]] ||
              !posData[graphTypesArr[firstGraphTypeContainingData]].length
            ) {
              return;
            }

            var bisectorLeft = d3.bisector(function (d) {
              return isTimeHorizontal ? d.y : d.x;
            }).left;

            var bisectorRight = d3.bisector(function (d) {
              return isTimeHorizontal ? d.y : d.x;
            }).right;

            var lBisect = bisectorLeft(
              posData[graphTypesArr[firstGraphTypeContainingData]],
              isTimeHorizontal ? mCoordinates[1] : mCoordinates[0]
            );
            var rBisect = bisectorRight(
              posData[graphTypesArr[firstGraphTypeContainingData]],
              isTimeHorizontal ? mCoordinates[1] : mCoordinates[0]
            );

            var finalPosIndex;

            if (lBisect !== rBisect) {
              finalPosIndex = lBisect;
            } else {
              if (
                lBisect > 0 &&
                lBisect <
                posData[graphTypesArr[firstGraphTypeContainingData]].length
              ) {
                if (isTimeHorizontal) {
                  var y1 =
                    posData[graphTypesArr[firstGraphTypeContainingData]][
                      lBisect - 1
                    ].y;
                  var y2 =
                    posData[graphTypesArr[firstGraphTypeContainingData]][
                      lBisect
                    ].y;

                  if (
                    Math.abs(mCoordinates[1] - y1) <
                    Math.abs(mCoordinates[1] - y2)
                  ) {
                    finalPosIndex = lBisect - 1;
                  } else {
                    finalPosIndex = lBisect;
                  }
                } else {
                  var x1 =
                    posData[graphTypesArr[firstGraphTypeContainingData]][
                      lBisect - 1
                    ].x;
                  var x2 =
                    posData[graphTypesArr[firstGraphTypeContainingData]][
                      lBisect
                    ].x;

                  if (
                    Math.abs(mCoordinates[0] - x1) <
                    Math.abs(mCoordinates[0] - x2)
                  ) {
                    finalPosIndex = lBisect - 1;
                  } else {
                    finalPosIndex = lBisect;
                  }
                }
              } else {
                finalPosIndex =
                  posData[graphTypesArr[firstGraphTypeContainingData]].length -
                  1;
              }
            }

            globCurrentGraphObjectFinalPosIndex = finalPosIndex;
          } else {
            var changeValueIndex;

            if (!isTimeHorizontal) {
              changeValueIndex = 0;
            } else {
              changeValueIndex = 1;
            }

            if (
              globCurrentGraphObjectFinalPosIndex > 0 &&
              globCurrentGraphObjectFinalPosIndex <
              data[graphTypesArr[0]].length - 1
            ) {
              globCurrentGraphObjectFinalPosIndex +=
                d3.event.detail[changeValueIndex];
            } else {
              if (
                globCurrentGraphObjectFinalPosIndex === 0 &&
                d3.event.detail[changeValueIndex] === 1
              ) {
                globCurrentGraphObjectFinalPosIndex += 1;
              } else if (
                globCurrentGraphObjectFinalPosIndex ===
                data[graphTypesArr[0]].length - 1 &&
                d3.event.detail[changeValueIndex] === -1
              ) {
                globCurrentGraphObjectFinalPosIndex += -1;
              }
            }

            finalPosIndex = globCurrentGraphObjectFinalPosIndex;

            if (changeValueIndex === 0) {
              mCoordinates[0] = posData[graphTypesArr[0]][finalPosIndex].x;
            } else {
              mCoordinates[1] = posData[graphTypesArr[0]][finalPosIndex].y;
            }
          }

          // var freqVal = freqScale.invert(isTimeHorizontal ? mCoordinates[1] : mCoordinates[0]);
          var freqVal =
            tdata.freqs.startFreq +
            globCurrentGraphObjectFinalPosIndex * tdata.freqs.mhzPerBin;

          // console.log('***************************************************');
          // console.log('mouseX = ', mCoordinates[0], ', freqVal = ',
          // freqVal, ', xPosDataIndexL = ', lBisect, 'xPosDataIndexR
          // = ', rBisect);
          // console.log('finalPos = ', finalPosIndex, ', dbm = ',
          // dbmScale.invert(posData[graphTypesArr[0]][finalPos].y));

          if (isTimeHorizontal) {
            var x2ForX =
              posData[graphTypesArr[firstGraphTypeContainingData]][
                finalPosIndex
              ].x;

            for (
              i = firstGraphTypeContainingData + 1;
              i < graphTypesArr.length;
              ++i
            ) {
              if (posData[graphTypesArr[i]].length) {
                if (posData[graphTypesArr[i]][finalPosIndex].x > x2ForX) {
                  x2ForX = posData[graphTypesArr[i]][finalPosIndex].x;
                }
              }
            }

            focus
              .select(".x")
              .attr(
                "transform",
                "translate(" +
                x2ForX +
                "," +
                posData[graphTypesArr[0]][finalPosIndex].y +
                ")"
              )
              .attr("x2", -x2ForX);
          } else {
            var y2ForX =
              posData[graphTypesArr[firstGraphTypeContainingData]][
                finalPosIndex
              ].y;

            for (
              i = firstGraphTypeContainingData + 1;
              i < graphTypesArr.length;
              ++i
            ) {
              if (posData[graphTypesArr[i]].length) {
                if (posData[graphTypesArr[i]][finalPosIndex].y < y2ForX) {
                  y2ForX = posData[graphTypesArr[i]][finalPosIndex].y;
                }
              }
            }

            focus
              .select(".x")
              .attr(
                "transform",
                "translate(" +
                posData[graphTypesArr[firstGraphTypeContainingData]][
                  finalPosIndex
                ].x +
                "," +
                y2ForX +
                ")"
              )
              .attr("y2", yAxisHeight);
          }

          var currentSpectrogramTDAxisTooltipElement;
          if (isRColumn) {
            currentSpectrogramTDAxisTooltipElement =
              spectrogramTDAxisTooltipElements[1];
          } else {
            currentSpectrogramTDAxisTooltipElement =
              spectrogramTDAxisTooltipElements[0];
          }

          currentSpectrogramTDAxisTooltipElement.text(
            freqVal.toFixed(2) + " MHz"
          );

          if (isTimeHorizontal) {
            var spectrogram2DAxisTooltipElement0 =
              currentSpectrogramTDAxisTooltipElement
                .node()
                .getBoundingClientRect();

            currentSpectrogramTDAxisTooltipElement
              .style(
                "top",
                rectCoordinates.top +
                posData[graphTypesArr[firstGraphTypeContainingData]][
                  finalPosIndex
                ].y +
                "px"
              )
              .style(
                "left",
                rectCoordinates.left -
                spectrogram2DAxisTooltipElement0.width +
                "px"
              );
          } else {
            var innerRectCoordinates = rect.node().getBoundingClientRect();
            currentSpectrogramTDAxisTooltipElement
              .style(
                "top",
                innerRectCoordinates.top + yAxisHeight - graphMargin.top + "px"
              )
              .style(
                "left",
                innerRectCoordinates.left +
                posData[graphTypesArr[firstGraphTypeContainingData]][
                  finalPosIndex
                ].x +
                "px"
              );
          }

          var textPosX = isTimeHorizontal
            ? actualGraphWidth - graphMargin.left - 160
            : numOfBins * lWidth - 160;
          for (i = 0; i < legendData.length; ++i) {
            if (posData[legendData[i]["key"]].length) {
              if (isTimeHorizontal) {
                // focus.select(".y" + (i + 1))
                // .attr("transform",
                // "translate(" +
                // posData[graphTypesArr[i]][finalPosIndex].x
                // + "," +
                // posData[graphTypesArr[i]][finalPosIndex].y
                // + ")")
                // .attr("y2", (yAxisHeight -
                // posData[graphTypesArr[i]][finalPosIndex].y
                // - graphMargin.top))
                // .style('visibility', 'visible');

                focus
                  .select("circle.y" + (i + 1))
                  .attr(
                    "transform",
                    "translate(" +
                    posData[legendData[i]["key"]][finalPosIndex].x +
                    "," +
                    posData[legendData[i]["key"]][finalPosIndex].y +
                    ")"
                  )
                  .style("visibility", "visible");
              } else {
                // focus.select(".y" + (i + 1))
                // .attr("transform",
                // "translate(" + 0 + "," +
                // (posData[graphTypesArr[i]][finalPosIndex].y)
                // + ")")
                // .attr("x2",
                // (posData[graphTypesArr[i]][finalPosIndex].x))
                // .style('visibility', 'visible');

                focus
                  .select("circle.y" + (i + 1))
                  .attr(
                    "transform",
                    "translate(" +
                    posData[legendData[i]["key"]][finalPosIndex].x +
                    "," +
                    posData[legendData[i]["key"]][finalPosIndex].y +
                    ")"
                  )
                  .style("visibility", "visible");
              }

              var textPosY = isTimeHorizontal ? 15 * i + 16 : 15 * i + 20;

              focus
                .select("text.info" + (i + 1))
                .attr(
                  "transform",
                  "translate(" + textPosX + "," + textPosY + ")"
                )
                .text(
                  dbmScale
                    .invert(
                      isTimeHorizontal
                        ? posData[legendData[i]["key"]][finalPosIndex].x
                        : posData[legendData[i]["key"]][finalPosIndex].y
                    )
                    .toFixed(1) + " dB"
                )
                .style("visibility", "visible");
            }
          }
        }

        if (!isEventFrom2DColumn && globIsSpectrogramGotRColumn) {
          var mouseEventDetail = {
            source: "2D",
            coordinates: mCoordinates,
          };

          var mouseoverEvent = new CustomEvent("mouseover", {
            bubbles: true,
            detail: mouseEventDetail,
          });

          var mousemoveEvent = new CustomEvent("mousemove", {
            bubbles: true,
            detail: mouseEventDetail,
          });

          if (isRColumn) {
            $(glob2DRectL.node())[0].dispatchEvent(mouseoverEvent);
            $(glob2DRectL.node())[0].dispatchEvent(mousemoveEvent);
          } else {
            if (glob2DRectR) {
              $(glob2DRectR.node())[0].dispatchEvent(mouseoverEvent);
              $(glob2DRectR.node())[0].dispatchEvent(mousemoveEvent);
            }
          }
        }
      });

    containingG = containingG
      .append("g")
      .attr(
        "transform",
        "translate(" +
        (isRColumn ? graphMargin.leftRColumn : graphMargin.left) +
        "," +
        graphMargin.top +
        ")"
      );

    // Graphs
    if (tdata.data.length) {
      for (i = 0; i < graphTypesArr.length; ++i) {
        if (data[graphTypesArr[i]].length) {
          containingG
            .append("path")
            .attr("name", graphTypesArr[i])
            .attr("d", lineFunc(data[graphTypesArr[i]]))
            .attr("fill", "none")
            .attr("stroke", tdGraphColor[graphTypesArr[i]].color)
            .attr("stroke-width", 2)
            .on("mouseover", function mouseover(d, i) {
              var mCoordinates = d3.mouse(this);

              if (isTimeHorizontal) {
                spectrogramTooltipElements[4].text(
                  dbmScale.invert(mCoordinates[0]).toFixed(1) + " dB"
                );
              } else {
                spectrogramTooltipElements[4].text(
                  dbmScale.invert(mCoordinates[1]).toFixed(1) + " dB"
                );
              }
              spectrogramTooltipElements[4].style("visibility", "visible");

              return false;
            })
            .on("mousemove", function mousemove() {
              spectrogramTooltipElements[4]
                .style("top", d3.event.pageY - 30 + "px")
                .style("left", d3.event.pageX + 15 + "px");

              return false;
            })
            .on("mouseout", function mouseout(d, i) {
              spectrogramTooltipElements[4].style("visibility", "hidden");

              return false;
            });
        }
      }
    }

    // FDEQ
    if (isSpectrogramsCancEnabled) {
      if (tdata.fdeq.length) {
        for (i = 0; i < fdeqGraphTypesArr.length; ++i) {
          if (
            data[fdeqGraphTypesArr[i]] != "" &&
            data[fdeqGraphTypesArr[i]].length
          ) {
            containingG
              .append("path")
              .attr("name", fdeqGraphTypesArr[i])
              .attr("d", lineFunc(data[fdeqGraphTypesArr[i]]))
              .attr("fill", "none")
              .attr("stroke", tdGraphColor[fdeqGraphTypesArr[i]].color)
              .attr("stroke-width", 2);
          }
        }
      }
    }

    // Y-Axis
    if (isTimeHorizontal) {
      var yScale = d3.scaleLinear().domain(freqDomain).range([0, binsLheight]);

      var yAxis = d3.axisLeft().ticks(12).scale(yScale);

      if (tdata.freqs.startFreq !== -1 && tdata.freqs.endFreq !== -1) {
        yAxis.tickFormat(d3.format(",.2f"));
      }

      d3.select("#" + $graphEl[0].id + " svg")
        .append("g")
        .attr(
          "transform",
          "translate(" + graphMargin.left + "," + graphMargin.top + ")"
        )
        // .style('stroke', 'white')
        .call(yAxis);

      // Grid lines
      d3.select("#" + $graphEl[0].id + " svg")
        .append("g")
        .attr("class", "ygrid")
        .attr(
          "transform",
          "translate(" + graphMargin.left + "," + graphMargin.top + ")"
        )
        .call(yAxis.tickSize(-binsLheight).tickFormat(""));

      // MHz label
      d3.select("#" + $graphEl[0].id + " svg")
        .append("g")
        .attr(
          "transform",
          "translate(" + 0 + "," + (yAxisHeight / 2 - 12) + ")"
        )
        .append("text")
        .style("font-size", ".9em")
        .text("MHz");
    } else {
      var powerSeries = [];
      var yStep = Math.abs(Math.round((maxDBM - minDBM) / 10));
      if (yStep === 0) {
        yStep = 0.5;
      }

      for (i = minDBM; i <= maxDBM; i += yStep) {
        powerSeries.push(i);
      }

      // console.log('powerSeries = ', powerSeries);

      var yAxis = d3
        .axisLeft()
        .tickValues(powerSeries)
        // .tickSizeInner(-actualGraphWidth - graphMargin.left)
        // .tickPadding(10)
        // .tickFormat(d3.format(',.1f'))
        .scale(dbmScale);

      if (
        !globIsSpectrogramGotRColumn ||
        (globIsSpectrogramGotRColumn && !isRColumn)
      ) {
        d3.select("#" + $graphEl[0].id + " svg")
          .append("g")
          .attr(
            "transform",
            "translate(" +
            (isRColumn ? graphMargin.leftRColumn : graphMargin.left) +
            "," +
            graphMargin.top +
            ")"
          )
          // .style('stroke', 'white')
          .call(yAxis);
      }

      // Grid lines
      d3.select("#" + $graphEl[0].id + " svg")
        .append("g")
        .attr("class", "ygrid")
        .attr(
          "transform",
          "translate(" +
          (isRColumn ? graphMargin.leftRColumn : graphMargin.left) +
          "," +
          graphMargin.top +
          ")"
        )
        .call(yAxis.tickSize(-(lWidth * numOfBins)).tickFormat(""));

      if (
        !globIsSpectrogramGotRColumn ||
        (globIsSpectrogramGotRColumn && !isRColumn)
      ) {
        // [dBm] label
        d3.select("#" + $graphEl[0].id + " svg")
          .append("g")
          .attr(
            "transform",
            "translate(" + 5 + "," + (yAxisHeight + 4) / 2 + ")"
          )
          .append("text")
          .style("font-size", ".9em")
          .text("[dBm]");
      }
    }

    // X-Axis
    if (isTimeHorizontal) {
      var powerSeries = [];
      var xStep = Math.abs(Math.round((maxDBM - minDBM) / 9));
      for (i = minDBM; i < maxDBM; i += xStep) {
        powerSeries.push(i);
      }

      // console.log('powerSeries = ', powerSeries);

      var xAxis = d3
        .axisBottom()
        .tickValues(powerSeries)
        // .tickFormat(d3.format(',.1f'))
        .scale(dbmScale);

      d3.select("#" + $graphEl[0].id + " svg")
        .append("g")
        .attr(
          "transform",
          "translate(" +
          graphMargin.left +
          "," +
          (binsLheight + graphMargin.top) +
          ")"
        )
        // .style('stroke', 'white')
        .call(xAxis);

      // Grid lines
      d3.select("#" + $graphEl[0].id + " svg")
        .append("g")
        .attr("class", "xgrid")
        .attr(
          "transform",
          "translate(" +
          graphMargin.left +
          "," +
          (yAxisHeight + graphMargin.top) +
          ")"
        )
        .call(xAxis.tickSize(-yAxisHeight).tickFormat(""));

      // [dBm] label
      d3.select("#" + $graphEl[0].id + " svg")
        .append("g")
        .attr(
          "transform",
          "translate(" +
          actualGraphWidth / 2 +
          "," +
          (spectrogramWindow1GraphHeight - 16) +
          ")"
        )
        .append("text")
        .style("font-size", ".9em")
        .text("[dBm]");
    } else {
      var xScale = d3
        .scaleLinear()
        .domain(freqDomain)
        .range([0, numOfBins * lWidth]);

      var xAxis = d3
        .axisBottom()
        // .tickSizeInner(-yAxisHeight - graphMargin.left)
        // .tickSizeOuter(5)
        // .tickPadding(10)
        .ticks(6)
        .scale(xScale);

      if (tdata.freqs.startFreq !== -1 && tdata.freqs.endFreq !== -1) {
        xAxis.tickFormat(d3.format(",.2f"));
      }

      d3.select("#" + $graphEl[0].id + " svg")
        .append("g")
        .attr(
          "transform",
          "translate(" +
          (isRColumn ? graphMargin.leftRColumn : graphMargin.left) +
          "," +
          (yAxisHeight + graphMargin.top) +
          ")"
        )
        // .style('stroke', 'white')
        .call(xAxis);

      // Grid lines
      d3.select("#" + $graphEl[0].id + " svg")
        .append("g")
        .attr("class", "xgrid")
        .attr(
          "transform",
          "translate(" +
          (isRColumn ? graphMargin.leftRColumn : graphMargin.left) +
          "," +
          (yAxisHeight + graphMargin.top) +
          ")"
        )
        .call(xAxis.tickSize(-yAxisHeight + graphMargin.top).tickFormat(""));
    }

    // Legend
    var legendData = [];

    for (i = 0; i < tdGraphLegend.length; ++i) {
      if (graphTypesArr.indexOf(tdGraphLegend[i]) != -1) {
        if (data[tdGraphLegend[i]].length) {
          legendData.push({
            key: tdGraphLegend[i],
            text: tdGraphColor[tdGraphLegend[i]].text,
            color: tdGraphColor[tdGraphLegend[i]].color,
            graphPos: graphTypesArr.indexOf(tdGraphLegend[i]),
          });
        }
      } else if (fdeqGraphTypesArr.indexOf(tdGraphLegend[i]) != -1) {
        legendData.push({
          key: tdGraphLegend[i],
          text: tdGraphColor[tdGraphLegend[i]].text,
          color: tdGraphColor[tdGraphLegend[i]].color,
          graphPos: graphTypesArr.indexOf(tdGraphLegend[i]),
        });
      }
    }

    // console.log('legendData = ', legendData);

    var legendContainer, timestampContainer, isPausedContainer;

    if (isTimeHorizontal) {
      legendContainer = d3
        .select("#" + $graphEl[0].id + " svg")
        .append("g")
        .attr(
          "transform",
          "translate(" +
          (actualGraphWidth - graphMargin.left - 11) +
          "," +
          (graphMargin.top + 3) +
          ")"
        );

      // if ((graphType === 'timestamphover') || (graphType === 'avg')) {
      timestampContainer = d3
        .select("#" + $graphEl[0].id + " svg")
        .append("g")
        .attr(
          "transform",
          "translate(" +
          (actualGraphWidth - graphMargin.left - 11) +
          "," +
          (legendData.length * 15 + 21) +
          ")"
        );
      // .attr("transform", "translate(" + (graphMargin.left + 5) +
      // "," + (graphMargin.top + 3) + ")");
      // }

      if (isPaused) {
        isPausedContainer = d3
          .select("#" + $graphEl[0].id + " svg")
          .append("g")
          .attr(
            "transform",
            "translate(" +
            (actualGraphWidth - graphMargin.left - 11) +
            "," +
            (legendData.length * 15 + 44) +
            ")"
          );
        // .attr("transform", "translate(" + (graphMargin.left + 5) + "," +
        // ((graphMargin.top + 3) + 25) + ")");
      }
    } else {
      legendContainer = d3
        .select("#" + $graphEl[0].id + " svg")
        .append("g")
        .attr("class", "legendcontainer")
        .attr(
          "transform",
          "translate(" +
          (numOfBins * lWidth -
            11 -
            (isRColumn ? graphMargin.left - graphMargin.leftRColumn : 0)) +
          "," +
          (graphMargin.top + 8) +
          ")"
        );

      // if ((graphType === 'timestamphover') || (graphType === 'avg')) {
      timestampContainer = d3
        .select("#" + $graphEl[0].id + " svg")
        .append("g")
        .attr(
          "transform",
          "translate(" +
          ((isRColumn ? graphMargin.leftRColumn : graphMargin.left) + 5) +
          "," +
          (graphMargin.top + 8) +
          ")"
        );
      // }

      if (isPaused) {
        isPausedContainer = d3
          .select("#" + $graphEl[0].id + " svg")
          .append("g")
          .attr(
            "transform",
            "translate(" +
            ((isRColumn ? graphMargin.leftRColumn : graphMargin.left) + 5) +
            "," +
            (graphMargin.top + 32) +
            ")"
          );
      }
    }

    legendContainer
      .append("rect")
      .attr("width", 82 + "px")
      .attr("height", svgSpan(legendData.length * 15 + 10))
      .attr("stroke", "white")
      .attr("stroke-width", 1)
      .style("fill", "rgba(0,0,0,0.3)");

    for (i = 0; i < legendData.length; ++i) {
      var legendItemContainer = legendContainer.append("g");

      legendItemContainer
        .append("circle")
        .attr("cx", 10)
        .attr("cy", 13 + 15 * i)
        .attr("r", 5)
        .attr("fill", legendData[i].color);

      legendItemContainer
        .append("text")
        .attr("x", 28)
        .attr("y", 18 + 15 * i)
        .attr("fill", "white")
        .text(legendData[i].text);
    }

    if (
      tdata.data.length &&
      (graphType === "timestamphover" || graphType === "lastsample")
    ) {
      timestampContainer
        .append("rect")
        .attr("width", 82 + "px")
        .attr("height", 21 + "px")
        .attr("stroke", "white")
        .attr("stroke-width", 1)
        .style("fill", "rgba(0,0,0,0.3)");

      var timestampVal =
        graphType === "lastsample"
          ? tdata.data[tdata.data.length - 1].msec_epoch
          : hoverTimestamp;

      timestampContainer
        .append("text")
        .attr("x", 3)
        .attr("y", graphMargin.top + 10)
        .attr("fill", "white")
        .text(
          moment(parseInt(timestampVal))
            .tz(globServerTimezone)
            .format("MM-DD HH:mm")
        ); // d3.timeFormat("%m-%d
      // %H:%M")(hoverTimestamp));

      if (isPaused) {
        isPausedContainer
          .append("rect")
          .attr("width", 82 + "px")
          .attr("height", 18 + "px")
          .style("stroke", "white")
          .style("stroke-width", "1px")
          .style("fill", "rgba(0,0,0,0.3)");

        isPausedContainer
          .append("text")
          .attr("x", 15)
          .attr("y", graphMargin.top + 9)
          .attr("fill", "orange")
          .text("Paused");
      }
    } else if (graphType === "avg" && tdata.data.length) {
      timestampContainer
        .append("rect")
        .attr("width", 82 + "px")
        .attr("height", 36 + "px")
        .attr("stroke", "white")
        .attr("stroke-width", 1)
        .style("fill", "rgba(0,0,0,0.3)");

      timestampContainer
        .append("text")
        .attr("x", 3)
        .attr("y", graphMargin.top + 10)
        .attr("fill", "white")
        .text(
          moment(parseInt(tdata.data[avgInfo.startIndex].msec_epoch))
            .tz(globServerTimezone)
            .format("MM-DD HH:mm")
        ); // d3.timeFormat("%m-%d
      // %H:%M")(hoverTimestamp));

      timestampContainer
        .append("text")
        .attr("x", 3)
        .attr("y", graphMargin.top + 26)
        .attr("fill", "white")
        .text(
          moment(parseInt(tdata.data[avgInfo.lastIndex].msec_epoch))
            .tz(globServerTimezone)
            .format("MM-DD HH:mm")
        ); // d3.timeFormat("%m-%d
      // %H:%M")(hoverTimestamp));
    }

    if (globSpectrogramsGraphsZoomDates.length) {
      timestampContainer.selectAll("text").attr("fill", "violet");
    }

    // ++ Crosshairs
    var focus = d3
      .select("#" + $graphEl[0].id + " svg")
      .append("g")
      .style("display", "none")
      .attr(
        "transform",
        "translate(" +
        (isRColumn ? graphMargin.leftRColumn : graphMargin.left) +
        "," +
        graphMargin.top +
        ")"
      );

    // append the x line
    focus
      .append("line")
      .attr("class", "x")
      .style("stroke", "lightgray")
      .style("stroke-width", "2px")
      .style("stroke-dasharray", "3,2")
      .style("opacity", 0.9)
      .attr("y1", 0)
      .attr("y2", 0);

    // append the y1 line
    // focus.append("line")
    // .attr("class", "y1")
    // .style("stroke", "lightgray")
    // .style("stroke-width", "2px")
    // .style("stroke-dasharray", "3,2")
    // .style('visibility', 'hidden')
    // .style("opacity", 0.9)
    // .attr("x1", 0)
    // .attr("x2", 0);

    // append the y2 line
    // focus.append("line")
    // .attr("class", "y2")
    // .style("stroke", "lightgray")
    // .style("stroke-width", "2px")
    // .style("stroke-dasharray", "3,2")
    // .style('visibility', 'hidden')
    // .style("opacity", 0.9)
    // .attr("x1", 0)
    // .attr("x2", 0);

    // append the y3 line
    // focus.append("line")
    // .attr("class", "y3")
    // .style("stroke", "lightgray")
    // .style("stroke-width", "2px")
    // .style("stroke-dasharray", "3,2")
    // .style('visibility', 'hidden')
    // .style("opacity", 0.9)
    // .attr("x1", 0)
    // .attr("x2", 0);

    // append the y4 line
    // focus.append("line")
    // .attr("class", "y4")
    // .style("stroke", "lightgray")
    // .style("stroke-width", "2px")
    // .style("stroke-dasharray", "3,2")
    // .style('visibility', 'hidden')
    // .style("opacity", 0.9)
    // .attr("x1", 0)
    // .attr("x2", 0);

    // append the circle1 at the intersection
    focus
      .append("circle")
      .attr("class", "y1")
      .style("fill", "none")
      .style("stroke", "lightgray")
      .style("stroke-width", "2px")
      .style("visibility", "hidden")
      .style("opacity", 0.9)
      .attr("r", 4);

    // append the circle2 at the intersection
    focus
      .append("circle")
      .attr("class", "y2")
      .style("fill", "none")
      .style("stroke", "lightgray")
      .style("stroke-width", "2px")
      .style("visibility", "hidden")
      .style("opacity", 0.9)
      .attr("r", 4);

    // append the circle3 at the intersection
    focus
      .append("circle")
      .attr("class", "y3")
      .style("fill", "none")
      .style("stroke", "lightgray")
      .style("stroke-width", "2px")
      .style("visibility", "hidden")
      .style("opacity", 0.9)
      .attr("r", 4);

    // append the circle4 at the intersection
    focus
      .append("circle")
      .attr("class", "y4")
      .style("fill", "none")
      .style("stroke", "lightgray")
      .style("stroke-width", "2px")
      .style("visibility", "hidden")
      .style("opacity", 0.9)
      .attr("r", 4);

    // append the circle5 at the intersection
    focus
      .append("circle")
      .attr("class", "y5")
      .style("fill", "none")
      .style("stroke", "lightgray")
      .style("stroke-width", "2px")
      .style("visibility", "hidden")
      .style("opacity", 0.9)
      .attr("r", 4);

    // append the circle6 at the intersection
    focus
      .append("circle")
      .attr("class", "y6")
      .style("fill", "none")
      .style("stroke", "lightgray")
      .style("stroke-width", "2px")
      .style("visibility", "hidden")
      .style("opacity", 0.9)
      .attr("r", 4);

    // append the circle7 at the intersection
    focus
      .append("circle")
      .attr("class", "y7")
      .style("fill", "none")
      .style("stroke", "lightgray")
      .style("stroke-width", "2px")
      .style("visibility", "hidden")
      .style("opacity", 0.9)
      .attr("r", 4);

    // append the circle8 at the intersection
    focus
      .append("circle")
      .attr("class", "y8")
      .style("fill", "none")
      .style("stroke", "lightgray")
      .style("stroke-width", "2px")
      .style("visibility", "hidden")
      .style("opacity", 0.9)
      .attr("r", 4);

    // place the value1 at the intersection
    focus
      .append("text")
      .attr("class", "info1")
      .style("fill", "white")
      .style("visibility", "hidden")
      .style("opacity", 0.9)
      .attr("dx", 8)
      .attr("dy", "0.4em");

    // place the value2 at the intersection
    focus
      .append("text")
      .attr("class", "info2")
      .style("fill", "white")
      .style("visibility", "hidden")
      .style("opacity", 0.9)
      .attr("dx", 8)
      .attr("dy", "0.4em");

    // place the value3 at the intersection
    focus
      .append("text")
      .attr("class", "info3")
      .style("fill", "white")
      .style("visibility", "hidden")
      .style("opacity", 0.9)
      .attr("dx", 8)
      .attr("dy", "0.4em");

    // place the value4 at the intersection
    focus
      .append("text")
      .attr("class", "info4")
      .style("fill", "white")
      .style("visibility", "hidden")
      .style("opacity", 0.9)
      .attr("dx", 8)
      .attr("dy", "0.4em");

    // place the value5 at the intersection
    focus
      .append("text")
      .attr("class", "info5")
      .style("fill", "white")
      .style("visibility", "hidden")
      .style("opacity", 0.9)
      .attr("dx", 8)
      .attr("dy", "0.4em");

    // place the value6 at the intersection
    focus
      .append("text")
      .attr("class", "info6")
      .style("fill", "white")
      .style("visibility", "hidden")
      .style("opacity", 0.9)
      .attr("dx", 8)
      .attr("dy", "0.4em");

    // place the value7 at the intersection
    focus
      .append("text")
      .attr("class", "info7")
      .style("fill", "white")
      .style("visibility", "hidden")
      .style("opacity", 0.9)
      .attr("dx", 8)
      .attr("dy", "0.4em");

    // place the value8 at the intersection
    focus
      .append("text")
      .attr("class", "info8")
      .style("fill", "white")
      .style("visibility", "hidden")
      .style("opacity", 0.9)
      .attr("dx", 8)
      .attr("dy", "0.4em");
    // == Crosshairs
  }

  function drawGraphs(data, dataTypes, dataTypesR, isZooming) {
    var numOfGraphsToDraw = isWin1TD
      ? spectrogramWindow1NumOfGraphs - 1
      : spectrogramWindow1NumOfGraphs;
    var numOfGraphsToDrawR = 0;
    if (globIs4AntDevice) {
      numOfGraphsToDrawR = isWin1TD
        ? spectrogramWindow2NumOfGraphs - 1
        : spectrogramWindow2NumOfGraphs;
    }

    if (data.numOfAnts == 2) {
      tdGraphColor = tdGraphColor2Col;
    } else {
      tdGraphColor = tdGraphColor4Col;
    }

    if (globIs4AntDevice) {
      globIsSpectrogramGotRColumn =
        numOfGraphsToDraw > 0 && numOfGraphsToDrawR > 0;
    } else {
      globIsSpectrogramGotRColumn = false;
    }

    if (IS_DEBUG) {
      console.log("drawGraphs", data);
    }

    if (!isZooming) {
      globSpectrogramsGraphsZoomDates = [];
    }

    $SpectrogramWin1GraphsContainer[0].innerHTML = "";
    $("#TabSpectrogramsContentMainTitleNodeName").text("");
    $("#TabSpectrogramsContentMainTitleTimeRange").text("");

    globSpectrogramGraphTypesArrL = dataTypes.split(";");

    globSpectrogramGraphTypesArrR = [];
    if (globIs4AntDevice) {
      globSpectrogramGraphTypesArrR = dataTypesR.split(";");
    }

    var combinedSpectrogramGraphTypeArray = [];
    globSpectrogramGraphTypesArrL
      .concat(globSpectrogramGraphTypesArrR)
      .forEach(function (i) {
        if (i != "" && !combinedSpectrogramGraphTypeArray[i]) {
          combinedSpectrogramGraphTypeArray[i] = true;
        }
      });
    combinedSpectrogramGraphTypeArray = Object.keys(
      combinedSpectrogramGraphTypeArray
    );

    var startBin = 0;
    var endBin = data.numOfBins - 1;

    // // ++ Power filter
    // if (globalIsSpectrogramsPowerFilter) {
    // 	var graphTypeToUse = combinedSpectrogramGraphTypeArray[0];

    // 	if (!isNaN(globalSpectrogramsPowerFilterMinVal)) {
    // 		data.data[0][graphTypeToUse].every((v, i) => {
    // 			if (v <= globalSpectrogramsPowerFilterMinVal) {
    // 				++startBin;
    // 				return true;
    // 			} else {
    // 				return false;
    // 			}
    // 		});
    // 	}

    // 	if (!isNaN(globalSpectrogramsPowerFilterMaxVal)) {
    // 		data.data[0][graphTypeToUse]
    // 			.slice()
    // 			.reverse()
    // 			.every(v => {
    // 				if (v >= globalSpectrogramsPowerFilterMaxVal) {
    // 					--endBin;
    // 					return true
    // 				} else {
    // 					return false;
    // 				}
    // 			});
    // 	}

    // }
    // // == Power filter

    // globalSpectrogramsStartBin = startBin;
    // globalSpectrogramsEndBin = endBin;

    if (isWin1TD) {
      var graphContainer;
      var tdGraph1, tdGraph2;

      // ++ TD container
      graphContainer = document.createElement("div");
      graphContainer.id = "SpectrogramWindow1TDGraphsContainer";

      graphContainer.style.width =
        (globIsSpectrogramGotRColumn
          ? spectrogramWindow1GraphWidth * 2
          : spectrogramWindow1GraphWidth) + "px";
      graphContainer.style.height = spectrogramWindow1GraphHeight + "px";

      if (isSpectrogramsWin1Vertical) {
        graphContainer.style.display = "inline-block";
        graphContainer.style.marginTop = 38 + "px";
      } else {
        graphContainer.style.marginTop = 10 + "px";
      }
      // == TD container

      globTwoColumnsWidthAdjustment = globIsSpectrogramGotRColumn
        ? graphMargin.left / 2 - graphMargin.leftRColumn / 2
        : 0;

      // ++ Graph1
      tdGraph1 = document.createElement("div");
      tdGraph1.id = "SpectrogramWindow1TDGraph";
      tdGraph1.style.display = "inline-block";
      tdGraph1.style.height = "100%";
      tdGraph1.style.width =
        spectrogramWindow1GraphWidth + globTwoColumnsWidthAdjustment + "px";
      tdGraph1.style.marginLeft = globGraphRectInlineSpace + "px";

      if (globIsSpectrogramGotRColumn) {
        tdGraph1.style.float = "left";
      }

      $SpectrogramWindow1TDGraph = $(tdGraph1);

      $(graphContainer).append(tdGraph1);
      // == Graph1

      // ++ Graph2
      if (globIsSpectrogramGotRColumn) {
        tdGraph2 = document.createElement("div");
        tdGraph2.id = "SpectrogramWindow1TDGraph2";
        tdGraph2.style.display = "inline-block";
        tdGraph2.style.height = "100%";
        tdGraph2.style.width = spectrogramWindow1GraphWidth + "px";
        tdGraph2.style.marginLeft = globGraphRectInlineSpace + "px";

        tdGraph2.style.position = "relative";
        tdGraph2.style.top = -spectrogramWindow1GraphHeight + "px";
        tdGraph2.style.left =
          spectrogramWindow1GraphWidth + globTwoColumnsWidthAdjustment + "px";

        $SpectrogramWindow1TDGraph2 = $(tdGraph2);

        $(graphContainer).append(tdGraph2);
      }
      // == Graph2

      $SpectrogramWin1GraphsContainer.append(graphContainer);

      // ++ calc minDBM, maxDBM
      var minDBM = 255;
      var maxDBM = -255;

      var lastIndex = data.data.length - 1;

      for (var i = 0; i <= lastIndex; ++i) {
        for (var j = 0; j < combinedSpectrogramGraphTypeArray.length; ++j) {
          var tmpExtent = d3.extent(
            data.data[i][combinedSpectrogramGraphTypeArray[j]],
            function extentAccessor(currentValue) {
              return parseFloat(currentValue);
            }
          );

          minDBM = d3.min([minDBM].concat(tmpExtent[0]));
          maxDBM = d3.max([maxDBM].concat(tmpExtent[1]));
        }
      }

      if (isSpectrogramsCancEnabled) {
        var maxFdeqDBM = -255;

        for (var i = 0; i < data.fdeq.length; ++i) {
          for (var j = 0; j < combinedSpectrogramGraphTypeArray.length; ++j) {
            var fdeqGraphType = "";

            if (combinedSpectrogramGraphTypeArray[j] == "a_out") {
              fdeqGraphType = "fdeq_a";
            } else if (combinedSpectrogramGraphTypeArray[j] == "b_out") {
              fdeqGraphType = "fdeq_b";
            } else if (combinedSpectrogramGraphTypeArray[j] == "c_out") {
              fdeqGraphType = "fdeq_c";
            } else if (combinedSpectrogramGraphTypeArray[j] == "d_out") {
              fdeqGraphType = "fdeq_d";
            } else if (combinedSpectrogramGraphTypeArray[j] == "avg_out") {
              fdeqGraphType = "fdeq_avg";
            }

            if (
              fdeqGraphType != "" &&
              typeof data.fdeq[i][fdeqGraphType] !== "undefined" &&
              data.fdeq[i][fdeqGraphType] != ""
            ) {
              var tmpFdeqExtent = d3.extent(
                data.fdeq[i][fdeqGraphType],
                function extentAccessor(currentValue) {
                  return parseFloat(currentValue);
                }
              );

              // minDBM = d3.min([ minDBM
              // ].concat(tmpFdeqExtent[0]));
              maxFdeqDBM = d3.max([maxFdeqDBM].concat(tmpFdeqExtent[1]));
            }
          }
        }

        if (maxFdeqDBM != -255) {
          maxDBM += maxFdeqDBM;
        }
      }

      minDBM = Math.floor(minDBM - 1);
      maxDBM = Math.ceil(maxDBM + 1);

      if (Math.abs(maxDBM - minDBM) < 10) {
        maxDBM = minDBM + 10;
      }

      globDbmAxisInfo = {
        minDBM: minDBM,
        maxDBM: maxDBM,
      };
      // == calc minDBM, maxDBM

      glob2DRectL = glob2DRectR = null;

      draw2DGraph(
        false,
        data,
        win1TDType,
        isSpectrogramsWin1Vertical,
        null,
        null,
        {
          startIndex: 0,
          lastIndex: lastIndex,
        },
        isZooming
      );

      if (globIsSpectrogramGotRColumn) {
        draw2DGraph(
          true,
          data,
          win1TDType,
          isSpectrogramsWin1Vertical,
          null,
          null,
          {
            startIndex: 0,
            lastIndex: lastIndex,
          },
          isZooming
        );
      }
    }

    var maxNumOfGraphsToDrawForBothColumns = Math.max(
      numOfGraphsToDraw,
      numOfGraphsToDrawR
    );
    // spectrogramWindow1GraphHeight = (spectrogramWindow1GraphHeight * numOfGraphsToDraw) / maxNumOfGraphsToDrawForBothColumns;

    var actualGraphHeightNoFreq =
      (maxNumOfGraphsToDrawForBothColumns * spectrogramWindow1GraphHeight -
        (graphMargin.bottom - 5)) /
      maxNumOfGraphsToDrawForBothColumns;
    var actualGraphHeightWithFreq =
      actualGraphHeightNoFreq + (graphMargin.bottom - 5);

    var isDrawFreq = false;

    // Left column
    $SpectrogramWindow1GraphElements = [];

    for (var i = 1; i <= numOfGraphsToDraw; ++i) {
      if (i == numOfGraphsToDraw) {
        isDrawFreq = true;
      }

      var actualGraphHeight;
      if (isDrawFreq) {
        actualGraphHeight = actualGraphHeightWithFreq;
      } else {
        actualGraphHeight = actualGraphHeightNoFreq;
      }

      graphContainer = document.createElement("div");
      graphContainer.id = "SpectrogramWindow1Graph" + i;

      graphContainer.style.width =
        spectrogramWindow1GraphWidth + globTwoColumnsWidthAdjustment + "px";
      // graphContainer.style.height = spectrogramWindow1GraphHeight + 'px';
      graphContainer.style.height = actualGraphHeight + "px";
      graphContainer.style.marginLeft = globGraphRectInlineSpace + "px";

      if (isSpectrogramsWin1Vertical) {
        graphContainer.style.display = "inline-block";
        graphContainer.style.marginTop = 38 + "px";
      } else {
        if (!isWin1TD && i == 1) {
          graphContainer.style.marginTop = globGraphBetweenSpace - 5 + "px";
        } else {
          graphContainer.style.marginTop = globGraphBetweenSpace + "px";
        }
      }

      // graphContainer.innerHTML = '<svg width="' +
      // spectrogramWindow1GraphWidth + 'px" height="' +
      // spectrogramWindow1GraphHeight + 'px"></svg>';
      graphContainer.innerHTML = '<svg width="100%" height="100%"></svg>';

      $SpectrogramWin1GraphsContainer.append(graphContainer);

      $SpectrogramWindow1GraphElements.push($(graphContainer));

      drawGraph(
        data,
        globSpectrogramGraphTypesArrL[i - 1],
        isSpectrogramsWin1Vertical,
        graphContainer,
        globGraphTypeTitle[globSpectrogramGraphTypesArrL[i - 1]],
        globSpectrogramGraphTypesArrL,
        isZooming,
        false,
        isDrawFreq
      );
    }

    isDrawFreq = false;

    var topPositionShift =
      (numOfGraphsToDraw - 1) * actualGraphHeightNoFreq +
      actualGraphHeightWithFreq +
      ((numOfGraphsToDraw - 1) * globGraphBetweenSpace +
        (!isWin1TD ? globGraphBetweenSpace - 5 : globGraphBetweenSpace));

    // 4Ant right column
    if (globIs4AntDevice) {
      var numOfGraphsToDrawR = isWin1TD
        ? spectrogramWindow2NumOfGraphs - 1
        : spectrogramWindow2NumOfGraphs;

      $SpectrogramWindow2GraphElements = [];

      for (var i = 1; i <= numOfGraphsToDrawR; ++i) {
        if (i == numOfGraphsToDrawR) {
          isDrawFreq = true;
        }

        var actualGraphHeight;
        if (isDrawFreq) {
          actualGraphHeight = actualGraphHeightWithFreq;
        } else {
          actualGraphHeight = actualGraphHeightNoFreq;
        }

        graphContainer = document.createElement("div");
        graphContainer.id = "SpectrogramWindow2Graph" + i;

        graphContainer.style.width = spectrogramWindow1GraphWidth + "px";
        graphContainer.style.height = actualGraphHeight + "px";
        graphContainer.style.marginLeft = globGraphRectInlineSpace + "px";

        if (isSpectrogramsWin1Vertical) {
          graphContainer.style.display = "inline-block";
          graphContainer.style.marginTop = 38 + "px";
        } else {
          if (!isWin1TD && i == 1) {
            graphContainer.style.marginTop = globGraphBetweenSpace - 5 + "px";
          } else {
            graphContainer.style.marginTop = globGraphBetweenSpace + "px";
          }
        }

        graphContainer.style.position = "relative";
        // graphContainer.style.top = -((spectrogramWindow1GraphHeight + parseInt(graphContainer.style.marginTop)) * topPositionShift) + 'px';
        graphContainer.style.top = -topPositionShift + "px";
        graphContainer.style.left =
          spectrogramWindow1GraphWidth + globTwoColumnsWidthAdjustment + "px";

        // graphContainer.innerHTML = '<svg width="' +
        // spectrogramWindow1GraphWidth + 'px" height="' +
        // spectrogramWindow1GraphHeight + 'px"></svg>';
        graphContainer.innerHTML = '<svg width="100%" height="100%"></svg>';

        $SpectrogramWin1GraphsContainer.append(graphContainer);

        $SpectrogramWindow1GraphElements.push($(graphContainer));

        drawGraph(
          data,
          globSpectrogramGraphTypesArrR[i - 1],
          isSpectrogramsWin1Vertical,
          graphContainer,
          globGraphTypeTitle[globSpectrogramGraphTypesArrR[i - 1]],
          globSpectrogramGraphTypesArrR,
          isZooming,
          true,
          isDrawFreq
        );
      }
    }
  }

  function drawRRDGraph(
    RRDGraphInfo,
    tdata,
    graphContainer,
    isZooming,
    isUCU,
    antsCombo,
    whichpim
  ) {
    // var IS_DEBUG = true; // DDD

    if (IS_DEBUG) {
      console.log(
        "drawRRDGraph:: ",
        graphContainer,
        RRDGraphInfo,
        tdata,
        isZooming
      );
    }

    var i, j, c;
    var data = {},
      avgData = {},
      avgDataCounter = {};
    var graphTypesArr = [];
    var minAxisVal = 255;
    var maxAxisVal = -255;
    var yAxisHeight;
    var graphContentWidth;
    var tScale;
    var posData = {};
    var rrdGraphTitleHeight, rrdGraphTimespanHeight;

    var isHasOptixData = false;

    var is4AntDevice = antsCombo && antsCombo.length > 2;

    var pimData;
    if (whichpim === "pim1") {
      pimData = tdata.suspected_pim1;
    } else if (whichpim === "pim2") {
      pimData = tdata.suspected_pim2;
    }

    var containingG = d3
      .select("#" + graphContainer.id)
      .append("svg")
      .attr("width", "100%")
      .attr("height", "100%");

    // ++ Graph's Title
    var nodeData = getNodeData("un_" + tdata.childId); // globCurrentNode);

    var graphsTitle;
    var AntsTitle;
    if (
      RRDGraphInfo.name !== "Alarms" &&
      RRDGraphInfo.name !== "MonitoringA" &&
      RRDGraphInfo.name !== "UCUTemperature" &&
      RRDGraphInfo.name !== "UCURSSI" &&
      RRDGraphInfo.name !== "UCURSRQ" &&
      RRDGraphInfo.name !== "AInOutRSSI" &&
      RRDGraphInfo.name !== "BInOutRSSI" &&
      RRDGraphInfo.name !== "CInOutRSSI" &&
      RRDGraphInfo.name !== "DInOutRSSI" &&
      RRDGraphInfo.name !== "ACancellation" &&
      RRDGraphInfo.name !== "BCancellation" &&
      RRDGraphInfo.name !== "CCancellation" &&
      RRDGraphInfo.name !== "DCancellation"
    ) {
      if (is4AntDevice) {
        AntsTitle = (
          antsCombo[0] +
          ", " +
          antsCombo[1] +
          ", " +
          antsCombo[2] +
          ", " +
          antsCombo[3]
        ).toUpperCase();
      } else {
        AntsTitle = (antsCombo[0] + ", " + antsCombo[1]).toUpperCase();
      }

      graphsTitle =
        RRDGraphInfo.titlePrefix + AntsTitle + RRDGraphInfo.titleSuffix;

      if (
        RRDGraphInfo.name === "PIMInOutRSSI" ||
        RRDGraphInfo.name === "PIMCancellation"
      ) {
        graphsTitle += pimData.suspectedPimBinNumber;
      } else if (RRDGraphInfo.name === "PIMBinDiffInOutRSSI") {
        graphsTitle +=
          "abs(bin " +
          tdata.suspected_pim1.suspectedPimBinNumber +
          " - bin " +
          tdata.suspected_pim2.suspectedPimBinNumber +
          ")";
      }
    } else {
      graphsTitle = RRDGraphInfo.title;
    }

    var actualTitle = getGraphNodeTitle(nodeData) + " " + graphsTitle;

    var svgTitle = containingG
      .append("text")
      .attr(
        "x",
        graphMarginRRD.left + RRDGraphWidth / 2 - (actualTitle.length / 2) * 9
      )
      .attr("font-weight", "bold")
      .text(actualTitle);

    var svgTitleBBox = svgTitle.node().getBBox();

    rrdGraphTitleHeight = svgTitleBBox.height;
    svgTitle.attr("y", rrdGraphTitleHeight);
    rrdGraphTitleHeight += 5;
    // == Graph's Title

    globTDGraphsLookupForFilter[actualTitle] = graphContainer.id;

    // ++ Graph's Timespan
    var startEpochIndexName, endEpochIndexName;

    if (isUCU) {
      startEpochIndexName = "startSecEpoch";
      endEpochIndexName = "endSecEpoch";
    } else {
      startEpochIndexName = "startMsecEpoch";
      endEpochIndexName = "endMsecEpoch";
    }

    var timespanText =
      moment(parseInt(tdata[endEpochIndexName] * (isUCU ? 1000 : 1)))
        .tz(globServerTimezone)
        .format("MM-DD HH:mm") +
      " - " +
      moment(parseInt(tdata[startEpochIndexName] * (isUCU ? 1000 : 1)))
        .tz(globServerTimezone)
        .format("MM-DD HH:mm");

    var svgTimeSpan = containingG
      .append("text")
      .attr(
        "x",
        graphMarginRRD.left +
        RRDGraphWidth / 2 -
        (actualTitle.length / 2.5) * 9 +
        ((actualTitle.length - timespanText.length) / 2) * 9
      )
      .attr("font-style", "italic")
      .text(timespanText);

    if (globRRDGraphsZoomDates.length) {
      svgTimeSpan.attr("stroke", "violet");
    }

    var svgTimespanBBox = svgTimeSpan.node().getBBox();

    rrdGraphTimespanHeight = svgTimespanBBox.height;
    svgTimeSpan.attr("y", rrdGraphTitleHeight + rrdGraphTimespanHeight);
    rrdGraphTimespanHeight += 5;
    // == Graph's Timespan

    var graphInfoAreaHeight = rrdGraphTitleHeight + rrdGraphTimespanHeight;

    yAxisHeight =
      RRDGraphHeight -
      graphMarginRRD.bottomWide -
      graphMarginRRD.top -
      graphInfoAreaHeight -
      RRD_GRAPH_LABELS_AREA_HEIGHT;
    graphContentWidth = RRDGraphWidth - graphMarginRRD.left - 1;

    tScale = d3
      .scaleLinear()
      .domain([
        tdata[endEpochIndexName] * (isUCU ? 1000 : 1),
        tdata[startEpochIndexName] * (isUCU ? 1000 : 1),
      ])
      .range([0, graphContentWidth])
      .clamp(true);

    // ++ Optix mode
    if (isRootUser() || isUserRole("OptixMode")) {
      if (!isUCU) {
        if (isUserRole("Display Status In Tree")) {
          if (tdata.childId == "2903") {
            tdata.mode_data.forEach(function (el, index) {
              tdata.mode_data[index].link_status = 2;
            });
          }
        }

        var reportThresholdMsec = 5 * 60 * 1000;

        var optixModeContainer = containingG.append("g");

        var optixModeContainerContent = optixModeContainer
          .selectAll("g")
          .data(tdata.mode_data)
          .enter()
          .append("g")
          .attr("data-epoch", function drawOptixModeRect_attr1(d, i) {
            return d.start_sec_epoch;
          });

        optixModeContainerContent
          .append("rect")
          .attr(
            "transform",
            "translate(" +
            graphMarginRRD.left +
            "," +
            (graphMarginRRD.top +
              graphInfoAreaHeight -
              globOptixModeRectHeight) +
            ")"
          )
          .attr("x", function drawOptixModeRect_attr2(d, i) {
            return tScale(d.start_sec_epoch).toFixed(2);
          })
          .attr("y", 0)
          .attr("width", function (d, i) {
            var rectWidth = 0;

            if (d.latest_update_sec_epoch) {
              if (i < tdata.mode_data.length - 1) {
                if (
                  tdata.mode_data[i + 1].start_sec_epoch -
                  d.latest_update_sec_epoch <=
                  reportThresholdMsec
                ) {
                  rectWidth =
                    tScale(tdata.mode_data[i + 1].start_sec_epoch).toFixed(2) -
                    tScale(d.start_sec_epoch).toFixed(2);
                } else {
                  rectWidth =
                    tScale(d.latest_update_sec_epoch).toFixed(2) -
                    tScale(d.start_sec_epoch).toFixed(2);
                }
              } else {
                rectWidth =
                  tScale(
                    d.latest_update_sec_epoch + reportThresholdMsec
                  ).toFixed(2) - tScale(d.start_sec_epoch).toFixed(2);
              }
            }

            return svgSpan(rectWidth);
          })
          .attr("height", globOptixModeRectHeight)
          .attr("stroke-width", 0)
          .attr("class", function drawOptixModeRect_class1(d, i) {
            return optixModeClass(d.mode_number);
          })
          .append("title")
          .text(function (d, i) {
            return globOptixModeGraphs["mode" + d.mode_number].title;
          });

        if (isUserRole("Display Status In Tree")) {
          optixModeContainerContent
            .filter((d) => d.link_status > 0)
            .append("rect")
            .attr(
              "transform",
              "translate(" +
              graphMarginRRD.left +
              "," +
              (graphMarginRRD.top +
                graphInfoAreaHeight -
                2 * globOptixModeRectHeight) +
              ")"
            )
            .attr("x", function drawOptixModeRect_attr2(d, i) {
              return tScale(d.start_sec_epoch).toFixed(2);
            })
            .attr("y", 0)
            .attr("width", function (d, i) {
              var rectWidth = 0;

              if (d.latest_update_sec_epoch) {
                if (i < tdata.mode_data.length - 1) {
                  if (
                    tdata.mode_data[i + 1].start_sec_epoch -
                    d.latest_update_sec_epoch <=
                    reportThresholdMsec
                  ) {
                    rectWidth =
                      tScale(tdata.mode_data[i + 1].start_sec_epoch).toFixed(
                        2
                      ) - tScale(d.start_sec_epoch).toFixed(2);
                  } else {
                    rectWidth =
                      tScale(d.latest_update_sec_epoch).toFixed(2) -
                      tScale(d.start_sec_epoch).toFixed(2);
                  }
                } else {
                  rectWidth =
                    tScale(
                      d.latest_update_sec_epoch + reportThresholdMsec
                    ).toFixed(2) - tScale(d.start_sec_epoch).toFixed(2);
                }
              }

              return svgSpan(rectWidth);
            })
            .attr("height", globOptixModeRectHeight)
            .attr("stroke-width", 0)
            .style("fill", function drawOptixModeRect_style1(d, i) {
              return globLinkStatusModeGraphs["status" + d.link_status].color;
            })
            .append("title")
            .text(function (d, i) {
              return globLinkStatusModeGraphs["status" + d.link_status].title;
            });
        }
      }
    }
    // == Optix mode

    // ++ Prepare Data
    var lineStopThresholdStep = 120;

    if ((nodeData.act_name.includes('7003')) || (nodeData.act_name.includes('7004')) || (nodeData.act_name.includes('7700')) || (nodeData.act_name.includes('7008')) || (nodeData.act_name.includes('7002'))) {
      lineStopThresholdStep = 720;
    }

    var lineStopThreshold = (RRDSecPerPixel + lineStopThresholdStep) * 1000;


    var fieldName1,
      fieldName2,
      fieldName3,
      fieldName4,
      fieldName5,
      fieldName6,
      fieldName7,
      fieldName8,
      fieldName9;

    var tmpArray, tmpExtent;

    function AntInOutRSSI(antComboIndex) {
      var avgInCnt = 0;
      var avgOutCnt = 0;

      for (i = 0; i < tdata.data.length; ++i) {
        tmpArray = [];

        for (c = 0; c < 4; ++c) {
          fieldName1 = "input_power_" + antsCombo[antComboIndex] + c;

          if (
            tdata.data[i][fieldName1] !== -999 &&
            tdata.data[i][fieldName1] <= -10
          ) {
            fieldName3 = "input_power_channel" + (c + 1);

            if (graphTypesArr.indexOf(fieldName3) === -1) {
              graphTypesArr.push(fieldName3);

              data[fieldName3] = [];
              avgData[fieldName3] = 0;
            }

            data[fieldName3][data[fieldName3].length] = {
              val: +tdata.data[i][fieldName1].toFixed(2),
              timeStamp: tdata.data[i]["msec_epoch"],
            };

            avgData[fieldName3] +=
              data[fieldName3][data[fieldName3].length - 1].val;

            ++avgInCnt;

            if (avgInCnt >= 2) {
              avgData[fieldName3] /= 2;
            }

            tmpArray.push(data[fieldName3][data[fieldName3].length - 1].val);
          }
        }

        for (c = 0; c < 4; ++c) {
          fieldName1 = "output_power_" + antsCombo[antComboIndex] + c;

          if (
            (tdata.data[i][fieldName1] !== -999) &
            (tdata.data[i][fieldName1] <= -10)
          ) {
            fieldName3 = "output_power_channel" + (c + 1);

            if (graphTypesArr.indexOf(fieldName3) === -1) {
              graphTypesArr.push(fieldName3);

              data[fieldName3] = [];
              avgData[fieldName3] = 0;
            }

            data[fieldName3][data[fieldName3].length] = {
              val: +tdata.data[i][fieldName1].toFixed(2),
              timeStamp: tdata.data[i]["msec_epoch"],
            };

            avgData[fieldName3] +=
              data[fieldName3][data[fieldName3].length - 1].val;

            ++avgOutCnt;

            if (avgOutCnt >= 2) {
              avgData[fieldName3] /= 2;
            }

            tmpArray.push(data[fieldName3][data[fieldName3].length - 1].val);
          }
        }

        tmpExtent = d3.extent(tmpArray);

        minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
        maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
      }
    }

    function AntCancellation(antComboIndex) {
      var avgInCnt = 0;

      for (i = 0; i < tdata.data.length; ++i) {
        tmpArray = [];

        for (c = 0; c < 4; ++c) {
          fieldName1 = "input_power_" + antsCombo[antComboIndex] + c;
          fieldName3 = "output_power_" + antsCombo[antComboIndex] + c;

          if (
            tdata.data[i][fieldName1] !== -999 &&
            tdata.data[i][fieldName1] <= -10
          ) {
            fieldName5 = "cancellation_channel" + (c + 1);

            if (graphTypesArr.indexOf(fieldName5) === -1) {
              graphTypesArr.push(fieldName5);

              data[fieldName5] = [];
              avgData[fieldName5] = 0;
            }

            var channelInput = tdata.data[i][fieldName1];
            var channelOutput = tdata.data[i][fieldName3];

            data[fieldName5][data[fieldName5].length] = {
              val: +(channelInput - channelOutput).toFixed(2),
              timeStamp: tdata.data[i]["msec_epoch"],
            };

            avgData[fieldName5] +=
              data[fieldName5][data[fieldName5].length - 1].val;

            ++avgInCnt;

            if (avgInCnt >= 2) {
              avgData[fieldName5] /= 2;
            }

            tmpArray.push(data[fieldName5][data[fieldName5].length - 1].val);
          }
        }

        tmpExtent = d3.extent(tmpArray);

        minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
        maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
      }
    }

    if (RRDGraphInfo.name === "InOutRSSI") {
      var avgInCnt = 0;
      var avgOutCnt = 0;
      var avgVal;

      for (i = 0; i < tdata.data.length; ++i) {
        tmpArray = [];

        for (c = 0; c < 4; ++c) {
          fieldName1 = "input_power_" + antsCombo[0] + c;

          if (
            tdata.data[i][fieldName1] !== -999 &&
            tdata.data[i][fieldName1] <= -10
          ) {
            fieldName3 = "input_power_channel" + (c + 1);

            if (graphTypesArr.indexOf(fieldName3) === -1) {
              graphTypesArr.push(fieldName3);

              data[fieldName3] = [];
              avgData[fieldName3] = 0;
            }

            fieldName2 = "input_power_" + antsCombo[1] + c;

            avgVal = tdata.data[i][fieldName1] + tdata.data[i][fieldName2];

            if (is4AntDevice) {
              fieldName4 = "input_power_" + antsCombo[2] + c;
              fieldName5 = "input_power_" + antsCombo[3] + c;

              avgVal += tdata.data[i][fieldName4] + tdata.data[i][fieldName5];

              avgVal = +(avgVal / 4).toFixed(2);
            } else {
              avgVal = +(avgVal / 2).toFixed(2);
            }

            data[fieldName3][data[fieldName3].length] = {
              val: avgVal,
              timeStamp: tdata.data[i]["msec_epoch"],
            };

            avgData[fieldName3] +=
              data[fieldName3][data[fieldName3].length - 1].val;

            ++avgInCnt;

            if (avgInCnt >= 2) {
              avgData[fieldName3] /= 2;
            }

            tmpArray.push(data[fieldName3][data[fieldName3].length - 1].val);
          }
        }

        for (c = 0; c < 4; ++c) {
          fieldName1 = "output_power_" + antsCombo[0] + c;

          if (
            (tdata.data[i][fieldName1] !== -999) &
            (tdata.data[i][fieldName1] <= -10)
          ) {
            fieldName3 = "output_power_channel" + (c + 1);

            if (graphTypesArr.indexOf(fieldName3) === -1) {
              graphTypesArr.push(fieldName3);

              data[fieldName3] = [];
              avgData[fieldName3] = 0;
            }

            fieldName2 = "output_power_" + antsCombo[1] + c;

            avgVal = tdata.data[i][fieldName1] + tdata.data[i][fieldName2];

            if (is4AntDevice) {
              fieldName4 = "output_power_" + antsCombo[2] + c;
              fieldName5 = "output_power_" + antsCombo[3] + c;

              avgVal += tdata.data[i][fieldName4] + tdata.data[i][fieldName5];

              avgVal = +(avgVal / 4).toFixed(2);
            } else {
              avgVal = +(avgVal / 2).toFixed(2);
            }

            data[fieldName3][data[fieldName3].length] = {
              val: avgVal,
              timeStamp: tdata.data[i]["msec_epoch"],
            };

            avgData[fieldName3] +=
              data[fieldName3][data[fieldName3].length - 1].val;

            ++avgOutCnt;

            if (avgOutCnt >= 2) {
              avgData[fieldName3] /= 2;
            }

            tmpArray.push(data[fieldName3][data[fieldName3].length - 1].val);
          }
        }

        tmpExtent = d3.extent(tmpArray);

        minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
        maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
      }
    } else if (RRDGraphInfo.name === "AInOutRSSI") {
      AntInOutRSSI(0);
    } else if (RRDGraphInfo.name === "BInOutRSSI") {
      AntInOutRSSI(1);
    } else if (RRDGraphInfo.name === "CInOutRSSI") {
      AntInOutRSSI(2);
    } else if (RRDGraphInfo.name === "DInOutRSSI") {
      AntInOutRSSI(3);
    } else if (RRDGraphInfo.name === "PIMInOutRSSI") {
      var avgInCnt = 0;
      var avgOutCnt = 0;
      var avgVal;

      var fieldName;
      for (i = 0; i < pimData.data.length; ++i) {
        tmpArray = [];

        for (c = 97; c < 101; ++c) {
          // in
          fieldName = String.fromCharCode(c) + "_in";

          if (fieldName in pimData.data[i]) {
            if (graphTypesArr.indexOf(fieldName) === -1) {
              graphTypesArr.push(fieldName);

              data[fieldName] = [];
              avgData[fieldName] = 0;
            }

            data[fieldName][data[fieldName].length] = {
              val: pimData.data[i][fieldName],
              timeStamp: pimData.data[i]["msec_epoch"],
            };

            avgData[fieldName] +=
              data[fieldName][data[fieldName].length - 1].val;

            ++avgInCnt;

            if (avgInCnt >= 2) {
              avgData[fieldName] /= 2;
            }

            tmpArray.push(data[fieldName][data[fieldName].length - 1].val);
          }

          // out
          fieldName = String.fromCharCode(c) + "_out";

          if (fieldName in pimData.data[i]) {
            if (graphTypesArr.indexOf(fieldName) === -1) {
              graphTypesArr.push(fieldName);

              data[fieldName] = [];
              avgData[fieldName] = 0;
            }

            data[fieldName][data[fieldName].length] = {
              val: pimData.data[i][fieldName],
              timeStamp: pimData.data[i]["msec_epoch"],
            };

            avgData[fieldName] +=
              data[fieldName][data[fieldName].length - 1].val;

            ++avgOutCnt;

            if (avgOutCnt >= 2) {
              avgData[fieldName] /= 2;
            }

            tmpArray.push(data[fieldName][data[fieldName].length - 1].val);
          }
        }

        tmpExtent = d3.extent(tmpArray);

        minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
        maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
      }

      if (is4AntDevice) {
        graphTypesArr[0] = "a_in";
        graphTypesArr[1] = "b_in";
        graphTypesArr[2] = "c_in";
        graphTypesArr[3] = "d_in";
        graphTypesArr[4] = "a_out";
        graphTypesArr[5] = "b_out";
        graphTypesArr[6] = "c_out";
        graphTypesArr[7] = "d_out";

        RRDGraphInfo["b_in"].isNewLine = false;
        RRDGraphInfo["d_in"].isNewLine = true;
      } else {
        graphTypesArr[0] = "a_in";
        graphTypesArr[1] = "b_in";
        graphTypesArr[2] = "a_out";
        graphTypesArr[3] = "b_out";

        RRDGraphInfo["b_in"].isNewLine = true;
      }
    } else if (RRDGraphInfo.name === "PIMBinDiffInOutRSSI") {
      var avgInCnt = 0;
      var avgOutCnt = 0;
      var avgVal;

      var pimData1 = tdata.suspected_pim1;
      var pimData2 = tdata.suspected_pim2;
      var fieldName;

      for (i = 0; i < pimData1.data.length; ++i) {
        tmpArray = [];

        for (c = 97; c < 101; ++c) {
          // in
          fieldName = String.fromCharCode(c) + "_in";

          if (fieldName in pimData1.data[i] && fieldName in pimData2.data[i]) {
            if (graphTypesArr.indexOf(fieldName) === -1) {
              graphTypesArr.push(fieldName);

              data[fieldName] = [];
              avgData[fieldName] = 0;
            }

            data[fieldName][data[fieldName].length] = {
              val: Math.abs(
                pimData1.data[i][fieldName] - pimData2.data[i][fieldName]
              ),
              timeStamp: pimData1.data[i]["msec_epoch"],
            };

            avgData[fieldName] +=
              data[fieldName][data[fieldName].length - 1].val;

            ++avgInCnt;

            if (avgInCnt >= 2) {
              avgData[fieldName] /= 2;
            }

            tmpArray.push(data[fieldName][data[fieldName].length - 1].val);
          }

          // out
          fieldName = String.fromCharCode(c) + "_out";

          if (fieldName in pimData1.data[i] && fieldName in pimData2.data[i]) {
            if (graphTypesArr.indexOf(fieldName) === -1) {
              graphTypesArr.push(fieldName);

              data[fieldName] = [];
              avgData[fieldName] = 0;
            }

            data[fieldName][data[fieldName].length] = {
              val: Math.abs(
                pimData1.data[i][fieldName] - pimData2.data[i][fieldName]
              ),
              timeStamp: pimData1.data[i]["msec_epoch"],
            };

            avgData[fieldName] +=
              data[fieldName][data[fieldName].length - 1].val;

            ++avgOutCnt;

            if (avgOutCnt >= 2) {
              avgData[fieldName] /= 2;
            }

            tmpArray.push(data[fieldName][data[fieldName].length - 1].val);
          }
        }

        tmpExtent = d3.extent(tmpArray);

        minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
        maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
      }

      if (is4AntDevice) {
        graphTypesArr[0] = "a_in";
        graphTypesArr[1] = "b_in";
        graphTypesArr[2] = "c_in";
        graphTypesArr[3] = "d_in";
        graphTypesArr[4] = "a_out";
        graphTypesArr[5] = "b_out";
        graphTypesArr[6] = "c_out";
        graphTypesArr[7] = "d_out";

        RRDGraphInfo["b_in"].isNewLine = false;
        RRDGraphInfo["d_in"].isNewLine = true;
      } else {
        graphTypesArr[0] = "a_in";
        graphTypesArr[1] = "b_in";
        graphTypesArr[2] = "a_out";
        graphTypesArr[3] = "b_out";

        RRDGraphInfo["b_in"].isNewLine = true;
      }
    } else if (RRDGraphInfo.name === "PIMCancellation") {
      var avgInCnt = 0;

      for (i = 0; i < pimData.data.length; ++i) {
        tmpArray = [];
        var antComboMaxVal = is4AntDevice ? 4 : 2;

        for (var ac = 0; ac < antComboMaxVal; ++ac) {
          fieldName1 = antsCombo[ac] + "_in";
          fieldName2 = antsCombo[ac] + "_out";

          fieldName9 = "cancellation_channel" + (ac + 1);
          RRDGraphInfo[fieldName9].label =
            "Cancellation " + antsCombo[ac].toUpperCase();

          if (graphTypesArr.indexOf(fieldName9) === -1) {
            graphTypesArr.push(fieldName9);

            data[fieldName9] = [];
            avgData[fieldName9] = 0;
          }

          var channelCanc = +(
            pimData.data[i][fieldName1] - pimData.data[i][fieldName2]
          ).toFixed(2);

          data[fieldName9][data[fieldName9].length] = {
            val: channelCanc,
            timeStamp: pimData.data[i]["msec_epoch"],
          };

          avgData[fieldName9] +=
            data[fieldName9][data[fieldName9].length - 1].val;

          ++avgInCnt;

          if (avgInCnt >= 2) {
            avgData[fieldName9] /= 2;
          }

          tmpArray.push(data[fieldName9][data[fieldName9].length - 1].val);
        }

        tmpExtent = d3.extent(tmpArray);

        minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
        maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
      }
    } else if (RRDGraphInfo.name === "Cancellation") {
      var avgInCnt = 0;
      var avgOutCnt = 0;

      for (i = 0; i < tdata.data.length; ++i) {
        tmpArray = [];

        for (c = 0; c < 4; ++c) {
          fieldName1 = "input_power_" + antsCombo[0] + c;

          if (
            (tdata.data[i][fieldName1] !== -999) &
            (tdata.data[i][fieldName1] <= -10)
          ) {
            fieldName5 = "cancellation_channel" + (c + 1);

            if (graphTypesArr.indexOf(fieldName5) === -1) {
              graphTypesArr.push(fieldName5);

              data[fieldName5] = [];
              avgData[fieldName5] = 0;
            }

            fieldName2 = "input_power_" + antsCombo[1] + c;
            fieldName3 = "output_power_" + antsCombo[0] + c;
            fieldName4 = "output_power_" + antsCombo[1] + c;

            var channelInput;
            var channelOutput;

            if (is4AntDevice) {
              fieldName6 = "input_power_" + antsCombo[2] + c;
              fieldName7 = "input_power_" + antsCombo[3] + c;
              fieldName8 = "output_power_" + antsCombo[2] + c;
              fieldName9 = "output_power_" + antsCombo[3] + c;

              channelInput =
                (tdata.data[i][fieldName1] +
                  tdata.data[i][fieldName2] +
                  tdata.data[i][fieldName6] +
                  tdata.data[i][fieldName7]) /
                4;
              channelOutput =
                (tdata.data[i][fieldName3] +
                  tdata.data[i][fieldName4] +
                  tdata.data[i][fieldName8] +
                  tdata.data[i][fieldName9]) /
                4;
            } else {
              channelInput =
                (tdata.data[i][fieldName1] + tdata.data[i][fieldName2]) / 2;
              channelOutput =
                (tdata.data[i][fieldName3] + tdata.data[i][fieldName4]) / 2;
            }

            data[fieldName5][data[fieldName5].length] = {
              val: +(channelInput - channelOutput).toFixed(2),
              timeStamp: tdata.data[i]["msec_epoch"],
            };

            avgData[fieldName5] +=
              data[fieldName5][data[fieldName5].length - 1].val;

            ++avgInCnt;

            if (avgInCnt >= 2) {
              avgData[fieldName5] /= 2;
            }

            tmpArray.push(data[fieldName5][data[fieldName5].length - 1].val);
          }
        }

        tmpExtent = d3.extent(tmpArray);

        minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
        maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
      }
    } else if (RRDGraphInfo.name === "ACancellation") {
      AntCancellation(0);
    } else if (RRDGraphInfo.name === "BCancellation") {
      AntCancellation(1);
    } else if (RRDGraphInfo.name === "CCancellation") {
      AntCancellation(2);
    } else if (RRDGraphInfo.name === "DCancellation") {
      AntCancellation(3);
    } else if (RRDGraphInfo.name === "ABInputsRSSI") {
      var avgCnt1 = 0;
      var avgCnt2 = 0;
      var avgCnt3 = 0;
      var avgCnt4 = 0;

      for (i = 0; i < tdata.data.length; ++i) {
        tmpArray = [];

        for (c = 0; c < 4; ++c) {
          fieldName1 = "input_power_" + antsCombo[0] + c;

          if (
            tdata.data[i][fieldName1] !== -999 &&
            tdata.data[i][fieldName1] <= -10
          ) {
            fieldName3 = "input_power_" + antsCombo[0] + "_channel" + (c + 1);

            if (graphTypesArr.indexOf(fieldName3) === -1) {
              graphTypesArr.push(fieldName3);

              data[fieldName3] = [];
              avgData[fieldName3] = 0;
            }

            data[fieldName3][data[fieldName3].length] = {
              val: +tdata.data[i][fieldName1].toFixed(2),
              timeStamp: tdata.data[i]["msec_epoch"],
            };

            avgData[fieldName3] +=
              data[fieldName3][data[fieldName3].length - 1].val;

            ++avgCnt1;

            if (avgCnt1 >= 2) {
              avgData[fieldName3] /= 2;
            }

            tmpArray.push(data[fieldName3][data[fieldName3].length - 1].val);
          }
        }

        for (c = 0; c < 4; ++c) {
          fieldName1 = "input_power_" + antsCombo[1] + c;

          if (
            tdata.data[i][fieldName1] !== -999 &&
            tdata.data[i][fieldName1] <= -10
          ) {
            fieldName3 = "input_power_" + antsCombo[1] + "_channel" + (c + 1);

            if (graphTypesArr.indexOf(fieldName3) === -1) {
              graphTypesArr.push(fieldName3);

              data[fieldName3] = [];
              avgData[fieldName3] = 0;
            }

            data[fieldName3][data[fieldName3].length] = {
              val: +tdata.data[i][fieldName1].toFixed(2),
              timeStamp: tdata.data[i]["msec_epoch"],
            };

            avgData[fieldName3] +=
              data[fieldName3][data[fieldName3].length - 1].val;

            ++avgCnt2;

            if (avgCnt2 >= 2) {
              avgData[fieldName3] /= 2;
            }

            tmpArray.push(data[fieldName3][data[fieldName3].length - 1].val);
          }
        }

        if (is4AntDevice) {
          for (c = 0; c < 4; ++c) {
            fieldName1 = "input_power_" + antsCombo[2] + c;

            if (
              tdata.data[i][fieldName1] !== -999 &&
              tdata.data[i][fieldName1] <= -10
            ) {
              fieldName3 = "input_power_" + antsCombo[2] + "_channel" + (c + 1);

              if (graphTypesArr.indexOf(fieldName3) === -1) {
                graphTypesArr.push(fieldName3);

                data[fieldName3] = [];
                avgData[fieldName3] = 0;
              }

              data[fieldName3][data[fieldName3].length] = {
                val: +tdata.data[i][fieldName1].toFixed(2),
                timeStamp: tdata.data[i]["msec_epoch"],
              };

              avgData[fieldName3] +=
                data[fieldName3][data[fieldName3].length - 1].val;

              ++avgCnt3;

              if (avgCnt3 >= 2) {
                avgData[fieldName3] /= 2;
              }

              tmpArray.push(data[fieldName3][data[fieldName3].length - 1].val);
            }
          }

          for (c = 0; c < 4; ++c) {
            fieldName1 = "input_power_" + antsCombo[3] + c;

            if (
              tdata.data[i][fieldName1] !== -999 &&
              tdata.data[i][fieldName1] <= -10
            ) {
              fieldName3 = "input_power_" + antsCombo[3] + "_channel" + (c + 1);

              if (graphTypesArr.indexOf(fieldName3) === -1) {
                graphTypesArr.push(fieldName3);

                data[fieldName3] = [];
                avgData[fieldName3] = 0;
              }

              data[fieldName3][data[fieldName3].length] = {
                val: +tdata.data[i][fieldName1].toFixed(2),
                timeStamp: tdata.data[i]["msec_epoch"],
              };

              avgData[fieldName3] +=
                data[fieldName3][data[fieldName3].length - 1].val;

              ++avgCnt4;

              if (avgCnt4 >= 2) {
                avgData[fieldName3] /= 2;
              }

              tmpArray.push(data[fieldName3][data[fieldName3].length - 1].val);
            }
          }
        }

        tmpExtent = d3.extent(tmpArray);

        minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
        maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
      }

      if (is4AntDevice) {
        graphTypesArr[0] = "input_power_a_channel1";
        graphTypesArr[1] = "input_power_c_channel1";
        graphTypesArr[2] = "input_power_b_channel1";
        graphTypesArr[3] = "input_power_d_channel1";

        RRDGraphInfo["input_power_a_channel1"].isNewLine = false;
        RRDGraphInfo["input_power_c_channel1"].isNewLine = true;
      } else {
        RRDGraphInfo["input_power_a_channel1"].isNewLine = true;
      }
    } else if (RRDGraphInfo.name === "ABInputsOffset") {
      var avgInCnt = 0;

      for (i = 0; i < tdata.data.length; ++i) {
        tmpArray = [];

        for (c = 0; c < 4; ++c) {
          fieldName1 = "input_power_" + antsCombo[0] + c;

          if (
            tdata.data[i][fieldName1] !== -999 &&
            tdata.data[i][fieldName1] <= -10
          ) {
            fieldName3 = "input_offset_channel" + (c + 1);

            if (graphTypesArr.indexOf(fieldName3) === -1) {
              graphTypesArr.push(fieldName3);

              data[fieldName3] = [];
              avgData[fieldName3] = 0;
            }

            fieldName2 = "input_power_" + antsCombo[1] + c;

            var maxOffset;
            var minVal, maxVal;

            if (is4AntDevice) {
              fieldName4 = "input_power_" + antsCombo[2] + c;
              fieldName5 = "input_power_" + antsCombo[3] + c;

              minVal = Math.min(
                tdata.data[i][fieldName1],
                tdata.data[i][fieldName2],
                tdata.data[i][fieldName4],
                tdata.data[i][fieldName5]
              );
              maxVal = Math.max(
                tdata.data[i][fieldName1],
                tdata.data[i][fieldName2],
                tdata.data[i][fieldName4],
                tdata.data[i][fieldName5]
              );
            } else {
              minVal = Math.min(
                tdata.data[i][fieldName1],
                tdata.data[i][fieldName2]
              );
              maxVal = Math.max(
                tdata.data[i][fieldName1],
                tdata.data[i][fieldName2]
              );
            }

            maxOffset = maxVal - minVal;

            data[fieldName3][data[fieldName3].length] = {
              val: +maxOffset.toFixed(2),
              timeStamp: tdata.data[i]["msec_epoch"],
            };

            avgData[fieldName3] +=
              data[fieldName3][data[fieldName3].length - 1].val;

            ++avgInCnt;

            if (avgInCnt >= avgInCnt) {
              avgData[fieldName3] /= 2;
            }

            tmpArray.push(data[fieldName3][data[fieldName3].length - 1].val);
          }
        }

        tmpExtent = d3.extent(tmpArray);

        minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
        maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
      }
    } else if (RRDGraphInfo.name === "ABOutputRSSI") {
      var avgCnt1 = 0;
      var avgCnt2 = 0;
      var avgCnt3 = 0;
      var avgCnt4 = 0;

      for (i = 0; i < tdata.data.length; ++i) {
        tmpArray = [];

        for (c = 0; c < 4; ++c) {
          fieldName1 = "output_power_" + antsCombo[0] + c;
          if (
            tdata.data[i][fieldName1] !== -999 &&
            tdata.data[i][fieldName1] <= -10
          ) {
            fieldName3 = "output_power_" + antsCombo[0] + "_channel" + (c + 1);

            if (graphTypesArr.indexOf(fieldName3) === -1) {
              graphTypesArr.push(fieldName3);

              data[fieldName3] = [];
              avgData[fieldName3] = 0;
            }

            data[fieldName3][data[fieldName3].length] = {
              val: +tdata.data[i][fieldName1].toFixed(2),
              timeStamp: tdata.data[i]["msec_epoch"],
            };

            avgData[fieldName3] +=
              data[fieldName3][data[fieldName3].length - 1].val;

            ++avgCnt1;

            if (avgCnt1 >= 2) {
              avgData[fieldName3] /= 2;
            }

            tmpArray.push(data[fieldName3][data[fieldName3].length - 1].val);
          }
        }

        for (c = 0; c < 4; ++c) {
          fieldName1 = "output_power_" + antsCombo[1] + c;
          if (
            tdata.data[i][fieldName1] !== -999 &&
            tdata.data[i][fieldName1] <= -10
          ) {
            fieldName3 = "output_power_" + antsCombo[1] + "_channel" + (c + 1);

            if (graphTypesArr.indexOf(fieldName3) === -1) {
              graphTypesArr.push(fieldName3);

              data[fieldName3] = [];
              avgData[fieldName3] = 0;
            }

            data[fieldName3][data[fieldName3].length] = {
              val: +tdata.data[i][fieldName1].toFixed(2),
              timeStamp: tdata.data[i]["msec_epoch"],
            };

            avgData[fieldName3] +=
              data[fieldName3][data[fieldName3].length - 1].val;

            ++avgCnt2;

            if (avgCnt2 >= 2) {
              avgData[fieldName3] /= 2;
            }

            tmpArray.push(data[fieldName3][data[fieldName3].length - 1].val);
          }
        }

        if (is4AntDevice) {
          for (c = 0; c < 4; ++c) {
            fieldName1 = "output_power_" + antsCombo[2] + c;
            if (
              tdata.data[i][fieldName1] !== -999 &&
              tdata.data[i][fieldName1] <= -10
            ) {
              fieldName3 =
                "output_power_" + antsCombo[2] + "_channel" + (c + 1);

              if (graphTypesArr.indexOf(fieldName3) === -1) {
                graphTypesArr.push(fieldName3);

                data[fieldName3] = [];
                avgData[fieldName3] = 0;
              }

              data[fieldName3][data[fieldName3].length] = {
                val: +tdata.data[i][fieldName1].toFixed(2),
                timeStamp: tdata.data[i]["msec_epoch"],
              };

              avgData[fieldName3] +=
                data[fieldName3][data[fieldName3].length - 1].val;

              ++avgCnt3;

              if (avgCnt3 >= 2) {
                avgData[fieldName3] /= 2;
              }

              tmpArray.push(data[fieldName3][data[fieldName3].length - 1].val);
            }
          }

          for (c = 0; c < 4; ++c) {
            fieldName1 = "output_power_" + antsCombo[3] + c;
            if (
              tdata.data[i][fieldName1] !== -999 &&
              tdata.data[i][fieldName1] <= -10
            ) {
              fieldName3 =
                "output_power_" + antsCombo[3] + "_channel" + (c + 1);

              if (graphTypesArr.indexOf(fieldName3) === -1) {
                graphTypesArr.push(fieldName3);

                data[fieldName3] = [];
                avgData[fieldName3] = 0;
              }

              data[fieldName3][data[fieldName3].length] = {
                val: +tdata.data[i][fieldName1].toFixed(2),
                timeStamp: tdata.data[i]["msec_epoch"],
              };

              avgData[fieldName3] +=
                data[fieldName3][data[fieldName3].length - 1].val;

              ++avgCnt4;

              if (avgCnt4 >= 2) {
                avgData[fieldName3] /= 2;
              }

              tmpArray.push(data[fieldName3][data[fieldName3].length - 1].val);
            }
          }
        }

        tmpExtent = d3.extent(tmpArray);

        minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
        maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
      }

      if (is4AntDevice) {
        graphTypesArr[0] = "output_power_a_channel1";
        graphTypesArr[1] = "output_power_c_channel1";
        graphTypesArr[2] = "output_power_b_channel1";
        graphTypesArr[3] = "output_power_d_channel1";

        RRDGraphInfo["output_power_a_channel1"].isNewLine = false;
        RRDGraphInfo["output_power_c_channel1"].isNewLine = true;
      } else {
        RRDGraphInfo["output_power_a_channel1"].isNewLine = true;
      }
    } else if (RRDGraphInfo.name === "ABOutputsOffset") {
      var avgOutCnt = 0;

      for (i = 0; i < tdata.data.length; ++i) {
        tmpArray = [];

        for (c = 0; c < 4; ++c) {
          fieldName1 = "output_power_" + antsCombo[0] + c;

          if (
            tdata.data[i][fieldName1] !== -999 &&
            tdata.data[i][fieldName1] <= -10
          ) {
            fieldName3 = "output_offset_channel" + (c + 1);

            if (graphTypesArr.indexOf(fieldName3) === -1) {
              graphTypesArr.push(fieldName3);

              data[fieldName3] = [];
              avgData[fieldName3] = 0;
            }

            fieldName2 = "output_power_" + antsCombo[1] + c;

            var maxOffset;
            var minVal, maxVal;

            if (is4AntDevice) {
              fieldName4 = "output_power_" + antsCombo[2] + c;
              fieldName5 = "output_power_" + antsCombo[3] + c;

              minVal = Math.min(
                tdata.data[i][fieldName1],
                tdata.data[i][fieldName2],
                tdata.data[i][fieldName4],
                tdata.data[i][fieldName5]
              );
              maxVal = Math.max(
                tdata.data[i][fieldName1],
                tdata.data[i][fieldName2],
                tdata.data[i][fieldName4],
                tdata.data[i][fieldName5]
              );
            } else {
              minVal = Math.min(
                tdata.data[i][fieldName1],
                tdata.data[i][fieldName2]
              );
              maxVal = Math.max(
                tdata.data[i][fieldName1],
                tdata.data[i][fieldName2]
              );
            }

            maxOffset = maxVal - minVal;

            data[fieldName3][data[fieldName3].length] = {
              val: +maxOffset.toFixed(2),
              timeStamp: tdata.data[i]["msec_epoch"],
            };

            avgData[fieldName3] +=
              data[fieldName3][data[fieldName3].length - 1].val;

            ++avgOutCnt;

            if (avgOutCnt >= 2) {
              avgData[fieldName3] /= 2;
            }

            tmpArray.push(data[fieldName3][data[fieldName3].length - 1].val);
          }
        }

        tmpExtent = d3.extent(tmpArray);

        minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
        maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
      }
    } else if (RRDGraphInfo.name === "Alarms") {
      for (i = 0; i < tdata.data.length; ++i) {
        var alarmRegVal = tdata.data[i]["alarm_reg"];

        for (j = 0; j < RRDGraphInfo.alarmNames.length; ++j) {
          fieldName1 = RRDGraphInfo.alarmNames[j];

          if (graphTypesArr.indexOf(fieldName1) === -1) {
            graphTypesArr.push(fieldName1);
            data[fieldName1] = [];
          }

          var bitMask = Math.pow(
            2,
            RRDGraphInfo[RRDGraphInfo.alarmNames[j]].bit
          );

          if ((alarmRegVal & bitMask) === bitMask) {
            data[fieldName1][data[fieldName1].length] = {
              val: RRDGraphInfo[RRDGraphInfo.alarmNames[j]].bit + 1,
              timeStamp: tdata.data[i]["msec_epoch"],
            };
          }
        }

        minAxisVal = 1;
        maxAxisVal = 15;
      }
    } else if (RRDGraphInfo.name === "UCUTemperature") {
      fieldName1 = "temperature";
      for (i = 0; i < tdata.data.length; ++i) {
        tmpArray = [];

        if (graphTypesArr.indexOf(fieldName1) === -1) {
          graphTypesArr.push(fieldName1);
          data[fieldName1] = [];
          avgData[fieldName1] = 0;
        }

        data[fieldName1][data[fieldName1].length] = {
          val: tdata.data[i][fieldName1],
          timeStamp: parseInt(tdata.data[i]["sec_epoch"]) * 1000,
        };

        avgData[fieldName1] +=
          data[fieldName1][data[fieldName1].length - 1].val;
        if (i > 0) {
          avgData[fieldName1] /= 2;
        }

        tmpArray.push(data[fieldName1][data[fieldName1].length - 1].val);

        tmpExtent = d3.extent(tmpArray);

        minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
        maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
      }

      if (tdata.sfp_data) {
        fieldName1 = "sfp_temperature";
        for (i = 0; i < tdata.sfp_data.length; ++i) {
          tmpArray = [];

          if (graphTypesArr.indexOf(fieldName1) === -1) {
            graphTypesArr.push(fieldName1);
            data[fieldName1] = [];
            avgData[fieldName1] = 0;
          }

          data[fieldName1][data[fieldName1].length] = {
            val: tdata.sfp_data[i][fieldName1],
            timeStamp: parseInt(tdata.sfp_data[i]["sec_epoch"]) * 1000,
          };

          avgData[fieldName1] +=
            data[fieldName1][data[fieldName1].length - 1].val;
          if (i > 0) {
            avgData[fieldName1] /= 2;
          }

          tmpArray.push(data[fieldName1][data[fieldName1].length - 1].val);

          tmpExtent = d3.extent(tmpArray);

          minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
          maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
        }
      }

      if (tdata.fa_data) {
        fieldName1 = "fa_temperature";
        for (i = 0; i < tdata.fa_data.length; ++i) {
          tmpArray = [];

          if (graphTypesArr.indexOf(fieldName1) === -1) {
            graphTypesArr.push(fieldName1);
            data[fieldName1] = [];
            avgData[fieldName1] = 0;
          }

          data[fieldName1][data[fieldName1].length] = {
            val: tdata.fa_data[i][fieldName1],
            timeStamp: parseInt(tdata.fa_data[i]["sec_epoch"]) * 1000,
          };

          avgData[fieldName1] +=
            data[fieldName1][data[fieldName1].length - 1].val;
          if (i > 0) {
            avgData[fieldName1] /= 2;
          }

          tmpArray.push(data[fieldName1][data[fieldName1].length - 1].val);

          tmpExtent = d3.extent(tmpArray);

          minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
          maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
        }
      }
    } else if (RRDGraphInfo.name === "UCURSSI") {
      fieldName1 = "modem_rssi";
      fieldName2 = "modem_rsrp";
      var nonZeroCount = 0;

      for (i = 0; i < tdata.data.length; ++i) {
        tmpArray = [];

        if (graphTypesArr.indexOf(fieldName1) === -1) {
          graphTypesArr.push(fieldName1);
          data[fieldName1] = [];
          avgData[fieldName1] = 0;
        }

        data[fieldName1][data[fieldName1].length] = {
          val: tdata.data[i][fieldName1],
          timeStamp: parseInt(tdata.data[i]["sec_epoch"]) * 1000,
        };

        avgData[fieldName1] +=
          data[fieldName1][data[fieldName1].length - 1].val;
        if (i > 0) {
          avgData[fieldName1] /= 2;
        }

        if (graphTypesArr.indexOf(fieldName2) === -1) {
          graphTypesArr.push(fieldName2);
          data[fieldName2] = [];
          avgData[fieldName2] = 0;
        }

        data[fieldName2][data[fieldName2].length] = {
          val: tdata.data[i][fieldName2],
          timeStamp: parseInt(tdata.data[i]["sec_epoch"]) * 1000,
        };

        if (data[fieldName2][data[fieldName2].length - 1].val != 0) {
          ++nonZeroCount;

          avgData[fieldName2] +=
            data[fieldName2][data[fieldName2].length - 1].val;

          if ((i > 0) && (nonZeroCount > 1)) {
            avgData[fieldName2] /= 2;
          }

          tmpArray.push(data[fieldName2][data[fieldName2].length - 1].val);
        }

        tmpArray.push(data[fieldName1][data[fieldName1].length - 1].val);

        tmpExtent = d3.extent(tmpArray);

        minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
        maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
      }
    } else if (RRDGraphInfo.name === "UCURSRQ") {
      fieldName1 = "modem_rsrq";
      var nonZeroCount = 0;

      for (i = 0; i < tdata.data.length; ++i) {
        tmpArray = [];

        if (graphTypesArr.indexOf(fieldName1) === -1) {
          graphTypesArr.push(fieldName1);
          data[fieldName1] = [];
          avgData[fieldName1] = 0;
        }

        data[fieldName1][data[fieldName1].length] = {
          val: tdata.data[i][fieldName1],
          timeStamp: parseInt(tdata.data[i]["sec_epoch"]) * 1000,
        };

        if (data[fieldName1][data[fieldName1].length - 1].val != 0) {
          ++nonZeroCount;

          avgData[fieldName1] +=
            data[fieldName1][data[fieldName1].length - 1].val;

          if ((i > 0) && (nonZeroCount > 1)) {
            avgData[fieldName1] /= 2;
          }

          tmpArray.push(data[fieldName1][data[fieldName1].length - 1].val);
        }

        tmpExtent = d3.extent(tmpArray);

        minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
        maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
      }
    } else if (RRDGraphInfo.name === "MonitoringA") {
      if (tdata["optix_data"]["monitoring_a"].length) {
        isHasOptixData = true;
      }

      for (i = 0; i < tdata["optix_data"]["monitoring_a"].length; ++i) {
        tmpArray = [];

        _.forEach(
          tdata["optix_data"]["monitoring_a"][i],
          function (value, key) {
            if (tdata["optix_data"]["monitoring_a"][i].hasOwnProperty(key)) {
              fieldName1 = key;

              if (key !== "msec_epoch") {
                if (graphTypesArr.indexOf(fieldName1) === -1) {
                  graphTypesArr.push(fieldName1);
                  data[fieldName1] = [];
                  avgData[fieldName1] = 0;
                  avgDataCounter[fieldName1] = 0;
                }

                data[fieldName1][data[fieldName1].length] = {
                  val: tdata["optix_data"]["monitoring_a"][i][fieldName1],
                  timeStamp:
                    tdata["optix_data"]["monitoring_a"][i]["msec_epoch"],
                };

                ++avgDataCounter[fieldName1];

                avgData[fieldName1] +=
                  data[fieldName1][data[fieldName1].length - 1].val;
                if (avgDataCounter[fieldName1] > 1) {
                  avgData[fieldName1] /= 2;
                }

                tmpArray.push(
                  data[fieldName1][data[fieldName1].length - 1].val
                );
              }
            }
          }
        );

        if (tmpArray.length) {
          tmpExtent = d3.extent(tmpArray);

          minAxisVal = d3.min([minAxisVal].concat(tmpExtent[0]));
          maxAxisVal = d3.max([maxAxisVal].concat(tmpExtent[1]));
        }
      }
    }

    if (IS_DEBUG) {
      console.log("avgData: ", avgData);
    }

    minAxisVal = Math.floor(minAxisVal - 1);
    maxAxisVal = Math.ceil(maxAxisVal + 1);

    if (
      ((RRDGraphInfo.name !== "PIMBinDiffInOutRSSI") &&
        (RRDGraphInfo.name !== "UCURSRQ")) &&
      globalIsRRDPowerFilter &&
      RRDGraphInfo.yAxisLabel === "[dBm]"
    ) {
      minAxisVal = globalRRDPowerFilterMinVal;
      maxAxisVal = globalRRDPowerFilterMaxVal;
    }

    // if (Math.abs(maxAxisVal - minAxisVal) < 10) {
    // maxAxisVal = minAxisVal + 10;
    // }

    if (IS_DEBUG) {
      console.log("graphTypesArr = ", graphTypesArr, ", data = ", data);
      console.log(
        "drawRRDGraph:: minAxisVal = ",
        minAxisVal,
        ", maxAxisVal = ",
        maxAxisVal
      );
    }

    var yAxisScale;
    yAxisScale = d3
      .scaleLinear()
      .domain([minAxisVal, maxAxisVal])
      .range([
        yAxisHeight + graphMarginRRD.top + graphInfoAreaHeight,
        graphMarginRRD.top + graphInfoAreaHeight,
      ]);

    for (i = 0; i < graphTypesArr.length; ++i) {
      posData[graphTypesArr[i]] = [];

      for (j = 0; j < data[graphTypesArr[i]].length; ++j) {
        posData[graphTypesArr[i]].push({
          x: +tScale(data[graphTypesArr[i]][j].timeStamp).toFixed(2),
          y: +yAxisScale(data[graphTypesArr[i]][j].val).toFixed(2),
        });
      }
    }
    // == Prepare Data

    if (IS_DEBUG) {
      console.log("posData = ", posData);
    }

    // MZN/FA live on sfp_data / fa_data. The UCU `_rrd` series can be empty
    // (ingest skipped rows without RSSI, or varchar epoch mismatch) while
    // those still have points — still need to draw the temperature paths.
    var hasSeriesData =
      (tdata.data && tdata.data.length) ||
      isHasOptixData ||
      (tdata.sfp_data && tdata.sfp_data.length) ||
      (tdata.fa_data && tdata.fa_data.length);

    var lineFunc = d3
      .line()
      // .curve(d3.curveBasis)
      .defined(function (d, i, data) {
        if (
          i !== 0 &&
          d.timeStamp - data[i - 1].timeStamp > lineStopThreshold
        ) {
          return false;
        } else {
          if ((RRDGraphInfo.name === "UCURSSI") || (RRDGraphInfo.name === "UCURSRQ")) {
            if (d.val === 0) {
              return false;
            }
          }

          if (
            ((RRDGraphInfo.name !== "PIMBinDiffInOutRSSI") && (RRDGraphInfo.name !== "UCURSRQ")) &&
            globalIsRRDPowerFilter &&
            RRDGraphInfo.yAxisLabel === "[dBm]"
          ) {
            if (d.val > globalRRDPowerFilterMaxVal) {
              d.val = globalRRDPowerFilterMaxVal;
            } else if (d.val < globalRRDPowerFilterMinVal) {
              d.val = globalRRDPowerFilterMinVal;
            }
          }

          return true;
        }
      })
      .x(function (d, i) {
        return tScale(d.timeStamp).toFixed(2);
      })
      .y(function (d, i) {
        return yAxisScale(d.val).toFixed(2);
      });

    // Graphs
    if (hasSeriesData) {
      for (i = 0; i < graphTypesArr.length; ++i) {
        containingG
          .append("path")
          .attr("graphType", graphTypesArr[i])
          .attr("transform", "translate(" + graphMarginRRD.left + "," + 0 + ")")
          .attr("d", lineFunc(data[graphTypesArr[i]]))
          .attr("fill", "none")
          .attr(
            "stroke",
            isHasOptixData
              ? RRDGraphInfo["line" + (i + 1)].color
              : RRDGraphInfo[graphTypesArr[i]].color
          )
          .attr("stroke-width", 2);
      }
    }

    // Y-Axis
    var powerSeries = [];
    var yStep = Math.abs(Math.ceil((maxAxisVal - minAxisVal) / 12));
    for (i = minAxisVal; i <= maxAxisVal; i += yStep) {
      powerSeries.push(i);
    }
    // console.log('powerSeries = ', powerSeries);

    var yAxis = d3
      .axisLeft()
      .tickValues(powerSeries)
      // .tickSizeInner(-spectrogramWindow1GraphWidth - graphMarginRRD.left)
      // .tickPadding(10)
      // .tickFormat(d3.format(',.1f'))
      .scale(yAxisScale);

    d3.select("#" + graphContainer.id + " svg")
      .append("g")
      .attr("transform", "translate(" + graphMarginRRD.left + "," + 0 + ")")
      // .style('stroke', 'white')
      .call(yAxis);

    // Grid lines
    d3.select("#" + graphContainer.id + " svg")
      .append("g")
      .attr("class", "ygrid")
      .attr("transform", "translate(" + graphMarginRRD.left + "," + 0 + ")")
      .call(yAxis.tickSize(-graphContentWidth).tickFormat(""));

    // label
    d3.select("#" + graphContainer.id + " svg")
      .append("g")
      .attr(
        "transform",
        "translate(" +
        5 +
        "," +
        (yAxisHeight + graphMarginRRD.top + graphInfoAreaHeight + 4) / 2 +
        ")"
      )
      .append("text")
      .style("font-size", ".9em")
      .html(RRDGraphInfo.yAxisLabel);

    // X-Axis
    var timeSeries = [];

    // var xStep = 3600000 * 2; // 3600000 = 1 hour
    var startEpoch = parseInt(tdata[startEpochIndexName]) * (isUCU ? 1000 : 1);
    var endEpoch = parseInt(tdata[endEpochIndexName]) * (isUCU ? 1000 : 1);
    var xStep = Math.ceil((startEpoch - endEpoch) / 20);

    for (var k = startEpoch; k >= endEpoch; k -= xStep) {
      timeSeries[timeSeries.length] = k;
    }

    var xAxis = d3
      .axisBottom()
      .tickValues(timeSeries)
      // .tickFormat(d3.timeFormat("%Y-%m-%d %H:%M"))
      // .tickFormat(d3.timeFormat("%m-%d %H:%M"))
      .tickFormat(function (d) {
        return moment(d).tz(globServerTimezone).format("MM-DD HH:mm");
      })
      .scale(tScale);

    d3.select("#" + graphContainer.id + " svg")
      .append("g")
      .attr(
        "transform",
        "translate(" +
        graphMarginRRD.left +
        "," +
        (yAxisHeight + graphMarginRRD.top + graphInfoAreaHeight) +
        ")"
      )
      .call(xAxis)
      .selectAll("text")
      .style("text-anchor", "end")
      .attr("dx", "-.8em")
      .attr("dy", ".15em")
      .attr("transform", "rotate(-45)");

    // Grid lines
    d3.select("#" + graphContainer.id + " svg")
      .append("g")
      .attr("class", "xgrid")
      .attr(
        "transform",
        "translate(" +
        graphMarginRRD.left +
        "," +
        (yAxisHeight + graphMarginRRD.top + graphInfoAreaHeight) +
        ")"
      )
      .call(xAxis.tickSize(-yAxisHeight).tickFormat(""));

    // ++ Crosshairs
    var focus = d3
      .select("#" + graphContainer.id + " svg")
      .append("g")
      // .attr('transform', 'translate(' + graphMarginRRD.left + ',' +
      // (graphMarginRRD.top + graphInfoAreaHeight) + ')')
      .attr("transform", "translate(" + graphMarginRRD.left + "," + 0 + ")")
      .style("display", "none");

    // append the x line
    focus
      .append("line")
      .attr("class", "x")
      .style("stroke", "black")
      .style("stroke-width", "2px")
      .style("stroke-dasharray", "3,2")
      .style("opacity", 0.9);

    for (i = 0; i < graphTypesArr.length; ++i) {
      // append the circle1 at the intersection
      focus
        .append("circle")
        .attr("class", "y" + (i + 1))
        .style("fill", "none")
        .style("stroke", "black") // RRDGraphInfo[graphTypesArr[i]].color
        .style("stroke-width", "2px")
        // . style('visibility', 'hidden')
        .style("opacity", 0.3)
        .attr("r", 4);
    }
    // == Crosshairs

    // Rect for Time AVG
    var timeRectContainer = d3
      .select("#" + graphContainer.id + " svg")
      .append("g")
      .attr("class", "rrd-timerect-container")
      .style("visibility", "hidden")
      .attr(
        "transform",
        "translate(" +
        graphMarginRRD.left +
        "," +
        (graphMarginRRD.top + graphInfoAreaHeight) +
        ")"
      );

    var timeRect = timeRectContainer
      .append("rect")
      .attr("class", "rrd-timerect")
      .attr("width", 0 + "px")
      .attr("stroke", "gray")
      .attr("stroke-width", 1)
      // .attr('stroke-dasharray', '10, 5, 4, 5')
      .attr("stroke-dasharray", "3,2")
      .attr("fill", "rgba(200,200,200,0.3)");

    // Hover rect
    var hoverRect;
    hoverRect = containingG
      .append("rect")
      .attr("class", "rrdHoverRect")
      .attr(
        "transform",
        "translate(" +
        graphMarginRRD.left +
        "," +
        (graphMarginRRD.top + graphInfoAreaHeight) +
        ")"
      )
      .attr("width", svgSpan(graphContentWidth))
      // lWidth * tdata.data.length
      // RRDGraphWidth - graphMarginRRD.left
      .attr("height", svgSpan(yAxisHeight))
      .attr("fill", "rgba(0, 0, 0, 0)");

    globTDGraphsHoverElements[
      RRDGraphInfo.name + tdata.childId + (whichpim ? whichpim : "")
    ] = hoverRect.node();

    var rectCoordinates = hoverRect.node().getBoundingClientRect();

    timeRect.attr("height", svgSpan(rectCoordinates.height));

    var isMouseDown,
      isTimeavgRect,
      isAfterTimeavgRect,
      isTimestampInfoVisible,
      mouseDownCoords,
      timeavgRectStartX,
      timeavgRectEndX,
      mCoordinates;

    isMouseDown =
      isTimeavgRect =
      isAfterTimeavgRect =
      isTimestampInfoVisible =
      false;

    hoverRect
      .style("pointer-events", "all")
      // .attr("focusable", true)
      .on("mousedown", function mouseout(d, i) {
        if (
          (hasSeriesData) &&
          (tdata[startEpochIndexName] - tdata[endEpochIndexName]) /
          (isUCU ? 1 : 1000) /
          60 >=
          RRD_GRAPH_MIN_MINUTES_FOR_ZOOM
        ) {
          mouseDownCoords = {
            x: d3.event.clientX,
            y: d3.event.clientY,
          };

          if (d3.event.which === 1) {
            // Left click.
            console.log("RRD hoverRect mousedown (left click)");

            isMouseDown = true;
            isTimeavgRect = globIsRRDTimeavgRect = false;

            // if (!globSpectrogramsUpdateTimer && isSpectrogramPre)
            // {
            // globSpectrogramsUpdateTimer =
            // setTimeout(tabSpectrogramsContentControlsGo,
            // SPECTROGRAMS_UPODATE_INTERVAL);
            // }

            // for (var i = 0; i <
            // $SpectrogramWindow1GraphElements.length; ++i) {
            // $('#' + $SpectrogramWindow1GraphElements[i][0].id + '
            // .timerect-container')[0].style.visibility = 'hidden';
            // }

            timeRect.attr("width", 0 + "px");

            focus.style("display", "none");
            RRDAxisTooltipElements[0].style("visibility", "hidden");
            // isTimestampInfoVisible = false;

            d3.event.preventDefault();
          }
        }
      })
      .on("contextmenu", function rrdContextMenu(d, i) {
        if (globRRDGraphsZoomDates.length) {
          var zoomOutData = globRRDGraphsZoomDates.pop();

          // console.log('Zoom out for startDate = ',
          // zoomOutData.startMsecEpoch, ', endDate = ',
          // zoomOutData.endMsecEpoch); // DDD
          // console.log('Zoom in data', globRRDGraphsZoomDates); //
          // DDD
          focus.style("display", "none");
          RRDAxisTooltipElements[0].style("visibility", "hidden");
          // isTimestampInfoVisible = false;

          // setTimeout(getUbifixRRDData(false,
          // zoomOutData.startMsecEpoch, zoomOutData.endMsecEpoch, {
          // RRDGraphInfo: RRDGraphInfo,
          // graphContainer: graphContainer
          // }), 0);

          if (isUCU) {
            setTimeout(
              getUCURRDData(
                false,
                zoomOutData.startMsecEpoch,
                zoomOutData.endMsecEpoch,
                true
              ),
              0
            );
          } else if (globIsParentSummaryRRDGraphs) {
            setTimeout(
              tabRRDGraphsContentControlsGo(
                null,
                {
                  startDate: zoomOutData.startMsecEpoch,
                  endDate: zoomOutData.endMsecEpoch,
                },
                true
              ),
              0
            );
          } else {
            setTimeout(
              tabRRDGraphsContentControlsGo(null, {
                startDate: zoomOutData.startMsecEpoch,
                endDate: zoomOutData.endMsecEpoch,
              }),
              0
            );
          }

          // ++ Dates Range
          var tmpStartTimeCloud = moment.tz(
            zoomOutData.endMsecEpoch * 1000,
            globServerTimezone
          );
          var newMomentStartDate = moment(
            new Date(tmpStartTimeCloud.format("ddd, DD MMM YYYY HH:mm"))
          );

          var tmpEndTimeCloud = moment.tz(
            zoomOutData.startMsecEpoch * 1000,
            globServerTimezone
          );
          var newMomentEndDate = moment(
            new Date(tmpEndTimeCloud.format("ddd, DD MMM YYYY HH:mm"))
          );

          var nowCloud = moment().tz(globServerTimezone);
          var localCloudTime = moment(
            new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
          );

          globRRDIsNOPDatesRangeFuncs = true;

          $TabRRDContentControlsStartDate
            .data("DateTimePicker")
            .maxDate(newMomentEndDate);
          $TabRRDContentControlsEndDate
            .data("DateTimePicker")
            .minDate(newMomentStartDate);
          $TabRRDContentControlsEndDate
            .data("DateTimePicker")
            .maxDate(localCloudTime);

          $TabRRDContentControlsStartDate
            .data("DateTimePicker")
            .date(newMomentStartDate);
          // $TabRRDContentControlsStartDate.data("DateTimePicker").maxDate(moment(new
          // Date(tmpStartTimeCloud)));

          $TabRRDContentControlsEndDate
            .data("DateTimePicker")
            .date(newMomentEndDate);
          // == Dates Range
        }

        d3.event.preventDefault();

        return false;
      })
      .on("mouseup", function mouseout(d, i) {
        if (hasSeriesData) {
          if (d3.event.which === 1) {
            // Left click.
            console.log("RRD hoverRect mouseup (left click)"); // DDD

            if (isTimeavgRect) {
              var mCoordinates = d3.mouse(this);
              var t1, t2;

              timeavgRectEndX = mCoordinates[0];

              t1 = +tScale.invert(timeavgRectStartX).toFixed(0);
              t2 = +tScale.invert(timeavgRectEndX).toFixed(0);

              if (t2 < t1) {
                var tmpVal = t1;
                t1 = t2;
                t2 = tmpVal;
              }

              console.log("t1 = ", t1, ", t2 = ", t2); // DDD

              var startDate = t2 / 1000;
              var endDate = t1 / 1000;

              if (
                (startDate - endDate) / 60 >=
                RRD_GRAPH_MIN_MINUTES_FOR_ZOOM
              ) {
                console.log(
                  "Zoom in for startDate = ",
                  startDate,
                  ", endDate = ",
                  endDate
                ); // DDD

                globRRDGraphsZoomDates.push({
                  startMsecEpoch:
                    parseInt(tdata[startEpochIndexName]) / (isUCU ? 1 : 1000),
                  endMsecEpoch:
                    parseInt(tdata[endEpochIndexName]) / (isUCU ? 1 : 1000),
                });

                // console.log('Zoom in data',
                // globRRDGraphsZoomDates); // DDD

                focus.style("display", "none");
                RRDAxisTooltipElements[0].style("visibility", "hidden");
                isTimestampInfoVisible = false;

                // setTimeout(getUbifixRRDData(false, startDate,
                // endDate, {
                // RRDGraphInfo: RRDGraphInfo,
                // graphContainer: graphContainer
                // }), 0);

                if (isUCU) {
                  setTimeout(getUCURRDData(false, startDate, endDate, true), 0);
                } else if (globIsParentSummaryRRDGraphs) {
                  setTimeout(
                    tabRRDGraphsContentControlsGo(
                      null,
                      {
                        startDate: startDate,
                        endDate: endDate,
                      },
                      true
                    ),
                    0
                  );
                } else {
                  setTimeout(
                    tabRRDGraphsContentControlsGo(null, {
                      startDate: startDate,
                      endDate: endDate,
                    }),
                    0
                  );
                }

                // ++ Dates Range
                var tmpStartTimeCloud = moment.tz(
                  endDate * 1000,
                  globServerTimezone
                );
                var newMomentStartDate = moment(
                  new Date(tmpStartTimeCloud.format("ddd, DD MMM YYYY HH:mm"))
                );

                var tmpEndTimeCloud = moment.tz(
                  startDate * 1000,
                  globServerTimezone
                );
                var newMomentEndDate = moment(
                  new Date(tmpEndTimeCloud.format("ddd, DD MMM YYYY HH:mm"))
                );

                var nowCloud = moment().tz(globServerTimezone);
                var localCloudTime = moment(
                  new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
                );

                globRRDIsNOPDatesRangeFuncs = true;
                $TabRRDContentControlsStartDate
                  .data("DateTimePicker")
                  .maxDate(newMomentEndDate);
                $TabRRDContentControlsEndDate
                  .data("DateTimePicker")
                  .maxDate(localCloudTime);
                $TabRRDContentControlsEndDate
                  .data("DateTimePicker")
                  .minDate(newMomentStartDate);

                $TabRRDContentControlsStartDate
                  .data("DateTimePicker")
                  .date(newMomentStartDate);

                $TabRRDContentControlsEndDate
                  .data("DateTimePicker")
                  .date(newMomentEndDate);
                // == Dates Range
              } else {
                timeRect.style("visibility", "hidden");
              }
            } else {
              if (
                !RRDGraphInfo.isNoValInLegend &&
                isTimestampInfoVisible &&
                !isAfterTimeavgRect
              ) {
                focus.style("display", null);
                RRDAxisTooltipElements[0].style("visibility", "visible");
                isTimestampInfoVisible = true;
              }
            }

            isMouseDown = isTimeavgRect = globIsRRDTimeavgRect = false;
          }
        }
      })
      .on("mouseover", function () {
        if (
          !RRDGraphInfo.isNoValInLegend &&
          (hasSeriesData)
        ) {
          if (!isMouseDown) {
            focus.style("display", null);
            RRDAxisTooltipElements[0].style("visibility", "visible");
            isTimestampInfoVisible = true;

            globCurrentGraphObject = this;
          }
        }
      })
      .on("mouseout", function () {
        if (hasSeriesData) {
          if (!isMouseDown) {
            if (!RRDGraphInfo.isNoValInLegend) {
              focus.style("display", "none");
              RRDAxisTooltipElements[0].style("visibility", "hidden");
              isTimestampInfoVisible = false;

              for (i = 0; i < graphTypesArr.length; ++i) {
                var legendTextVal = avgData[graphTypesArr[i]].toFixed(1);

                if (((graphTypesArr[i] === "modem_rsrp") || (graphTypesArr[i] === "modem_rsrq")) && (legendTextVal === "0.0")) {
                  legendTextVal = "NA";
                }

                legendValText[i].innerHTML =
                  legendTextVal + " " + RRDGraphInfo.yAxisLabel;
              }

              var isUpdateLegend =
                Array.isArray(d3.event.detail) && d3.event.detail[0] == -1111;

              if (!isUpdateLegend) {
                _.forEach(globTDGraphsHoverElements, function (value, key) {
                  if (
                    key !==
                    RRDGraphInfo.name +
                    tdata.childId +
                    (whichpim ? whichpim : "")
                  ) {
                    if (
                      (RRDGraphInfo.name.substring(0, 3) === "PIM" &&
                        key.substring(0, 3) !== "PIM") ||
                      (RRDGraphInfo.name.substring(0, 3) !== "PIM" &&
                        (key.substring(0, 3) === "PIM" ||
                          key === "MonitoringA" + tdata.childId)) ||
                      RRDGraphInfo.name === "MonitoringA"
                    ) {
                      return;
                    } else {
                      d3.select(globTDGraphsHoverElements[key]).dispatch(
                        "mouseout",
                        {
                          detail: [-1111],
                        }
                      );
                    }
                  }
                });
              }
            }
          } else {
            isMouseDown = isTimeavgRect = globIsRRDTimeavgRect = false;

            timeRect.style("visibility", "hidden");
          }
        }

        globCurrentGraphObject = null;
      })
      .on("mousemove", function mousemove() {
        if (hasSeriesData) {
          if (isMouseDown) {
            if (
              d3.event.clientX !== mouseDownCoords.x ||
              d3.event.clientY !== mouseDownCoords.y
            ) {
              if (!globIsRRDTimeavgRect) {
                isTimeavgRect = isAfterTimeavgRect = false;
              }

              if (isTimeavgRect) {
                mCoordinates = d3.mouse(this);

                var diffX = mCoordinates[0] - timeavgRectStartX;

                if (diffX >= 0) {
                  timeRect.attr("width", diffX + "px");
                } else {
                  timeRect
                    .attr("x", mCoordinates[0] + "px")
                    .attr("width", Math.abs(diffX) + "px");
                }

                var t1, t2;

                timeavgRectEndX = mCoordinates[0];

                t1 = +tScale.invert(timeavgRectStartX).toFixed(0);
                t2 = +tScale.invert(timeavgRectEndX).toFixed(0);

                if (t2 < t1) {
                  var tmpVal = t1;
                  t1 = t2;
                  t2 = tmpVal;
                }

                var startDate = t2 / 1000;
                var endDate = t1 / 1000;

                if (
                  (startDate - endDate) / 60 >=
                  RRD_GRAPH_MIN_MINUTES_FOR_ZOOM
                ) {
                  timeRect
                    // .attr('stroke', 'gray')
                    // .attr('fill',
                    // 'rgba(200,200,200,0.3)');
                    .attr("stroke", "rgb(126, 230, 0)") // Green
                    .attr("fill", "rgba(126, 230, 0,0.3)");
                } else {
                  timeRect
                    .attr("stroke", "red")
                    .attr("fill", "rgba(255,0,0,0.3)");
                }
              } else {
                mCoordinates = d3.mouse(this);

                timeavgRectStartX = mCoordinates[0];

                timeRect.attr("x", timeavgRectStartX + "px");

                timeRect.style("visibility", "visible");

                isTimeavgRect =
                  isAfterTimeavgRect =
                  globIsRRDTimeavgRect =
                  true;
                // isTimestampInfoVisible = false;
              }
            }
          } else {
            // CCC
            if (!RRDGraphInfo.isNoValInLegend) {
              var isUpdateLegend =
                Array.isArray(d3.event.detail) && d3.event.detail[0] == -1111;
              var isKeyboardEvent =
                Array.isArray(d3.event.detail) && d3.event.detail[0] != -1111;

              var finalPosIndex;
              var graphsFinalPosIndex = [];

              if (!isKeyboardEvent) {
                if (isUpdateLegend) {
                  mCoordinates = d3.event.detail[3];
                } else {
                  mCoordinates = d3.mouse(this);
                }
              }

              for (i = 0; i < graphTypesArr.length; ++i) {
                if (isKeyboardEvent) {
                  globCurrentRRDGraphsObjectLastXPosTimestamp[i] +=
                    d3.event.detail[0] * 61 * (isUCU ? 1000 : 1);
                  mCoordinates = [
                    +tScale(globCurrentRRDGraphsObjectLastXPosTimestamp[i]),
                    -1,
                  ];
                }

                /* Same shape as the spectrogram crosshair above: a graph type
                   with no rows leaves posData[key] undefined, and the bisector
                   reads .length off it. Skip that series instead. */
                if (
                  !posData[graphTypesArr[i]] ||
                  !posData[graphTypesArr[i]].length
                ) {
                  continue;
                }

                var bisectorLeft = d3.bisector(function (d) {
                  return d.x;
                }).left;

                var bisectorRight = d3.bisector(function (d) {
                  return d.x;
                }).right;

                var lBisect = bisectorLeft(
                  posData[graphTypesArr[i]],
                  mCoordinates[0]
                );
                var rBisect = bisectorRight(
                  posData[graphTypesArr[i]],
                  mCoordinates[0]
                );

                // console.log(lBisect, rBisect, posData[graphTypesArr[0]].length); // DDD

                if (lBisect !== rBisect) {
                  finalPosIndex = lBisect;
                } else {
                  if (
                    lBisect > 0 &&
                    lBisect < posData[graphTypesArr[i]].length
                  ) {
                    var x1 = posData[graphTypesArr[i]][lBisect - 1].x;
                    var x2 = posData[graphTypesArr[i]][lBisect].x;

                    // console.log(x1, x2); // DDD

                    if (
                      Math.abs(mCoordinates[0] - x1) <
                      Math.abs(mCoordinates[0] - x2)
                    ) {
                      finalPosIndex = lBisect - 1;
                    } else {
                      finalPosIndex = lBisect;
                    }
                  } else {
                    if (lBisect === 0) {
                      finalPosIndex = 0;
                    } else {
                      finalPosIndex = posData[graphTypesArr[i]].length - 1;
                    }
                  }
                }

                while (
                  finalPosIndex > 0 &&
                  finalPosIndex < data[graphTypesArr[i]].length - 1 &&
                  data[graphTypesArr[i]][finalPosIndex].timeStamp -
                  data[graphTypesArr[i]][finalPosIndex - 1].timeStamp >
                  lineStopThreshold
                ) {
                  ++finalPosIndex;
                }

                // if (isKeyboardEvent) { // not working because there are points which are not drawn because not enought points and this logic moves the circles to such points
                // 	if (finalPosIndex == globCurrentRRDGraphsObjectFinalPosIndex[i]) {
                // 		var newFinalPosIndex = finalPosIndex;

                // 		if ((d3.event.detail[0] == 1) && (finalPosIndex < posData[graphTypesArr[i]].length)) {
                // 			newFinalPosIndex = finalPosIndex + 1;
                // 		} else if ((d3.event.detail[0] == -1) && (finalPosIndex > 0)) {
                // 			newFinalPosIndex = finalPosIndex - 1;
                // 		}

                // 		if (finalPosIndex != newFinalPosIndex) {
                // 			finalPosIndex = newFinalPosIndex;
                // 			globCurrentRRDGraphsObjectFinalPosIndex[i] = newFinalPosIndex;
                // 			globCurrentRRDGraphsObjectLastXPosTimestamp[i] = tScale.invert(posData[graphTypesArr[i]][finalPosIndex].x);
                // 		}

                // 	}
                // }

                graphsFinalPosIndex[i] = finalPosIndex;

                if (!isUpdateLegend) {
                  if (!isKeyboardEvent) {
                    // globCurrentRRDGraphsObjectFinalPosIndex[i] = finalPosIndex;
                    globCurrentRRDGraphsObjectLastXPosTimestamp[i] =
                      tScale.invert(posData[graphTypesArr[i]][finalPosIndex].x);
                  }
                }
              }

              // ++ Time tooltip
              if (!isUpdateLegend) {
                var timeVal = +tScale
                  .invert(posData[graphTypesArr[0]][graphsFinalPosIndex[0]].x)
                  .toFixed(0);
                RRDAxisTooltipElements[0].text(
                  moment(timeVal).tz(globServerTimezone).format("MM-DD HH:mm")
                );

                rectCoordinates = hoverRect.node().getBoundingClientRect();

                var hoverRectClientCoordinates = RRDAxisTooltipElements[0]
                  .style("top", rectCoordinates.top + yAxisHeight + "px")
                  .style(
                    "left",
                    rectCoordinates.left +
                    posData[graphTypesArr[0]][graphsFinalPosIndex[0]].x +
                    "px"
                  );
              }
              // == Time tooltip

              // ++ Focus line and circles
              var y2ForX = posData[graphTypesArr[0]][graphsFinalPosIndex[0]].y;

              for (i = 1; i < graphTypesArr.length; ++i) {
                if (
                  posData[graphTypesArr[i]][graphsFinalPosIndex[i]] &&
                  posData[graphTypesArr[i]][graphsFinalPosIndex[i]].y < y2ForX
                ) {
                  y2ForX = posData[graphTypesArr[i]][graphsFinalPosIndex[i]].y;
                }
              }

              focus
                .select(".x")
                .attr("x1", posData[graphTypesArr[0]][graphsFinalPosIndex[0]].x)
                .attr("x2", posData[graphTypesArr[0]][graphsFinalPosIndex[0]].x)
                .attr(
                  "y1",
                  yAxisHeight + graphMarginRRD.top + graphInfoAreaHeight
                )
                .attr("y2", y2ForX);

              for (i = 0; i < graphTypesArr.length; ++i) {
                if (posData[graphTypesArr[i]][graphsFinalPosIndex[i]]) {
                  focus
                    .select("circle.y" + (i + 1))
                    .attr(
                      "transform",
                      "translate(" +
                      posData[graphTypesArr[i]][graphsFinalPosIndex[i]].x +
                      "," +
                      posData[graphTypesArr[i]][graphsFinalPosIndex[i]].y +
                      ")"
                    )
                    .style("visibility", "visible");

                  var legendTextVal = yAxisScale
                    .invert(posData[graphTypesArr[i]][graphsFinalPosIndex[i]].y)
                    .toFixed(1);

                  if (((graphTypesArr[i] === "modem_rsrp") || (graphTypesArr[i] === "modem_rsrq")) && (legendTextVal === "0.0")) {
                    legendTextVal = "NA";
                  }

                  legendValText[i].innerHTML =
                    (legendTextVal === "-0.0" ? 0 : legendTextVal) +
                    " " +
                    RRDGraphInfo.yAxisLabel;
                } else {
                  focus
                    .select("circle.y" + (i + 1))
                    .style("visibility", "hidden");

                  legendValText[i].innerHTML = "NA " + RRDGraphInfo.yAxisLabel;
                }
              }
              // == Focus line and circles

              if (isTimestampInfoVisible || isUpdateLegend) {
                focus.style("display", null);
                RRDAxisTooltipElements[0].style("visibility", "visible");
                isTimestampInfoVisible = true;
              }

              isAfterTimeavgRect = false;

              // Dispatch isUpdateLegend action to all other graphs.
              if (!isUpdateLegend) {
                _.forEach(globTDGraphsHoverElements, function (value, key) {
                  if (
                    key !==
                    RRDGraphInfo.name +
                    tdata.childId +
                    (whichpim ? whichpim : "")
                  ) {
                    if (
                      (RRDGraphInfo.name.substring(0, 3) === "PIM" &&
                        key.substring(0, 3) !== "PIM") ||
                      (RRDGraphInfo.name.substring(0, 3) !== "PIM" &&
                        (key.substring(0, 3) === "PIM" ||
                          key === "MonitoringA" + tdata.childId)) ||
                      RRDGraphInfo.name === "MonitoringA"
                    ) {
                      return;
                    } else {
                      d3.select(globTDGraphsHoverElements[key]).dispatch(
                        "mousemove",
                        {
                          detail: [
                            -1111,
                            graphsFinalPosIndex[0],
                            RRDGraphInfo.name,
                            mCoordinates,
                            isKeyboardEvent,
                            d3.event.detail[0],
                          ],
                        }
                      );
                    }
                  }
                });
              }
            }
          }
        }
      });

    // ++ Legend
    var legendG = containingG.append("g");

    // var legendRect = legendG.append('rect')
    // .attr('width', graphContentWidth + 'px')
    // // lWidth * tdata.data.length
    // // RRDGraphWidth - graphMarginRRD.left
    // .attr('height', RRD_GRAPH_LABELS_AREA_HEIGHT + 'px')
    // .style('fill', 'gray');
    var maxTextLabelX = 0;

    legendG
      .append("g")
      .selectAll("text")
      .data(graphTypesArr)
      .enter()
      .append("text")
      .attr("x", function (d, index) {
        var textOffset = 0;
        var offsetIndex = 0;
        var numUpps;

        for (var t = 0; t < index; ++t) {
          if (RRDGraphInfo[graphTypesArr[t]].isNewLine) {
            if (
              (RRDGraphInfo.name !== "InOutRSSI" &&
                /*(RRDGraphInfo.name !== 'ABInputsRSSI') && (RRDGraphInfo.name !== 'ABOutputRSSI') &&*/ RRDGraphInfo.name !==
                "AInOutRSSI" &&
                RRDGraphInfo.name !== "BInOutRSSI") ||
              (RRDGraphInfo.name === "InOutRSSI" &&
                RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                0 &&
                RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") === 0) ||
              (RRDGraphInfo.name === "AInOutRSSI" &&
                RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                0 &&
                RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") === 0) ||
              (RRDGraphInfo.name === "BInOutRSSI" &&
                RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                0 &&
                RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") === 0) // ||
              //((RRDGraphInfo.name === 'ABInputsRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Input B') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Input A') === 0)) ||
              //((RRDGraphInfo.name === 'ABInputsRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Input D') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Input C') === 0)) ||
              //((RRDGraphInfo.name === 'ABOutputRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Output B') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Output A') === 0)) ||
              //((RRDGraphInfo.name === 'ABOutputRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Output D') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Output C') === 0))
            ) {
              textOffset = offsetIndex = 0;
            } else {
              numUpps = (
                RRDGraphInfo[graphTypesArr[t]].label.match(/[A-Z]/g) || []
              ).length;
              textOffset +=
                (RRDGraphInfo[graphTypesArr[t]].label.length - numUpps) *
                RRD_GRAPH_LABELS_X_OFFSET_MULTIPLIER +
                numUpps * RRD_GRAPH_LABELS_X_OFFSET_MULTIPLIER_BIG;

              ++offsetIndex;
            }
          } else {
            numUpps = (
              RRDGraphInfo[graphTypesArr[t]].label.match(/[A-Z]/g) || []
            ).length;
            textOffset +=
              (RRDGraphInfo[graphTypesArr[t]].label.length - numUpps) *
              RRD_GRAPH_LABELS_X_OFFSET_MULTIPLIER +
              numUpps * RRD_GRAPH_LABELS_X_OFFSET_MULTIPLIER_BIG;

            ++offsetIndex;
          }
        }

        if (
          (RRDGraphInfo.name === "InOutRSSI" ||
            RRDGraphInfo.name === "AInOutRSSI" ||
            RRDGraphInfo.name === "BInOutRSSI") &&
          index > 0 &&
          RRDGraphInfo[graphTypesArr[index]].label.indexOf("Input") === 0
        ) {
          textOffset += RRD_GRAPH_LABELS_X_OFFSET_MULTIPLIER;
        }

        var returnX =
          RRD_GRAPH_LABELS_ICON_SIZE * (offsetIndex + 1) +
          graphMarginRRD.top +
          textOffset +
          RRD_GRAPH_LABELS_X_VAL_OFFSET * offsetIndex;

        if (RRDGraphInfo[graphTypesArr[index]].adjustXPos) {
          returnX += RRDGraphInfo[graphTypesArr[t]].adjustXPos;
        }

        if (returnX > maxTextLabelX) {
          maxTextLabelX = returnX;
        }

        return returnX;
      })
      .attr("y", function (d, index) {
        var yOffset = RRD_GRAPH_LABELS_Y_OFFSET_BEGIN;

        for (var t = 0; t < index; ++t) {
          if (RRDGraphInfo[graphTypesArr[t]].isNewLine) {
            if (
              (RRDGraphInfo.name !== "InOutRSSI" &&
                /*(RRDGraphInfo.name !== 'ABInputsRSSI') && (RRDGraphInfo.name !== 'ABOutputRSSI') &&*/ RRDGraphInfo.name !==
                "AInOutRSSI" &&
                RRDGraphInfo.name !== "BInOutRSSI") ||
              (RRDGraphInfo.name === "InOutRSSI" &&
                RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                0 &&
                RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") === 0) ||
              (RRDGraphInfo.name === "AInOutRSSI" &&
                RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                0 &&
                RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") === 0) ||
              (RRDGraphInfo.name === "BInOutRSSI" &&
                RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                0 &&
                RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") === 0) //||
              //((RRDGraphInfo.name === 'ABInputsRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Input B') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Input A') === 0)) ||
              //((RRDGraphInfo.name === 'ABInputsRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Input D') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Input C') === 0)) ||
              //((RRDGraphInfo.name === 'ABOutputRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Output B') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Output A') === 0)) ||
              //((RRDGraphInfo.name === 'ABOutputRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Output D') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Output C') === 0))
            ) {
              yOffset += RRD_GRAPH_LABELS_Y_OFFSET_NEXT;
            }
          }
        }

        return yOffset;
      })
      .text(function (d, index) {
        return (
          RRDGraphInfo[graphTypesArr[index]].label +
          (RRDGraphInfo.name === "Alarms"
            ? " (" + (RRDGraphInfo[graphTypesArr[index]].bit + 1) + ")"
            : "")
        );
      });

    var legendValText = [];
    var maxTextValX = 0;

    if (!RRDGraphInfo.isNoValInLegend) {
      legendG
        .append("g")
        .selectAll("text")
        .data(graphTypesArr)
        .enter()
        .append("text")
        .attr("x", function (d, index) {
          var textOffset = 0;
          var offsetIndex = 0;

          for (var t = 0; t < index; ++t) {
            if (RRDGraphInfo[graphTypesArr[t]].isNewLine) {
              if (
                (RRDGraphInfo.name !== "InOutRSSI" &&
                  /*(RRDGraphInfo.name !== 'ABInputsRSSI') && (RRDGraphInfo.name !== 'ABOutputRSSI') &&*/ RRDGraphInfo.name !==
                  "AInOutRSSI" &&
                  RRDGraphInfo.name !== "BInOutRSSI") ||
                (RRDGraphInfo.name === "InOutRSSI" &&
                  RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                  0 &&
                  RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") ===
                  0) ||
                (RRDGraphInfo.name === "AInOutRSSI" &&
                  RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                  0 &&
                  RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") ===
                  0) ||
                (RRDGraphInfo.name === "BInOutRSSI" &&
                  RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                  0 &&
                  RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") === 0) //||
                //((RRDGraphInfo.name === 'ABInputsRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Input B') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Input A') === 0)) ||
                //((RRDGraphInfo.name === 'ABInputsRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Input D') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Input C') === 0)) ||
                //((RRDGraphInfo.name === 'ABOutputRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Output B') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Output A') === 0)) ||
                //((RRDGraphInfo.name === 'ABOutputRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Output D') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Output C') === 0))
              ) {
                textOffset = offsetIndex = 0;
              } else {
                textOffset += RRDGraphInfo[graphTypesArr[t]].label.length;
                ++offsetIndex;
              }
            } else {
              textOffset += RRDGraphInfo[graphTypesArr[t]].label.length;
              ++offsetIndex;
            }
          }

          if (
            (RRDGraphInfo.name === "InOutRSSI" ||
              RRDGraphInfo.name === "AInOutRSSI" ||
              RRDGraphInfo.name === "BInOutRSSI") &&
            RRDGraphInfo[graphTypesArr[index]].label.indexOf("Input") === 0
          ) {
            textOffset += index + 1;
          }

          var returnX =
            RRD_GRAPH_LABELS_ICON_SIZE * (offsetIndex + 1) +
            graphMarginRRD.top +
            textOffset * RRD_GRAPH_LABELS_X_OFFSET_MULTIPLIER +
            RRD_GRAPH_LABELS_X_VAL_OFFSET * offsetIndex +
            (RRDGraphInfo[graphTypesArr[index]].label.length *
              RRD_GRAPH_LABELS_X_OFFSET_MULTIPLIER -
              5);

          if (RRDGraphInfo[graphTypesArr[index]].adjustXPos) {
            returnX += RRDGraphInfo[graphTypesArr[t]].adjustXPos;
          }

          if (RRDGraphInfo[graphTypesArr[index]].adjustValXPos) {
            returnX += RRDGraphInfo[graphTypesArr[t]].adjustValXPos;
          }

          if (returnX > maxTextValX) {
            maxTextValX = returnX;
          }

          return returnX;
        })
        .attr("y", function (d, index) {
          var yOffset = RRD_GRAPH_LABELS_Y_OFFSET_BEGIN;

          for (var t = 0; t < index; ++t) {
            if (RRDGraphInfo[graphTypesArr[t]].isNewLine) {
              if (
                (RRDGraphInfo.name !== "InOutRSSI" &&
                  /*(RRDGraphInfo.name !== 'ABInputsRSSI') && (RRDGraphInfo.name !== 'ABOutputRSSI') &&*/ RRDGraphInfo.name !==
                  "AInOutRSSI" &&
                  RRDGraphInfo.name !== "BInOutRSSI") ||
                (RRDGraphInfo.name === "InOutRSSI" &&
                  RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                  0 &&
                  RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") ===
                  0) ||
                (RRDGraphInfo.name === "AInOutRSSI" &&
                  RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                  0 &&
                  RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") ===
                  0) ||
                (RRDGraphInfo.name === "BInOutRSSI" &&
                  RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                  0 &&
                  RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") === 0) //||
                //((RRDGraphInfo.name === 'ABInputsRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Input B') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Input A') === 0)) ||
                //((RRDGraphInfo.name === 'ABInputsRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Input D') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Input C') === 0)) ||
                //((RRDGraphInfo.name === 'ABOutputRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Output B') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Output A') === 0)) ||
                //((RRDGraphInfo.name === 'ABOutputRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Output D') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Output C') === 0))
              ) {
                yOffset += RRD_GRAPH_LABELS_Y_OFFSET_NEXT;
              }
            }
          }

          return yOffset;
        })
        .html(function (d, index) {
          legendValText.push(this);

          return (
            avgData[graphTypesArr[index]].toFixed(1) +
            " " +
            RRDGraphInfo.yAxisLabel
          );
        });
    }

    legendG.attr(
      "transform",
      "translate(" +
      (graphMargin.left +
        RRDGraphWidth / 2 -
        (RRDGraphInfo.name === "Alarms"
          ? maxTextLabelX / 2
          : maxTextValX / 2) -
        (RRDGraphInfo.adjustLegend ? RRDGraphInfo.adjustLegend : 7) * 9) +
      "," +
      (RRDGraphHeight - RRD_GRAPH_LABELS_AREA_HEIGHT) +
      ")"
    );

    legendG
      .selectAll("rect")
      .data(graphTypesArr)
      .enter()
      .append("rect")
      .attr("x", function (d, index) {
        var textOffset = 0;
        var offsetIndex = 0;

        for (var t = 0; t < index; ++t) {
          if (RRDGraphInfo[graphTypesArr[t]].isNewLine) {
            if (
              (RRDGraphInfo.name !== "InOutRSSI" &&
                /*(RRDGraphInfo.name !== 'ABInputsRSSI') && (RRDGraphInfo.name !== 'ABOutputRSSI') &&*/ RRDGraphInfo.name !==
                "AInOutRSSI" &&
                RRDGraphInfo.name !== "BInOutRSSI") ||
              (RRDGraphInfo.name === "InOutRSSI" &&
                RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                0 &&
                RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") === 0) ||
              (RRDGraphInfo.name === "AInOutRSSI" &&
                RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                0 &&
                RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") === 0) ||
              (RRDGraphInfo.name === "BInOutRSSI" &&
                RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                0 &&
                RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") === 0) //||
              //((RRDGraphInfo.name === 'ABInputsRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Input B') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Input A') === 0)) ||
              //((RRDGraphInfo.name === 'ABInputsRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Input D') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Input C') === 0)) ||
              //((RRDGraphInfo.name === 'ABOutputRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Output B') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Output A') === 0)) |
              //((RRDGraphInfo.name === 'ABOutputRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Output D') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Output C') === 0))
            ) {
              textOffset = offsetIndex = 0;
            } else {
              textOffset += RRDGraphInfo[graphTypesArr[t]].label.length;
              ++offsetIndex;
            }
          } else {
            textOffset += RRDGraphInfo[graphTypesArr[t]].label.length;
            ++offsetIndex;
          }
        }

        if (
          (RRDGraphInfo.name === "InOutRSSI" ||
            RRDGraphInfo.name === "AInOutRSSI" ||
            RRDGraphInfo.name === "BInOutRSSI") &&
          index > 0 &&
          RRDGraphInfo[graphTypesArr[index]].label.indexOf("Input") === 0
        ) {
          ++textOffset;
        }

        var returnX =
          (textOffset === 0 ? 0 : RRD_GRAPH_LABELS_ICON_SIZE * offsetIndex) +
          textOffset * RRD_GRAPH_LABELS_X_OFFSET_MULTIPLIER +
          RRD_GRAPH_LABELS_X_VAL_OFFSET * offsetIndex;

        if (RRDGraphInfo[graphTypesArr[t]].adjustXPos) {
          returnX += RRDGraphInfo[graphTypesArr[t]].adjustXPos;
        }

        return returnX;
      })
      .attr("y", function (d, index) {
        var yOffset = RRD_GRAPH_LABELS_Y_OFFSET_BEGIN;

        for (var t = 0; t < index; ++t) {
          if (RRDGraphInfo[graphTypesArr[t]].isNewLine) {
            if (
              (RRDGraphInfo.name !== "InOutRSSI" &&
                /*(RRDGraphInfo.name !== 'ABInputsRSSI') && (RRDGraphInfo.name !== 'ABOutputRSSI') &&*/ RRDGraphInfo.name !==
                "AInOutRSSI" &&
                RRDGraphInfo.name !== "BInOutRSSI") ||
              (RRDGraphInfo.name === "InOutRSSI" &&
                RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                0 &&
                RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") === 0) ||
              (RRDGraphInfo.name === "AInOutRSSI" &&
                RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                0 &&
                RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") === 0) ||
              (RRDGraphInfo.name === "BInOutRSSI" &&
                RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf("Output") ===
                0 &&
                RRDGraphInfo[graphTypesArr[t]].label.indexOf("Input") === 0) //||
              //((RRDGraphInfo.name === 'ABInputsRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Input B') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Input A') === 0)) ||
              //((RRDGraphInfo.name === 'ABInputsRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Input D') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Input C') === 0)) ||
              //((RRDGraphInfo.name === 'ABOutputRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Output B') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Output A') === 0)) ||
              //((RRDGraphInfo.name === 'ABOutputRSSI') && (RRDGraphInfo[graphTypesArr[t + 1]].label.indexOf('Output D') === 0) && (RRDGraphInfo[graphTypesArr[t]].label.indexOf('Output C') === 0))
            ) {
              yOffset += RRD_GRAPH_LABELS_Y_OFFSET_NEXT;
            }
          }
        }

        return yOffset - RRD_GRAPH_LABELS_ICON_SIZE;
      })
      .attr("width", RRD_GRAPH_LABELS_ICON_SIZE + "px")
      .attr("height", RRD_GRAPH_LABELS_ICON_SIZE + "px")
      .style("fill", function (d, index) {
        return isHasOptixData
          ? RRDGraphInfo["line" + (index + 1)].color
          : RRDGraphInfo[graphTypesArr[index]].color;
      });
    // == Legend
  }

  function drawOptixModeGraphs(data) {
    for (
      var deviceIndex = 0;
      deviceIndex < data.devices.length;
      ++deviceIndex
    ) {
      var graphContainer = document.createElement("div");
      graphContainer.id = "OptixModeGraph" + deviceIndex;

      graphContainer.style.width = OptixModeGraphWidth + "px";
      graphContainer.style.height = OptixModeGraphHeight + "px";
      graphContainer.style.marginLeft = globGraphRectInlineSpaceRRD + "px";
      graphContainer.style.marginTop = 12 + "px";

      $TabOptixModeContentGraphsContainer.append(graphContainer);

      // var graphSeparator = document.createElement('div');
      // graphSeparator.className = 'rrd-graph-separator';
      // $TabOptixModeContentGraphsContainer.append(graphSeparator);

      drawOptixModeGraph(
        data.devices[deviceIndex],
        graphContainer,
        data.startSecEpoch,
        data.endSecEpoch
      );
    }
  }

  function drawOptixModeGraph(
    tdata,
    graphContainer,
    startSecEpoch,
    endSecEpoch
  ) {
    var optixModeGraphTitleHeight, optixModeGraphTimespanHeight;
    var tScale;
    var graphContentWidth;
    var yAxisHeight;
    var isHasData = false;
    var posData = [];

    var containingG = d3
      .select("#" + graphContainer.id)
      .append("svg")
      .attr("width", "100%")
      .attr("height", "100%");

    // ++ Graph's Title
    var optixUnitName = getDeviceGraphDisplayName(tdata["deviceName"]);
    var graphsTitle = optixUnitName + ": Optix Mode";

    var svgTitle = containingG
      .append("text")
      .attr(
        "x",
        graphMarginRRD.left +
        OptixModeGraphWidth / 2 -
        (graphsTitle.length / 2) * 9
      )
      .attr("font-weight", "bold")
      .text(graphsTitle);

    var svgTitleBBox = svgTitle.node().getBBox();

    optixModeGraphTitleHeight = svgTitleBBox.height;
    svgTitle.attr("y", optixModeGraphTitleHeight);
    optixModeGraphTitleHeight += 5;
    // == Graph's Title

    // ++ Graph's Timespan
    var timespanText =
      moment(parseInt(endSecEpoch * 1000))
        .tz(globServerTimezone)
        .format("MM-DD HH:mm") +
      " - " +
      moment(parseInt(startSecEpoch * 1000))
        .tz(globServerTimezone)
        .format("MM-DD HH:mm");

    var svgTimeSpan = containingG
      .append("text")
      .attr(
        "x",
        graphMarginRRD.left +
        OptixModeGraphWidth / 2 -
        (graphsTitle.length / 2.5) * 9 +
        ((graphsTitle.length - timespanText.length) / 2) * 9
      )
      .attr("font-style", "italic")
      .text(timespanText);

    if (globRRDGraphsZoomDates.length) {
      svgTimeSpan.attr("stroke", "violet");
    }

    var svgTimespanBBox = svgTimeSpan.node().getBBox();

    optixModeGraphTimespanHeight = svgTimespanBBox.height;
    svgTimeSpan.attr(
      "y",
      optixModeGraphTitleHeight + optixModeGraphTimespanHeight
    );
    optixModeGraphTimespanHeight += 5;
    // == Graph's Timespan

    // ++ Graph
    var graphInfoAreaHeight =
      optixModeGraphTitleHeight + optixModeGraphTimespanHeight;

    yAxisHeight =
      OptixModeGraphHeight -
      graphMarginRRD.bottomWide -
      graphMarginRRD.top -
      graphInfoAreaHeight -
      RRD_GRAPH_LABELS_AREA_HEIGHT;
    graphContentWidth = OptixModeGraphWidth - graphMarginRRD.left - 1;

    tScale = d3
      .scaleLinear()
      .domain([endSecEpoch, startSecEpoch])
      .range([0, graphContentWidth])
      .clamp(true);

    var yAxisScale = d3
      .scaleLinear()
      .domain([0, 50])
      .range([
        yAxisHeight + graphMarginRRD.top + graphInfoAreaHeight,
        graphMarginRRD.top + graphInfoAreaHeight,
      ]);

    // ++ Prepare data
    var graphData = [];
    for (var linkNumber = 0; linkNumber < tdata.data.length; ++linkNumber) {
      graphData[linkNumber] = [];

      for (var i = 0; i < tdata.data[linkNumber].optixModeData.length; ++i) {
        isHasData = true;

        if (tdata.deviceName == "ucu9997") {
          if (linkNumber == 0 || linkNumber == 1) {
            tdata.data[linkNumber].optixModeData[i]["linkStatus"] = 2;
          }
        } else if (tdata.deviceName == "ucu2635") {
          if (linkNumber == 0) {
            tdata.data[linkNumber].optixModeData[i]["linkStatus"] = 1;
          } else if (linkNumber == 1) {
            tdata.data[linkNumber].optixModeData[i]["linkStatus"] = 2;
          }
        }

        graphData[linkNumber][i * 2] = {
          secEpoch: tdata.data[linkNumber].optixModeData[i].startSecEpoch,
          optixMode: tdata.data[linkNumber].optixModeData[i].modeNumber,
          linkStatus: tdata.data[linkNumber].optixModeData[i].linkStatus,
        };

        graphData[linkNumber][i * 2 + 1] = {
          secEpoch: tdata.data[linkNumber].optixModeData[i].endSecEpoch,
          optixMode: tdata.data[linkNumber].optixModeData[i].modeNumber,
          linkStatus: tdata.data[linkNumber].optixModeData[i].linkStatus,
        };
      }
    }
    // == Prepare data

    // ++ Positional Data
    for (i = 0; i < 4; ++i) {
      posData["Link" + i] = [];

      if (graphData[i]) {
        for (var j = 0; j < graphData[i].length; ++j) {
          posData["Link" + i].push({
            x: +tScale(graphData[i][j].secEpoch).toFixed(2),
            y:
              yAxisScale((i + 1) * 10).toFixed(2) - globOptixModeRectHeight / 2, // +yAxisScale(graphData[i][j].optixMode).toFixed(2)
          });
        }
      }
    }
    // == Positional Data

    var reportThresholdSec = 5 * 60;

    for (var linkNumber = 0; linkNumber < tdata.data.length; ++linkNumber) {
      var optixModeContainer = containingG
        .append("g")
        .attr("transform", "translate(" + graphMarginRRD.left + "," + 0 + ")") // (graphMarginRRD.top + graphInfoAreaHeight) + ')')
        .attr("id", "OptixModeRectLink" + linkNumber);

      var optixModeContainerContent = optixModeContainer
        .selectAll("g")
        .data(tdata.data[linkNumber].optixModeData)
        .enter()
        .append("g")
        .attr("data-epoch", function drawOptixModeRect_attr1(d, i) {
          return d.startSecEpoch;
        });

      optixModeContainerContent
        .append("rect")
        .attr("x", function drawOptixModeRect_attr2(d, i) {
          return tScale(d.startSecEpoch).toFixed(2);
        })
        .attr(
          "y",
          yAxisScale((linkNumber + 1) * 10).toFixed(2) -
          globOptixModeRectHeight / 2
        )
        .attr("width", function (d, i) {
          var rectWidth = 0;

          if (d.endSecEpoch) {
            if (i < tdata.data[linkNumber].optixModeData.length - 1) {
              if (
                tdata.data[linkNumber].optixModeData[i + 1].startSecEpoch -
                d.endSecEpoch <=
                reportThresholdSec
              ) {
                rectWidth =
                  tScale(
                    tdata.data[linkNumber].optixModeData[i + 1].startSecEpoch
                  ).toFixed(2) - tScale(d.startSecEpoch).toFixed(2);
              } else {
                rectWidth =
                  tScale(d.endSecEpoch).toFixed(2) -
                  tScale(d.startSecEpoch).toFixed(2);
              }
            } else {
              rectWidth =
                tScale(+d.endSecEpoch + reportThresholdSec).toFixed(2) -
                tScale(d.startSecEpoch).toFixed(2);
            }
          }

          return svgSpan(rectWidth);
        })
        .attr("height", globOptixModeRectHeight)
        .attr("stroke-width", 0)
        .attr("class", function drawOptixModeRect_class1(d, i) {
          return optixModeClass(d.modeNumber);
        });
      // .append('svg:title')
      // .text(function (d, i) {
      // 	return globOptixModeGraphs['mode' + d.modeNumber].title;
      // });

      if (isUserRole("Display Status In Tree")) {
        optixModeContainerContent
          .filter((d) => d.linkStatus != 0)
          .append("rect")
          .attr("x", function drawOptixModeRect_attr2(d, i) {
            return tScale(d.startSecEpoch).toFixed(2);
          })
          .attr(
            "y",
            (
              yAxisScale((linkNumber + 1) * 10) +
              globOptixModeRectHeight +
              1
            ).toFixed(2) -
            globOptixModeRectHeight / 2
          )
          .attr("width", function (d, i) {
            var rectWidth = 0;

            if (d.endSecEpoch) {
              if (i < tdata.data[linkNumber].optixModeData.length - 1) {
                if (
                  tdata.data[linkNumber].optixModeData[i + 1].startSecEpoch -
                  d.endSecEpoch <=
                  reportThresholdSec
                ) {
                  rectWidth =
                    tScale(
                      tdata.data[linkNumber].optixModeData[i + 1].startSecEpoch
                    ).toFixed(2) - tScale(d.startSecEpoch).toFixed(2);
                } else {
                  rectWidth =
                    tScale(d.endSecEpoch).toFixed(2) -
                    tScale(d.startSecEpoch).toFixed(2);
                }
              } else {
                rectWidth =
                  tScale(+d.endSecEpoch + reportThresholdSec).toFixed(2) -
                  tScale(d.startSecEpoch).toFixed(2);
              }
            }

            return svgSpan(rectWidth);
          })
          .attr("height", globOptixModeRectHeight)
          .attr("stroke-width", 0)
          .style("fill", function drawOptixModeRect_style1(d, i) {
            return globLinkStatusModeGraphs["status" + d.linkStatus].color;
          });
        // .append('svg:title')
        // .text(function (d, i) {
        // 	return globLinkStatusModeGraphs['status' + d.linkStatus].title;
        // });
      }
    }
    // == Graph

    // ++ Y-Axis
    var yAxisTicksScale = d3
      .scaleLinear()
      .domain([0, 5])
      .range([
        yAxisHeight + graphMarginRRD.top + graphInfoAreaHeight,
        graphMarginRRD.top + graphInfoAreaHeight,
      ]);

    var powerSeries = [0, 1, 2, 3, 4, 5];

    var yAxis = d3
      .axisLeft()
      .tickValues(powerSeries)
      // .tickSizeInner(-spectrogramWindow1GraphWidth - graphMarginRRD.left)
      // .tickPadding(10)
      // .tickFormat(d3.format(',.1f'))
      .scale(yAxisTicksScale);

    containingG
      .append("g")
      .attr("transform", "translate(" + graphMarginRRD.left + "," + 0 + ")")
      // .style('stroke', 'white')
      .call(yAxis);

    // Grid lines
    containingG
      .append("g")
      .attr("class", "ygrid")
      .attr("transform", "translate(" + graphMarginRRD.left + "," + 0 + ")")
      .call(yAxis.tickSize(-graphContentWidth).tickFormat(""));

    // label
    containingG
      .append("g")
      .attr(
        "transform",
        "translate(" +
        5 +
        "," +
        (yAxisHeight + graphMarginRRD.top + graphInfoAreaHeight + 4) / 2 +
        ")"
      )
      .append("text")
      .style("font-size", ".9em")
      .html("Link");
    // == Y-Axis

    // ++ X-Axis
    var tAxisTicksScale = d3
      .scaleLinear()
      .domain([parseInt(endSecEpoch) * 1000, parseInt(startSecEpoch) * 1000])
      .range([0, graphContentWidth])
      .clamp(true);

    var timeSeries = [];
    // var xStep = 3600000 * 2; // 3600000 = 1 hour
    var startEpoch = parseInt(startSecEpoch) * 1000;
    var endEpoch = parseInt(endSecEpoch) * 1000;
    var xStep = Math.ceil((startEpoch - endEpoch) / 20);
    for (var k = endEpoch; k <= startEpoch; k += xStep) {
      timeSeries[timeSeries.length] = k;
    }

    var xAxis = d3
      .axisBottom()
      .tickValues(timeSeries)
      // .tickFormat(d3.timeFormat("%Y-%m-%d %H:%M"))
      // .tickFormat(d3.timeFormat("%m-%d %H:%M"))
      .tickFormat(function (d) {
        return moment(d).tz(globServerTimezone).format("MM-DD HH:mm");
      })
      .scale(tAxisTicksScale);

    containingG
      .append("g")
      .attr(
        "transform",
        "translate(" +
        graphMarginRRD.left +
        "," +
        (yAxisHeight + graphMarginRRD.top + graphInfoAreaHeight) +
        ")"
      )
      .call(xAxis)
      .selectAll("text")
      .style("text-anchor", "end")
      .attr("dx", "-.8em")
      .attr("dy", ".15em")
      .attr("transform", "rotate(-45)");

    // Grid lines
    containingG
      .append("g")
      .attr("class", "xgrid")
      .attr(
        "transform",
        "translate(" +
        graphMarginRRD.left +
        "," +
        (yAxisHeight + graphMarginRRD.top + graphInfoAreaHeight) +
        ")"
      )
      .call(xAxis.tickSize(-yAxisHeight).tickFormat(""));
    // == X-Axis

    // ++ Crosshairs
    var focus = containingG
      .append("g")
      .attr("transform", "translate(" + graphMarginRRD.left + "," + 0 + ")")
      .style("display", "none");

    // append the x line
    focus
      .append("line")
      .attr("class", "x")
      .style("stroke", "black")
      .style("stroke-width", "2px")
      .style("stroke-dasharray", "3,2")
      .style("opacity", 0.9);

    for (i = 0; i < 4; ++i) {
      // append the circle1 at the intersection
      focus
        .append("circle")
        .attr("class", "y" + (i + 1))
        .style("fill", "none")
        .style("stroke", "black") // RRDGraphInfo[graphTypesArr[i]].color
        .style("stroke-width", "2px")
        // . style('visibility', 'hidden')
        .style("opacity", 0.3)
        .attr("r", 4);
    }
    // == Crosshairs

    // Rect for Time AVG
    var timeRectContainer = d3
      .select("#" + graphContainer.id + " svg")
      .append("g")
      .attr("class", "rrd-timerect-container")
      .style("visibility", "hidden")
      .attr(
        "transform",
        "translate(" +
        graphMarginRRD.left +
        "," +
        (graphMarginRRD.top + graphInfoAreaHeight) +
        ")"
      );

    var timeRect = timeRectContainer
      .append("rect")
      .attr("class", "rrd-timerect")
      .attr("width", 0 + "px")
      .attr("stroke", "gray")
      .attr("stroke-width", 1)
      // .attr('stroke-dasharray', '10, 5, 4, 5')
      .attr("stroke-dasharray", "3,2")
      .attr("fill", "rgba(200,200,200,0.3)");

    // Hover rect
    var hoverRect;
    hoverRect = containingG
      .append("rect")
      .attr("class", "rrdHoverRect")
      .attr(
        "transform",
        "translate(" +
        graphMarginRRD.left +
        "," +
        (graphMarginRRD.top + graphInfoAreaHeight) +
        ")"
      )
      .attr("width", svgSpan(graphContentWidth))
      .attr("height", svgSpan(yAxisHeight))
      .attr("fill", "rgba(0, 0, 0, 0)");

    var rectCoordinates = hoverRect.node().getBoundingClientRect();

    timeRect.attr("height", svgSpan(rectCoordinates.height));

    var isMouseDown,
      isTimeavgRect,
      isTimestampInfoVisible,
      mouseDownCoords,
      timeavgRectStartX,
      timeavgRectEndX,
      mCoordinates;

    isMouseDown = isTimeavgRect = isTimestampInfoVisible = false;

    hoverRect
      .style("pointer-events", "all")
      .on("mousedown", function mouseout(d, i) {
        if (
          isHasData &&
          (startSecEpoch - endSecEpoch) / 60 >= RRD_GRAPH_MIN_MINUTES_FOR_ZOOM
        ) {
          mouseDownCoords = {
            x: d3.event.clientX,
            y: d3.event.clientY,
          };

          if (d3.event.which === 1) {
            // Left click.
            console.log("OPTiX Mode hoverRect mousedown (left click)");

            isMouseDown = true;
            isTimeavgRect = globIsRRDTimeavgRect = false;

            timeRect.attr("width", 0 + "px");

            focus.style("display", "none");
            OptixModeAxisTooltipElement.style("visibility", "hidden");
            isTimestampInfoVisible = false;

            d3.event.preventDefault();
          }
        }
      })
      .on("contextmenu", function rrdContextMenu(d, i) {
        if (globRRDGraphsZoomDates.length) {
          var zoomOutData = globRRDGraphsZoomDates.pop();

          focus.style("display", "none");
          OptixModeAxisTooltipElement.style("visibility", "hidden");

          if (globIsParentSummaryRRDGraphs) {
            /*
            setTimeout(
              tabRRDGraphsContentControlsGo(null, {
                startDate : zoomOutData.startMsecEpoch,
                endDate : zoomOutData.endMsecEpoch
              },
                true),
              0);
            */
          } else {
            setTimeout(
              tabOptixModeGraphsContentControlsGo({
                startDate: zoomOutData.startMsecEpoch,
                endDate: zoomOutData.endMsecEpoch,
              }),
              0
            );
          }

          // ++ Dates Range
          var tmpStartTimeCloud = moment.tz(
            zoomOutData.endMsecEpoch * 1000,
            globServerTimezone
          );
          var newMomentStartDate = moment(
            new Date(tmpStartTimeCloud.format("ddd, DD MMM YYYY HH:mm"))
          );

          var tmpEndTimeCloud = moment.tz(
            zoomOutData.startMsecEpoch * 1000,
            globServerTimezone
          );
          var newMomentEndDate = moment(
            new Date(tmpEndTimeCloud.format("ddd, DD MMM YYYY HH:mm"))
          );

          var nowCloud = moment().tz(globServerTimezone);
          var localCloudTime = moment(
            new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
          );

          globOptixModeIsNOPDatesRangeFuncs = true;

          $TabOptixModeContentControlsStartDate
            .data("DateTimePicker")
            .maxDate(newMomentEndDate);
          $TabOptixModeContentControlsEndDate
            .data("DateTimePicker")
            .minDate(newMomentStartDate);
          $TabOptixModeContentControlsEndDate
            .data("DateTimePicker")
            .maxDate(localCloudTime);

          $TabOptixModeContentControlsStartDate
            .data("DateTimePicker")
            .date(newMomentStartDate);

          $TabOptixModeContentControlsEndDate
            .data("DateTimePicker")
            .date(newMomentEndDate);
          // == Dates Range
        }

        d3.event.preventDefault();

        return false;
      })
      .on("mouseup", function mouseout(d, i) {
        if (isHasData) {
          if (d3.event.which === 1) {
            // Left click.
            console.log("optIx Mode hoverRect mouseup (left click)"); // DDD

            if (isTimeavgRect) {
              var mCoordinates = d3.mouse(this);
              var t1, t2;

              timeavgRectEndX = mCoordinates[0];

              t1 = +tScale.invert(timeavgRectStartX).toFixed(0);
              t2 = +tScale.invert(timeavgRectEndX).toFixed(0);

              if (t2 < t1) {
                var tmpVal = t1;
                t1 = t2;
                t2 = tmpVal;
              }

              console.log("t1 = ", t1, ", t2 = ", t2); // DDD

              var startDate = t2;
              var endDate = t1;

              if (
                (startDate - endDate) / 60 >=
                RRD_GRAPH_MIN_MINUTES_FOR_ZOOM
              ) {
                console.log(
                  "Zoom in for startDate = ",
                  startDate,
                  ", endDate = ",
                  endDate
                ); // DDD

                globRRDGraphsZoomDates.push({
                  startMsecEpoch: parseInt(startSecEpoch),
                  endMsecEpoch: parseInt(endSecEpoch),
                });

                focus.style("display", "none");
                OptixModeAxisTooltipElement.style("visibility", "hidden");
                isTimestampInfoVisible = false;

                setTimeout(
                  tabOptixModeGraphsContentControlsGo({
                    startDate: startDate,
                    endDate: endDate,
                  }),
                  0
                );

                // ++ Dates Range
                var tmpStartTimeCloud = moment.tz(
                  endDate * 1000,
                  globServerTimezone
                );
                var newMomentStartDate = moment(
                  new Date(tmpStartTimeCloud.format("ddd, DD MMM YYYY HH:mm"))
                );

                var tmpEndTimeCloud = moment.tz(
                  startDate * 1000,
                  globServerTimezone
                );
                var newMomentEndDate = moment(
                  new Date(tmpEndTimeCloud.format("ddd, DD MMM YYYY HH:mm"))
                );

                var nowCloud = moment().tz(globServerTimezone);
                var localCloudTime = moment(
                  new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
                );

                globOptixModeIsNOPDatesRangeFuncs = true;
                $TabOptixModeContentControlsStartDate
                  .data("DateTimePicker")
                  .maxDate(newMomentEndDate);
                $TabOptixModeContentControlsEndDate
                  .data("DateTimePicker")
                  .maxDate(localCloudTime);
                $TabOptixModeContentControlsEndDate
                  .data("DateTimePicker")
                  .minDate(newMomentStartDate);

                $TabOptixModeContentControlsStartDate
                  .data("DateTimePicker")
                  .date(newMomentStartDate);

                $TabOptixModeContentControlsEndDate
                  .data("DateTimePicker")
                  .date(newMomentEndDate);
                // == Dates Range
              } else {
                timeRect.style("visibility", "hidden");

                isTimestampInfoVisible = true;
              }
            } else {
              isTimestampInfoVisible = true;
            }

            isMouseDown = isTimeavgRect = globIsRRDTimeavgRect = false;
          }
        }
      })
      .on("mouseover", function () {
        if (isHasData) {
          if (!isMouseDown) {
            // focus.style('display', null);
            // OptixModeAxisTooltipElement.style('visibility', 'visible');
            isTimestampInfoVisible = true;
          }
        }
      })
      .on("mouseout", function () {
        if (isHasData) {
          if (!isMouseDown) {
            focus.style("display", "none");

            /* Back to the resting state — each link's latest sample — rather
               than blanking every entry to "NA". */
            showOptixLegendLatest();

            OptixModeAxisTooltipElement.style("visibility", "hidden");
            isTimestampInfoVisible = false;
          }
        }
      })
      .on("mousemove", function mousemove() {
        if (isHasData) {
          if (isMouseDown) {
            if (
              d3.event.clientX !== mouseDownCoords.x ||
              d3.event.clientY !== mouseDownCoords.y
            ) {
              if (!globIsRRDTimeavgRect) {
                isTimeavgRect = false;
              }

              if (isTimeavgRect) {
                mCoordinates = d3.mouse(this);

                var diffX = mCoordinates[0] - timeavgRectStartX;

                if (diffX >= 0) {
                  timeRect.attr("width", diffX + "px");
                } else {
                  timeRect
                    .attr("x", mCoordinates[0] + "px")
                    .attr("width", Math.abs(diffX) + "px");
                }

                var t1, t2;

                timeavgRectEndX = mCoordinates[0];

                t1 = +tScale.invert(timeavgRectStartX).toFixed(0);
                t2 = +tScale.invert(timeavgRectEndX).toFixed(0);

                if (t2 < t1) {
                  var tmpVal = t1;
                  t1 = t2;
                  t2 = tmpVal;
                }

                var startDate = t2;
                var endDate = t1;

                if (
                  (startDate - endDate) / 60 >=
                  RRD_GRAPH_MIN_MINUTES_FOR_ZOOM
                ) {
                  timeRect
                    .attr("stroke", "rgb(126, 230, 0)") // Green
                    .attr("fill", "rgba(126, 230, 0,0.3)");
                } else {
                  timeRect
                    .attr("stroke", "red")
                    .attr("fill", "rgba(255,0,0,0.3)");
                }
              } else {
                mCoordinates = d3.mouse(this);

                timeavgRectStartX = mCoordinates[0];

                timeRect.attr("x", timeavgRectStartX + "px");

                timeRect.style("visibility", "visible");

                isTimeavgRect = globIsRRDTimeavgRect = true;
                // isTimestampInfoVisible = false;
              }
            }
          } else {
            var isKeyboardEvent =
              Array.isArray(d3.event.detail) && d3.event.detail[0] != -1111;

            var finalPosIndex;

            /*
            if (!isKeyboardEvent) {
              mCoordinates = d3.mouse(this);

              ...
            }
            */

            mCoordinates = d3.mouse(this);

            // ++ Focus line and circles
            var linkForFocusLineY = -1;
            var linksYForCircles = [];
            var linksModeValForLegend = [];
            var linksStatusValForLegend = [];

            for (
              var linkNumber = 0;
              linkNumber < tdata.data.length;
              ++linkNumber
            ) {
              if (posData["Link" + linkNumber].length) {
                linksYForCircles[linkNumber] = -1;
                linksModeValForLegend[linkNumber] = -1;
                linksStatusValForLegend[linkNumber] = -1;

                for (
                  var i = 0;
                  i < posData["Link" + linkNumber].length / 2;
                  ++i
                ) {
                  var x1 = posData["Link" + linkNumber][i * 2].x;
                  var x2 = posData["Link" + linkNumber][i * 2 + 1].x;

                  if (mCoordinates[0] >= x1 && mCoordinates[0] <= x2) {
                    linkForFocusLineY = linkNumber;

                    linksYForCircles[linkNumber] =
                      posData["Link" + linkNumber][i * 2].y;
                    linksModeValForLegend[linkNumber] =
                      graphData[linkNumber][i * 2].optixMode;
                    linksStatusValForLegend[linkNumber] =
                      graphData[linkNumber][i * 2].linkStatus;
                  }
                }
              }
            }

            if (linkForFocusLineY != -1) {
              focus
                .select(".x")
                .attr("x1", mCoordinates[0])
                .attr("x2", mCoordinates[0])
                .attr(
                  "y1",
                  yAxisHeight + graphMarginRRD.top + graphInfoAreaHeight
                )
                .attr("y2", posData["Link" + linkForFocusLineY][0].y);

              // ++ Time tooltip
              var timeVal = +tScale.invert(mCoordinates[0]).toFixed(0);
              OptixModeAxisTooltipElement.text(
                moment(timeVal * 1000)
                  .tz(globServerTimezone)
                  .format("MM-DD HH:mm")
              );

              rectCoordinates = hoverRect.node().getBoundingClientRect();

              OptixModeAxisTooltipElement.style(
                "top",
                rectCoordinates.top + yAxisHeight + "px"
              ).style("left", rectCoordinates.left + mCoordinates[0] + "px");
              // == Time tooltip
            }

            var legendTextVal;

            for (
              var linkNumber = 0;
              linkNumber < tdata.data.length;
              ++linkNumber
            ) {
              if (
                linksYForCircles[linkNumber] &&
                linksYForCircles[linkNumber] != -1
              ) {
                focus
                  .select("circle.y" + (linkNumber + 1))
                  .attr(
                    "transform",
                    "translate(" +
                    mCoordinates[0] +
                    "," +
                    linksYForCircles[linkNumber] +
                    ")"
                  )
                  .style("visibility", "visible");

                if (
                  isUserRole("Display Status In Tree") &&
                  linksStatusValForLegend[linkNumber] != 0
                ) {
                  legendTextVal =
                    globOptixModeGraphs[
                      "mode" + linksModeValForLegend[linkNumber]
                    ].title +
                    "," +
                    globLinkStatusModeGraphs[
                      "status" + linksStatusValForLegend[linkNumber]
                    ].title;
                } else {
                  legendTextVal =
                    globOptixModeGraphs[
                      "mode" + linksModeValForLegend[linkNumber]
                    ].title;
                }
              } else {
                focus
                  .select("circle.y" + (linkNumber + 1))
                  .style("visibility", "hidden");

                legendTextVal = "NA";
              }

              legendValText[linkNumber].innerHTML = legendTextVal;

              /* Keep the swatch in step with the text, so the key matches the
                 line it refers to. */
              if (legendValIcons[linkNumber]) {
                legendValIcons[linkNumber].setAttribute(
                  "class",
                  legendTextVal === "NA"
                    ? "optix-mode-na"
                    : optixModeClass(linksModeValForLegend[linkNumber])
                );
              }
            }
            // == Focus line and circles

            if (isTimestampInfoVisible) {
              focus.style("display", null);
              OptixModeAxisTooltipElement.style("visibility", "visible");
            }
          }
        }
      });

    var OptixModeAxisTooltipElement = d3
      .select("#" + graphContainer.id)
      .append("div")
      .style("visibility", "hidden")
      .style("position", "fixed")
      .style("z-index", "10")
      .style("background", "rgba(0,0,0,0.5)")
      // .style("background", 'rgba(0,0,0,0.2)')
      .style("border", "1px solid lightgray")
      .style("border-radius", "2px")
      .style("padding", "2px 3px")
      .style("color", "white");

    // ++ Legend
    var legendDataText = ["Link 1", "Link 2", "Link 3", "Link 4"];

    var maxTextLabelX = 0;

    var legendG = containingG.append("g");

    // ++ Labels
    legendG
      .append("g")
      .selectAll("text")
      .data(legendDataText)
      .enter()
      .append("text")
      .attr("x", function (d, index) {
        var textOffset = 0;
        var offsetIndex = 0;
        var numUpps;

        for (var t = 0; t < index; ++t) {
          numUpps = (legendDataText[t].match(/[A-Z]/g) || []).length;
          textOffset +=
            (legendDataText[t].length - numUpps) *
            RRD_GRAPH_LABELS_X_OFFSET_MULTIPLIER +
            numUpps * RRD_GRAPH_LABELS_X_OFFSET_MULTIPLIER_BIG +
            60;

          ++offsetIndex;
        }

        //if (((RRDGraphInfo.name === 'InOutRSSI') || (RRDGraphInfo.name === 'AInOutRSSI') || (RRDGraphInfo.name === 'BInOutRSSI')) && (index > 0) && (RRDGraphInfo[graphTypesArr[index]].label.indexOf('Input') === 0)) {
        //	textOffset += RRD_GRAPH_LABELS_X_OFFSET_MULTIPLIER;
        //}

        var returnX =
          RRD_GRAPH_LABELS_ICON_SIZE * (offsetIndex + 1) +
          graphMarginRRD.top +
          textOffset +
          RRD_GRAPH_LABELS_X_VAL_OFFSET * offsetIndex;

        //if (RRDGraphInfo[graphTypesArr[index]].adjustXPos) {
        //	returnX += RRDGraphInfo[graphTypesArr[t]].adjustXPos;
        //}

        if (returnX > maxTextLabelX) {
          maxTextLabelX = returnX;
        }

        return returnX;
      })
      .attr("y", function (d, index) {
        var yOffset = RRD_GRAPH_LABELS_Y_OFFSET_BEGIN;

        return yOffset;
      })
      .text(function (d, index) {
        return legendDataText[index];
      });
    // == Labels

    // ++ Values
    var legendDataVal = ["Link1", "Link2", "Link3", "Link4"];

    var legendValText = [];

    /* Swatch rects, kept in step with legendValText so the icon and the text
       for a link are always updated together. */
    var legendValIcons = [];

    var maxTextValX = 0;

    /*
     * Show each link's most recent sample in the legend.
     *
     * This is the resting state: it runs once after the legend is built, and
     * again whenever the cursor leaves the plot. Previously neither happened —
     * the legend only filled in on mousemove and was reset to a bare "NA" on
     * mouseout, so the graph was unreadable except while being actively
     * hovered, which is not how it is usually looked at.
     *
     * graphData[link] is ordered, so the last element is the latest sample.
     * Text and swatch follow the same rules as the hover path so the two
     * cannot drift apart. Declared here and hoisted, since mouseout is wired
     * up before this point in the function.
     */
    function showOptixLegendLatest() {
      for (var link = 0; link < legendValText.length; ++link) {
        var points = graphData[link];
        var latest = points && points.length ? points[points.length - 1] : null;
        var mode = latest ? globOptixModeGraphs["mode" + latest.optixMode] : null;

        if (!mode) {
          /* No data, or a mode the palette does not know. Say so plainly
             rather than showing a stale value from another link. */
          legendValText[link].innerHTML = "NA";

          if (legendValIcons[link]) {
            legendValIcons[link].setAttribute("class", "optix-mode-na");
          }

          continue;
        }

        var text = mode.title;
        var status = globLinkStatusModeGraphs["status" + latest.linkStatus];

        if (
          isUserRole("Display Status In Tree") &&
          latest.linkStatus != 0 &&
          status
        ) {
          text += "," + status.title;
        }

        legendValText[link].innerHTML = text;

        if (legendValIcons[link]) {
          legendValIcons[link].setAttribute(
            "class",
            optixModeClass(latest.optixMode)
          );
        }
      }
    }

    legendG
      .append("g")
      .selectAll("text")
      .data(legendDataVal)
      .enter()
      .append("text")
      .attr("x", function (d, index) {
        var textOffset = 0;
        var offsetIndex = 0;

        for (var t = 0; t < index; ++t) {
          textOffset += legendDataText[t].length;
          ++offsetIndex;
        }

        var returnX =
          RRD_GRAPH_LABELS_ICON_SIZE * (offsetIndex + 1) +
          graphMarginRRD.top +
          textOffset * RRD_GRAPH_LABELS_X_OFFSET_MULTIPLIER +
          RRD_GRAPH_LABELS_X_VAL_OFFSET * offsetIndex +
          (legendDataText[index].length * RRD_GRAPH_LABELS_X_OFFSET_MULTIPLIER -
            5) +
          offsetIndex * 60;

        if (returnX > maxTextValX) {
          maxTextValX = returnX;
        }

        return returnX;
      })
      .attr("y", function (d, index) {
        var yOffset = RRD_GRAPH_LABELS_Y_OFFSET_BEGIN;

        return yOffset;
      })
      .html(function (d, index) {
        legendValText.push(this);

        return "NA";
      });

    legendG.attr(
      "transform",
      "translate(" +
      (graphMargin.left + OptixModeGraphWidth / 2 - maxTextValX / 2 - 7 * 9) +
      "," +
      (OptixModeGraphHeight - RRD_GRAPH_LABELS_AREA_HEIGHT) +
      ")"
    );
    // == Values

    // ++ Icons
    legendG
      .selectAll("rect")
      .data(legendDataVal)
      .enter()
      .append("rect")
      .attr("x", function (d, index) {
        var textOffset = 0;
        var offsetIndex = 0;

        for (var t = 0; t < index; ++t) {
          textOffset += legendDataText[t].length;
          ++offsetIndex;
        }

        var returnX =
          (textOffset === 0 ? 0 : RRD_GRAPH_LABELS_ICON_SIZE * offsetIndex) +
          textOffset * RRD_GRAPH_LABELS_X_OFFSET_MULTIPLIER +
          RRD_GRAPH_LABELS_X_VAL_OFFSET * offsetIndex +
          offsetIndex * 60;

        return returnX;
      })
      .attr("y", function (d, index) {
        var yOffset = RRD_GRAPH_LABELS_Y_OFFSET_BEGIN;

        return yOffset - RRD_GRAPH_LABELS_ICON_SIZE;
      })
      .attr("width", RRD_GRAPH_LABELS_ICON_SIZE + "px")
      .attr("height", RRD_GRAPH_LABELS_ICON_SIZE + "px")
      /*
       * Was a hardcoded black for every entry, so the swatch never matched the
       * line it labelled — a Bypass link drew fuchsia but was keyed with a
       * black square. Captured here the same way the value text is, and
       * recoloured alongside it as the cursor moves. Starts at "na" because
       * no mode is known until the first hover.
       */
      .attr("class", function (d, index) {
        legendValIcons.push(this);

        return "optix-mode-na";
      });
    // == Icons

    showOptixLegendLatest();

    // == Legend
  }

  function drawRRDGraphs(data, isZooming, isUCU) {
    var graphsData;

    /*
     * Empty the container here, not only when a request starts.
     *
     * getUbifixRRDData() and its siblings already clear it alongside
     * rrdAjaxUi(true), which is enough for one request at a time. It is not
     * enough for two in flight: both clear up front, then both responses
     * append after the last clear, so the second render lands on top of the
     * first and every graph is drawn twice, titles overlapping the previous
     * graph's legend. Clearing at render time means whichever response draws
     * last leaves a clean, complete set.
     *
     * The GO button is disabled for the duration, so this is not normally
     * reachable by clicking; it is reachable by keyboard, by re-triggering
     * the handler directly, or by changing node mid-request.
     */
    $TabRRDContentGraphsContainer.html("");

    globIsParentSummaryRRDGraphs = false;

    globTDGraphsLookupForFilter = [];

    globTDGraphsHoverElements = {};

    if (isUCU) {
      graphsData = globUCUGraphs;
    } else {
      graphsData = globRRDGraphs;
    }

    if (!isZooming) {
      globRRDGraphsZoomDates = [];
    }

    for (var i = 0; i < graphsData.length; ++i) {
      if (graphsData[i].isGraphPerAnt) {
        // One graph for each ant in the pair(s)
      } else {
        if (graphsData[i].isGraphForEachAntPair) {
          // One graph for each ant pair
        } else {
          // One graph for all ant pairs
          if (graphsData[i].is4AntOnly && !(data.antsCombo.length == 2)) {
            // Skip when graph is meant only for 4ant devices and is not the case
            continue;
          }

          var graphContainer = document.createElement("div");
          graphContainer.id = graphsData[i].name;

          graphContainer.style.width = RRDGraphWidth + "px";
          graphContainer.style.height = RRDGraphHeight + "px";
          graphContainer.style.marginLeft = globGraphRectInlineSpaceRRD + "px";
          graphContainer.style.marginTop = 12 + "px";

          $TabRRDContentGraphsContainer.append(graphContainer);

          // var graphSeparator = document.createElement('hr');
          // graphSeparator.className = 'rrd-graph-separator';
          var graphSeparator = document.createElement("div");
          graphSeparator.className = "rrd-graph-separator";

          $TabRRDContentGraphsContainer.append(graphSeparator);

          drawRRDGraph(
            graphsData[i],
            data,
            graphContainer,
            isZooming,
            isUCU,
            isUCU
              ? null
              : data.antsCombo.length === 2
                ? data.antsCombo[0].concat(data.antsCombo[1])
                : data.antsCombo[0]
          );
        }
      }

      // OLD CODE inside "for (var i = 0; i < graphsData.length; ++i) {"
      /*
      for (var j = 0; j < (isUCU ? 1 : data.antsCombo.length); ++j) {
        if ((graphsData[i].name === 'Alarms') && (j > 0)) {
          continue;
        }

        var graphContainer = document.createElement("div");
        graphContainer.id = graphsData[i].name + j;

        graphContainer.style.width = RRDGraphWidth + 'px';
        graphContainer.style.height = RRDGraphHeight + 'px';
        graphContainer.style.marginLeft = globGraphRectInlineSpaceRRD + 'px';
        graphContainer.style.marginTop = 12 + 'px';

        $TabRRDContentGraphsContainer.append(graphContainer);

        // var graphSeparator = document.createElement('hr');
        // graphSeparator.className = 'rrd-graph-separator';
        var graphSeparator = document.createElement('div');
        graphSeparator.className = 'rrd-graph-separator';

        $TabRRDContentGraphsContainer.append(graphSeparator);

        // $SpectrogramWindow1GraphElements.push($(graphContainer));

        drawRRDGraph(graphsData[i], data, graphContainer, isZooming, isUCU, (isUCU ? null : data.antsCombo[j]));
      }
      */
    }

    if (data["optix_data"]) {
      var graphData;

      _.forEach(data["optix_data"], function (value, key) {
        if (data["optix_data"].hasOwnProperty(key)) {
          graphData = globRRDOptixGraphs[key];

          for (var i = 0; i < data["optix_data"][key].length; ++i) {
            _.forEach(data["optix_data"][key][i], function (value1, key1) {
              if (
                data["optix_data"][key][i].hasOwnProperty(key1) &&
                key1 !== "msec_epoch"
              ) {
                graphData[key1] = {
                  label: key1,
                };
              }
            });
          }

          var graphContainer = document.createElement("div");
          graphContainer.id = graphData.name;

          graphContainer.style.width = RRDGraphWidth + "px";
          graphContainer.style.height = RRDGraphHeight + "px";
          graphContainer.style.marginLeft = globGraphRectInlineSpaceRRD + "px";
          graphContainer.style.marginTop = 10 + "px";

          $TabRRDContentGraphsContainer.append(graphContainer);

          var graphSeparator = document.createElement("div");
          graphSeparator.className = "rrd-graph-separator";

          $TabRRDContentGraphsContainer.append(graphSeparator);

          drawRRDGraph(graphData, data, graphContainer, isZooming, isUCU);
        }
      });
    }

    if (isUbiqamUser()) {
      if (data["suspected_pim1"]) {
        for (var i = 0; i < globRRDPimGraphs.length; ++i) {
          var graphContainer = document.createElement("div");
          graphContainer.id = globRRDPimGraphs[i].name + "1";

          graphContainer.style.width = RRDGraphWidth + "px";
          graphContainer.style.height = RRDGraphHeight + "px";
          graphContainer.style.marginLeft = globGraphRectInlineSpaceRRD + "px";
          graphContainer.style.marginTop = 12 + "px";

          $TabRRDContentGraphsContainer.append(graphContainer);

          // var graphSeparator = document.createElement('hr');
          // graphSeparator.className = 'rrd-graph-separator';
          var graphSeparator = document.createElement("div");
          graphSeparator.className = "rrd-graph-separator";

          $TabRRDContentGraphsContainer.append(graphSeparator);

          drawRRDGraph(
            globRRDPimGraphs[i],
            data,
            graphContainer,
            isZooming,
            false,
            data.antsCombo.length === 2
              ? data.antsCombo[0].concat(data.antsCombo[1])
              : data.antsCombo[0],
            "pim1"
          );
        }
      }

      if (data["suspected_pim2"]) {
        for (var i = 0; i < globRRDPimGraphs.length; ++i) {
          var graphContainer = document.createElement("div");
          graphContainer.id = globRRDPimGraphs[i].name + "2";

          graphContainer.style.width = RRDGraphWidth + "px";
          graphContainer.style.height = RRDGraphHeight + "px";
          graphContainer.style.marginLeft = globGraphRectInlineSpaceRRD + "px";
          graphContainer.style.marginTop = 12 + "px";

          $TabRRDContentGraphsContainer.append(graphContainer);

          // var graphSeparator = document.createElement('hr');
          // graphSeparator.className = 'rrd-graph-separator';
          var graphSeparator = document.createElement("div");
          graphSeparator.className = "rrd-graph-separator";

          $TabRRDContentGraphsContainer.append(graphSeparator);

          drawRRDGraph(
            globRRDPimGraphs[i],
            data,
            graphContainer,
            isZooming,
            false,
            data.antsCombo.length === 2
              ? data.antsCombo[0].concat(data.antsCombo[1])
              : data.antsCombo[0],
            "pim2"
          );
        }
      }

      if (data["suspected_pim1"] && data["suspected_pim2"]) {
        for (var i = 0; i < globRRDPimBinDiffGraphs.length; ++i) {
          var graphContainer = document.createElement("div");
          graphContainer.id = globRRDPimBinDiffGraphs[i].name + "BinDiff";

          graphContainer.style.width = RRDGraphWidth + "px";
          graphContainer.style.height = RRDGraphHeight + "px";
          graphContainer.style.marginLeft = globGraphRectInlineSpaceRRD + "px";
          graphContainer.style.marginTop = 12 + "px";

          $TabRRDContentGraphsContainer.append(graphContainer);

          // var graphSeparator = document.createElement('hr');
          // graphSeparator.className = 'rrd-graph-separator';
          var graphSeparator = document.createElement("div");
          graphSeparator.className = "rrd-graph-separator";

          $TabRRDContentGraphsContainer.append(graphSeparator);

          drawRRDGraph(
            globRRDPimBinDiffGraphs[i],
            data,
            graphContainer,
            isZooming,
            false,
            data.antsCombo.length === 2
              ? data.antsCombo[0].concat(data.antsCombo[1])
              : data.antsCombo[0],
            "pimbindiff"
          );
        }
      }
    }

    doDTGraphsSearch();
  }

  function drawParentSummaryRRDGraphs(data, isZooming, isPhysicalPort) {
    function drawRRDGraphCaller(RRDGraphInfo, tdata, isUCU, antsCombo) {
      if (RRDGraphInfo.isGraphPerAnt) {
        // One graph for each ant in the pair(s)
      } else {
        if (RRDGraphInfo.isGraphForEachAntPair) {
          // One graph for each ant pair
        } else {
          // One graph for all ant pairs
          if (RRDGraphInfo.is4AntOnly && !(antsCombo.length == 2)) {
            // Skip when graph is meant only for 4ant devices and is not the case
            return;
          }

          var graphContainer = document.createElement("div");
          graphContainer.id = RRDGraphInfo.name + tdata.childId;

          graphContainer.style.width = RRDGraphWidth + "px";
          graphContainer.style.height = RRDGraphHeight + "px";
          graphContainer.style.marginLeft = globGraphRectInlineSpaceRRD + "px";
          graphContainer.style.marginTop = 12 + "px";

          $TabRRDContentGraphsContainer.append(graphContainer);

          // var graphSeparator = document.createElement('hr');
          // graphSeparator.className = 'rrd-graph-separator';
          var graphSeparator = document.createElement("div");
          graphSeparator.className = "rrd-graph-separator";

          $TabRRDContentGraphsContainer.append(graphSeparator);

          // $SpectrogramWindow1GraphElements.push($(graphContainer));

          drawRRDGraph(
            RRDGraphInfo,
            tdata,
            graphContainer,
            isZooming,
            isUCU,
            isUCU
              ? null
              : antsCombo.length === 2
                ? antsCombo[0].concat(antsCombo[1])
                : antsCombo[0]
          );
        }
      }
    }

    function deviceHandler(workingGraphSet, deviceData) {
      for (var i = 0; i < workingGraphSet.length; ++i) {
        var isUCUGraphs = workingGraphSet[i]["isUCU"];

        if (isUCUGraphs) {
          for (var n = 0; n < workingGraphSet[i]["graphNames"].length; ++n) {
            var graphIndex = -1;

            for (var gi = 0; gi < globUCUGraphs.length; ++gi) {
              if (
                globUCUGraphs[gi].name === workingGraphSet[i]["graphNames"][n]
              ) {
                graphIndex = gi;

                break;
              }
            }

            if (graphIndex !== -1) {
              drawRRDGraphCaller(
                globUCUGraphs[gi],
                deviceData[deviceData.length - 1].data,
                true,
                null
              );
            }
          }
        } else {
          var maxLength;
          if (isPhysicalPort) {
            maxLength = deviceData.length;
          } else {
            maxLength = deviceData.length - 1;
          }

          for (var d = 0; d < maxLength; ++d) {
            for (var n = 0; n < workingGraphSet[i]["graphNames"].length; ++n) {
              var graphIndex = -1;

              for (var gi = 0; gi < globRRDGraphs.length; ++gi) {
                if (
                  globRRDGraphs[gi].name === workingGraphSet[i]["graphNames"][n]
                ) {
                  graphIndex = gi;

                  break;
                }
              }

              if (graphIndex !== -1) {
                drawRRDGraphCaller(
                  globRRDGraphs[graphIndex],
                  deviceData[d].data,
                  false,
                  deviceData[d].data.antsCombo
                );
              }
            }
          }
        }
      }
    }

    globTDGraphsLookupForFilter = [];

    globTDGraphsHoverElements = {};

    if (!isZooming) {
      globRRDGraphsZoomDates = [];
    }

    var workingGraphSet;

    if (isPhysicalPort) {
      workingGraphSet = globParentSummaryRRDGraphsPhysicalPort;
    } else {
      workingGraphSet = globParentSummaryRRDGraphs;
    }

    if (!globIsHighLevelParent) {
      deviceHandler(workingGraphSet, data);
    } else {
      if (data.length) {
        var dataSets = [];
        var newSet = [];
        var currentDevice = data[0].name.substr(0, 7);

        for (var i = 0; i < data.length; ++i) {
          var deviceName = data[i].name.substr(0, 7);

          if (deviceName == currentDevice) {
            newSet.push(data[i]);
          } else {
            dataSets.push(newSet);

            newSet = [];
            currentDevice = deviceName;
            newSet.push(data[i]);
          }
        }
        dataSets.push(newSet);

        for (var i = 0; i < dataSets.length; ++i) {
          deviceHandler(workingGraphSet, dataSets[i]);
        }
      }
    }

    doDTGraphsSearch();
  }

  function spectrogramsAjaxUi(enable) {
    if (enable) {
      $TabSpectrogramsContentControlsGo.prop("disabled", true);
      $("#SpectrogramsAjaxLoader").removeClass("hidden");
    } else {
      $TabSpectrogramsContentControlsGo.prop("disabled", false);
      $("#SpectrogramsAjaxLoader").addClass("hidden");
    }
  }

  function rrdAjaxUi(enable) {
    if (enable) {
      $TabRRDContentControlsGo.prop("disabled", true);
      $("#RRDAjaxLoader").removeClass("hidden");
    } else {
      $TabRRDContentControlsGo.prop("disabled", false);

      $("#RRDAjaxLoader").addClass("hidden");
    }
  }

  function optixModeAjaxUi(enable) {
    if (enable) {
      $TabOptixModeContentControlsGo.prop("disabled", true);
      $("#OptixModeAjaxLoader").removeClass("hidden");
    } else {
      $TabOptixModeContentControlsGo.prop("disabled", false);

      $("#OptixModeAjaxLoader").addClass("hidden");
    }
  }

  function pimReportAjaxUi(enable) {
    if (enable) {
      $TabInternalsContentContainerParentGo.prop("disabled", true);
      $("#InternalsParentAjaxLoader").removeClass("hidden");
    } else {
      $TabInternalsContentContainerParentGo.prop("disabled", false);

      $("#InternalsParentAjaxLoader").addClass("hidden");
    }
  }

  function cehReportAjaxUi(enable) {
    if (enable) {
      $TabInternalsContentContainerParentGoCEH.prop("disabled", true);
      $("#InternalsParentAjaxLoaderCEH").removeClass("hidden");
    } else {
      $TabInternalsContentContainerParentGoCEH.prop("disabled", false);

      $("#InternalsParentAjaxLoaderCEH").addClass("hidden");
    }
  }

  function tehReportAjaxUi(enable) {
    if (enable) {
      $TabInternalsContentContainerParentGoTEH.prop("disabled", true);
      $("#InternalsParentAjaxLoaderTEH").removeClass("hidden");
    } else {
      $TabInternalsContentContainerParentGoTEH.prop("disabled", false);
      $("#InternalsParentAjaxLoaderTEH").addClass("hidden");
    }
  }


  function ParsersOperationRunningUi(isRunning) {
    if (isRunning) {
      NodePadParserAjaxUi(false);
      ParsersPrmsExportAjaxUi(false);
      ParsersAjaxImageUi(true);
    } else {
      NodePadParserAjaxUi(true);
      ParsersPrmsExportAjaxUi(true);
      ParsersAjaxImageUi(false);
    }
  }

  function ParsersAjaxImageUi(enable) {
    if (enable) {
      $("#TabInternalsParsersAjaxImage").removeClass("hidden");
    } else {
      $("#TabInternalsParsersAjaxImage").addClass("hidden");
    }
  }

  function NodePadParserAjaxUi(enable) {
    if (!enable) {
      $("#TabInternalsNParserGo").prop("disabled", true);
    } else {
      $("#TabInternalsNParserGo").prop("disabled", false);
    }
  }

  function ParsersPrmsExportAjaxUi(enable) {
    if (!enable) {
      $("#TabInternalsParsersPrmsExportGo").prop("disabled", true);
    } else {
      $("#TabInternalsParsersPrmsExportGo").prop("disabled", false);
    }
  }

  function nodepadAjaxUi(enable) {
    if (enable) {
      $TabNodePadContentControlsGo.prop("disabled", true);
      $("#NodePadSecondContentControlsDownload").prop("disabled", true);
      $("#NodePadSecondContentControlsDelete").prop("disabled", true);

      $("#NodePadAjaxLoader").removeClass("hidden");
    } else {
      $TabNodePadContentControlsGo.prop("disabled", false);
      $("#NodePadSecondContentControlsDownload").prop("disabled", false);
      $("#NodePadSecondContentControlsDelete").prop("disabled", false);

      $("#NodePadAjaxLoader").addClass("hidden");
    }
  }

  /*
   * Last-resort UI cleanup for any failed jQuery request.
   *
   * jQuery invokes only the success callback, and nearly every $.post here
   * raises a spinner and disables its button before firing, then clears both
   * inside that callback. There are ~50 such call sites and almost none have
   * a .fail(), so any network failure left the tab spinning with a dead
   * button until the page was reloaded.
   *
   * This does not replace per-site .fail() handlers — those are where a
   * meaningful message belongs. It only guarantees the UI is never left
   * stuck, including for call sites added later.
   *
   * d3.request does not go through jQuery and is not covered here. Those
   * callbacks are always invoked, with null on failure, and reset their own
   * UI on the way through; see parseXhrJson.
   */
  $(document).ajaxError(function (event, jqXHR) {
    // An abort is a deliberate cancel — switching tabs, or a new request
    // superseding one in flight — and whoever aborted owns the UI from here.
    // Clearing spinners on abort would fight the request that replaced it.
    if (jqXHR && jqXHR.statusText === "abort") {
      return;
    }

    spectrogramsAjaxUi(false);
    rrdAjaxUi(false);
    optixModeAjaxUi(false);
    pimReportAjaxUi(false);
    cehReportAjaxUi(false);
    tehReportAjaxUi(false);
    ParsersOperationRunningUi(false);
    nodepadAjaxUi(false);

    // Sites that raise a spinner inline instead of through one of the
    // helpers above. Every one of them is an id ending in AjaxImage.
    $("[id$='AjaxImage']").addClass("hidden");

    // ... and the buttons those same sites disable by hand. Listed
    // explicitly rather than re-enabling every disabled button on the page,
    // which would also revive ones held disabled on purpose — the NodePad
    // submit stays disabled until its text area has content, for one.
    $(
      [
        "#TabWebifAdminPassMDownloadSiteCSVGo",
        "#TabTabWebifAdminPassMUploadFile",
        "#TabTabWebifAdminPassMFileUploadGo",
        "#TabInternalsURebootContentGo",
        "#TabInternalsDBContentDBDownloadGo",
        "#TabInternalsDBUploadGo",
        "#TabInternalsGenerateSampleBtn",
        "#TabInternalsSamplesDownloadBtn",
        "#TabUtilsCmdExecBtn",
      ].join(",")
    ).prop("disabled", false);
  });

  function getUbifixSpectrogramData(
    dataTypes,
    dataTypesR,
    presetPeriod,
    startDate,
    endDate,
    isZooming,
    isSpectrogramDisplay2Columns
  ) {
    spectrogramsAjaxUi(true);

    var nodeData = getNodeData(globCurrentNode);

    var req = d3
      .request("adminservice.php")
      .header("X-Requested-With", "XMLHttpRequest")
      .header("Content-Type", "application/x-www-form-urlencoded")
      .header("Accept", "application/json");

    globAjaxRequest = req;

    var isAvg = 0;
    if (
      (dataTypes && dataTypes.indexOf("avg") !== -1) ||
      (dataTypesR && dataTypesR.indexOf("avg") !== -1)
    ) {
      isAvg = 1;
    }

    var is4AntGraphs =
      isHas4AntGraphType(dataTypes) || isHas4AntGraphType(dataTypesR);
    var numOfAnts;

    if (!globIs4AntDevice || (globIs4AntDevice && !is4AntGraphs)) {
      numOfAnts = 2;
    } else {
      numOfAnts = 4;
    }

    if (presetPeriod) {
      req.send(
        "POST",
        "method=getUbifixInoutData&childId=" +
        nodeData.treeid +
        "&customTreeId=" +
        nodeData.id +
        "&nodeName=" +
        nodeData.act_name +
        "&numOfAnts=" +
        numOfAnts +
        "&presetPeriod=last" +
        presetPeriod +
        "&isAvg=" +
        isAvg +
        "&secPerPixel=" +
        spectrogramWindow1SecPerPixel +
        "&isFdeq=" +
        (isSpectrogramsCancEnabled ? 1 : 0) +
        "&isSpectrogramDisplay2Columns=" +
        (isSpectrogramDisplay2Columns ? 1 : 0),
        function xhrPost(data) {
          // d3.select('#AjaxLoader').classed('hidden', true);
          data = parseXhrJson(data);

          spectrogramsAjaxUi(false);
          hideTitleElements();
          globAjaxRequest = false;

          if (data) {
            if (data.isNo4Ant) {
              // displaySpectrogramsMsg('No 4 antennas (C, D) Spectrograms data found for UMU device for the selected time period.<br><br>Please change the time period or select only antennas A or B.', true);
              enableSpectrogramsContent(globIs4AntDevice, true, true); // Set default 2ant graphs for 4ant device
              setTimeout(tabSpectrogramsContentControlsGo(null, null), 0);
            } else if (data.data) {
              window.ubid.data.spectrogramsData = data;

              if (data.fdeq == null) {
                isSpectrogramsCancEnabled = false;
              }

              enableSpectrogramsContent(globIs4AntDevice);

              setTimeout(function () {
                drawGraphs(data, dataTypes, dataTypesR, isZooming);

                if (!globSpectrogramsUpdateTimer && isSpectrogramPre) {
                  globSpectrogramsUpdateTimer = setTimeout(
                    tabSpectrogramsContentControlsGo,
                    SPECTROGRAMS_UPODATE_INTERVAL
                  );
                }
              }, 0);
            }
          } else {
            displaySpectrogramsMsg(
              "Spectrograms data not found for UMU device."
            );
          }
        }
      );
    } else {
      req.send(
        "POST",
        "method=getUbifixInoutData&childId=" +
        nodeData.treeid +
        "&customTreeId=" +
        nodeData.id +
        "&nodeName=" +
        nodeData.act_name +
        "&numOfAnts=" +
        numOfAnts +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&isAvg=" +
        isAvg +
        "&secPerPixel=" +
        spectrogramWindow1SecPerPixel +
        "&isFdeq=" +
        (isSpectrogramsCancEnabled ? 1 : 0) +
        "&isSpectrogramDisplay2Columns=" +
        (isSpectrogramDisplay2Columns ? 1 : 0),
        function xhrPost(data) {
          data = parseXhrJson(data);

          spectrogramsAjaxUi(false);
          hideTitleElements();
          globAjaxRequest = false;

          if (data) {
            // console.log('data =', data);

            if (data.isNo4Ant) {
              // displaySpectrogramsMsg('No 4 antennas (C, D) Spectrograms data found for UMU device for the selected time period.<br><br>Please change the time period or select only antennas A or B.', true);
              enableSpectrogramsContent(globIs4AntDevice, true, true); // Set default 2ant graphs for 4ant device
              setTimeout(tabSpectrogramsContentControlsGo(null, null), 0);
            } else if (data.data) {
              window.ubid.data.spectrogramsData = data;

              if (data.fdeq == null) {
                isSpectrogramsCancEnabled = false;
              }

              enableSpectrogramsContent(globIs4AntDevice);

              setTimeout(function () {
                drawGraphs(data, dataTypes, dataTypesR, isZooming);

                if (!globSpectrogramsUpdateTimer && isSpectrogramPre) {
                  globSpectrogramsUpdateTimer = setTimeout(
                    tabSpectrogramsContentControlsGo,
                    SPECTROGRAMS_UPODATE_INTERVAL
                  );
                }
              }, 0);
            }
          } else {
            displaySpectrogramsMsg(
              "Spectrograms data not found for UMU device."
            );
          }
        }
      );
    }
  }

  function getPIMReportData(
    presetPeriod,
    startDate,
    endDate,
    childrenData,
    requestData
  ) {
    pimReportAjaxUi(true);

    var req = d3
      .request("adminservice.php")
      .header("X-Requested-With", "XMLHttpRequest")
      .header("Content-Type", "application/x-www-form-urlencoded")
      .header("Accept", "application/json");

    if (presetPeriod) {
      req.send(
        "POST",
        "method=getPIMReportData&childrenData=" +
        childrenData +
        "&requestParams=" +
        requestData +
        "&presetPeriod=last" +
        presetPeriod,
        function xhrPost(data) {
          var retData = parseXhrJson(data);

          pimReportAjaxUi(false);

          if (retData) {
            var link = document.createElement("a");
            link.style = "display: none";
            link.href =
              window.location.href.substring(
                0,
                window.location.href.lastIndexOf("/")
              ) +
              "/pimReportDownload.php?fileName=" +
              retData.reportFileName;
            link.download =
              "PIM_" +
              retData.requestParams.groupNodeName.replaceAll(" ", "_") +
              "-" +
              retData.endMSecEpoch +
              "-" +
              retData.startMSecEpoch +
              ".csv";
            link.click();
          } else {
            displayInternalsPIMReportMsg(
              "An error occured getting the PIM report."
            );
          }
        }
      );
    } else {
      req.send(
        "POST",
        "method=getPIMReportData&childrenData=" +
        childrenData +
        "&requestParams=" +
        requestData +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate,
        function xhrPost(data) {
          var retData = parseXhrJson(data);

          pimReportAjaxUi(false);

          if (retData) {
            var link = document.createElement("a");
            link.style = "display: none";
            link.href =
              window.location.href.substring(
                0,
                window.location.href.lastIndexOf("/")
              ) +
              "/pimReportDownload.php?fileName=" +
              retData.reportFileName;
            link.download =
              "PIM_" +
              retData.requestParams.groupNodeName.replaceAll(" ", "_") +
              "-" +
              retData.endMSecEpoch +
              "-" +
              retData.startMSecEpoch +
              ".csv";
            link.click();
          } else {
            displayInternalsPIMReportMsg(
              "An error occured getting the PIM report."
            );
          }
        }
      );
    }
  }

  function getTEHReportData(
    presetPeriod,
    startDate,
    endDate,
    childrenData,
    requestData
  ) {
    tehReportAjaxUi(true);

    var req = d3
      .request("adminservice.php")
      .header("X-Requested-With", "XMLHttpRequest")
      .header("Content-Type", "application/x-www-form-urlencoded")
      .header("Accept", "application/json");

    if (presetPeriod) {
      req.send(
        "POST",
        "method=getTEHReportData&childrenData=" +
        childrenData +
        "&requestParams=" +
        requestData +
        "&presetPeriod=last" +
        presetPeriod,
        function xhrPost(data) {
          var retData = parseXhrJson(data);

          tehReportAjaxUi(false);

          if (retData) {
            var link = document.createElement("a");
            link.style = "display: none";
            link.href =
              window.location.href.substring(
                0,
                window.location.href.lastIndexOf("/")
              ) +
              "/pimReportDownload.php?fileName=" +
              retData.reportFileName;
            link.download =
              "TEH_" +
              retData.requestParams.groupNodeName.replaceAll(" ", "_") +
              "-" +
              retData.endSecEpoch +
              "-" +
              retData.startSecEpoch +
              ".csv";
            link.click();
          } else {
            displayInternalsTEHReportMsg(
              "An error occured getting the TEH report."
            );
          }
        }
      );
    } else {
      req.send(
        "POST",
        "method=getTEHReportData&childrenData=" +
        childrenData +
        "&requestParams=" +
        requestData +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate,
        function xhrPost(data) {
          var retData = parseXhrJson(data);

          tehReportAjaxUi(false);

          if (retData) {
            var link = document.createElement("a");
            link.style = "display: none";
            link.href =
              window.location.href.substring(
                0,
                window.location.href.lastIndexOf("/")
              ) +
              "/pimReportDownload.php?fileName=" +
              retData.reportFileName;
            link.download =
              "TEH_" +
              retData.requestParams.groupNodeName.replaceAll(" ", "_") +
              "-" +
              retData.endSecEpoch +
              "-" +
              retData.startSecEpoch +
              ".csv";
            link.click();
          } else {
            displayInternalsTEHReportMsg(
              "An error occured getting the TEH report."
            );
          }
        }
      );
    }
  }

  function getCEHReportData(
    presetPeriod,
    startDate,
    endDate,
    childrenData,
    requestData
  ) {
    cehReportAjaxUi(true);

    var req = d3
      .request("adminservice.php")
      .header("X-Requested-With", "XMLHttpRequest")
      .header("Content-Type", "application/x-www-form-urlencoded")
      .header("Accept", "application/json");

    if (presetPeriod) {
      req.send(
        "POST",
        "method=getCEHReportData&childrenData=" +
        childrenData +
        "&requestParams=" +
        requestData +
        "&presetPeriod=last" +
        presetPeriod,
        function xhrPost(data) {
          var retData = parseXhrJson(data);

          cehReportAjaxUi(false);

          if (retData) {
            var link = document.createElement("a");
            link.style = "display: none";
            link.href =
              window.location.href.substring(
                0,
                window.location.href.lastIndexOf("/")
              ) +
              "/pimReportDownload.php?fileName=" +
              retData.reportFileName;
            link.download =
              "CEH_" +
              retData.requestParams.groupNodeName.replaceAll(" ", "_") +
              "-" +
              retData.endMSecEpoch +
              "-" +
              retData.startMSecEpoch +
              ".csv";
            link.click();
          } else {
            displayInternalsCEHReportMsg(
              "An error occured getting the CEH report."
            );
          }
        }
      );
    } else {
      req.send(
        "POST",
        "method=getCEHReportData&childrenData=" +
        childrenData +
        "&requestParams=" +
        requestData +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate,
        function xhrPost(data) {
          var retData = parseXhrJson(data);

          cehReportAjaxUi(false);

          if (retData) {
            var link = document.createElement("a");
            link.style = "display: none";
            link.href =
              window.location.href.substring(
                0,
                window.location.href.lastIndexOf("/")
              ) +
              "/pimReportDownload.php?fileName=" +
              retData.reportFileName;
            link.download =
              "CEH_" +
              retData.requestParams.groupNodeName.replaceAll(" ", "_") +
              "-" +
              retData.endMSecEpoch +
              "-" +
              retData.startMSecEpoch +
              ".csv";
            link.click();
          } else {
            displayInternalsCEHReportMsg(
              "An error occured getting the CEH report."
            );
          }
        }
      );
    }
  }

  function getUbifixOptixModeData(
    presetPeriod,
    startDate,
    endDate,
    childrenData
  ) {
    optixModeAjaxUi(true);
    $TabOptixModeContentGraphsContainer.html("");

    var req = d3
      .request("adminservice.php")
      .header("X-Requested-With", "XMLHttpRequest")
      .header("Content-Type", "application/x-www-form-urlencoded")
      .header("Accept", "application/json");

    if (presetPeriod) {
      req.send(
        "POST",
        "method=getUbifixOptixModeData&childrenData=" +
        childrenData +
        "&presetPeriod=last" +
        presetPeriod,
        function xhrPost(data) {
          data = parseXhrJson(data);

          optixModeAjaxUi(false);

          if (data) {
            // console.log(data); // DDD
            // window.ubid.data.RRDData = data;

            setTimeout(function () {
              drawOptixModeGraphs(data);
            }, 0);
          } else {
            displayOptixModeMsg("Graphs' data not found for device.");
          }
        }
      );
    } else {
      req.send(
        "POST",
        "method=getUbifixOptixModeData&childrenData=" +
        childrenData +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate,
        function xhrPost(data) {
          data = parseXhrJson(data);

          optixModeAjaxUi(false);

          if (data) {
            // console.log(data); // DDD
            // window.ubid.data.RRDData = data;

            setTimeout(function () {
              drawOptixModeGraphs(data);
            }, 0);
          } else {
            displayOptixModeMsg("Graphs' data not found for device.");
          }
        }
      );
    }
  }

  function getUbifixRRDData(presetPeriod, startDate, endDate, isZooming) {
    rrdAjaxUi(true);
    $TabRRDContentGraphsContainer.html("");

    var nodeData = getNodeData(globCurrentNode);

    /* Container and port nodes have no device name — getNodeData returns null
       for a port node, and Unassigned carries act_name null. Concatenated into
       the query that became the literal string "null", which the backend fed
       to getUbifixIndex(): the last letter "l" gives 2 - (ord('l') - 97) = -9,
       and getSuspectedPIMBins() then built the table name
       ubifix_data._-9_prms. That is not valid SQL, so the request 500'd with
       an empty body. Nothing to graph here, so do not ask. */
    if (!nodeData || !nodeData.act_name) {
      rrdAjaxUi(false);
      displayRRDMsg("Select a device to view TD graphs.");

      return;
    }

    var numOfAnts = 0;

    var req = d3
      .request("adminservice.php")
      .header("X-Requested-With", "XMLHttpRequest")
      .header("Content-Type", "application/x-www-form-urlencoded")
      .header("Accept", "application/json");
    globAjaxRequest = req;

    if (presetPeriod) {
      req.send(
        "POST",
        "method=getUbifixRRDData&childId=" +
        nodeData.treeid +
        "&customTreeId=" +
        nodeData.id +
        "&nodeName=" +
        nodeData.act_name +
        "&numOfAnts=" +
        numOfAnts +
        "&presetPeriod=last" +
        presetPeriod +
        "&secPerPixel=" +
        RRDSecPerPixel +
        "&antsCombo=" +
        nodeData.antsCombo +
        "&isSuspectedPim=" +
        (globalIsRRDSuspectedPim ? 1 : 0),
        function xhrPost(data) {
          data = parseXhrJson(data);

          rrdAjaxUi(false);
          globAjaxRequest = false;

          if (data) {
            // console.log(data); // DDD
            window.ubid.data.RRDData = data;

            setTimeout(function () {
              drawRRDGraphs(data, isZooming);

              // RRDTimer
              // if (!globSpectrogramsUpdateTimer && isSpectrogramPre)
              // {
              // globSpectrogramsUpdateTimer =
              // setTimeout(tabSpectrogramsContentControlsGo,
              // SPECTROGRAMS_UPODATE_INTERVAL);
              // }
            }, 0);
          } else {
            displayRRDMsg("Graphs' data not found for device.");
          }
        }
      );
    } else {
      req.send(
        "POST",
        "method=getUbifixRRDData&childId=" +
        nodeData.treeid +
        "&customTreeId=" +
        nodeData.id +
        "&nodeName=" +
        nodeData.act_name +
        "&numOfAnts=" +
        numOfAnts +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&secPerPixel=" +
        RRDSecPerPixel +
        "&antsCombo=" +
        nodeData.antsCombo +
        "&isSuspectedPim=" +
        (globalIsRRDSuspectedPim ? 1 : 0),
        function xhrPost(data) {
          data = parseXhrJson(data);

          rrdAjaxUi(false);
          globAjaxRequest = false;

          if (data) {
            // console.log(data); // DDD
            window.ubid.data.RRDData = data;

            setTimeout(function () {
              drawRRDGraphs(data, isZooming);

              // RRDTimer
              // if (!globSpectrogramsUpdateTimer && isSpectrogramPre)
              // {
              // globSpectrogramsUpdateTimer =
              // setTimeout(tabSpectrogramsContentControlsGo,
              // SPECTROGRAMS_UPODATE_INTERVAL);
              // }
            }, 0);
          } else {
            displayRRDMsg("Graphs' data not found for device.");
          }
        }
      );
    }
  }

  function getUCURRDData(presetPeriod, startDate, endDate, isZooming) {
    rrdAjaxUi(true);
    $TabRRDContentGraphsContainer.html("");

    var nodeData = getNodeData(globCurrentNode);

    /* Same guard as getUbifixRRDData: no device name, nothing to ask for. */
    if (!nodeData || !nodeData.act_name) {
      rrdAjaxUi(false);
      displayRRDMsg("Select a device to view TD graphs.");

      return;
    }

    var req = d3
      .request("adminservice.php")
      .header("X-Requested-With", "XMLHttpRequest")
      .header("Content-Type", "application/x-www-form-urlencoded")
      .header("Accept", "application/json");
    globAjaxRequest = req;

    if (presetPeriod) {
      req.send(
        "POST",
        "method=getUCURRDData&childId=" +
        nodeData.treeid +
        "&customTreeId=" +
        nodeData.id +
        "&nodeName=" +
        nodeData.act_name +
        "&presetPeriod=last" +
        presetPeriod +
        "&secPerPixel=" +
        RRDSecPerPixel,
        function xhrPost(data) {
          data = parseXhrJson(data);

          rrdAjaxUi(false);
          globAjaxRequest = false;

          if (data) {
            // console.log(data); // DDD
            window.ubid.data.RRDData = data;

            setTimeout(function () {
              drawRRDGraphs(data, isZooming, true);

              // RRDTimer
              // if (!globSpectrogramsUpdateTimer && isSpectrogramPre)
              // {
              // globSpectrogramsUpdateTimer =
              // setTimeout(tabSpectrogramsContentControlsGo,
              // SPECTROGRAMS_UPODATE_INTERVAL);
              // }
            }, 0);
          } else {
            displayRRDMsg("Graphs' data not found for device.");
          }
        }
      );
    } else {
      if (isZooming) {
        RRDGraphWidth = Math.ceil(
          RRDGraphsContainerRect.width - globGraphRectInlineSpace * 2
        );

        RRDNumOfPixelsForTimeAxis = RRDGraphWidth - graphMarginRRD.left;
        if (IS_DEBUG) {
          console.log(
            "RRDNumOfPixelsForTimeAxis  = ",
            RRDNumOfPixelsForTimeAxis
          );
        }

        RRDSecPerPixel = Math.abs(
          Math.ceil((startDate - endDate) / RRDNumOfPixelsForTimeAxis)
        );
        if (IS_DEBUG) {
          console.log("RRDSecPerPixel  = ", RRDSecPerPixel);
        }
      }

      req.send(
        "POST",
        "method=getUCURRDData&childId=" +
        nodeData.treeid +
        "&customTreeId=" +
        nodeData.id +
        "&nodeName=" +
        nodeData.act_name +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&secPerPixel=" +
        RRDSecPerPixel,
        function xhrPost(data) {
          data = parseXhrJson(data);

          rrdAjaxUi(false);
          globAjaxRequest = false;

          if (data) {
            console.log(data); // DDD
            window.ubid.data.RRDData = data;

            setTimeout(function () {
              drawRRDGraphs(data, isZooming, true);

              // RRDTimer
              // if (!globSpectrogramsUpdateTimer && isSpectrogramPre)
              // {
              // globSpectrogramsUpdateTimer =
              // setTimeout(tabSpectrogramsContentControlsGo,
              // SPECTROGRAMS_UPODATE_INTERVAL);
              // }
            }, 0);
          } else {
            displayRRDMsg("Graphs' data not found for device.");
          }
        }
      );
    }
  }

  function getParentSummaryRRDData(
    presetPeriod,
    startDate,
    endDate,
    isZooming,
    isPhysicalPort
  ) {
    rrdAjaxUi(true);
    $TabRRDContentGraphsContainer.html("");

    var parentChildren = $("#TreeGraph").jstree(
      "get_node",
      $("#TreeGraph").jstree("get_node", globCurrentNode)
    ).children_d;
    var parentChildrenData = [];
    var nodeData;

    for (var i = 0; i < parentChildren.length; ++i) {
      if (
        !(
          parentChildren[i].indexOf("D_") === 0 ||
          parentChildren[i].indexOf("L_") === 0
        )
      ) {
        nodeData = getNodeData(parentChildren[i]);

        if (nodeData) {
          parentChildrenData.push({
            nodeName: nodeData.act_name,
            antsCombo: nodeData.antsCombo,
            childId: nodeData.treeid,
          });
        }
      }
    }

    parentChildrenData = parentChildrenData.sort(function compare(a, b) {
      if (a.nodeName < b.nodeName) {
        return -1;
      }

      if (a.nodeName > b.nodeName) {
        return 1;
      }

      return 0;
    });

    var parentChildrenJSONString = JSON.stringify(parentChildrenData);

    var req = d3
      .request("adminservice.php")
      .header("X-Requested-With", "XMLHttpRequest")
      .header("Content-Type", "application/x-www-form-urlencoded")
      .header("Accept", "application/json");
    globAjaxRequest = req;

    if (presetPeriod) {
      req.send(
        "POST",
        "method=getParentSummaryRRDData&parentChildrenJSONString=" +
        parentChildrenJSONString +
        "&presetPeriod=last" +
        presetPeriod +
        "&secPerPixel=" +
        RRDSecPerPixel,
        function xhrPost(data) {
          data = parseXhrJson(data);

          rrdAjaxUi(false);
          globAjaxRequest = false;

          if (data) {
            window.ubid.data.RRDData = data;

            setTimeout(function () {
              drawParentSummaryRRDGraphs(data, isZooming, isPhysicalPort);

              // RRDTimer
              // if (!globSpectrogramsUpdateTimer && isSpectrogramPre)
              // {
              // globSpectrogramsUpdateTimer =
              // setTimeout(tabSpectrogramsContentControlsGo,
              // SPECTROGRAMS_UPODATE_INTERVAL);
              // }
            }, 0);
          } else {
            displayRRDMsg("Graphs' data not found for device.");
          }
        }
      );
    } else {
      req.send(
        "POST",
        "method=getParentSummaryRRDData&parentChildrenJSONString=" +
        parentChildrenJSONString +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&secPerPixel=" +
        RRDSecPerPixel,
        function xhrPost(data) {
          data = parseXhrJson(data);

          rrdAjaxUi(false);
          globAjaxRequest = false;

          if (data) {
            window.ubid.data.RRDData = data;

            setTimeout(function () {
              drawParentSummaryRRDGraphs(data, isZooming, isPhysicalPort);

              // RRDTimer
              // if (!globSpectrogramsUpdateTimer && isSpectrogramPre)
              // {
              // globSpectrogramsUpdateTimer =
              // setTimeout(tabSpectrogramsContentControlsGo,
              // SPECTROGRAMS_UPODATE_INTERVAL);
              // }
            }, 0);
          } else {
            displayRRDMsg("Graphs' data not found for device.");
          }
        }
      );
    }
  }

  function startApp() {
    if (isDebug()) {
      console.log("userData:", globUserData); // DDD
    }

    globLastTimeCheck = new Date(); // resolve issues that might happen
    // after computer suspend.
    updateDateTime();
    setInterval(updateDateTime, DATE_TIME_UPODATE_INTERVAL);

    window.ubid = {
      data: {
        lastTreeUpdateTime: globLastTreeUpdateTime,
        userData: globUserData,
      },
      api: {
        getNextTreeRefresh: getNextTreeRefresh,
        refreshTree: createTree,
        getNodeData: getNodeData,
        getHData: getHData,
      },
    };

    // rwdAdjust();
    enableUserTabs();
    createTree();

    setTreeRefreshInterval();

    $.fn.dataTable.moment("DD/MM/YYYY,HH:mm:ss");

    initSpectrogramsTab();
    initRRDTab();
    initNodePadTab();
    initOptixModeTab();
    initRemoteAdminMngTab();

    if (isUserRole("Internals")) {
      initInternalsTab();
    }

    if ((isUserRole("Utils")) || (isUbiqamUser())) {
      initUtilsTab();
    }

    if (!IS_ON_PREMISE) {
      enableTabContent("mapinfo");

      setTimeout(function () {
        if (!globCurrentNode) {
          $TreeGraph.jstree("select_node", "root", false);
        }
      }, 10000);
    } else {
      enableTabContent("rrdgraphs");
    }

    $(window).on("resize", function () {
      if (globResizeTimer) {
        clearTimeout(globResizeTimer);
      }
      globResizeTimer = setTimeout(function () {
        if (!globCurrentNode) return;
        if (globCurrentTab === "spectrographs") {
          tabSpectrogramsContentControlsGo();
        } else if (globCurrentTab === "rrdgraphs") {
          tabRRDGraphsContentControlsGo();
        } else if (globCurrentTab === "optixmode") {
          OptixModeGraphsContainerRect =
            $TabOptixModeContentGraphsContainer[0].getBoundingClientRect();
          tabOptixModeGraphsContentControlsGo();
        }
      }, 600);
    });

    // $.post("updateLog.php", {
    // ignore: globUserData.ignoredNodes,
    // },
    // function (result) {
    // if (result.trim() == 'Authentication error.') {
    // window.location = 'index.php';
    // }
    // else {
    // $TabEventLContent.html(result);
    //
    // $('#myTable').DataTable({
    // "order": [[1, 'desc']]
    // });
    // }
    // });
  }

  function addNodepadLogEntry(
    entryId,
    nodeName,
    userName,
    textData,
    msgDate,
    keyIndex
  ) {
    var classNames = "panel nodpad_entry";
    var matchResult = textData.match(/\r?\n/g);
    var numOfRows = (matchResult ? matchResult.length : 0) + 1;

    if (keyIndex % 2) {
      classNames += " panel-info nodpad_entry_indent";
    } else {
      classNames += " panel-primary";
    }

    var html =
      '<div class="' +
      classNames +
      '" data-entryid="' +
      entryId +
      '"><div class="panel-heading bg-primary">';

    html +=
      '<span class="nodpad_entry_nodename">' +
      nodeName +
      "</span>" +
      ', &nbsp;<span class="nodpad_entry_username">' +
      userName +
      '</span><span class="pull-right text-bold">' +
      msgDate +
      "</span>";

    html += '</div><div class="panel-body">';

    html +=
      '<textarea class="nodpad_entry_textdata" rows="' +
      numOfRows +
      '" readonly>' +
      textData +
      "</textarea>";

    html +=
      '<div class="pull-right"><button type="button" class="btn btn-xs btn-default" data-editbutton="1">Edit</button>&nbsp;<button type="button" class="btn btn-xs btn-default" data-submitbutton="1" disabled>Submit</button></div>';

    html += "</div></div>";

    $NodePadEntries.append(html);
    $NodePadEntries.scrollTop($NodePadEntries[0].scrollHeight);
  }

  function dateRangeHandler(sourceDatesControls, targetDatesControls) {
    var startDate = sourceDatesControls.startDate.data("DateTimePicker").date();
    var endDate = sourceDatesControls.endDate.data("DateTimePicker").date();

    if (startDate && endDate) {
      var nowCloud = moment().tz(globServerTimezone);
      var localCloudTime = moment(
        new Date(nowCloud.format("ddd, DD MMM YYYY HH:mm"))
      );

      targetDatesControls.startDate.data("DateTimePicker").maxDate(endDate);
      targetDatesControls.endDate.data("DateTimePicker").minDate(startDate);
      targetDatesControls.endDate
        .data("DateTimePicker")
        .maxDate(localCloudTime);

      targetDatesControls.startDate.data("DateTimePicker").date(startDate);
      targetDatesControls.endDate.data("DateTimePicker").date(endDate);
    }
  }

  // ++ Events
  $TabGraphs.on("click", function () {
    enableTabContent("graphs");

    $TreeGraph.jstree("deselect_all");
    $TreeGraph.jstree("select_node", globCurrentNode, false);
  });

  $TabRRDGraphs.on("click", function () {
    enableTabContent("rrdgraphs");

    var sourceDateControls = {};
    if (isHasPrevDateRangeContainingTab(sourceDateControls)) {
      globRRDIsNOPDatesRangeFuncs = true;

      dateRangeHandler(sourceDateControls, {
        startDate: $TabRRDContentControlsStartDate,
        endDate: $TabRRDContentControlsEndDate,
      });

      $("#TabRRDContentControlsRange").prop("checked", true);
      enableRRDDateRangeUI();
    } else {
      $("#TabRRDContentControlsPre").prop("checked", true);
      enableRRDPreDateUI();
      $("#TabRRDContentControlsShowLast").val("6hours");
    }

    $TreeGraph.jstree("deselect_all");
    $TreeGraph.jstree("select_node", globCurrentNode, false);
  });

  $TabSpectrogram.on("click", function () {
    enableTabContent("spectrographs");

    var sourceDateControls = {};
    if (isHasPrevDateRangeContainingTab(sourceDateControls)) {
      globSpectrogramsIsNOPDatesRangeFuncs = true;

      dateRangeHandler(sourceDateControls, {
        startDate: $TabSpectrogramsContentControlsStartDate,
        endDate: $TabSpectrogramsContentControlsEndDate,
      });

      $("#TabSpectrogramsContentControlsRange").prop("checked", true);
      enableSpectrogramsDateRangeUI();
    } else {
      $("#TabSpectrogramsContentControlsPre").prop("checked", true);
      enableSpectrogramsPreDateUI();
      $("#TabSpectrogramsContentControlsShowLast").val("2hours");
    }

    $TreeGraph.jstree("deselect_all");
    $TreeGraph.jstree("select_node", globCurrentNode, false);
  });

  $TabRemoteM.on("click", function () {
    enableTabContent("remotem");

    $TreeGraph.jstree("deselect_all");
    $TreeGraph.jstree("select_node", globCurrentNode, false);
  });

  $TabEventL.on("click", function () {
    enableTabContent("eventlog");

    $TreeGraph.jstree("deselect_all");
    $TreeGraph.jstree("select_node", globCurrentNode, false);
  });

  $TabUserAudit.on("click", function () {
    enableTabContent("useraudit");

    $TreeGraph.jstree("deselect_all");
    $TreeGraph.jstree("select_node", globCurrentNode, false);
  });

  $TabDeviceInfo.on("click", function () {
    enableTabContent("deviceinfo");

    $TreeGraph.jstree("deselect_all");
    $TreeGraph.jstree("select_node", globCurrentNode, false);
  });

  $TabWebifAdminPassM.on("click", function () {
    enableTabContent("remoteadminm");

    if (globCurrentNode) {
      $TreeGraph.jstree("deselect_all");
      $TreeGraph.jstree("select_node", globCurrentNode, false);
    }

    webifAdminPassUpdaterEnableReportChecker();
  });

  $TabUserM.on("click", function () {
    enableTabContent("userm");
  });

  $TabMap.on("click", function () {
    enableTabContent("mapinfo");

    $TreeGraph.jstree("deselect_all");
    $TreeGraph.jstree("select_node", globCurrentNode, false);
  });

  $TabNodePad.on("click", function () {
    if (globCurrentNode) {
      enableTabContent("nodepad");

      var sourceDateControls = {};
      if (isHasPrevDateRangeContainingTab(sourceDateControls)) {
        // globSpectrogramsIsNOPDatesRangeFuncs = true;

        dateRangeHandler(sourceDateControls, {
          startDate: $TabNodePadContentControlsStartDate,
          endDate: $TabNodePadContentControlsEndDate,
        });

        $("#TabNodePadContentControlsRange").prop("checked", true);
        enableNodePadDateRangeUI();
      } else {
        $("#TabNodePadContentControlsPre").prop("checked", true);
        enableNodePadPreDateUI();
        $("#TabNodePadContentControlsShowLast").val("6hours");
      }

      $TreeGraph.jstree("deselect_all");
      $TreeGraph.jstree("select_node", globCurrentNode, false);
    }
  });

  $TabOptixMode.on("click", function () {
    enableTabContent("optixmode");

    var sourceDateControls = {};
    if (isHasPrevDateRangeContainingTab(sourceDateControls)) {
      // globSpectrogramsIsNOPDatesRangeFuncs = true;

      dateRangeHandler(sourceDateControls, {
        startDate: $TabOptixModeContentControlsStartDate,
        endDate: $TabOptixModeContentControlsEndDate,
      });

      $("#TabOptixModeContentControlsRange").prop("checked", true);
      enableOptixModeDateRangeUI();
    } else {
      $("#TabOptixModeContentControlsPre").prop("checked", true);
      enableOptixModePreDateUI();
      $("#TabOptixModeContentControlsShowLast").val("6hours");
    }

    $TreeGraph.jstree("deselect_all");
    $TreeGraph.jstree("select_node", globCurrentNode, false);
  });

  function tabUtilsCmdsListUpdate(data) {
    $TabUtilsCmdSelect.empty();

    if (data && Array.isArray(data)) {
      data.forEach(function (cmd, key) {
        $TabUtilsCmdSelect.append(
          $("<option>", {
            value: (key + 1),
            text: cmd
          }).addClass("data-sample-entry")
        );
      });
    }
  }

  function tabUtilsCmdsListRefresh() {
    $TabUtilsCmdsLoadAjaxImage.removeClass("hidden");

    var req = d3
      .request("adminservice.php")
      .header("X-Requested-With", "XMLHttpRequest")
      .header("Content-Type", "application/x-www-form-urlencoded")
      .header("Accept", "application/json");

    req.send(
      "POST",
      "method=utilsGetCmdsList",
      function xhrPost(data) {
        data = parseXhrJson(data);

        if (data) {
          tabUtilsCmdsListUpdate(data);
        }

        $TabUtilsCmdsLoadAjaxImage.addClass("hidden");
      }
    );
  }

  $TabUtils.on("click", function () {
    enableTabContent("utils");
    // $TreeGraph.jstree("deselect_all");
    // $TreeGraph.jstree("select_node", globCurrentNode, false);
    tabUtilsCmdsListRefresh();
  });

  $TabInternals.on("click", function () {
    enableTabContent("internals");

    var nodeId = globCurrentNode || "root";
    var nodeData = getNodeData(nodeId);
    if (isGroupNode(nodeData) || isParentGroupNode(nodeData)) {
      var sourceDateControls = {};
      if (isHasPrevDateRangeContainingTab(sourceDateControls)) {
        // globSpectrogramsIsNOPDatesRangeFuncs = true;

        dateRangeHandler(sourceDateControls, {
          startDate: $TabInternalsContentContainerParentStartDate,
          endDate: $TabInternalsContentContainerParentEndDate,
        });

        $("#TabInternalsContentContainerParentRange").prop("checked", true);
        enableInternalsParentDateRangeUI();
      } else {
        $("#TabInternalsContentContainerParentPre").prop("checked", true);
        enableInternalsParentPreDateUI();
        $("#TabInternalsContentContainerParentShowLast").val("6hours");
      }
    }

    $TreeGraph.jstree("deselect_all");
    $TreeGraph.jstree("select_node", nodeId, false);
  });

  $TabPaper.on("click", function () {
    enableTabContent("paper");

    $TreeGraph.jstree("deselect_all");
    $TreeGraph.jstree("select_node", globCurrentNode, false);
  });

  $NodePadEntries.on("click", function (e) {
    // console.log(e); // DDD

    var $target = $(e.target);

    if ($target.attr("data-editbutton")) {
      var $thePanel = $target.parents(".panel");
      var entryId = $thePanel.attr("data-entryid");
      var $textArea = $thePanel
        .children("div.panel-body")
        .first()
        .children("textarea");
      var $submitButton = $target.siblings("button[data-submitbutton=1]");

      if (globIsNodePadEntryEdit) {
        // Cancel
        if (entryId === globNodePadCurrentEntryEdit) {
          // console.log('cancel');

          $submitButton.prop("disabled", true);
          $textArea.prop("readonly", true);
          $target.text("Edit");

          globIsNodePadEntryEdit = false;
          globNodePadCurrentEntryEdit = "";

          $NodePadEntries.focus();
        }

        return;
      }

      // console.log('edit');

      globIsNodePadEntryEdit = true;
      globNodePadCurrentEntryEdit = entryId;

      $textArea.prop("readonly", false);
      $textArea.focus();

      $submitButton.prop("disabled", false);

      $target.text("Cancel");
    } else if ($target.attr("data-submitbutton")) {
      // console.log('submit');

      var $thePanel = $target.parents(".panel");
      var $textArea = $thePanel
        .children("div.panel-body")
        .first()
        .children("textarea");
      var $editButton = $target.siblings("button[data-editbutton=1]");


      var nodeData = getNodeData(globCurrentNode);

      $.post(
        "adminservice.php",
        {
          method: "updateNodePadEntry",
          childId: nodeData.treeid,
          nodpadId: globNodePadCurrentEntryEdit,
          textData: $textArea.val(),
        },
        function (data) {
          if (data) {
            $NodePadEntries.text("");

            tabNodePadGraphsContentControlsGo();
          }
        },
        "json"
      );

      $target.prop("disabled", true);
      $editButton.text("Edit");
      $textArea.prop("readonly", true);

      globIsNodePadEntryEdit = false;
      globNodePadCurrentEntryEdit = "";

      $NodePadEntries.focus();
    }
  });

  function getAllDeviceNodes(nodeId) {
    var nodeTreeData = $TreeGraph.jstree("get_node", nodeId);

    $TreeGraph.jstree("load_all");

    var deviceNodes = [];

    if (nodeId.indexOf("un_") === 0) {
      deviceNodes.push($("#" + nodeId).attr("data-treeid"));
    }

    _.forEach(nodeTreeData.children_d, function (childId, key) {
      if (childId.indexOf("un_") === 0) {
        // var treeId = $('#' + childId).attr('data-treeid');
        var nodeData = getNodeData(childId);

        // console.log('Device node: ', childId, ', treeId: ',
        // nodeData.treeid); // DDD

        deviceNodes.push(nodeData.treeid);
      }
    });

    return deviceNodes;
  }

  function fetchNodepadEntries(presetPeriod, startDate, endDate, textFilter) {
    nodepadAjaxUi(true);

    var deviceNodes = getAllDeviceNodes(globCurrentNode);
    globNodePadFetchSeq += 1;
    var fetchSeq = globNodePadFetchSeq;

    if (globNodePadFetchXhr && globNodePadFetchXhr.abort) {
      globNodePadFetchXhr.abort();
    }

    if (deviceNodes.length) {
      globNodePadFetchXhr = $.post(
        "adminservice.php",
        {
          method: "getNodePad",
          childIds: deviceNodes.join(","),
          presetPeriod: "last" + presetPeriod,
          startDate: startDate,
          endDate: endDate,
          textFilter: textFilter,
        },
        function (data) {
          if (fetchSeq !== globNodePadFetchSeq) {
            return;
          }
          globNodePadFetchXhr = null;
          // Replace, do not append: a slower previous getNodePad must not
          // keep its rows on screen (or in the next Download).
          $NodePadEntries.html("");
          if (data) {
            _.forEach(data, function (logEntry, key) {
              addNodepadLogEntry(
                logEntry.id,
                logEntry.node_name,
                logEntry.name,
                logEntry.text_data,
                logEntry.last_update,
                key
              );
            });
          }

          nodepadAjaxUi(false);
        },
        "json"
      ).fail(function (jqXHR) {
        if (jqXHR && jqXHR.statusText === "abort") {
          return;
        }
        if (fetchSeq !== globNodePadFetchSeq) {
          return;
        }
        globNodePadFetchXhr = null;
        nodepadAjaxUi(false);
        displayNodePadMsg(
          "ERROR: could not load NodePad entries. Please try again.",
          true
        );
      });
    } else {
      globNodePadFetchXhr = null;
      nodepadAjaxUi(false);
    }
  }

  function deleteNodepadEntries(presetPeriod, startDate, endDate, textFilter) {
    nodepadAjaxUi(true);

    var deviceNodes = getAllDeviceNodes(globCurrentNode);

    if (deviceNodes.length) {
      $.post(
        "adminservice.php",
        {
          method: "deleteNodePadEntries",
          childIds: deviceNodes.join(","),
          presetPeriod: "last" + presetPeriod,
          startDate: startDate,
          endDate: endDate,
          textFilter: textFilter,
        },
        function (data) {
          if (data) {
            displayNodePadMsg(
              "NodePad entries deleted according to selected filter."
            );
          } else {
            displayNodePadMsg(
              "ERROR: could not delete NodePad entries according to selected filter. Please try again.",
              true
            );
          }

          nodepadAjaxUi(false);
        },
        "json"
      ).fail(function () {
        nodepadAjaxUi(false);
        displayNodePadMsg(
          "ERROR: could not delete NodePad entries. Please try again.",
          true
        );
      });
    } else {
      nodepadAjaxUi(false);
    }
  }

  $NodePadTabChangeWindowDoSwitch.on("click", function () {
    globIsAllowNodePadDataDiscard = true;

    $NewNodePadEntrySubmit.prop("disabled", true);
    $NodePadNewText.val("");
    globIsNodePadDataChanged = false;

    $NodePadTabChangeWindow.modal("hide");

    enableTabContent(globLastTabChangeRequest);

    $TreeGraph.jstree("deselect_all");
    $TreeGraph.jstree("select_node", globCurrentNode, false);
  });

  $NodePadNodeChangeWindowSwitchDiscard.on("click", function () {
    globIsAllowNodePadDataDiscard = false;

    $NewNodePadEntrySubmit.prop("disabled", true);
    $NodePadNewText.val("");
    globIsNodePadDataChanged = false;

    $NodePadNodeChangeWindow.modal("hide");

    $TreeGraph.jstree("deselect_all");
    $TreeGraph.jstree("select_node", globLastNodeChangeRequest, false);
  });

  $NodePadNodeChangeWindowSwitchKeep.on("click", function () {
    globIsAllowNodePadDataDiscard = false;

    $NodePadNodeChangeWindow.modal("hide");

    $TreeGraph.jstree("deselect_all");
    $TreeGraph.jstree("select_node", globLastNodeChangeRequest, false);
  });

  $NodePadTabDeleteEntriesDoDelete.on("click", function () {
    $NodePadTabDeleteEntries.modal("hide");

    tabNodePadGraphsContentControlsGo(null, true);
  });

  $("#NodePadSecondContentControlsDownload").on("click", function () {
    var nodepadEntries = $("#NodePadEntries")[0].children;
    if (!nodepadEntries.length) {
      return;
    }

    var byNode = {};
    _.forEach(nodepadEntries, function (logEntry) {
      var nodeName = $(logEntry).find("span.nodpad_entry_nodename")[0]
        .innerText;
      var userName = $(logEntry).find("span.nodpad_entry_username")[0]
        .innerText;
      var when = $(logEntry)
        .find("div.panel-heading")
        .first()
        .find("span.pull-right")[0].innerText;
      var body = $(logEntry).find("div.panel-body").first().find("textarea")[0]
        .value;
      if (!byNode[nodeName]) {
        byNode[nodeName] = { start: when, end: when, text: "" };
      }
      byNode[nodeName].end = when;
      byNode[nodeName].text +=
        nodeName +
        ", " +
        userName +
        "\t\t\t\t\t\t\t\t\t\t" +
        when +
        "\n" +
        body +
        "\n\n***************************************************************************************\n\n";
    });

    var names = Object.keys(byNode);
    _.forEach(names, function (nodeName, i) {
      var group = byNode[nodeName];
      var filename =
        "NodePad_" +
        nodeName +
        "(" +
        nodeName +
        ")_" +
        group.start +
        "-" +
        group.end +
        ".txt";
      setTimeout(function () {
        saveBlob(filename, group.text);
      }, i * 250);
    });
  });

  $("#NodePadSecondContentControlsDelete").on("click", function () {
    $NodePadTabDeleteEntries.modal({
      keyboard: false,
      backdrop: "static",
    });
  });

  $LoginButton.on("click", function () {
    var userName = $("#LoginUsername").val();
    var userPassword = $("#LoginPassword").val();
    var userLoginRemember = $("#UserLoginRemember").is(":checked");
    var userOptCode;

    if (globIsOtpValidationProcess) {
      userOptCode = $("#LoginOtpCode").val();

      if (userOptCode) {
        // if (Number.isInteger(Number(userOptCode))) {
        $("#UserLoginAjaxImage").removeClass("hidden");

        $.post(
          "adminservice.php",
          {
            method: "user_login_otp",
            userId: globIsOtpValidationProcessUserId,
            userOptCode: userOptCode,
          },
          function (data) {
            $("#UserLoginAjaxImage").addClass("hidden");

            if (data.isAuth) {
              $("#UserLoginError").addClass("hidden");

              globIsOtpValidationProcess = false;
              globIsMustChangeTempPassword = false;
              globIsMustChangeExpiredPassword = false;

              globUserData = data.userData;
              globCsrfToken = data.csrfToken || "";
              // globServerTime = data.serverTime;
              globServerTimezone = data.timezone;

              $UserName.text(userName);

              hideLoginWindow();

              startApp();
            } else if (data.isOTPWrongCode) {
              $("#UserLoginError").removeClass("hidden").text("Wrong verification code (" + (data.otpMaxRetries - data.otpRetryNumber) + " tries left)");
            } else if (data.isOtpAccountLocked) {
              globIsOtpValidationProcess = false;

              $("#UserLoginError").removeClass("hidden").text(data.otpConfigErrorReason + " - Please try again later");

              hideLoginWindow();
              showLoginWindow();
            } else if (data.isOtpAccounUnlocked) {
              $("#UserLoginError").removeClass("hidden").text("OTP lock removed. New verification code was sent");
            } else if (data.isOtpCodeExpiredAndNewCode) {
              $("#UserLoginError").removeClass("hidden").text("Verification code has expired. New code was sent");
            } else if (data.isOtpWrongCodeOutsideTimeframe) {
              $("#UserLoginError").removeClass("hidden").text("Wrong verification code. New code was sent");
            }
          }, "json");
        // } else {
        //   $("#UserLoginError").removeClass("hidden").text("Verification code must be a number");	
        // }
      } else {
        $("#UserLoginError").removeClass("hidden").text("Verification code can't be empty");
      }
    } else if (userName && userPassword) {
      $("#UserLoginError").addClass("hidden");
      $("#UserLoginAjaxImage").removeClass("hidden");

      $.post(
        "adminservice.php",
        {
          method: "user_login",
          username: userName,
          password: userPassword,
          remember: userLoginRemember,
        },
        function (data) {
          $("#UserLoginAjaxImage").addClass("hidden");

          if (data) {
            if (data.isAuth) {
              globIsMustChangeTempPassword = false;
              globIsMustChangeExpiredPassword = false;

              globUserData = data.userData;
              globCsrfToken = data.csrfToken || "";
              // globServerTime = data.serverTime;
              globServerTimezone = data.timezone;

              $UserName.text(userName);

              hideLoginWindow();

              startApp();
            } else {
              if (data.isAccountDisabled) {
                $("#UserLoginError")
                  .removeClass("hidden")
                  .text(
                    "Authentication error: Account is not active. Contact administrator."
                  );
              } else if (data.isTempPassword) {
                if (data.isTempPasswordExpired) {
                  $("#UserLoginError")
                    .removeClass("hidden")
                    .text(
                      "Authentication error: temporary password expired. Contact administrator."
                    );
                } else {
                  globIsUserStrictPassword = parseInt(data.is_strict_password);
                  globIsMustChangeTempPassword = true;

                  prepareLoginChangePasswordWindow();
                  showLoginChangePasswordWindow();
                }
              } else if (data.isPasswordExpired) {
                globIsUserStrictPassword = parseInt(data.is_strict_password);
                globIsMustChangeExpiredPassword = true;

                prepareLoginChangePasswordWindow();
                showLoginChangePasswordWindow();
              } else if (data.isOtpAccountLocked) {
                $("#UserLoginError")
                  .removeClass("hidden")
                  .text(
                    data.otpConfigErrorReason + " - Please try again later"
                  );
              } else if (data.isOtpConfigError) {
                $("#UserLoginError")
                  .removeClass("hidden")
                  .text("OTP configuration is invalid - Please contact Ubiqam");
              } else if (data.isUseGroupOtp | data.isUseUserOtp) {
                globIsOtpValidationProcess = true;
                globIsOtpValidationProcessUserId = data.userId;

                $("#LoginOtpCodeControl").removeClass("hidden");
                $("#LoginUsername").prop("disabled", true);
                $("#LoginPassword").prop("disabled", true);

                $LoginChangePasswordButton.prop("disabled", true);

                var otpMethodText = "";
                if (data.otpMethod === "email") {
                  otpMethodText = "email address";
                } else if (data.otpMethod === "SMS") {
                  otpMethodText = "phone";
                }

                $("#UserLoginError").removeClass("hidden").text("A verification code was sent to your " + otpMethodText + ", please enter the code");
              }
            }
          } else {
            $("#UserLoginError").removeClass("hidden").text("Authentication error: Check user and password");
          }
        },
        "json"
      );
    } else {
      $("#UserLoginAjaxImage").addClass("hidden");
      $("#UserLoginError")
        .removeClass("hidden")
        .text("Please enter a user and password");
    }
  });

  $LoginChangePasswordButton.on("click", function () {
    var userName = $("#LoginUsername").val();
    var userPassword = $("#LoginPassword").val();
    var userOptCode;

    if (globIsChangePasswordOtpValidationProcess) {
      userOptCode = $("#LoginOtpCode").val();

      if (userOptCode) {
        // if (Number.isInteger(Number(userOptCode))) {
        $("#UserLoginAjaxImage").removeClass("hidden");

        $.post(
          "adminservice.php",
          {
            method: "user_login_otp",
            userId: globIsOtpValidationProcessUserId,
            userOptCode: userOptCode,
          },
          function (data) {
            $("#UserLoginAjaxImage").addClass("hidden");

            if (data.isAuth) {
              $("#UserLoginError").addClass("hidden");

              globIsChangePasswordOtpValidationProcess = false;

              globIsMustChangeTempPassword = false;
              globIsMustChangeExpiredPassword = false;

              globIsUserStrictPassword = parseInt(
                data.userData.is_strict_password
              );

              prepareLoginChangePasswordWindow();
              showLoginChangePasswordWindow();
            } else if (data.isOTPWrongCode) {
              $("#UserLoginError").removeClass("hidden").text("Wrong verification code (" + (data.otpMaxRetries - data.otpRetryNumber) + " tries left)");
            } else if (data.isOtpAccountLocked) {
              globIsOtpValidationProcess = false;

              $("#UserLoginError").removeClass("hidden").text(data.otpConfigErrorReason + " - Please try again later");

              hideLoginWindow();
              showLoginWindow();
            } else if (data.isOtpAccounUnlocked) {
              $("#UserLoginError").removeClass("hidden").text("OTP lock removed. New verification code was sent");
            } else if (data.isOtpCodeExpiredAndNewCode) {
              $("#UserLoginError").removeClass("hidden").text("Verification code has expired. New code was sent");
            } else if (data.isOtpWrongCodeOutsideTimeframe) {
              $("#UserLoginError").removeClass("hidden").text("Wrong verification code. New code was sent");
            }
          }, "json");
        // } else {
        //   $("#UserLoginError").removeClass("hidden").text("OTP code must be a number");	
        // }
      } else {
        $("#UserLoginError").removeClass("hidden").text("Verification code can't be empty");
      }
    } else if (userName && userPassword) {
      $("#UserLoginError").addClass("hidden");
      $("#UserLoginChangePasswordAjaxImage").removeClass("hidden");

      $.post(
        "adminservice.php",
        {
          method: "user_login",
          username: userName,
          password: userPassword,
        },
        function (data) {
          $("#UserLoginChangePasswordAjaxImage").addClass("hidden");

          if (data) {
            if (data.isAuth) {
              $("#UserLoginError").addClass("hidden");

              globIsMustChangeTempPassword = false;
              globIsMustChangeExpiredPassword = false;

              globIsUserStrictPassword = parseInt(
                data.userData.is_strict_password
              );

              prepareLoginChangePasswordWindow();
              showLoginChangePasswordWindow();
            } else {
              if (data.isAccountDisabled) {
                $("#UserLoginError")
                  .removeClass("hidden")
                  .text(
                    "Authentication error: Account is not active. Contact administrator."
                  );
              } else if (data.isTempPassword) {
                if (data.isTempPasswordExpired) {
                  $("#UserLoginError")
                    .removeClass("hidden")
                    .text(
                      "Authentication error: temporary password expired. Contact administrator."
                    );
                } else {
                  globIsUserStrictPassword = parseInt(data.is_strict_password);
                  globIsMustChangeTempPassword = true;

                  prepareLoginChangePasswordWindow();
                  showLoginChangePasswordWindow();
                }
              } else if (data.isPasswordExpired) {
                globIsUserStrictPassword = parseInt(data.is_strict_password);
                globIsMustChangeExpiredPassword = true;

                prepareLoginChangePasswordWindow();
                showLoginChangePasswordWindow();
              } else if (data.isOtpAccountLocked) {
                $("#UserLoginError")
                  .removeClass("hidden")
                  .text(
                    data.otpConfigErrorReason + " - Please try again later"
                  );
              } else if (data.isOtpConfigError) {
                $("#UserLoginError")
                  .removeClass("hidden")
                  .text("OTP configuration is invalid - Please contact Ubiqam");
              } else if (data.isUseGroupOtp | data.isUseUserOtp) {
                globIsChangePasswordOtpValidationProcess = true;
                globIsOtpValidationProcessUserId = data.userId;

                $("#LoginOtpCodeControl").removeClass("hidden");
                $("#LoginUsername").prop("disabled", true);
                $("#LoginPassword").prop("disabled", true);

                $("#LoginButton").prop("disabled", true);

                var otpMethodText = "";
                if (data.otpMethod === "email") {
                  otpMethodText = "email address";
                } else if (data.otpMethod === "SMS") {
                  otpMethodText = "phone";
                }

                $("#UserLoginError").removeClass("hidden").text("A verification code was sent to your " + otpMethodText + ", please enter the code");
              }
            }
          } else {
            $("#UserLoginError")
              .removeClass("hidden")
              .text("Authentication error: Check user and password");
          }
        },
        "json"
      );
    } else {
      $("#UserLoginAjaxImage").addClass("hidden");
      $("#UserLoginError")
        .removeClass("hidden")
        .text("Please enter a user and password");
    }
  });

  function isChangePasswordLengthOK(pass) {
    return pass.length >= 8 && pass.length <= 46;
  }

  function isChangePasswordAlphaOK(pass) {
    return /[a-z]/i.test(pass);
  }

  function isChangePasswordNumericOK(pass) {
    return /[0-9]/i.test(pass);
  }

  function isChangePasswordSpecialOK(pass) {
    var isHasSymbol = /[\+\=_\)\(\*%$#@\!`\\\}\{\[\]\?\/.,\-]/i.test(pass);
    var isSpaceOk =
      / /i.test(pass) &&
      pass.indexOf(" ") > 0 &&
      pass.lastIndexOf(" ") < pass.length - 1;
    var isOk = false;

    if (!/ /i.test(pass)) {
      if (isHasSymbol) {
        isOk = true;
      }
    } else {
      isOk = isSpaceOk;
    }

    return isOk;
  }

  function setColorWarningOrOk(el, isOk) {
    if (isOk) {
      el.removeClass("text-danger");
      el.addClass("text-success");
    } else {
      el.removeClass("text-success");
      el.addClass("text-danger");
    }
  }

  function setColorWarningOrOkChangePassword(passEl, passVerifyEl, isPassOk) {
    if (isPassOk) {
      passEl.css("border-color", "rgb(204, 204, 204)");
    } else {
      passEl.css("border-color", "red");
    }

    if (isPassOk && passEl.val() === passVerifyEl.val()) {
      $("#LoginChangePasswordVerify").css("border-color", "rgb(204, 204, 204)");
      $("#LoginChangePasswordChangeButton").prop("disabled", false);
    } else {
      $("#LoginChangePasswordVerify").css("border-color", "red");
      $("#LoginChangePasswordChangeButton").prop("disabled", true);
    }
  }

  $("#LoginChangePassword").on("input", function (e) {
    var isChangePasswordLength = false;
    var isChangePasswordAlpha = false;
    var isChangePasswordNumeric = false;
    var isChangePasswordSpecial = false;
    var RulesCount = 0;

    var changePassword = $("#LoginChangePassword").val();

    globIsChangePasswordOK = isChangePasswordLength =
      isChangePasswordLengthOK(changePassword);
    setColorWarningOrOk(
      $("#LoginChangePasswordReqLength"),
      isChangePasswordLength
    );

    if (globIsUserStrictPassword) {
      isChangePasswordAlpha = isChangePasswordAlphaOK(changePassword);
      setColorWarningOrOk(
        $("#LoginChangePasswordReqAlpha"),
        isChangePasswordAlpha
      );
      if (isChangePasswordAlpha) {
        ++RulesCount;
      }

      isChangePasswordNumeric = isChangePasswordNumericOK(changePassword);
      setColorWarningOrOk(
        $("#LoginChangePasswordReqNumeric"),
        isChangePasswordNumeric
      );
      if (isChangePasswordNumeric) {
        ++RulesCount;
      }

      isChangePasswordSpecial = isChangePasswordSpecialOK(changePassword);
      setColorWarningOrOk(
        $("#LoginChangePasswordReqSpecial"),
        isChangePasswordSpecial
      );
      if (isChangePasswordSpecial) {
        ++RulesCount;
      }

      globIsChangePasswordOK = isChangePasswordLength && RulesCount >= 2;
    }

    setColorWarningOrOkChangePassword(
      $("#LoginChangePassword"),
      $("#LoginChangePasswordVerify"),
      globIsChangePasswordOK
    );
  });

  $("#LoginChangePasswordVerify").on("input", function (e) {
    setColorWarningOrOkChangePassword(
      $("#LoginChangePassword"),
      $("#LoginChangePasswordVerify"),
      globIsChangePasswordOK
    );
  });

  $("#LoginChangePasswordChangeButton").on(
    "click",
    function doChangePassword() {
      $("#UserLoginChangePasswordError").addClass("hidden");
      $("#UserLoginChangePasswordChangeAjaxImage").removeClass("hidden");

      var userName = $("#LoginUsername").val();
      var userPassword = $("#LoginPassword").val();
      var userNewPassword = $("#LoginChangePassword").val();

      $.post(
        "adminservice.php",
        {
          method: "user_change_password",
          username: userName,
          currentpassword: userPassword,
          newpassword: userNewPassword,
        },
        function postReturn(data) {
          $("#UserLoginChangePasswordChangeAjaxImage").addClass("hidden");

          if (data.isAccountDisabled) {
            $("#UserLoginChangePasswordError").text(
              "Account is not active. Contact administrator."
            );

            $("#UserLoginChangePasswordError").removeClass("hidden");
          } else if (data.isFailOnSimilarity) {
            $("#UserLoginChangePasswordError").text(
              "Password is too similar to a previous password."
            );

            $("#UserLoginChangePasswordError").removeClass("hidden");
          } else if (!data.isNewPasswordOk) {
            $("#UserLoginChangePasswordError").text(
              "Password doesn't conform to the requirements."
            );

            $("#UserLoginChangePasswordError").removeClass("hidden");
          } else {
            // success
            hideLoginChangePasswordWindow();
            hideLoginWindow();
            showLoginWindow();

            if (globIsMustChangeTempPassword) {
              globIsMustChangeTempPassword = false;

              showLoginWindow();
            }
          }
        },
        "json"
      );
    }
  );

  $("#LoginChangePasswordCancelButton").on("click", function () {
    if (!globIsMustChangeTempPassword) {
      $("#UserLoginChangePasswordError").addClass("hidden");

      hideLoginChangePasswordWindow();
      hideLoginWindow();
      showLoginWindow();
    }
  });

  /*
   * Theme toggle. The <head> bootstrap has already applied the stored choice
   * before first paint; this only handles switching and persisting it, and
   * syncs the button's label/state to whatever is currently applied.
   *
   * Graphs read their colours at draw time, so switching theme does not
   * restyle anything already on screen. Nothing is redrawn here on purpose:
   * a redraw would drop the user's zoom/selection. The plots are black in
   * both themes, so they stay legible either way, and the next GO picks up
   * the new surface colours.
   */
  var THEME_KEY = "ubiview-theme";

  function applyThemeUi(theme) {
    var isDark = theme === "dark";
    var label = isDark ? "Switch to light theme" : "Switch to dark theme";

    $("#ThemeToggle")
      .attr("title", label)
      .attr("aria-label", label)
      .attr("aria-pressed", isDark ? "true" : "false");
  }

  function currentTheme() {
    return document.documentElement.getAttribute("data-theme") === "light"
      ? "light"
      : "dark";
  }

  applyThemeUi(currentTheme());

  $("#ThemeToggle").on("click", function () {
    var next = currentTheme() === "dark" ? "light" : "dark";

    // Always written out, never removed. With dark as the default, a missing
    // attribute would mean light at runtime but dark on the next load, so the
    // attribute is kept explicit and the two agree.
    document.documentElement.setAttribute("data-theme", next);

    try {
      localStorage.setItem(THEME_KEY, next);
    } catch (e) {
      // Private mode: the theme still applies for this session, just not after
      // a reload. Not worth surfacing to the user.
    }

    applyThemeUi(next);
  });

  $LogoutButton.on("click", function () {
    clearTreeRefreshInterval();

    $.post(
      "adminservice.php",
      {
        method: "user_logout",
      },
      function (data) {
        console.log("Logout", data); // DDD
      },
      "json"
    );

    if (globTreeData) {
      $TreeGraph.jstree(true).destroy();
    }

    globUserData = null;
    globTreeData = null;
    globCsrfToken = "";
    $UserName.text("");

    $TabGraphsContent.text("");
    $TabRRDGraphsContent.text("");
    $TabRemoteMContent.text("");
    $TabEventLContent.text("");
    $TabUserAuditContent.text("");
    $TabDeviceInfoContent.text("");

    globCurrentNode = "";
    globNumCommStatusErrors = 0;
    updateCommStatus();

    showLoginWindow();
  });

  $TreeRefreshButton.on("click", function (e) {
    globIsManualTreeRefresh = true;

    setTreeRefreshInterval();
    createTree();
  });

  $("#LoginUsername, #LoginPassword").keyup(function (e) {
    if (e.keyCode == 13) {
      $("#LoginButton").click();
    }
  });

  $NodePadNewText.on("keyup", function (e) {
    var isToEnable = $NodePadNewText.val().trim().length > 0;

    if (isToEnable) {
      globIsNodePadDataChanged = true;
    } else {
      globIsNodePadDataChanged = false;
    }

    $NewNodePadEntrySubmit.prop("disabled", !isToEnable);
  });

  $NewNodePadEntrySubmit.on("click", function (e) {
    var textData = $NodePadNewText.val();

    if (textData.trim().length > 0) {
      $NewNodePadEntrySubmit.prop("disabled", true);
      $NewNodePadEntrySubmitImage.removeClass("hidden");

      var nodeData = getNodeData(globCurrentNode);

      $.post(
        "adminservice.php",
        {
          method: "addNodePadEntry",
          childId: nodeData.treeid,
          textData: textData,
        },
        function (data) {
          if (data) {
            // data = false/nodeId
            var msgDate = moment
              .tz(globServerTimezone)
              .format("ddd, DD MMM YYYY HH:mm");

            addNodepadLogEntry(
              data,
              nodeData.node_name,
              globUserData.name,
              textData,
              msgDate,
              $NodePadEntries.children(".nodpad_entry").length
            );
          } else {
            // OOO
            // $("#UserLoginError").removeClass("hidden").text("Login
            // error: Check user and password");
          }

          $NodePadNewText.val("");
          globIsNodePadDataChanged = false;

          // $NewNodePadEntrySubmit.prop('disabled', false);
          $NewNodePadEntrySubmitImage.addClass("hidden");
        },
        "json"
      );
    }
  });

  function commErrorNodesDisplay() {
    var inst = $TreeGraph.jstree(true);
    if (!inst) return;

    try {
      if ($StatusCommButton.hasClass("active")) {
        globSaveTreeScrollTop = $TreeArea.scrollTop();
        globTreeData.treeNodesData.forEach(function (v, i) {
          if (
            v.communication_status !== "1" &&
            !inst.is_undetermined(v.id) &&
            !inst.is_checked(v.id)
          ) {
            // console.log('Hiding: ', v.id, v.node_name); // DDD
            inst.hide_node(v.id);
          }
        });
      } else {
        inst.show_all();
        $TreeArea.scrollTop(globSaveTreeScrollTop);
      }
    } catch (err) {
      console.log("commErrorNodesDisplay: skipped due to error: ", err);
    }
  }

  $StatusCommButton.on("click", function (e) {
    $StatusCommButton.toggleClass("active");

    commErrorNodesDisplay();
  });

  function propagateBypassState() {
    // var nodesInBypass = [];
    // var nodeId = data.node.id;
    // var isInBypass = isNodeInBypass(nodeId);
    // commStatus from check plugin (not sure if the parent are checked like the actual nodes or just the icon is different).
    // setNodeIcon(nodeParent, commStatus, null, null, isInBypass);
  }

  function bindTreeEvents() {
    $TreeGraph.on("check_node.jstree uncheck_node.jstree", function (e, data) {
      if (isDebug()) {
        console.log("EVENT " + e.type + ".jstree: ", e, data); // DDD
      }

      var nodeId = data.node.id;

      if (
        e.type === "check_node" ||
        e.type === "uncheck_node" /*&& (!IsSiblingsWithCommError(nodeId))*/
      ) {
        if (isDebug()) {
          console.log(e.type, ": ", nodeId); // DDD
        }

        var nodeParents = data.node.parents;

        _.forEach(nodeParents, function (nodeParent, key) {
          if (nodeParent !== "#") {
            var isUndetermined = $TreeGraph.jstree(
              "is_undetermined",
              nodeParent
            );
            var commStatus = e.type === "check_node" ? "1" : null;
            var isPhysicalPort = isPhysicalPortNode(nodeParent);

            if (isDebug()) {
              console.log(
                nodeParent,
                ", isUndetermined = ",
                isUndetermined,
                "commStatus = ",
                commStatus
              );
            }

            if (isUndetermined || e.type === "uncheck_node" || isPhysicalPort) {
              if (isDebug()) {
                console.log("isUndeterminded: ", nodeParent, commStatus);
              }

              setNodeIcon(nodeParent, commStatus);
            }
          }
        });
      }
    });

    $TreeGraph.on("select_node.jstree", function (e, data) {
      var isPhysicalPort = isPhysicalPortNode(data.node.id);

      if (globIsNodePadEntryEdit || globDeviceInfoIsEdit) {
        return;
      }

      setTreeRefreshInterval();

      if (isDebug()) {
        console.log("EVENT " + e.type + ".jstree: ", e, data); // DDD
      }

      if (!data.node.data) {
        return;
      }

      var nodeId = data.node.id;
      var nodeTreeId = data.node.data.treeid;
      var nodeParent = data.node.parent;
      var nodePid = data.node.data.pid;

      if (globCurrentNode != nodeId) {
        globTabRRDContentGraphsContainerScrollPos = 0;
        globIsSameNodeSelected = false;

        $TabUtilsCmdSelectOutput.html("");
      } else {
        globIsSameNodeSelected = true;
      }

      globCurrentNode = nodeId;

      var nodeData;
      var emsIP;

      if (!isPhysicalPort) {
        nodeData = getNodeData(nodeId);

        var is4Ant = isHas4AntData(nodeData);
      }

      if (isDebug()) {
        console.log(
          "id = ",
          nodeId,
          ",treeid = ",
          nodeTreeId,
          ", pid = ",
          nodePid
        ); // DDD
      }

      globMap = null;

      switch (globCurrentTab) {
        case "graphs":
          if (!globIsManualTreeRefresh) {
            if (nodeTreeId !== -1) {
              // console.log('nodeTreeId = ', nodeTreeId);

              $TabGraphsContent.html(
                "<iframe style='width:100%;height:100%' seamless frameborder=0 id='cacti_graph' src='/cacti/graph_view.php?action=tree&tree_id=" +
                nodePid +
                "&leaf_id=" +
                nodeTreeId +
                "&cacti_user_id=" +
                globUserData.cactiuser +
                "'  ></iframe>"
              );

              // if ((globUserData.groupName === 'dev') ||
              // (globUserData.groupName === 'Ubiqam')) {
              // // 817 = ucu1285-a
              // if (nodeTreeId === 817) {
              // // console.log('Display POC');
              //
              // $TabGraphsContent.find('iframe').css('height', '51%');
              // $TabGraphsContent.append("<iframe
              // style='width:100%;height:49%;margin-top:-5px;border-top:1px
              // solid black;' seamless frameborder=0
              // id='GraphsPOCContent'
              // src='http://192.168.33.150:8080/NMS/graphsPOC.html'></iframe>");
              // }
              // }
            }
          } else {
            globIsManualTreeRefresh = false;
          }

          break;
        case "rrdgraphs":
          if (!(globIsManualTreeRefresh || globIsCreateTree)) {
            if (globAjaxRequest) {
              globAjaxRequest.abort();
              globAjaxRequest = false;
              rrdAjaxUi(false);
              globIsParentSummaryRRDGraphs = false;
            }

            if (
              !isUserRole("High Level Graphs") &&
              !isPhysicalPort &&
              (!nodeData ||
                (nodeData.id.indexOf("un_") !== 0 &&
                  nodeData.id.indexOf("D_") !== 0))
            ) {
              displayRRDMsg(
                "Graphs are only available for UCU & UMU devices and their immediate parents."
              );
            } else {
              enableRRDContent();

              RRDGraphsContainerRect =
                $TabRRDContentGraphsContainer[0].getBoundingClientRect();

              globRRDGraphsZoomDates = [];

              var isImmediateParent =
                !isPhysicalPort && nodeData.id.indexOf("D_") === 0
                  ? true
                  : false;
              globIsHighLevelParent =
                !isPhysicalPort &&
                  (nodeData.id.indexOf("L_") === 0 ||
          nodeData.id === "root" ||
          // "un" (Unassigned) is a container like root, not a device. Leaving
          // it out sent it down the single-device branch, which walks up two
          // levels for a grandparent it does not have: get_node("#").parent is
          // null, get_node(null) returns false, and false.children_d is
          // undefined — hence "Cannot read properties of undefined (reading
          // 'filter')" on OPTiX. It also has act_name null, which reached the
          // backend as the string "null" and produced a 500.
          nodeData.id === "un")
                  ? true
                  : false;

              if (!(globIsHighLevelParent && globIsSameNodeSelected)) {
                $TabRRDContentGraphsContainer.html("");
              }

              // For without auto go
              // globIsParentSummaryRRDGraphs = (!isPhysicalPort && (nodeData.id.indexOf('D_') === 0)) ? true : false;

              // ++ Auto go
              // if (!globIsSameNodeSelected) {
              if (isPhysicalPort) {
                tabRRDGraphsContentControlsGo(null, null, false);
              } else if (isImmediateParent) {
                tabRRDGraphsContentControlsGo(null, null, true);
              } else if (globIsHighLevelParent) {
                // No auto-Go on high level parent.
              } else {
                tabRRDGraphsContentControlsGo();
              }
              // }
              // == Auto go
            }
          }

          break;
        case "spectrographs":
          if (!(globIsManualTreeRefresh || globIsCreateTree)) {
            if (globAjaxRequest) {
              globAjaxRequest.abort();
              globAjaxRequest = false;
              spectrogramsAjaxUi(false);
            }

            if (isPhysicalPort) {
              var portTreeData = $("#TreeGraph").jstree("get_node", nodeId);
              if (portTreeData.children.length) {
                $TreeGraph.jstree("deselect_all");
                $TreeGraph.jstree(
                  "select_node",
                  portTreeData.children[0],
                  false
                );
              }
            } else {
              if (
                !nodeData ||
                isUCU(nodeData) ||
                nodeData.id.indexOf("un_") !== 0
              ) {
                displaySpectrogramsMsg(
                  "Spectrograms are only available for UMU devices."
                );
              } else {
                enableSpectrogramsContent(is4Ant, true);

                spectrogramWindow1Rect =
                  $SpectrogramWindow1[0].getBoundingClientRect();
                spectrogramWin1GraphsContainerRect =
                  $SpectrogramWin1GraphsContainer[0].getBoundingClientRect();
                // console.log('SpectrogramWindow1Rect',
                // spectrogramWindow1Rect);
                // console.log('spectrogramWin1GraphsContainerRect',
                // spectrogramWin1GraphsContainerRect);

                if ($("#TabSpectrogramsContentControlsRange").prop("checked")) {
                  var spectrogramsStartDate =
                    $TabSpectrogramsContentControlsStartDate
                      .data("DateTimePicker")
                      .date();
                  var spectrogramsEndDate =
                    $TabSpectrogramsContentControlsEndDate
                      .data("DateTimePicker")
                      .date();

                  if (spectrogramsStartDate && spectrogramsEndDate) {
                    tabSpectrogramsContentControlsGo();
                  }
                } else {
                  tabSpectrogramsContentControlsGo();
                }
              }
            }
          }

          break;
        case "remotem":
          if (!isPhysicalPort) {
            if (!globIsCreateTree) {
              var parentDNodeID;

              // "un_", not "un": device nodes are un_38, un_39 and so on, but
              // the Unassigned container's id is exactly "un", so the loose
              // prefix matched it too and sent a container down the
              // find-my-parent-device branch. Its parent is the tree root, so
              // the walk produced a null id and getNodeData(null) threw on
              // indexOf. Unassigned has no EMS to reach, so it belongs in
              // neither branch.
              if (data.node.id.indexOf("un_") === 0) {
                var parentDNodeData;

                if (isUCU(getNodeData(data.node.id))) {
                  parentDNodeID = $("#TreeGraph").jstree(
                    "get_node",
                    data.node.parent
                  ).id;
                } else {
                  parentDNodeID = $("#TreeGraph").jstree(
                    "get_node",
                    data.node.parent
                  ).parent;
                }

                parentDNodeData = parentDNodeID
                  ? getNodeData(parentDNodeID)
                  : null;
                emsIP = parentDNodeData ? parentDNodeData.ip : null;
              } else if (data.node.id.indexOf("D_") === 0) {
                parentDNodeID = data.node.id;
                emsIP = nodeData.ip;
              }

              if (emsIP) {
                var unitNumber = +(emsIP.match(/\d+/) || [])[0];

                if (unitNumber >= 7000) {
                  emsIP = emsIP.replace(/^(https?:\/\/)?/, 'https://');
                } else {
                  if (emsIP.indexOf("http://") < 0 && emsIP.indexOf("https://") < 0) {
                    emsIP = "http://" + emsIP;
                  }
                }

                // The proxy adds the unit login for this node on the server.
                var credMode = "ems";

                if (unitNumber < 2600) {
                  emsIP += "/cgi-bin/luci/admin/lucigen_ucu/overview";
                  credMode = "luci";
                }

                emsIP +=
                  "&uvnode=" +
                  encodeURIComponent(parentDNodeID) +
                  "&uvcred=" +
                  credMode;

                if (isDebug()) {
                  console.log(emsIP);
                }

                $TabRemoteMContent.html(
                  "<iframe style='width:100%;height:100%' seamless frameborder=0 id='remote_page' src='glypeproxy/browse.php?u=" +
                  escapeHtml(emsIP) +
                  "' ></iframe>  </div>"
                );
              }
            }
          }

          break;
        case "eventlog":
          if (!isPhysicalPort) {
            $.post(
              "updateLog.php",
              {
                id: nodeId,
                ignore: globUserData.ignoredNodes,
                par: data.node.parent,
              },
              function (result) {
                if (result.trim() == "Authentication error.") {
                  window.location = "index.php";
                } else {
                  $TabEventLContent.html(DOMPurify.sanitize(result));

                  $("#myTable").DataTable({
                    order: [[1, "desc"]],
                  });
                }
              }
            );
          }

          break;
        case "useraudit":
          if (!isPhysicalPort) {
            $.post(
              "adminservice.php",
              {
                method: "getUserAuditLog",
                viewtree: globUserData.viewtree,
              },
              function (data) {
                // console.log('getUserAuditLog data: ', data); // DDD

                $TabUserAuditContent.html(DOMPurify.sanitize(data));

                $("#userAuditTable").DataTable({
                  order: [[0, "asc"]],
                });
              }
            );
          }

          break;
        case "deviceinfo":
          var html = '';

          if (isPhysicalPort) {
            var portTreeData = $("#TreeGraph").jstree("get_node", nodeId);
            if (portTreeData.children.length) {
              $TreeGraph.jstree("deselect_all");
              $TreeGraph.jstree("select_node", portTreeData.children[0], false);
            } else {
              html = '<h4 id="DeviceInfoNoData" class="text-center">Device info is available only for links or UCU.</h4>';
              $TabDeviceInfoContent.html(html);
            }
          } else {
            //if (!isPhysicalPort) {
            var deviceId = nodeData.id;

            if (deviceId.indexOf("un_") !== 0) {
              html = '<h4 id="DeviceInfoNoData" class="text-center">Device info is available only for links or UCU.</h4>';
              $TabDeviceInfoContent.html(html);

              break;
            }

            var deviceName = isUCU(nodeData) ? nodeData.act_name.substr(0, 7) : "";

            $.post(
              "adminservice.php",
              {
                method: "getDeviceInfo",
                isUCU: isUCU(nodeData),
                deviceId: deviceId,
                deviceName: deviceName
              },
              function (data) {
                if (isDebug()) {
                  console.log("dinfo data: ", data);
                }

                html = '<div id="DeviceInfoData">';
                html += '<table class="table table-striped table-hover">';
                html += "<thead><tr><th>Key</th><th>Value</th></tr></thead><tbody>";

                if (data.deviceInfoHuman) {
                  _.forOwn(data.deviceInfoHuman, function (value, key) {
                    if (key === "Location Accuracy") {
                      if (value === "-1") {
                        value = "User set"
                      }
                    }

                    html +=
                      '<tr><td class="DeviceInfoKey">' +
                      key +
                      '</td><td class="DeviceInfoValue">' +
                      value +
                      "</td></tr>";
                  });
                }

                if (data.deviceSaveInfoHuman) {
                  _.forOwn(data.deviceSaveInfoHuman, function (value, key) {
                    html +=
                      '<tr data-savevalue="1"><td class="DeviceInfoKey">' + value.displayName +
                      '</td><td class="DeviceInfoValue">' +
                      '<span style="display: inline-block;width:87%;"><input type="text" disabled style="width: 99%;" id="' + key + '" name="' + key + '" value="' + value.value + '">' +
                      '</input></span>' +
                      '<span style="display: inline-block;width:13%"><button type="button" class="btn btn-sm btn-primary" data-purpose="edit" data-key="' + key + '">&nbsp;&nbsp;Edit&nbsp;&nbsp;&nbsp;</button>' +
                      '<button type="button" disabled class="btn btn-sm btn-primary" style="margin-left: 5px;" data-purpose="submit" data-key="' + key + '">Submit</button>' +
                      '</span>' +
                      "</td></tr>";
                  });
                }

                html += "</tbody></table></div>";
                $TabDeviceInfoContent.html(html);

                $("#DeviceInfoData tr[data-savevalue='1'] button[data-purpose='edit']").on('click', function (e) {
                  var eKey = e.target.attributes['data-key'].nodeValue;
                  var editElement = $("#" + eKey);

                  if (!globDeviceInfoIsEdit) { // Edit
                    $(e.target).text('Cancel');
                    editElement.prop("disabled", false);
                    globDeviceInfoIsEdit = true;
                    globDeviceEditKey = eKey;
                    globDeviceInfoOriginalText = editElement.val();
                    globDeviceInfoIsEditDataChanged = false;

                    editElement.on('change keyup', function (e) {
                      if (editElement.val() !== globDeviceInfoOriginalText) {
                        globDeviceInfoIsEditDataChanged = true;
                      } else {
                        globDeviceInfoIsEditDataChanged = false;
                      }
                    });

                    $("#DeviceInfoData tr[data-savevalue='1'] button[data-purpose='submit'][data-key='" + eKey + "'").prop("disabled", false);
                  } else if (eKey === globDeviceEditKey) { // Cancel
                    editElement.off('change keyup');
                    $(e.target).html('&nbsp;&nbsp;Edit&nbsp;&nbsp;&nbsp;');
                    editElement.prop("disabled", true);
                    globDeviceInfoIsEdit = false;
                    editElement.val(globDeviceInfoOriginalText);
                    globDeviceInfoIsEditDataChanged = false;

                    $("#DeviceInfoData tr[data-savevalue='1'] button[data-purpose='submit'][data-key='" + eKey + "'").prop("disabled", true);
                  }
                });


                $("#DeviceInfoData tr[data-savevalue='1'] button:contains('Submit')").on('click', function (e) {
                  // console.log(e);
                  var eKey = e.target.attributes['data-key'].nodeValue;;
                  var editElement = $("#" + eKey);

                  globDeviceInfoIsEdit = false;
                  $("#DeviceInfoData tr[data-savevalue='1'] button[data-purpose='edit'][data-key='" + eKey + "'").html('&nbsp;&nbsp;Edit&nbsp;&nbsp;&nbsp;');
                  editElement.prop("disabled", true);
                  $(e.target).prop("disabled", true);

                  if (globDeviceInfoIsEditDataChanged) {
                    globDeviceInfoIsEditDataChanged = false;

                    var data = {};
                    data[eKey] = editElement.val();

                    $.post(
                      "adminservice.php",
                      {
                        method: "saveDeviceInfo",
                        deviceId: deviceId,
                        deviceName: deviceName,
                        data: JSON.stringify(data)
                      },
                      function (data) {
                        if (!data) {
                          $("#DeviceInfoEntryEditErrorWindow").modal({
                            keyboard: false,
                            backdrop: "static",
                          });

                          editElement.val(globDeviceInfoOriginalText); // change to original value on error
                        }
                      });
                  }
                });
              }
            );
          }

          break;
        case "mapinfo":
          if (!globIsCreateTree) {
            $TabMapContent.html("").css("background-color", "white");

            var deviceLocations = [];
            var aLoc = null;
            globMapMarkers = [];

            // "un_" rather than "un" — see the note in the remotem case. The
            // Unassigned container is not a device and has no location.
            if (data.node.id.indexOf("un_") === 0) {
              aLoc = getDeviceLocation(nodeData, nodeParent);

              if (aLoc) {
                deviceLocations.push(aLoc);
              }
            } else if (data.node.id.indexOf("D_") === 0) {
              aLoc = getDeviceLocation(nodeData, nodeId);

              if (aLoc) {
                deviceLocations.push(aLoc);
              }
            } else {
              // virtual
              var parentTreeData = $TreeGraph.jstree("get_node", nodeId);
              var deviceParents = [];

              _.forEach(parentTreeData.children_d, function (child, key) {
                if (child.indexOf("D_") === 0 && !isPhysicalPortNode(child)) {
                  deviceParents.push(child);
                }
              });

              _.forEach(deviceParents, function (deviceParent, key) {
                var deviceParentData = getNodeData(deviceParent);

                var deviceLocation = getDeviceLocation(
                  deviceParentData,
                  deviceParent
                );

                if (deviceLocation) {
                  // deviceLocation.id = deviceParent;
                  // deviceLocation.node_name =
                  // deviceParentData.node_name;
                  deviceLocations.push(deviceLocation);
                }
              });
            }

            if (deviceLocations.length) {
              // console.log(deviceLocations); // DDD

              globMap = new google.maps.Map($TabMapContent[0], {
                center: {
                  lat: deviceLocations[0].lat,
                  lng: deviceLocations[0].lng,
                },
                zoom: 11, // 1: World, 5: Landmass/continent, 10:
                // City, 15: Streets, 20: Buildings
                draggable: true,
                scaleControl: true,
                fullscreenControl: false,
              });

              var mapBounds = new google.maps.LatLngBounds();

              _.forEach(deviceLocations, function (aLocation, key) {
                var markerIcon = getMapMarkerIcon(aLocation);
                // console.log(markerIcon); // DDD

                var marker = new google.maps.Marker({
                  map: globMap,
                  position: new google.maps.LatLng(
                    aLocation.lat,
                    aLocation.lng
                  ),
                  icon: {
                    url: markerIcon,
                  },
                  title:
                    aLocation.node_name.indexOf("-") > -1
                      ? aLocation.node_name.substr(
                        0,
                        aLocation.node_name.indexOf("-")
                      )
                      : aLocation.node_name,
                });

                globMapMarkers.push({
                  location: aLocation,
                  marker: marker,
                });

                mapBounds.extend(marker.position);
              });

              _.forEach(globMapMarkers, function (marker, key) {
                // console.log(marker); // DDD

                google.maps.event.addListener(
                  marker.marker,
                  "click",
                  (function (marker) {
                    return function (e) {
                      $TreeGraph.jstree("select_node", marker.location.id);

                      var offset =
                        Math.abs(
                          $TreeArea.scrollTop() -
                          $("#" + marker.location.id)[0].offsetTop
                        ) * 0.8;

                      $TreeArea.scrollTop($TreeArea.scrollTop() + offset);
                    };
                  })(marker)
                );
              });

              if (deviceLocations.length > 1) {
                globMap.fitBounds(mapBounds);
              }

              // if (deviceLocations.length === 1) {
              // var listener = google.maps.event.addListener(globMap, "idle",
              // function() {
              // globMap.setZoom(11);
              // google.maps.event.removeListener(listener);
              // });
              // }
            }
          }

          break;
        case "nodepad":
          if (!globIsCreateTree) {
            enableNodePadContent();

            $NodePadEntries.html("");

            var isToDisable = !(globCurrentNode.indexOf("un_") === 0);
            $NodePadNewText.prop("disabled", isToDisable);

            if (nodeId.indexOf("un_") !== 0) {
              $NewNodePadEntrySubmit.prop("disabled", true);
            } else {
              var isToEnableSubmit = $NodePadNewText.val().trim().length > 0;
              $NewNodePadEntrySubmit.prop("disabled", !isToEnableSubmit);
            }

            if (isPhysicalPort) {
              var portTreeData = $("#TreeGraph").jstree("get_node", nodeId);
              if (portTreeData.children.length) {
                $TreeGraph.jstree("deselect_all");
                $TreeGraph.jstree("select_node", portTreeData.children[0], false);
              }
            } else { //if (!isPhysicalPort) {
              // if ((nodeId.indexOf("D_") !== 0) && (nodeId.indexOf("un_") !== 0)) {
              //   html = '<h4 id="NodepadNoData" class="text-center">Nodepad is available only for device node, links or UCU.</h4>';
              //   $NodePadEntries.html(html);

              //   break;
              // }

              tabNodePadGraphsContentControlsGo();
            }
          }

          break;
        case "optixmode":
          if (!(globIsManualTreeRefresh || globIsCreateTree)) {
            // if (!nodeData)

            if (
              !isPhysicalPort &&
              (nodeData.id.indexOf("un_") == 0 ||
                nodeData.id.indexOf("D_") == 0)
            ) {
              //if (nodeData.act_name.indexOf('ucu22') == -1) {
              if (parseInt(nodeData.act_name.substring(3, 7)) < 2200) {
                displayOptixModeMsg(
                  "Graphs are only available for OPTiX devices (>= 22xx)."
                );

                break;
              }
            }

            enableOptixModeContent();

            OptixModeGraphsContainerRect =
              $TabOptixModeContentGraphsContainer[0].getBoundingClientRect();

            globRRDGraphsZoomDates = [];

            tabOptixModeGraphsContentControlsGo();

            /*else if (nodeData.id.indexOf('L_') == 0) {
              var children = $TreeGraph.jstree(true).get_children_dom(nodeData.id);
                var subChildren;
                var childrenNamesForProd = [];

                for(var i = 0; i < children.length; ++i) {
                    if (children[i].id.indexOf('D_') == 0) {
                        subChildren = $TreeGraph.jstree(true).get_children_dom(children[i].id);
                    } else if (children[i].id.indexOf('L_') == 0) {
                        subChildren = $TreeGraph.jstree(true).get_children_dom(children[i].id);
                    }
                }
            } //  else {
            //	displayOptixModeMsg("Graphs are only available for UCU & UMU devices and their immediate parents.")							
            // }
            */
          }

          break;
        case "internals":
          if (!isPhysicalPort) {
            if (!(globIsManualTreeRefresh || globIsCreateTree)) {
              if (globInternalsSamplesUpdateTimer) {
                clearInterval(globInternalsSamplesUpdateTimer);

                globInternalsSamplesUpdateTimer = null;
              }

              // if (!nodeData || (nodeData.id.indexOf('un_') !== 0)) {
              // 	displayInternalsMsg("Internals are only available for UCU & UMU devices.")
              // } else {
              enableInternalsContent();

              if (isUCU(nodeData)) {
                enableInternalsContentUCU();
                tabInternalsUCUHandler();
              } else if (isLinkNode(nodeData)) {
                enableInternalsContentUMU();
                tabInternalsUMUHandler();
              } else if (isGroupNode(nodeData) || isParentGroupNode(nodeData) || (nodeData.id === "root")) {
                enableInternalsContentParentGroup();
              } else {
                displayInternalsMsg("Internals are not available for this node. Select a UCU, a link or a group node.");
              }
              // }
            }
          }

          break;
        case 'utils':
          // if (!(globIsManualTreeRefresh || globIsCreateTree)) {
          //   if (isPhysicalPort) {
          //     var portTreeData = $("#TreeGraph").jstree("get_node", nodeId);
          //     if (portTreeData.children.length) {
          //       $TreeGraph.jstree("deselect_all");
          //       $TreeGraph.jstree("select_node", portTreeData.children[0], false);
          //     }
          //   }
          //   else {
          //     if (nodeData.id.indexOf("un_") == 0 || nodeData.id.indexOf("D_") == 0) {
          //       enableUtilsContent();
          //     } else {
          //       displayUtilsMsg(
          //         "Utils are only available for device level nodes"
          //       );

          //       break;
          //     }
          //   }
          // }

          break;
        case "paper":
          if (!isPhysicalPort && (isUCU(nodeData) || isLinkNode(nodeData))) {
            enablePaperContent();

            if (embeddedPaper) {
              Dropbox.unmount(embeddedPaper);
            }

            var currentTimestamp = new Date().getTime();
            if (
              dropboxAccessData.lastAccessTimestamp === -1 ||
              dropboxAccessData.lastAccessTimestamp >= currentTimestamp
            ) {
              $.ajax({
                type: "post",
                async: false,
                url: "https://api.dropbox.com/oauth2/token",
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
                contentType: "application/x-www-form-urlencoded; charset=utf-8",
                dataType: "json",
                data: {
                  refresh_token: dropboxAccessData.refresh_token,
                  grant_type: "refresh_token",
                  client_id: dropboxAccessData.client_id,
                  client_secret: dropboxAccessData.client_secret,
                },
                success: function (data) {
                  // console.log(data);

                  dropboxAccessData.token = data.access_token;
                  dropboxAccessData.lastAccessTimestamp =
                    currentTimestamp + data.expires_in - 60;
                },
                error: function (jqXHR, textStatus, errorThrown) {
                  dropboxAccessData.lastAccessTimestamp = -1;
                },
              });
            }

            if (dropboxAccessData.lastAccessTimestamp !== -1) {
              $.ajax({
                url: "https://api.dropboxapi.com/2/sharing/list_shared_links",
                type: "post",
                data: JSON.stringify({
                  path:
                    "/ubiqam Team Folder/SitePapers/" +
                    nodeData.act_name.substr(3, 4) +
                    ".paper",
                }),
                headers: {
                  Authorization: "Bearer " + dropboxAccessData.token,
                  "Content-Type": "application/json",
                },
                dataType: "json",
                success: function (data) {
                  // console.log(data);

                  if (data.links.length) {
                    var options = {
                      link: data.links[0].url,
                      file: {
                        zoom: "fit", // "best/fit"
                      },
                    };

                    embeddedPaper = Dropbox.embed(
                      options,
                      $("#TabPaperContentContainer")[0]
                    );
                  } else {
                    // No share yet, create one
                    $.ajax({
                      url: "https://api.dropboxapi.com/2/sharing/create_shared_link_with_settings",
                      type: "post",
                      data: JSON.stringify({
                        path:
                          "/ubiqam Team Folder/SitePapers/" +
                          nodeData.act_name.substr(3, 4) +
                          ".paper",
                        settings: {
                          audience: "public",
                          access: "editor",
                          requested_visibility: "public",
                          allow_download: false,
                        },
                      }),
                      headers: {
                        Authorization: "Bearer " + dropboxAccessData.token,
                        "Content-Type": "application/json",
                      },
                      dataType: "json",
                      success: function (data) {
                        // console.log(data);

                        var options = {
                          link: data.url,
                          file: {
                            zoom: "fit", // "best/fit"
                          },
                        };

                        embeddedPaper = Dropbox.embed(
                          options,
                          $("#TabPaperContentContainer")[0]
                        );
                      },
                    });
                  }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                  // console.log(jqXHR, textStatus, errorThrown)

                  if (
                    jqXHR.responseJSON.error_summary.indexOf(
                      "path/not_found"
                    ) !== -1
                  ) {
                    displayPaperMsg("Paper not found for device.");
                  }
                },
              });
            }
          }

          break;
      }
    });

    $TreeGraph.on("open_node.jstree", function (e, data) {
      if (!globCheckOpen) {
        rememberTreeOpenState(data.node.id, true);

        $.post(
          "setTreeOpen.php",
          {
            state: "open",
            node: data.node.id,
          },
          function (result) {
            setTreeRefreshInterval();
          }
        );
      }

      if (isUserRole("Display Status In Tree")) {
        DisplayDeviceStatus();
        propogateDeviceStatus();
      }
    });

    $TreeGraph.on("close_node.jstree", function (e, data) {
      if (!globCheckOpen) {
        rememberTreeOpenState(data.node.id, false);

        $.post(
          "setTreeOpen.php",
          {
            state: "close",
            node: data.node.id,
          },
          function (result) {
            setTreeRefreshInterval();
          }
        );
      }
    });

    $TreeGraph.on("create_node.jstree", function (e, data) {
      // data.rslt is the new node

      if (!globIsCreateTree) {
        $.post(
          "createTree.php",
          {
            id: "L_" + data.node.id,
            name: data.node.text,
            parent: data.parent,
            pos: data.position,
          },
          function (result) {
            if (isDebug()) {
              console.log("EVENT create_node.jstree: result: ", result);
            }
          }
        );
      }

      propogateTreeIgnoredIcons(); // OOO is needed?

      $TreeGraph.jstree("deselect_all");
      $TreeGraph.jstree("select_node", globCurrentNode, false);
    });

    $TreeGraph.on("rename_node.jstree", function (e, data) {
      if (!globIsCreateTree) {
        globIsRenaming = true;

        if (data.text === "") {
          console.log("Rename: empty node name. Setting back previous name.");
          // $TreeGraph.jstree.rollback(data.rlbk);
          // data.text = data.node.original.text;
          $TreeGraph.jstree("rename_node", data.node, data.node.original.text);
        } else {
          $.post(
            "updateTree.php",
            {
              id: data.node.id,
              name: data.text,
              parent: data.node.parent,
            },
            function (result) {
              // if (isDebug()) {
              // console.log('rename_node.jstree: result = ', result);
              // // DDD
              // }

              globIsRenaming = false;
              setTreeRefreshInterval();

              $TreeGraph.jstree("deselect_all");
              $TreeGraph.jstree("select_node", globCurrentNode, false);
            }
          );
        }
      }
    });

    $TreeGraph.on("delete_node.jstree", function (e, data) {
      if (!globIsCreateTree) {
        $.post(
          "deleteNode.php",
          {
            id: data.node.id,
          },
          function (result) {
            $TreeGraph.jstree("deselect_all");
            $TreeGraph.jstree("select_node", globCurrentNode, false);
          }
        );
      }
    });

    $TreeGraph.on("move_node.jstree", function (e, data) {
      if (isDebug()) {
        console.log("EVENT move_node.jstree: ", e, data); // DDD
      }

      if (!globIsCreateTree) {
        // var oldParent = data.old_parent;
        //
        // var target = $TreeGraph.jstree('get_node', data.parent,
        // false);
        // var children = target.parent;
        //
        // var ddd = data.node.id; /// OOO ddd = node to move
        //
        // var iconid = data.node.id;
        // var tempNodeId = "";

        if (
          data.parent.indexOf("L_") > -1 &&
          data.node.text.indexOf("-") > -1
        ) {
          // ||data.parent=="root"||data.parent=="un")//children=="root"&&data.node.text.indexOf("-")>-1)
          console.log("!!! move_node.jstree: THE SPECIAL CASE TO CHECK !!!"); // DDD
        }

        if (isDebug()) {
          console.log("Do move of: ", data.node.id, ", to: ", data.parent); // DDD
        }

        // A drop onto a collapsed branch - jstree allows it without waiting
        // for the hover timer to expand it - would otherwise leave the node
        // invisible once the tree is rebuilt below. No-op when it is already
        // expanded, which is the usual case.
        $TreeGraph.jstree("open_node", data.parent);

        $.post(
          "moveNode.php",
          {
            id: data.node.id,
            parent: data.parent,
            pos: data.position,
          },
          function (result) {
            if (isDebug()) {
              console.log("moveNode result: ", result); // DDD
            }

            // Reload only after the parent is persisted so the refresh
            // reflects the new location instead of racing the DB write.
            createTree();
            setTreeRefreshInterval();
          }
        ).fail(function () {
          // Even on failure, resync the tree so the UI matches the DB.
          createTree();
          setTreeRefreshInterval();
        });
      }
    });

    function doNodeSearch() {
      $TreeGraph.jstree("search", $("#NodeSearch").val());

      if (isUserRole("Display Status In Tree")) {
        DisplayDeviceStatus();
        propogateDeviceStatus();
      }
    }

    $("#NodeSearch").keyup(function (e) {
      if (globNodeSearchTimer) {
        clearTimeout(globNodeSearchTimer);
      }

      globNodeSearchTimer = setTimeout(doNodeSearch, NODE_SEARCH_DELAY);
    });

    $("#NodeSearchInputClear").on("click", function (e) {
      if ($("#NodeSearch").val()) {
        $("#NodeSearch").val("");
        doNodeSearch();
      }
    });

    $TreeArea.on("scroll", function (e) {
      setTreeRefreshInterval();
    });

    // $TreeGraph.on('search.jstree', function(e, data) {
    // console.log('EVENT search.jstree: ', e, data); // DDD
    // });
  }

  $TabRRDContentGraphsContainer.on("scroll", function (e) {
    globTabRRDContentGraphsContainerScrollPos =
      $TabRRDContentGraphsContainer[0].scrollTop;
  });

  function doDTGraphsSearch(isScrollTop) {
    _.forOwn(globTDGraphsLookupForFilter, function (graphId, graphTitle) {
      if (
        graphTitle
          .toLowerCase()
          .indexOf($("#RRDFilterSearch").val().toLowerCase()) === -1
      ) {
        $("#" + graphId).hide();
        $("#" + graphId)
          .next()
          .hide();
      } else {
        $("#" + graphId).show();
        $("#" + graphId)
          .next()
          .show();
      }
    });

    if (isScrollTop) {
      globTabRRDContentGraphsContainerScrollPos = 0;
    }

    $TabRRDContentGraphsContainer[0].scrollTop =
      globTabRRDContentGraphsContainerScrollPos;
  }

  $("#RRDFilterSearch").keyup(function (e) {
    if (dtGraphsSearchTimer) {
      clearTimeout(dtGraphsSearchTimer);
    }

    dtGraphsSearchTimer = setTimeout(function () {
      doDTGraphsSearch(1);
    }, TD_GRAPHS_SEARCH_DELAY);
  });

  $("#TabRRDContentControlsPoweFilterMin").on("change", function (e) {
    enableRRDPowerFilterUI(true);
  });

  $("#TabRRDContentControlsPoweFilterMax").on("change", function (e) {
    enableRRDPowerFilterUI(true);
  });

  $("#RRDFilterSearchInputClear").on("click", function (e) {
    if ($("#RRDFilterSearch").val()) {
      $("#RRDFilterSearch").val("");

      _.forOwn(globTDGraphsLookupForFilter, function (graphId, graphTitle) {
        $("#" + graphId).show();
        $("#" + graphId)
          .next()
          .show();
      });

      globTabRRDContentGraphsContainerScrollPos = 0;
      $TabRRDContentGraphsContainer[0].scrollTop =
        globTabRRDContentGraphsContainerScrollPos;
    }
  });

  $("#TabSpectrogramsContentControlsPoweFilterMin").on("change", function (e) {
    enableSpectrogramsPowerFilterUI(true);
  });

  $("#TabSpectrogramsContentControlsPoweFilterMax").on("change", function (e) {
    enableSpectrogramsPowerFilterUI(true);
  });

  d3.select("body").on("keydown", function () {
    if (globCurrentGraphObject) {
      // console.log(d3.event, globCurrentGraphObject);

      if (d3.event.keyCode === 70) {
        // "f" for freeze
        d3.select(globCurrentGraphObject).dispatch("keypress", {
          detail: "DoFreeze",
        });
      } else {
        var diffX = 0;
        var diffY = 0;

        if (d3.event.keyCode === 37) {
          diffX = -1;
        } else if (d3.event.keyCode === 39) {
          diffX = 1;
        } else if (d3.event.keyCode === 38) {
          diffY = -1;
        } else if (d3.event.keyCode === 40) {
          diffY = 1;
        }

        if (diffX !== 0 || diffY !== 0) {
          d3.select(globCurrentGraphObject).dispatch("mousemove", {
            detail: [diffX, diffY],
          });
        }
      }
    }
  });
  // == Events

  // *****
  // Start
  // *****

  /*
   * $(function() { setTimeout(function() { $('#NodeSearch').prop('type',
   * "text"); $('#RRDFilterSearch').prop('type', "text");
   * $('#TabNodePadContentControlsTextFilter').prop('type', "text"); }, 50);
   * });
   */

  // Prevent form resubmission when page is refreshed (F5 / CTRL+R) (because
  // of form trick to prevent auto-completion of input text fields)
  if (window.history.replaceState) {
    window.history.replaceState(null, null, window.location.href);
  }

  function onDragStartHandler(e) {
    // console.log(globCurrentTab);

    if (globCurrentTab === "spectrographs") {
      $SpectrogramWin1GraphsContainer[0].innerHTML = "";
    } else if (globCurrentTab === "rrdgraphs") {
      $TabRRDContentGraphsContainer.html("");
    } else if (globCurrentTab === "optixmode") {
      $TabOptixModeContentGraphsContainer.html("");
    }
  }

  function onDragEndHandler(e) {
    if (globCurrentNode) {
      $TreeGraph.jstree("deselect_all");
      $TreeGraph.jstree("select_node", globCurrentNode, false);
    }
  }

  var isMobile = /Android|iPhone/i.test(navigator.userAgent);

  if (!isMobile) {
    $("#MainContent").addClass("split");

    Split(["#MainContentLeft", "#MainContentContent"], {
      sizes: [20, 80],
      gutterSize: 5,
      minSize: [325, 1355],
      onDragStart: onDragStartHandler,
      onDragEnd: onDragEndHandler,
    });
  }

  // Pre-session-token builds kept the login in a readable "uid" cookie.
  if (Utils.getCookie("uid") != "") {
    Utils.deleteCookie("uid");
  }

  // The session cookie is HttpOnly, so the server says whether it is valid.
  checkSession();

  function checkSession() {
    $.post(
      "adminservice.php",
      {
        method: "user_auth",
      },
      function (data) {
        if (data.isAuth) {
          globUserData = data.userData;
          globCsrfToken = data.csrfToken || "";
          // globServerTime = data.serverTime;
          globServerTimezone = data.timezone;

          $UserName.text(globUserData.name);

          startApp();
        } else {
          $("#UserLoginError").addClass("hidden");

          if (data.isAccountDisabled) {
            $("#UserLoginError")
              .removeClass("hidden")
              .text(
                "Authentication error: Account is not active. Contact administrator."
              );
            showLoginWindow();
          } else if (data.isTempPassword) {
            if (data.isTempPasswordExpired) {
              $("#UserLoginError")
                .removeClass("hidden")
                .text(
                  "Authentication error: temporary password expired. Contact administrator."
                );
              showLoginWindow();
            } else {
              globIsUserStrictPassword = parseInt(data.is_strict_password);
              globIsMustChangeTempPassword = true;

              prepareLoginChangePasswordWindow();
              showLoginChangePasswordWindow();
            }
          } else if (data.isPasswordExpired) {
            globIsUserStrictPassword = parseInt(data.is_strict_password);
            globIsMustChangeExpiredPassword = true;

            prepareLoginChangePasswordWindow();
            showLoginChangePasswordWindow();
          } else {
            showLoginWindow();
          }
        }
      },
      "json"
    ).fail(function () {
      showLoginWindow();
    });
  }
});
